import React, { useState, useEffect, useCallback } from "react";
import "./admin.css";
import {  } from "firebase/firestore";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from "xlsx";
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  addDoc,
  updateDoc,
  query,
  orderBy,
  limit,
  where,
  serverTimestamp,
  arrayUnion,
  runTransaction,
   startAfter,
} from "firebase/firestore";





import { db } from "../FirebaseComp/firebase"; // adjust your path
import { saveAs } from 'file-saver';

import { Bar, Doughnut, Line } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title } from 'chart.js';

// Register ChartJS components
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, PointElement, LineElement, Title);









function AdminPanel() {
const [openMenu, setOpenMenu] = useState(null); 

  const [selectedOption, setSelectedOption] = useState("dashboard");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpenStock, setDropdownOpenStock] = useState(false);
  const [dropdownOpenSupplier, setDropdownOpenSupplier] = useState(false);
  const [dropdownOpenReport, setDropdownOpenReport] = useState(false);
  const [dropdownOpenInvoice, setDropdownOpenInvoice] = useState(false);




// ✅ State variables MUST come first
const [suppliers, setSuppliers] = useState([]);
const [lensList, setLensList] = useState([]);
const [frameList, setFrameList] = useState([]);
const [supplierName, setSupplierName] = useState("");
const [purchaseOrderNo, setPurchaseOrderNo] = useState("");


//fetch all the eye exam report
const [eyeExamRecords, setEyeExamRecords] = useState([]);
const [selectedRecord, setSelectedRecord] = useState(null);

// State variables
const [searchTerm, setSearchTerm] = useState("");
//search function in view eye report
const [filterOption, setFilterOption] = useState('all');
const [lens, setLens] = useState("");


// Add Service states
const [serviceDescription, setServiceDescription] = useState("");

const [serviceAmount, setServiceAmount] = useState("");

const [servicePaymentType, setServicePaymentType] = useState("full");


const [purchaseOrders, setPurchaseOrders] = useState([]);

const [purchaseDate, setPurchaseDate] = useState("");
const [items, setItems] = useState([]);

const [nextBalanceInvoiceNo, setNextBalanceInvoiceNo] = useState('');



useEffect(() => {
  const close = () => setOpenMenu(null);
  document.addEventListener("click", close);
  return () => document.removeEventListener("click", close);
}, []);


  const handleSelect = (option) => {
    setSelectedOption(option);
    setDropdownOpen(false);
  };

    const handleSelectStock = (optionstock) => {
    setSelectedOption(optionstock);
    setDropdownOpenStock(false);
  };


    const handleSelectSupplier = (optionsupplier) => {
    setSelectedOption(optionsupplier);
    setDropdownOpenSupplier(false);
  };



      const handleSelectInvoice = (optioninvoice) => {
    setSelectedOption(optioninvoice);
    setDropdownOpenInvoice(false);
  };



  
    const handleSelectReport = (optionsReport) => {
    setSelectedOption(optionsReport);
    setDropdownOpenReport(false);
  };







///////////////////////////////////////////// lens price ///////////////////////////////////////////////////
const lensData = {


STANDARD: {
  SV: [
    { name: "Single Vision CR 39 (Plano)", pairPrice: 1850 },
    { name: "Single Vision CR 39 (0.25 to 2.00) SPH", pairPrice: 2300 },
    { name: "Single Vision CR 39 (2.25 to 4.00) SPH", pairPrice: 2450 },
    { name: "Single Vision CR 39 (4.25 to 6.00) SPH", pairPrice: 2650 },
    { name: "Single Vision CR 39 (6.25 to 8.00) SPH", pairPrice: 3150 },
    { name: "Single Vision CR 39 (8.25 to 10.00) SPH", pairPrice: 3650 },

    { name: "Single Vision CR 39 TORIC 2/2", pairPrice: 2050 },
    { name: "Single Vision CR 39 TORIC 4/2", pairPrice: 2250 },
    { name: "Single Vision CR 39 TORIC 6/2", pairPrice: 2600 },
    { name: "Single Vision CR 39 TORIC 8/2", pairPrice: 2900 },
    { name: "Single Vision CR 39 TORIC 10/2", pairPrice: 3200 },
    { name: "Single Vision CR 39 TORIC 2/4", pairPrice: 3750 },
    { name: "Single Vision CR 39 TORIC 4/4", pairPrice: 4800 },
    { name: "Single Vision CR 39 TORIC 6/4", pairPrice: 5500 },

    { name: "Exceed Above Powers Extra", pairPrice: 700 },

    { name: "Single Vision HMC 1.56 (4.00 DS / 4/2 DC)", pairPrice: 4800 },
    { name: "Single Vision HMC 1.56 (8.00 DS / 8/2 DC)", pairPrice: 5800 },
    { name: "Single Vision HMC 1.56 (10.00 DS / 10/2 DC)", pairPrice: 7300 },

    { name: "Single Vision Bluecut 1.56 Rx (4.00 DS / 4/2 DC)", pairPrice: 6300 },
    { name: "Single Vision Bluecut 1.56 Rx (8.00 DS / 8/2 DC)", pairPrice: 7300 },
    { name: "Single Vision Bluecut 1.56 Rx (10.00 DS / 10/2 DC)", pairPrice: 8800 },

    { name: "Single Vision HC Photo Grey 2.00 DS", pairPrice: 3562.5 },
    { name: "Single Vision HC Photo Grey 4.00 DS", pairPrice: 4050 },
    { name: "Single Vision HC Photo Grey 6.00 DS", pairPrice: 4987.5 },

    { name: "Single Vision HC Photo Grey 2/2 DC", pairPrice: 4050 },
    { name: "Single Vision HC Photo Grey 4/2 DC", pairPrice: 4987.5 },
    { name: "Single Vision HC Photo Grey 6/2 DC", pairPrice: 6037.5 },

    { name: "Single Vision HC Photo Grey Grinding", pairPrice: 7425 },

    { name: "Single Vision HMC Transition Grey (Local Outside)", pairPrice: 12050 },

    { name: "Single Vision HMC Photo Grey 2.00 DS", pairPrice: 6050 },
    { name: "Single Vision HMC Photo Grey 4.00 DS", pairPrice: 8800 },
    { name: "Single Vision HMC Photo Grey 6.00 DS", pairPrice: 12050 },

    { name: "Single Vision HMC Photo Grey 2/2 DC", pairPrice: 8100 },
    { name: "Single Vision HMC Photo Grey 4/2 DC", pairPrice: 9300 },
    { name: "Single Vision HMC Photo Grey 6/2 DC", pairPrice: 12050 },

    { name: "Single Vision Bluecut Photo Grey 2.00 DS", pairPrice: 7550 },
    { name: "Single Vision Bluecut Photo Grey 4.00 DS", pairPrice: 10300 },

    { name: "Single Vision Bluecut Photo Grey 2/2 DC", pairPrice: 9600 },
    { name: "Single Vision Bluecut Photo Grey 4/2 DC", pairPrice: 10800 },
    { name: "Single Vision Bluecut Photo Grey 6/2 DC", pairPrice: 13550 }
  ],

  BF: [
    { name: "Bifocal Roundtop Stock", pairPrice: 2150 },
    { name: "Bifocal Roundtop Grinding SPH", pairPrice: 2600 },
    { name: "Bifocal Roundtop Grinding Toric", pairPrice: 2750 },
    { name: "Bifocal Roundtop HMC Photo Grey", pairPrice: 8400 },

    { name: "Bifocal Flattop Grinding SPH", pairPrice: 2900 },
    { name: "Bifocal Flattop Grinding Toric", pairPrice: 3150 },
    { name: "Bifocal Flattop Photo Grey Grinding", pairPrice: 12700 }
  ],

  PAL: [
    { name: "Progressive UnCoated (Plano to +3.00) Add 3.00", pairPrice: 8700 },
    { name: "Progressive HMC (Plano to +3.00) Add 3.00", pairPrice: 7900 },
    { name: "Progressive HMC Photo Grey (Plano to +3.00) Add 3.00", pairPrice: 17500 },
    { name: "Progressive Bluecut (Plano to +3.00) Add 3.00", pairPrice: 9400 },
    { name: "Progressive Bluecut Photo Grey (Plano to +3.00) Add 3.00", pairPrice: 21300 },

    { name: "Progressive UnCoated (-0.25 to -3.00) Add 3.00", pairPrice: 8700 },
    { name: "Progressive HMC (-0.25 to -3.00) Add 3.00", pairPrice: 10000 },
    { name: "Progressive HMC Photo Grey (-0.25 to -3.00) Add 3.00", pairPrice: 17500 },
    { name: "Progressive Bluecut (-0.25 to -3.00) Add 3.00", pairPrice: 9400 },
    { name: "Progressive Bluecut Photo Grey (-0.25 to -3.00) Add 3.00", pairPrice: 21300 },

    { name: "Progressive Polysoft SPH", pairPrice: 9250 },
    { name: "Progressive Polysoft Toric", pairPrice: 10600 },
    { name: "Progressive Sunsensor", pairPrice: 18400 },
    { name: "Progressive HMC Workshop Grinding Short Corridor", pairPrice: 10000 }
  ]
},




ESSILOR: {
  SV: [
    // Stock Single Vision
    {name: "Crizal Easy Transition Single Vision", pairPrice:35750},
    { name: "Crizal Easy Pro Single Vision Stock 1.56", pairPrice: 12500 },
    { name: "Crizal Prevencia Single Vision Stock 1.56", pairPrice: 17500 },
    
    // Rx Single Vision - Clear
    { name: "Single Vision 1.5 Rx Crizal Easy Pro", pairPrice: 13500 },
    { name: "Single Vision 1.5 Rx Prevencia", pairPrice: 19000 },
    { name: "Single Vision - High Index Airwear (Polycarbonate) 1.59 Rx Crizal Easy Pro", pairPrice: 37200 },
    { name: "Single Vision - High Index Airwear (Polycarbonate) 1.59 Rx Prevencia", pairPrice: 43700 },
    { name: "Single Vision - High Index 1.6 Rx Crizal Easy Pro", pairPrice: 25000 },
    { name: "Single Vision - High Index 1.6 Rx Prevencia", pairPrice: 31400 },
    { name: "Single Vision - High Index 1.67 Rx Crizal Easy Pro", pairPrice: 33000 },
    { name: "Single Vision - High Index 1.67 Rx Prevencia", pairPrice: 39700 },
    { name: "Single Vision - High Index 1.74 Rx Crizal Easy Pro", pairPrice: 55250 },
    { name: "Single Vision - High Index 1.74 Rx Prevencia", pairPrice: 61700 },
    
    // Rx Single Vision - Photochromic
    { name: "Single Vision - Photochromic 1.5 Rx Crizal Easy Pro", pairPrice: 25250 },
    { name: "Single Vision - Photochromic 1.5 Rx Prevencia", pairPrice: 30875 },
    
    // Polarized
    { name: "Single Vision - Polarized (Standard Polarised Lens) Grey/Green/Brown 1.5 Titus", pairPrice: 20750 },
    { name: "Single Vision - Polarized (Standard Polarised Lens) Grey/Green/Brown 1.5 Crizal Easy", pairPrice: 30750 },
    { name: "Single Vision - Xperio (Essilor Polarized Lens) Grey/Green/Brown 1.5 Titus", pairPrice: 28000 },
    { name: "Single Vision - Xperio (Essilor Polarized Lens) Grey/Green/Brown 1.5 Crizal Easy", pairPrice: 39000 },
  ],

  BF: [
    // Bifocal - Clear
    { name: "Round Segment 1.5 Rx e-HMC", pairPrice: 10400 },
    { name: "Flat Top 1.5 Rx e-HMC", pairPrice: 10400 },
    
    // Bifocal - Photochromic
    { name: "Round segment Photochromic 1.5 Rx e-HMC", pairPrice: 18200 },
    { name: "Round segment Photochromic 1.5 Rx Crizal Uv", pairPrice: 25500 },
  ],

  PAL: [
    // Essentials Everyday
    { name: "Essentials Everyday 1.5 Crizal Easy Pro", pairPrice: 26250 },
    { name: "Essentials Everyday 1.6 Crizal Easy Pro", pairPrice: 43750 },
    { name: "Essentials Everyday 1.67 Crizal Easy Pro", pairPrice: 61250 },
    { name: "Essentials Everyday Transitions Classic 1.5 Crizal Easy Pro", pairPrice: 50000 },
    { name: "Essentials Everyday Transitions Classic 1.6 Crizal Easy Pro", pairPrice: 75000 },
    { name: "Essentials Everyday Transitions Classic 1.67 Crizal Easy Pro", pairPrice: 87500 },
    
    // Essentials Active
    { name: "Essentials Active 1.5 Crizal Easy Pro", pairPrice: 35000 },
    { name: "Essentials Active 1.59 Crizal Easy Pro", pairPrice: 52500 },
    { name: "Essentials Active 1.6 Crizal Easy Pro", pairPrice: 45000 },
    { name: "Essentials Active 1.67 Crizal Easy Pro", pairPrice: 63750 },
    { name: "Essentials Active Transitions Classic 1.5 Crizal Easy Pro", pairPrice: 60000 },
    { name: "Essentials Active Airwear Transitions Classic 1.59 Crizal Easy Pro", pairPrice: 91250 },
    { name: "Essentials Active Transitions Classic 1.6 Crizal Easy Pro", pairPrice: 81250 },
    { name: "Essentials Active Transitions Classic 1.67 Crizal Easy Pro", pairPrice: 105000 },
    
    // Varilux Liberty 3.0
    { name: "Varilux Liberty 3.0 Digital 1.5 Crizal Easy", pairPrice: 44500 },
    { name: "Varilux Liberty 3.0 Digital 1.5 Crizal Prevencia", pairPrice: 50750 },
    { name: "Varilux Liberty 3.0 Digital Airwear (Polycarbonate) 1.59 Crizal Easy", pairPrice: 62500 },
    { name: "Varilux Liberty 3.0 Digital Airwear (Polycarbonate) 1.59 Crizal Prevencia", pairPrice: 68750 },
    { name: "Varilux Liberty 3.0 Digital 1.6 Crizal Easy", pairPrice: 71250 },
    { name: "Varilux Liberty 3.0 Digital 1.6 Crizal Prevencia", pairPrice: 77500 },
    { name: "Varilux Liberty 3.0 Digital 1.67 Crizal Easy", pairPrice: 83750 },
    { name: "Varilux Liberty 3.0 Digital 1.67 Crizal Prevencia", pairPrice: 90000 },
    { name: "Varilux Liberty Digital Transitions Classic 1.5 Crizal Easy", pairPrice: 75000 },
    { name: "Varilux Liberty Digital Transitions Signature GEN8 1.5 Crizal Easy", pairPrice: 80000 },
    { name: "Varilux Liberty Digital Airwear Transitions Classic 1.59 Crizal Easy", pairPrice: 96250 },
    { name: "Varilux Liberty Digital Transitions Classic 1.6 Crizal Easy", pairPrice: 97500 },
    { name: "Varilux Liberty Digital Transitions Classic 1.67 Crizal Easy", pairPrice: 127500 },
    
    // Varilux Ultra
    { name: "Varilux Ultra Digital 1.5 Crizal Easy", pairPrice: 50750 },
    { name: "Varilux Ultra Digital 1.5 Crizal Prevencia", pairPrice: 57000 },
    { name: "Varilux Ultra Digital Airwear (Polycarbonate) 1.59 Crizal Easy", pairPrice: 68750 },
    { name: "Varilux Ultra Digital Airwear (Polycarbonate) 1.59 Crizal Prevencia", pairPrice: 75000 },
    { name: "Varilux Ultra Digital 1.67 Crizal Easy", pairPrice: 90000 },
    { name: "Varilux Ultra Digital 1.67 Crizal Prevencia", pairPrice: 96250 },
    { name: "Varilux Ultra Digital Transitions Classic 1.5 Crizal Easy", pairPrice: 81250 },
    { name: "Varilux Ultra Digital Airwear Transitions Classic 1.59 Crizal Easy", pairPrice: 102500 },
    { name: "Varilux Ultra Digital Transitions Classic 1.67 Crizal Easy", pairPrice: 133750 },
    
    // Varilux Comfort Max
    { name: "Varilux Comfort Max Digital 1.5 Crizal Easy", pairPrice: 64500 },
    { name: "Varilux Comfort Max Digital 1.5 Crizal Prevencia", pairPrice: 70750 },
    { name: "Varilux Comfort Max Digital Airwear 1.59 Crizal Easy", pairPrice: 85000 },
    { name: "Varilux Comfort Max Digital Airwear 1.59 Crizal Prevencia", pairPrice: 91250 },
    { name: "Varilux Comfort Max Digital 1.67 Crizal Easy", pairPrice: 106250 },
    { name: "Varilux Comfort Max Digital 1.67 Crizal Prevencia", pairPrice: 112500 },
    { name: "Varilux Comfort Max Digital Transitions Signature GEN8 1.5 Crizal Easy", pairPrice: 95000 },
    { name: "Varilux Comfort Max Digital Airwear Transitions Classic 1.59 Crizal Easy", pairPrice: 121250 },
    { name: "Varilux Comfort Max Digital Transitions Classic 1.67 Crizal Easy", pairPrice: 152500 },
    
    // Varilux E Series
    { name: "Varilux E Series - Clear 1.5 Crizal Easy", pairPrice: 80000 },
    { name: "Varilux E Series - Clear 1.5 Crizal Prevencia", pairPrice: 87000 },
    { name: "Varilux E Series Airwear - Clear 1.59 Crizal Easy", pairPrice: 101250 },
    { name: "Varilux E Series Airwear - Clear 1.59 Crizal Prevencia", pairPrice: 107500 },
    { name: "Varilux E Series - Clear 1.67 Crizal Easy", pairPrice: 122500 },
    { name: "Varilux E Series - Clear 1.67 Crizal Prevencia", pairPrice: 128750 },
    { name: "Varilux E Series Transitions Classic 1.5 Crizal Easy", pairPrice: 116250 },
    { name: "Varilux E Series Airwear Transitions Classic 1.59 Crizal Easy", pairPrice: 142500 },
    { name: "Varilux E Series Transitions Signature classic 1.67 Crizal Easy", pairPrice: 171250 },
    
    // Varilux S Series
    { name: "Varilux S Series 1.5 Crizal Easy", pairPrice: 117000 },
    { name: "Varilux S Series 1.5 Crizal Prevencia", pairPrice: 138250 },
    { name: "Varilux S Series Airwear 1.59 Crizal Easy", pairPrice: 142500 },
    { name: "Varilux S Series Airwear 1.59 Crizal Prevencia", pairPrice: 163750 },
    { name: "Varilux S Series 1.67 Crizal Easy", pairPrice: 173750 },
    { name: "Varilux S Series 1.67 Crizal Prevencia", pairPrice: 195000 },
    { name: "Varilux S Series Transitions Signature GEN 8 1.5 Crizal Easy", pairPrice: 165000 },
    { name: "Varilux S Series Airwear Transitions Signature GEN 8 1.59 Crizal Easy", pairPrice: 198750 },
    { name: "Varilux S Series Transitions Signature GEN 8 1.67 Crizal Easy", pairPrice: 222500 },
  ]
},





 NEOFORM: {
  SV: [
    // Endless Single Vision
    { name: "Endless Single Vision DurachromeRelax 1.5", pairPrice: 36000 },
    { name: "Endless Single Vision DurachromeGuard 1.5", pairPrice: 37500 },
    
    // Endless Boost Single Vision
    { name: "Endless Boost Single Vision DuraUV 1.5", pairPrice: 24000 },
    { name: "Endless Boost Single Vision DuraRelax 1.5", pairPrice: 24750 },
    { name: "Endless Boost Single Vision DuraGuard 1.5", pairPrice: 33500 },
    { name: "Endless Boost Single Vision DurachromeUV 1.5", pairPrice: 36000 },
    { name: "Endless Boost Single Vision DurachromeRelax 1.5", pairPrice: 37250 },
    { name: "Endless Boost Single Vision DurachromeGuard 1.5", pairPrice: 42250 },
    
    // POLYCARBONATE SV
    { name: "POLYCARBONATE Digital Single Vision Endless SV Duramax", pairPrice: 27500 },
    { name: "POLYCARBONATE Digital Single Vision Endless SV DuraUV", pairPrice: 30000 },
    { name: "POLYCARBONATE Digital Single Vision Endless SV DuraRelax", pairPrice: 32000 },
    
    // TRILOGY TRIVEX SV
    { name: "TRILOGY TRIVEX Digital Single Vision Endless SV Duramax", pairPrice: 40500 },
    { name: "TRILOGY TRIVEX Digital Single Vision Endless SV DuraUV", pairPrice: 42500 },
    { name: "TRILOGY TRIVEX Digital Single Vision Endless SV DuraRelax", pairPrice: 44500 },
    
    // NEOCHROMES SV
    { name: "NEOCHROMES Digital Single Vision Endless SV Duramax 1.5", pairPrice: 68000 },
    { name: "NEOCHROMES Digital Single Vision Endless SV DuraUV 1.5", pairPrice: 70000 },
    { name: "NEOCHROMES Digital Single Vision Endless Boost Duramax 1.5", pairPrice: 70500 },
    { name: "NEOCHROMES Digital Single Vision Endless Boost DuraUV 1.5", pairPrice: 72500 },
    { name: "NEOCHROMES POLYCARBONATE Digital Single Vision Endless SV DuraUV 1.5", pairPrice: 80000 },
    { name: "NEOCHROMES POLYCARBONATE Digital Single Vision Endless Boost DuraUV 1.5", pairPrice: 85000 },
    
    // TRANSITION GEN 08 SV
    { name: "TRANSITION GEN 08 Style Colors Digital Single Endless SV Duramax", pairPrice: 43750 },
    { name: "TRANSITION GEN 08 Style Colors Digital Single Endless SV DuraUV", pairPrice: 49750 },
    { name: "TRANSITION GEN 08 Style Colors Digital Single Endless Boost Duramax", pairPrice: 47250 },
    { name: "TRANSITION GEN 08 Style Colors Digital Single Endless Boost DuraUV", pairPrice: 52250 },
    
    // TRANSITION GEN S SV
    { name: "TRANSITION GEN S Style Colors Digital Single Endless SV Duramax", pairPrice: 61625 },
    { name: "TRANSITION GEN S Style Colors Digital Single Endless SV DuraUV", pairPrice: 66725 },
    { name: "TRANSITION GEN S Style Colors Digital Single Endless Boost Duramax", pairPrice: 64125 },
    { name: "TRANSITION GEN S Style Colors Digital Single Endless Boost DuraUV", pairPrice: 69225 },
    
    // TRANSITION Xtractive SV
    { name: "TRANSITION Xtractive Digital Single Endless SV Duramax", pairPrice: 130500 },
    { name: "TRANSITION Xtractive Digital Single Endless SV DuraUV", pairPrice: 132500 },
    { name: "TRANSITION Xtractive Digital Single Endless SV DuraRelax", pairPrice: 134500 },
    { name: "TRANSITION Xtractive Digital Single Endless Boost Duramax", pairPrice: 132500 },
    { name: "TRANSITION Xtractive Digital Single Endless Boost DuraUV", pairPrice: 135000 },
    { name: "TRANSITION Xtractive Digital Single Endless Boost DuraRelax", pairPrice: 137000 },
    { name: "TRANSITION Xtractive Polarized Digital Single Endless SV Duramax", pairPrice: 178000 },
    { name: "TRANSITION Xtractive Polarized Digital Single Endless SV DuraUV", pairPrice: 180000 },
    { name: "TRANSITION Xtractive Polarized Digital Single Endless SV DuraRelax", pairPrice: 182000 },
    { name: "TRANSITION Xtractive Polarized Digital Single Endless Boost Duramax", pairPrice: 182000 },
    { name: "TRANSITION Xtractive Polarized Digital Single Endless Boost DuraUV", pairPrice: 184000 },
    { name: "TRANSITION Xtractive Polarized Digital Single Endless Boost DuraRelax", pairPrice: 186000 },
    
    // NUPOLAR SV
    { name: "NUPOLAR Single Vision Endless SV Duramax", pairPrice: 42250 },
    { name: "NUPOLAR Single Vision Endless SV DuraUV", pairPrice: 44750 },
    { name: "NUPOLAR Single Vision Endless SV DuraRelax", pairPrice: 46750 },
    { name: "NUPOLAR Single Vision Endless Boost Duramax", pairPrice: 44750 },
    { name: "NUPOLAR Single Vision Endless Boost DuraUV", pairPrice: 46750 },
    { name: "NUPOLAR Single Vision Endless Boost DuraRelax", pairPrice: 48750 }
  ],

  BF: [
    // Add Bifocal lenses here when you have them
  ],

  PAL: [
    // Camber Steady Plus Progressive
    { name: "Camber Steady Plus Progressive DuraUV 1.5", pairPrice: 95000 },
    { name: "Camber Steady Plus Progressive DuraRelax 1.5", pairPrice: 100000 },
    { name: "Camber Steady Plus Progressive DuraUV Trivex", pairPrice: 117500 },
    { name: "Camber Steady Plus Progressive DuraRelax Trivex", pairPrice: 122500 },
    { name: "Camber Steady Plus Progressive DuraUV 1.67", pairPrice: 170000 },
    { name: "Camber Steady Plus Progressive DuraRelax 1.67", pairPrice: 172500 },
    { name: "Camber Steady Plus Progressive Transition Gen S Grey", pairPrice: 217500 },
    
    // Endless Steady Progressive
    { name: "Endless Steady Progressive Duramax 1.5", pairPrice: 34750 },
    { name: "Endless Steady Progressive DuraBlue 1.5", pairPrice: 39750 },
    { name: "Endless Steady Progressive DuraUV 1.5", pairPrice: 44750 },
    { name: "Endless Steady Progressive DuraRelax 1.5", pairPrice: 49750 },
    { name: "Endless Steady Progressive DuraGuard 1.5", pairPrice: 59750 },
    { name: "Endless Steady Progressive DuraGold 1.5", pairPrice: 64750 },
    { name: "Endless Steady Progressive DuraUV 1.6", pairPrice: 49900 },
    { name: "Endless Steady Progressive DuraRelax 1.6", pairPrice: 51900 },
    { name: "Endless Steady Progressive DuraUV 1.67", pairPrice: 74000 },
    { name: "Endless Steady Progressive DuraRelax 1.67", pairPrice: 75500 },
    { name: "Endless Steady Progressive DuraUV 1.74", pairPrice: 147500 },
    { name: "Endless Steady Progressive DuraRelax 1.74", pairPrice: 149000 },
    { name: "Endless Steady Progressive DuraChrome 1.5", pairPrice: 47250 },
    { name: "Endless Steady Progressive DuraChromeUV 1.5", pairPrice: 62250 },
    { name: "Endless Steady Progressive DuraChromeRelax 1.5", pairPrice: 64750 },
    { name: "Endless Steady Progressive DuraChromeGuard 1.5", pairPrice: 69750 },
    { name: "Endless Steady Progressive DuraChromeGold 1.5", pairPrice: 74750 },
    
    // Essential Steady Progressive
    { name: "Essential Steady Progressive Duramax 1.5", pairPrice: 21000 },
    { name: "Essential Steady Progressive DuraBlue 1.5", pairPrice: 24750 },
    { name: "Essential Steady Progressive DuraUV 1.5", pairPrice: 27250 },
    { name: "Essential Steady Progressive DuraRelax 1.5", pairPrice: 29750 },
    { name: "Essential Steady Progressive DuraGuard 1.5", pairPrice: 32250 },
    { name: "Essential Steady Progressive DuraGold 1.5", pairPrice: 34750 },
    { name: "Essential Steady Progressive DuraUV 1.6", pairPrice: 43000 },
    { name: "Essential Steady Progressive DuraRelax 1.6", pairPrice: 44000 },
    { name: "Essential Steady Progressive DuraUV 1.67", pairPrice: 69900 },
    { name: "Essential Steady Progressive DuraRelax 1.67", pairPrice: 71000 },
    { name: "Essential Steady Progressive DuraUV 1.74", pairPrice: 142000 },
    { name: "Essential Steady Progressive DuraRelax 1.74", pairPrice: 143000 },
    { name: "Essential Steady Progressive DuraChrome 1.5", pairPrice: 39750 },
    { name: "Essential Steady Progressive DuraChromeUV 1.5", pairPrice: 41000 },
    { name: "Essential Steady Progressive DuraChromeRelax 1.5", pairPrice: 42250 },
    { name: "Essential Steady Progressive DuraChromeGuard 1.5", pairPrice: 57250 },
    { name: "Essential Steady Progressive DuraChromeGold 1.5", pairPrice: 59750 },
    
    // Easyfit Digital Progressive
    { name: "Easyfit Digital Progressive Duramax 1.5", pairPrice: 14250 },
    { name: "Easyfit Digital Progressive DuraBlue 1.5", pairPrice: 22250 },
    { name: "Easyfit Digital Progressive DuraUV 1.5", pairPrice: 19500 },
    { name: "Easyfit Digital Progressive DuraRelax 1.5", pairPrice: 24500 },
    { name: "Easyfit Digital Progressive DuraGuard 1.5", pairPrice: 29500 },
    { name: "Easyfit Digital Progressive DuraUV 1.6", pairPrice: 35000 },
    { name: "Easyfit Digital Progressive DuraRelax 1.6", pairPrice: 36000 },
    { name: "Easyfit Digital Progressive DuraUV 1.67", pairPrice: 42000 },
    { name: "Easyfit Digital Progressive DuraRelax 1.67", pairPrice: 43000 },
    { name: "Easyfit Digital Progressive Durachrome 1.5", pairPrice: 34750 },
    { name: "Easyfit Digital Progressive DurachromeUV 1.5", pairPrice: 32000 },
    { name: "Easyfit Digital Progressive DurachromeRelax 1.5", pairPrice: 34750 },
    { name: "Easyfit Digital Progressive DurachromeGuard 1.5", pairPrice: 39750 },
    { name: "Easyfit Digital Progressive Single Side HMC 1.5", pairPrice: 16875 },
    { name: "Easyfit Digital Progressive Single Side BlueCut HMC 1.5", pairPrice: 18625 },
    { name: "Easyfit Digital Progressive Single Side Photo Gray 1.5", pairPrice: 22375 },
    { name: "Easyfit Digital Progressive Single Side BlueCut Photo Gray 1.5", pairPrice: 27375 },
    
    // Crossbow Digital Progressive
    { name: "Crossbow Digital Progressive UnCoated 1.5", pairPrice: 7250 },
    { name: "Crossbow Digital Progressive Duramax 1.5", pairPrice: 9750 },
    { name: "Crossbow Digital Progressive DuraBlue 1.5", pairPrice: 17250 },
    { name: "Crossbow Digital Progressive DuraUV 1.5", pairPrice: 24750 },
    { name: "Crossbow Digital Progressive DuraChrome 1.5", pairPrice: 24750 },
    { name: "Crossbow Digital Progressive DuraChromeUV 1.5", pairPrice: 27000 },
    { name: "Crossbow Digital Progressive Single Side HMC 1.5", pairPrice: 8500 },
    { name: "Crossbow Digital Progressive Single Side BlueCut HMC 1.5", pairPrice: 9875 },
    { name: "Crossbow Digital Progressive Single Side Photo Gray 1.5", pairPrice: 12375 },
    { name: "Crossbow Digital Progressive Single Side BlueCut Photo Gray 1.5", pairPrice: 16000 },
    
    // POLYCARBONATE PAL
    { name: "POLYCARBONATE Digital Progressive Crossbow Duramax", pairPrice: 22750 },
    { name: "POLYCARBONATE Digital Progressive Crossbow DuraUV", pairPrice: 24750 },
    { name: "POLYCARBONATE Digital Progressive EasyFit Duramax", pairPrice: 37000 },
    { name: "POLYCARBONATE Digital Progressive EasyFit Dura UV", pairPrice: 39000 },
    { name: "POLYCARBONATE Digital Progressive EasyFit DuraRelax", pairPrice: 32250 },
    { name: "POLYCARBONATE Digital Progressive Essential Steady Duramax", pairPrice: 47750 },
    { name: "POLYCARBONATE Digital Progressive Essential Steady DuraUV", pairPrice: 49750 },
    { name: "POLYCARBONATE Digital Progressive Essential Steady Dura Relax", pairPrice: 51750 },
    { name: "POLYCARBONATE Digital Progressive Endless Steady Duramax", pairPrice: 57750 },
    { name: "POLYCARBONATE Digital Progressive Endless Steady Dura UV", pairPrice: 59750 },
    { name: "POLYCARBONATE Digital Progressive Endless Steady DuraRelax", pairPrice: 61750 },
    
    // TRILOGY TRIVEX PAL
    { name: "TRILOGY TRIVEX Digital Progressive EasyFit Duramax", pairPrice: 55250 },
    { name: "TRILOGY TRIVEX Digital Progressive EasyFit DuraUV", pairPrice: 57250 },
    { name: "TRILOGY TRIVEX Digital Progressive EasyFit DuraRelax", pairPrice: 59250 },
    { name: "TRILOGY TRIVEX Digital Progressive Essential Steady Duramax", pairPrice: 65250 },
    { name: "TRILOGY TRIVEX Digital Progressive Essential Steady DuraUV", pairPrice: 67250 },
    { name: "TRILOGY TRIVEX Digital Progressive Essential Steady DuraRelax", pairPrice: 69500 },
    { name: "TRILOGY TRIVEX Digital Progressive Endless Steady Duramax", pairPrice: 72750 },
    { name: "TRILOGY TRIVEX Digital Progressive Endless Steady DuraUV", pairPrice: 74750 },
    { name: "TRILOGY TRIVEX Digital Progressive Endless Steady DuraRelax", pairPrice: 76750 },
    
    // NEOCHROMES PAL
    { name: "NEOCHROMES Digital Progressive EasyFit Duramax 1.5", pairPrice: 68750 },
    { name: "NEOCHROMES Digital Progressive EasyFit DuraUV 1.5", pairPrice: 72500 },
    { name: "NEOCHROMES Digital Progressive Essential Steady Duramax 1.5", pairPrice: 76250 },
    { name: "NEOCHROMES Digital Progressive Essential Steady DuraUV 1.5", pairPrice: 82500 },
    { name: "NEOCHROMES Digital Progressive Endless Steady Duramax 1.5", pairPrice: 87500 },
    { name: "NEOCHROMES Digital Progressive Endless Steady DuraUV 1.5", pairPrice: 95500 },
    { name: "NEOCHROMES POLYCARBONATE Digital Progressive EasyFit DuraUV 1.5", pairPrice: 90000 },
    { name: "NEOCHROMES POLYCARBONATE Digital Progressive Essential Steady DuraUV 1.5", pairPrice: 97500 },
    { name: "NEOCHROMES POLYCARBONATE Digital Progressive Endless Steady DuraUV 1.5", pairPrice: 99750 },
    
    // TRANSITION GEN 08 PAL
    { name: "TRANSITION GEN 08 Style Colors Digital Progressive EasyFit Duramax", pairPrice: 47250 },
    { name: "TRANSITION GEN 08 Style Colors Digital Progressive EasyFit DuraUV", pairPrice: 49750 },
    { name: "TRANSITION GEN 08 Style Colors Digital Progressive Essential Steady Duramax", pairPrice: 54750 },
    { name: "TRANSITION GEN 08 Style Colors Digital Progressive Essential Steady DuraUV", pairPrice: 57250 },
    { name: "TRANSITION GEN 08 Style Colors Digital Progressive Endless Steady Duramax", pairPrice: 82250 },
    { name: "TRANSITION GEN 08 Style Colors Digital Progressive Endless Steady DuraUV", pairPrice: 89750 },
    
    // TRANSITION GEN S PAL
    { name: "TRANSITION GEN S Style Colors Digital Progressive EasyFit Duramax", pairPrice: 72250 },
    { name: "TRANSITION GEN S Style Colors Digital Progressive EasyFit DuraUV", pairPrice: 77250 },
    { name: "TRANSITION GEN S Style Colors Digital Progressive Essential Steady Duramax", pairPrice: 87500 },
    { name: "TRANSITION GEN S Style Colors Digital Progressive Essential Steady DuraUV", pairPrice: 92500 },
    { name: "TRANSITION GEN S Style Colors Digital Progressive Endless Steady Duramax", pairPrice: 110000 },
    { name: "TRANSITION GEN S Style Colors Digital Progressive Endless Steady DuraUV", pairPrice: 112500 },
    
    // TRANSITION Xtractive PAL
    { name: "TRANSITION Xtractive Digital Progressive EasyFit Duramax", pairPrice: 107250 },
    { name: "TRANSITION Xtractive Digital Progressive EasyFit DuraUV", pairPrice: 114750 },
    { name: "TRANSITION Xtractive Digital Progressive EasyFit DuraRelax", pairPrice: 119750 },
    { name: "TRANSITION Xtractive Digital Progressive Essential Steady DuraUV", pairPrice: 119750 },
    { name: "TRANSITION Xtractive Digital Progressive Essential Steady DuraRelax", pairPrice: 119750 },
    { name: "TRANSITION Xtractive Digital Progressive Endless Steady DuraUV", pairPrice: 139750 },
    { name: "TRANSITION Xtractive Digital Progressive Endless Steady DuraRelax", pairPrice: 147250 },
    { name: "TRANSITION Xtractive Polarized Digital Progressive Essential Steady DuraUV", pairPrice: 190250 },
    { name: "TRANSITION Xtractive Polarized Digital Progressive Essential Steady DuraRelax", pairPrice: 197250 },
    { name: "TRANSITION Xtractive Polarized Digital Progressive Endless Steady DuraUV", pairPrice: 207250 },
    { name: "TRANSITION Xtractive Polarized Digital Progressive Endless Steady DuraRelax", pairPrice: 214750 },
    
    // NUPOLAR PAL
    { name: "NUPOLAR Digital Progressive EasyFit Duramax", pairPrice: 42250 },
    { name: "NUPOLAR Digital Progressive EasyFit DuraUV", pairPrice: 44750 },
    { name: "NUPOLAR Digital Progressive EasyFit DuraRelax", pairPrice: 46750 },
    { name: "NUPOLAR Digital Progressive Essential Steady Duramax", pairPrice: 49250 },
    { name: "NUPOLAR Digital Progressive Essential Steady DuraUV", pairPrice: 51250 },
    { name: "NUPOLAR Digital Progressive Essential Steady DuraRelax", pairPrice: 53250 },
    { name: "NUPOLAR Digital Progressive Endless Steady Duramax", pairPrice: 75000 },
    { name: "NUPOLAR Digital Progressive Endless Steady DuraUV", pairPrice: 77000 },
    { name: "NUPOLAR Digital Progressive Endless Steady DuraRelax", pairPrice: 78000 }
  ]
},












  GENERIC: {
    SV: [],
    BF: [],
    PAL: []
  },


};


const [leftLensBrand, setLeftLensBrand] =
  useState("");

const [leftLensType, setLeftLensType] =
  useState("");

const [leftLens, setLeftLens] =
  useState(null);

const [rightLensBrand, setRightLensBrand] =
  useState("");

const [rightLensType, setRightLensType] =
  useState("");

const [rightLens, setRightLens] =
  useState(null);

  











  useEffect(() => {

  let total = 0;

  if (leftLens) {
    total += leftLens.pairPrice / 2;
  }

  if (rightLens) {
    total += rightLens.pairPrice / 2;
  }

  setFormData(prev => ({
    ...prev,
    lensPrice: total.toFixed(2)
  }));

}, [leftLens, rightLens]);


















///////////////////////////////////////////// Add Item ////////////////////////////////////////////

// Add Items states
const [itemName, setItemName] = useState("");
const [itemPrice, setItemPrice] = useState("");


// Add Items handler
const handleAddItemforconsultation = async () => {
  // Validation
  if (!itemName.trim()) return alert("Item Name is required");
  if (!itemPrice) return alert("Price is required");
  if (parseFloat(itemPrice) <= 0) return alert("Price must be greater than 0");

  try {
    await addDoc(collection(db, "items"), {
      name: itemName.trim(),
      price: parseFloat(itemPrice),
      createdAt: serverTimestamp()
    });

    alert("Item added successfully!");
    handleClearItems();
  } catch (err) {
    console.error(err);
    alert("Failed to add item.");
  }
};

// Clear Items form
const handleClearItems = () => {
  setItemName("");
  setItemPrice("");
};










const handleLogout = () => {
  // Remove login token / session
  localStorage.removeItem("adminToken");

  // Redirect to login page
  window.location.href = "/";
};









/////////////////////////////////////////////////////// view supplier ////////////////////////////////////////////////////////////


  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState("");
  const [sortType, setSortType] = useState("newest");
  const [currentPage, setCurrentPage] = useState(1);
  const [editData, setEditData] = useState(null);

  const itemsPerPage = 5;

  // FETCH DATA
  const fetchSuppliers = async () => {
    try {
      const q = query(collection(db, "suppliers"), orderBy("createdAt", "desc"));
      const snapshot = await getDocs(q);
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setSuppliers(list);
      setFiltered(list);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchSuppliers();
  }, []);

  // SEARCH
  useEffect(() => {
    let data = [...suppliers];

    if (search) {
      data = data.filter((s) =>
        s.name.toLowerCase().includes(search.toLowerCase())
      );
    }

    // SORT
    if (sortType === "az") {
      data.sort((a, b) => a.name.localeCompare(b.name));
    } else if (sortType === "newest") {
      data.sort((a, b) => b.createdAt?.seconds - a.createdAt?.seconds);
    }

    setFiltered(data);
    setCurrentPage(1);
  }, [search, sortType, suppliers]);

  // DELETE
  const handleDelete = async (id) => {
    if (!window.confirm("Delete this supplier?")) return;
    await deleteDoc(doc(db, "suppliers", id));
    fetchSuppliers();
  };

  // UPDATE
  const handleUpdate = async () => {
    try {
      const ref = doc(db, "suppliers", editData.id);
      await updateDoc(ref, {
        name: editData.name,
        email: editData.email,
        phone: editData.phone,
        company: editData.company,
        address: editData.address,
      });
      setEditData(null);
      fetchSuppliers();
    } catch (err) {
      console.error(err);
    }
  };

  // PAGINATION
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = filtered.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filtered.length / itemsPerPage);


 
  

//////////////////////////////////////////////////// purchasing order //////////////////////////////////////////////////////////////////////

// Fetch suppliers from Firestore
useEffect(() => {
  const fetchSuppliers = async () => {
    const snapshot = await getDocs(collection(db, "suppliers"));
    const supplierData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    setSuppliers(supplierData);
  };

  fetchSuppliers();
}, []);

// Generate next PO number
useEffect(() => {
  const fetchLastPO = async () => {
    const q = query(
      collection(db, "purchasing_order"),
      orderBy("createdAt", "desc"),
      limit(1)
    );

    const snapshot = await getDocs(q);

    if (!snapshot.empty) {
      const lastPO = snapshot.docs[0].data().purchaseOrderNo;
      const lastNum = parseInt(lastPO.split("-").pop());
      const newNum = String(lastNum + 1).padStart(3, "0");
      setPurchaseOrderNo(`PO-${newNum}`);
    } else {
      setPurchaseOrderNo("PO-001");
    }
  };

  fetchLastPO();
}, [lensList, frameList]);

// Create PO
const handleCreatePurchaseOrder = async () => {
  if (!supplierName) return alert("Select a supplier");

  try {
    await addDoc(collection(db, "purchasing_order"), {
      purchaseOrderNo,
      supplierName,
      lensList,
      frameList,
      createdAt: serverTimestamp(),
    });

    alert("Purchase Order Created Successfully!");

    // Reset fields
    setLensList([]);
    setFrameList([]);
    setSupplierName("");

    // Update PO no
    const lastNum = parseInt(purchaseOrderNo.split("-").pop());
    const nextNum = String(lastNum + 1).padStart(3, "0");
    setPurchaseOrderNo(`PO-${nextNum}`);

  } catch (error) {
    console.error("Error creating PO:", error);
    alert("Failed to create purchase order. Check console for details.");
  }
};






/////////////////////////////////////////// Add Stock //////////////////////////////////////////////

const [selectedCategory, setSelectedCategory] = useState(""); // "lens" or "frame"

useEffect(() => {
  const fetchPurchaseOrders = async () => {
    const q = query(
      collection(db, "purchasing_order"),
      orderBy("createdAt", "desc")
    );
    const snapshot = await getDocs(q);
    const list = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setPurchaseOrders(list);
  };

  fetchPurchaseOrders();
}, []);








const handleAddItems = async () => {
  if (!selectedCategory) return alert("Select Lens or Frame");

  try {
    await addDoc(collection(db, "stock"), {
      purchaseOrderNo,
      supplierName,
      category: selectedCategory,
      purchaseDate,
      items,
      createdAt: serverTimestamp()
    });

    alert("Stock added successfully!");
    handleClear();
  } catch (err) {
    console.error(err);
    alert("Failed to add stock.");
  }
};




  // Clears the form fields
const handleClear = () => {
  setPurchaseOrderNo("");
  setSupplierName("");
  setPurchaseDate("");
  setSelectedCategory("");
  setItems([]);
};




const handleLoad = () => {
  if (!selectedCategory) return alert("Select Lens or Frame first");

  const selectedOrder = purchaseOrders.find(po => po.purchaseOrderNo === purchaseOrderNo);
  if (!selectedOrder) return;

  setSupplierName(selectedOrder.supplierName || "");
  setPurchaseDate(selectedOrder.createdAt
    ? selectedOrder.createdAt.toDate().toISOString().split("T")[0]
    : ""
  );

  // Load only lens or frame items
  const dataToLoad = selectedCategory === "lens" ? selectedOrder.lensList || [] : selectedOrder.frameList || [];

  const formattedItems = dataToLoad.map(item => ({ ...item, supplyQty: item.supplyQty || 0 }));
  setItems(formattedItems);
};






// Example: Update quantity of an item
const handleSupplyQtyChange = (index, value) => {
  const updatedItems = [...items];
  updatedItems[index].supplyQty = value;
  setItems(updatedItems);
};






 
  
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


  const [lensForm, setLensForm] = useState({
  
    sph: "",
    add: "",
    cyl: "",
    axis: "",
    model: "CR39",
    progressive: false,
    qty: ""
  });

  const [frameForm, setFrameForm] = useState({
  
    modelNo: "",
    brand: "",
    colour: "",
    sex: "",
    qty: ""
  });

  const handleLensAdd = () => {
    setLensList([...lensList, lensForm]);
    setLensForm({
      sph: "",
      add: "",
      cyl: "",
      axis: "",
      model: "CR39",
      progressive: false,
      qty: ""
    });
  };

  const handleFrameAdd = () => {
    setFrameList([...frameList, frameForm]);
    setFrameForm({
      modelNo: "",
      brand: "",
      colour: "",
      sex: "",
      qty: ""
    });
  };




////////////////////////////////////////////////////// Quick Stock add/////////////////////////////////////////////////////////

// State
const [lensFormquickAdd, setLensFormquickAdd] = useState({
  sph: 0,
  cyl: 0,
  add: 0,
  model: "",
  buyingPrice: "",
  sellingPrice: "",
  qty: "",
});

// Handle Input Change
const handleChange = (e) => {
  setLensFormquickAdd({
    ...lensFormquickAdd,
    [e.target.name]: e.target.value,
  });
};

// Add Lens to List
const handleAdd = () => {
  if (
    lensFormquickAdd.buyingPrice === "" ||
    lensFormquickAdd.sellingPrice === "" ||
    lensFormquickAdd.qty === ""
  ) {
    alert("Please fill all fields!");
    return;
  }

  setLensList([...lensList, lensFormquickAdd]);

  // Reset fields
  setLensFormquickAdd({
    sph: 0,
    cyl: 0,
    add: 0,
    model: "CR39 S/V",
    buyingPrice: "",
    sellingPrice: "",
    qty: "",
  });
};

// Clear Entire List
const clearList = () => {
  setLensList([]);
};


/////////////////////////////////////////////////////////////////////// Add Suppliers//////////////////////////////////////////////

// Add Supplier states
const [supplierEmail, setSupplierEmail] = useState("");
const [supplierPhone, setSupplierPhone] = useState("");
const [supplierCompany, setSupplierCompany] = useState("");
const [supplierAddress, setSupplierAddress] = useState("");
const [addingSupplier, setAddingSupplier] = useState(false);


// Add Supplier handler
const handleAddSupplier = async () => {
  // Validation
  if (!supplierName.trim()) {
    return alert("Supplier Name is required");
  }

  setAddingSupplier(true);

  try {
    await addDoc(collection(db, "suppliers"), {
      name: supplierName.trim(),
      email: supplierEmail.trim() || null,
      phone: supplierPhone.trim(),
      company: supplierCompany.trim(),
      address: supplierAddress.trim(),
      createdAt: serverTimestamp()
    });

    alert("Supplier added successfully!");
    handleClearSupplier();

  } catch (err) {
    console.error(err);
    alert("Failed to add supplier.");
  } finally {
    setAddingSupplier(false);
  }
};

// Clear Supplier form
const handleClearSupplier = () => {
  setSupplierName("");
  setSupplierEmail("");
  setSupplierPhone("");
  setSupplierCompany("");
  setSupplierAddress("");
};



  


////////////////////////////////////////////////////////////////////// stock report Hisotry report - stock history/////////////////////////////////////////////////////////
 
const [searchText, setSearchText] = useState("");
//////////////////////////////////////////////////////////////////////History report - stock history/////////////////////////////////////////////////////////
const [sunglassStockHistory, setSunglassStockHistory] = useState([]);
const [otherStockHistory, setOtherStockHistory] = useState([]);

const [filteredSunglassHistory, setFilteredSunglassHistory] = useState([]);
const [filteredOtherHistory, setFilteredOtherHistory] = useState([]);

const [historyCategory, setHistoryCategory] = useState("lens");
const [lensStockHistory, setLensStockHistory] = useState([]);
const [frameStockHistory, setFrameStockHistory] = useState([]);
const [loading, setLoading] = useState(false);
const [filterType, setFilterType] = useState("all"); // "all", "day", "month", "year"
const [filterValue, setFilterValue] = useState("");
const [filteredLensHistory, setFilteredLensHistory] = useState([]);
const [filteredFrameHistory, setFilteredFrameHistory] = useState([]);

// Function to filter data by date
// const filterByDate = (data, type, value) => {
//   if (type === "all" || !value) return data;
  
//   return data.filter(item => {
//     const itemDate = item.createdAt?.toDate();
//     if (!itemDate) return false;
    
//     switch(type) {
//       case "day":
//         const selectedDate = new Date(value);
//         return itemDate.toDateString() === selectedDate.toDateString();
      
//       case "month":
//         const selectedMonth = parseInt(value.split("-")[1]);
//         const selectedYear = parseInt(value.split("-")[0]);
//         return itemDate.getMonth() + 1 === selectedMonth && 
//                itemDate.getFullYear() === selectedYear;
      
//       case "year":
//         const selectedYearOnly = parseInt(value);
//         return itemDate.getFullYear() === selectedYearOnly;
      
//       default:
//         return true;
//     }
//   });
// };

// Function to filter data by date - FIXED to handle both Timestamp and string
// Function to filter data by date - SIMPLE FIX
const filterByDate = (data, type, value) => {
  if (type === "all" || !value) return data;
  
  return data.filter(item => {
    let itemDate = null;
    
    // Handle both Firestore Timestamp and string date
    if (item.createdAt) {
      if (typeof item.createdAt.toDate === 'function') {
        // Firestore Timestamp
        itemDate = item.createdAt.toDate();
      } else if (typeof item.createdAt === 'string') {
        // ISO string
        itemDate = new Date(item.createdAt);
      } else if (item.createdAt.seconds) {
        // Firestore Timestamp object
        itemDate = new Date(item.createdAt.seconds * 1000);
      }
    }
    
    if (!itemDate || isNaN(itemDate.getTime())) return false;
    
    switch(type) {
      case "day":
        const selectedDate = new Date(value);
        return itemDate.toDateString() === selectedDate.toDateString();
      
      case "month":
        const selectedMonth = parseInt(value.split("-")[1]);
        const selectedYear = parseInt(value.split("-")[0]);
        return itemDate.getMonth() + 1 === selectedMonth && 
               itemDate.getFullYear() === selectedYear;
      
      case "year":
        const selectedYearOnly = parseInt(value);
        return itemDate.getFullYear() === selectedYearOnly;
      
      default:
        return true;
    }
  });
};






// Helper function to safely format date for display
const formatDateDisplay = (createdAt) => {
  if (!createdAt) return "-";
  
  try {
    let date = null;
    if (typeof createdAt.toDate === 'function') {
      date = createdAt.toDate();
    } else if (typeof createdAt === 'string') {
      date = new Date(createdAt);
    } else if (createdAt.seconds) {
      date = new Date(createdAt.seconds * 1000);
    }
    
    if (date && !isNaN(date.getTime())) {
      return date.toLocaleDateString();
    }
    return "-";
  } catch (e) {
    return "-";
  }
};



// Helper function to safely format date for Excel export
const formatDateForExport = (createdAt) => {
  if (!createdAt) return "";
  
  try {
    let date = null;
    if (typeof createdAt.toDate === 'function') {
      date = createdAt.toDate();
    } else if (typeof createdAt === 'string') {
      date = new Date(createdAt);
    } else if (createdAt.seconds) {
      date = new Date(createdAt.seconds * 1000);
    } else if (createdAt instanceof Date) {
      date = createdAt;
    }
    
    if (date && !isNaN(date.getTime())) {
      return date.toLocaleDateString();
    }
    return "";
  } catch (error) {
    return "";
  }
};








// Function to apply search filter to ALL categories
const applySearchFilter = (data, searchTerm) => {
  if (!searchTerm || searchTerm.trim() === "") return data;
  
  return data.filter(stock =>
    stock.items?.some(item => {
      const searchableText = [
        item.brand || "",
        item.modelNo || "",
        item.model || "",
        item.colour || "",
        item.sph || "",
        item.add || "",
        item.cyl || "",
        item.axis || "",
        item.rPower || "",
        item.lPower || "",
        item.BaseCurve || "",
        item.itemName || "",
        item.size || ""
      ].join(" ").toLowerCase();
      
      return searchableText.includes(searchTerm.toLowerCase());
    })
  );
};

useEffect(() => {
  // Apply date filter first
  const lensByDate = filterByDate(lensStockHistory, filterType, filterValue);
  const frameByDate = filterByDate(frameStockHistory, filterType, filterValue);
  const sunglassByDate = filterByDate(sunglassStockHistory, filterType, filterValue);
  const otherByDate = filterByDate(otherStockHistory, filterType, filterValue);
  
  // Then apply search filter to ALL categories
  const lens = applySearchFilter(lensByDate, searchText);
  const frame = applySearchFilter(frameByDate, searchText);
  const sunglass = applySearchFilter(sunglassByDate, searchText);
  const other = applySearchFilter(otherByDate, searchText);
  
  setFilteredLensHistory(lens);
  setFilteredFrameHistory(frame);
  setFilteredSunglassHistory(sunglass);
  setFilteredOtherHistory(other);
}, [
  lensStockHistory,
  frameStockHistory,
  sunglassStockHistory,
  otherStockHistory,
  filterType,
  filterValue,
  searchText
]);

// Function to reset filters
const resetStockHistoryFilters = () => {
  setFilterType("all");
  setFilterValue("");
  setSearchText("");
};

// Function to export to Excel
// Function to export to Excel
const exportToExcel = () => {
  try {
    let exportData = [];
    let sheetName = "";
    
    if (historyCategory === "lens") {
      sheetName = "Lens_Stock_History";
      filteredLensHistory.forEach(stock => {
        if (stock.items && Array.isArray(stock.items)) {
          stock.items.forEach(item => {
            exportData.push({
              "Purchase Order No": stock.purchaseOrderNo || "",
              "Supplier Name": stock.supplierName || "",
              "Purchase Date": stock.purchaseDate || "",
              "Model": item.model || "",
              "SPH": item.sph || "",
              "Add": item.add || "",
              "CYL": item.cyl || "",
              "Axis": item.axis || "",
              "Is Progressive": item.progressive ? "Yes" : "No",
              "Available Qty": item.qty || 0,
              "Supply Qty": item.supplyQty || 0,
              "Status": item.supplyQty >= item.qty ? "Complete" : "Pending",
              "Stock Added Date": formatDateForExport(stock.createdAt),
              "Filter Applied": filterType === "all" ? "All Data" : 
                filterType === "day" ? `Date: ${filterValue}` :
                filterType === "month" ? `Month: ${filterValue}` : `Year: ${filterValue}`
            });
          });
        }
      });
    } else if (historyCategory === "frame") {
      sheetName = "Frame_Stock_History";
      filteredFrameHistory.forEach(stock => {
        if (stock.items && Array.isArray(stock.items)) {
          stock.items.forEach(item => {
            exportData.push({
              "Purchase Order No": stock.purchaseOrderNo || "",
              "Supplier Name": stock.supplierName || "",
              "Purchase Date": stock.purchaseDate || "",
              "Brand": item.brand || "",
              "Model No": item.modelNo || "",
              "Size": item.size || "",
              "Colour": item.colour || "",
              "Available Qty": item.qty || 0,
              "Supply Qty": item.supplyQty || 0,
              "Status": item.supplyQty >= item.qty ? "Complete" : "Pending",
              "Stock Added Date": formatDateForExport(stock.createdAt),
              "Filter Applied": filterType === "all" ? "All Data" : 
                filterType === "day" ? `Date: ${filterValue}` :
                filterType === "month" ? `Month: ${filterValue}` : `Year: ${filterValue}`
            });
          });
        }
      });
    } else if (historyCategory === "sunglass") {
      sheetName = "Sunglass_Stock_History";
      filteredSunglassHistory.forEach(stock => {
        stock.items?.forEach(item => {
          exportData.push({
            "Purchase Order No": stock.purchaseOrderNo || "",
            "Supplier Name": stock.supplierName || "",
            "Purchase Date": stock.purchaseDate || "",
            "Brand": item.brand || "",
            "Model No": item.modelNo || "",
            "Size": item.size || "",
            "Colour": item.colour || "",
            "Available Qty": item.qty || 0,
            "Supply Qty": item.supplyQty || 0,
            "Status": item.supplyQty >= item.qty ? "Complete" : "Pending",
            "Stock Added Date": formatDateForExport(stock.createdAt),
            "Filter Applied": filterType === "all" ? "All Data" : 
              filterType === "day" ? `Date: ${filterValue}` :
              filterType === "month" ? `Month: ${filterValue}` : `Year: ${filterValue}`
          });
        });
      });
    } else if (historyCategory === "other") {
      sheetName = "Other_Stock_History";
      filteredOtherHistory.forEach(stock => {
        stock.items?.forEach(item => {
          exportData.push({
            "Purchase Order No": stock.purchaseOrderNo || "",
            "Supplier Name": stock.supplierName || "",
            "Purchase Date": stock.purchaseDate || "",
            "Brand": item.brand || "",
            "Model No": item.modelNo || "",
            "R Power": item.rPower || "",
            "L Power": item.lPower || "",
            "Base Curve": item.BaseCurve || "",
            "Colour": item.colour || "",
            "Available Qty": item.qty || 0,
            "Supply Qty": item.supplyQty || 0,
            "Status": item.supplyQty >= item.qty ? "Complete" : "Pending",
            "Stock Added Date": formatDateForExport(stock.createdAt),
            "Filter Applied": filterType === "all" ? "All Data" : 
              filterType === "day" ? `Date: ${filterValue}` :
              filterType === "month" ? `Month: ${filterValue}` : `Year: ${filterValue}`
          });
        });
      });
    }
    
    if (exportData.length === 0) {
      alert("No data to export!");
      return;
    }
    
    // Create worksheet
    const ws = XLSX.utils.json_to_sheet(exportData);
    
    // Auto-size columns
    const colWidths = [];
    Object.keys(exportData[0]).forEach(key => {
      const maxLength = Math.max(
        key.length,
        ...exportData.map(row => String(row[key] || "").length)
      );
      colWidths.push({ wch: Math.min(maxLength + 2, 50) });
    });
    ws['!cols'] = colWidths;
    
    // Create workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    
    // Generate filename with current date and filter info
    const date = new Date();
    const dateStr = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    let filterStr = "";
    if (filterType !== "all") {
      filterStr = `_${filterType}_${filterValue.replace(/[^a-zA-Z0-9]/g, '-')}`;
    }
    const fileName = `${sheetName}${filterStr}_${dateStr}.xlsx`;
    
    // Save file
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, fileName);
    
    alert(`Successfully exported ${exportData.length} records to Excel!`);
  } catch (error) {
    console.error("Export error:", error);
    alert("Error exporting to Excel: " + error.message);
  }
};













// Update the useEffect to fetch stock history
useEffect(() => {
  const fetchStockHistory = async () => {
    setLoading(true);
    try {
      const q = query(
        collection(db, "stock"),
        orderBy("createdAt", "desc")
      );
      const snapshot = await getDocs(q);
      
      const lensStocks = [];
      const frameStocks = [];
      const sunglassStocks = [];
      const otherStocks = [];
      
      snapshot.docs.forEach(doc => {
        const stockData = { id: doc.id, ...doc.data() };
        if (stockData.category === "lens") {
          lensStocks.push(stockData);
        } else if (stockData.category === "frame") {
          frameStocks.push(stockData);
        } else if (stockData.category === "sunglass") {
          sunglassStocks.push(stockData);
        } else if (stockData.category === "other") {
          otherStocks.push(stockData);
        }
      });
      
      setLensStockHistory(lensStocks);
      setFrameStockHistory(frameStocks);
      setSunglassStockHistory(sunglassStocks);
      setOtherStockHistory(otherStocks);
    } catch (err) {
      console.error("Error fetching stock history:", err);
      alert("Failed to load stock history");
    } finally {
      setLoading(false);
    }
  };
  
  if (selectedOption === "StockHistory") {
    fetchStockHistory();
  }
}, [selectedOption]);



// Delete stock record
// Delete stock record - Now deletes individual stock records
const handleDeleteStock = async (id) => {
  const password = prompt("Enter authorization password");
  if (!password) return;
  
  if (password !== "rayban@142") {
    alert("Incorrect password!");
    return;
  }
  
  const confirmDelete = window.confirm(
    "Are you sure you want to delete this stock item?"
  );
  
  if (!confirmDelete) return;
  
  try {
    await deleteDoc(doc(db, "stock", id));
    
    // Remove from all state arrays
    setLensStockHistory(prev => prev.filter(x => x.id !== id));
    setFrameStockHistory(prev => prev.filter(x => x.id !== id));
    setSunglassStockHistory(prev => prev.filter(x => x.id !== id));
    setOtherStockHistory(prev => prev.filter(x => x.id !== id));
    
    alert("Record deleted successfully.");
  } catch (err) {
    console.error(err);
    alert("Failed to delete.");
  }
};








////////////////////////////////////////////////// Quick Add Stock /////////////////////////////////////////////////

// Quick Add Stock states
const [isAddingStock, setIsAddingStock] = useState(false);
const [quickSelectedCategory, setQuickSelectedCategory] = useState("");
const [quickSupplierName, setQuickSupplierName] = useState("");
const [quickPurchaseDate, setQuickPurchaseDate] = useState("");
const [quickItems, setQuickItems] = useState([]);
const [suppliersList, setSuppliersList] = useState([]);

// Fetch suppliers for quick add
useEffect(() => {
  const fetchSuppliers = async () => {
    try {
      const q = query(collection(db, "suppliers"), orderBy("name"));
      const snapshot = await getDocs(q);
      const suppliers = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setSuppliersList(suppliers);
    } catch (err) {
      console.error("Error fetching suppliers:", err);
    }
  };
  
  if (selectedOption === "quickAdd") {
    fetchSuppliers();
  }
}, [selectedOption]);





// Quick Add Stock handlers
const handleAddQuickItemRow = () => {
  if (!quickSelectedCategory) {
    alert("Please select a category first");
    return;
  }
  
  // Each item added will become its own stock record
  if (quickSelectedCategory === "lens") {
    setQuickItems([
      ...quickItems,
      {
        sph: "",
        add: "",
        cyl: "",
        axis: "",
        model: "",
        progressive: false,
        buyingPrice: "",
        sellingPrice: "",
        qty: "",
        supplyQty: "",
      }
    ]);
  } else if (quickSelectedCategory === "frame") {
    setQuickItems([
      ...quickItems,
      {
        brand: "",
        modelNo: "",
        size: "",
        colour: "",
        sex: "",
        qty: "",
        buyingPrice: "",
        sellingPrice: "",
        supplyQty: "",
      }
    ]);
  } else if (quickSelectedCategory === "sunglass") {
    setQuickItems([
      ...quickItems,
      {
        brand: "",
        modelNo: "",
        size: "",
        colour: "",
        sex: "",
        qty: "",
        buyingPrice: "",
        sellingPrice: "",
        supplyQty: "",
      }
    ]);
  } else if (quickSelectedCategory === "other") {
    setQuickItems([
      ...quickItems,
      {
        brand: "",
        modelNo: "",
        rPower: "",
        lPower: "",
        BaseCurve: "",
        colour: "",
        sex: "",
        qty: "",
        buyingPrice: "",
        sellingPrice: "",
        supplyQty: "",
      }
    ]);
  }
};









const handleQuickItemChange = (index, field, value) => {
  const updatedItems = [...quickItems];
  updatedItems[index][field] = value;
  setQuickItems(updatedItems);
};

const handleRemoveQuickItem = (index) => {
  const updatedItems = quickItems.filter((_, i) => i !== index);
  setQuickItems(updatedItems);
};





const handleQuickAddStock = async () => {
  if (isAddingStock) return;
  setIsAddingStock(true);

  try {
    // Validation
    if (!quickSelectedCategory) {
      alert("Please select a category");
      setIsAddingStock(false);
      return;
    }

    if (!quickSupplierName) {
      alert("Please select a supplier");
      setIsAddingStock(false);
      return;
    }

    if (!quickPurchaseDate) {
      alert("Please select purchase date");
      setIsAddingStock(false);
      return;
    }

    if (quickItems.length === 0) {
      alert("Please add at least one item");
      setIsAddingStock(false);
      return;
    }

    // Validate each item based on category - ONLY compulsory fields
    for (let i = 0; i < quickItems.length; i++) {
      const item = quickItems[i];

      if (quickSelectedCategory === "lens") {
        if (!item.model || item.qty <= 0 || item.supplyQty <= 0 || !item.sellingPrice) {
          alert(`Lens Item ${i + 1}: Please fill all required fields (Model, Qty, Supply Qty, Selling Price)`);
          setIsAddingStock(false);
          return;
        }
      } else if (quickSelectedCategory === "frame") {
        if (!item.brand || !item.modelNo || item.qty <= 0 || item.supplyQty <= 0 || !item.sellingPrice) {
          alert(`Frame Item ${i + 1}: Please fill all required fields (Brand, Model No, Qty, Supply Qty, Selling Price)`);
          setIsAddingStock(false);
          return;
        }
      } else if (quickSelectedCategory === "sunglass") {
        if (!item.brand || !item.modelNo || item.qty <= 0 || item.supplyQty <= 0 || !item.sellingPrice) {
          alert(`Sunglass Item ${i + 1}: Please fill all required fields (Brand, Model No, Qty, Supply Qty, Selling Price)`);
          setIsAddingStock(false);
          return;
        }
      } else if (quickSelectedCategory === "other") {
        if (!item.brand || !item.modelNo || item.qty <= 0 || item.supplyQty <= 0 || !item.sellingPrice) {
          alert(`Other Item ${i + 1}: Please fill all required fields (Brand, Model No, Qty, Supply Qty, Selling Price)`);
          setIsAddingStock(false);
          return;
        }
      }
    }

    const quickPONo = `QUICK-${Date.now()}`;

    // 🔥 NEW: Save each item as an INDIVIDUAL stock record
    for (let i = 0; i < quickItems.length; i++) {
      const item = quickItems[i];
      
      // Prepare item data for Firestore
      const stockData = {
        purchaseOrderNo: quickPONo,
        supplierName: quickSupplierName,
        category: quickSelectedCategory,
        purchaseDate: quickPurchaseDate,
        status: "In Stock",
        isQuickAdd: true,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };

      // Add category-specific fields
      if (quickSelectedCategory === "lens") {
        stockData.items = [{
          sph: item.sph || "",
          add: item.add || "",
          cyl: item.cyl || "",
          axis: item.axis || "",
          model: item.model || "",
          progressive: item.progressive || false,
          buyingPrice: parseFloat(item.buyingPrice) || 0,
          sellingPrice: parseFloat(item.sellingPrice) || 0,
          qty: parseInt(item.qty) || 0,
          supplyQty: parseInt(item.supplyQty) || 0
        }];
      } else if (quickSelectedCategory === "frame") {
        stockData.items = [{
          brand: item.brand || "",
          modelNo: item.modelNo || "",
          size: item.size || "",
          colour: item.colour || "",
          sex: item.sex || "",
          buyingPrice: parseFloat(item.buyingPrice) || 0,
          sellingPrice: parseFloat(item.sellingPrice) || 0,
          qty: parseInt(item.qty) || 0,
          supplyQty: parseInt(item.supplyQty) || 0
        }];
      } else if (quickSelectedCategory === "sunglass") {
        stockData.items = [{
          brand: item.brand || "",
          modelNo: item.modelNo || "",
          size: item.size || "",
          colour: item.colour || "",
          sex: item.sex || "",
          buyingPrice: parseFloat(item.buyingPrice) || 0,
          sellingPrice: parseFloat(item.sellingPrice) || 0,
          qty: parseInt(item.qty) || 0,
          supplyQty: parseInt(item.supplyQty) || 0
        }];
      } else if (quickSelectedCategory === "other") {
        stockData.items = [{
          brand: item.brand || "",
          modelNo: item.modelNo || "",
          rPower: item.rPower || "",
          lPower: item.lPower || "",
          BaseCurve: item.BaseCurve || "",
          colour: item.colour || "",
          buyingPrice: parseFloat(item.buyingPrice) || 0,
          sellingPrice: parseFloat(item.sellingPrice) || 0,
          qty: parseInt(item.qty) || 0,
          supplyQty: parseInt(item.supplyQty) || 0
        }];
      }

      // Save individual record
      await addDoc(collection(db, "stock"), stockData);
    }

    alert(`${quickItems.length} item(s) added successfully!`);
    handleClearQuickForm();

  } catch (err) {
    console.error("Error adding stock:", err);
    alert("Failed to add stock. Please try again.");
  } finally {
    setIsAddingStock(false);
  }
};





const handleClearQuickForm = () => {
  setQuickSelectedCategory("");
  setQuickSupplierName("");
  setQuickPurchaseDate("");
  setQuickItems([]);
};

////////////////////////////// high index lens //////////////////////////////////////////////////////////

const [isHighIndexLens, setIsHighIndexLens] = useState(false);

const [highIndexLeftBrand, setHighIndexLeftBrand] = useState("");
const [highIndexLeftType, setHighIndexLeftType] = useState("");
const [highIndexLeftName, setHighIndexLeftName] = useState("");
const [highIndexLeftPrice, setHighIndexLeftPrice] = useState(0);

const [highIndexRightBrand, setHighIndexRightBrand] = useState("");
const [highIndexRightType, setHighIndexRightType] = useState("");
const [highIndexRightName, setHighIndexRightName] = useState("");
const [highIndexRightPrice, setHighIndexRightPrice] = useState(0);






///////////////////////////////////////// create invoice /////////////////////////////////////////////////////
// Frame & Lens Discount States
const [frameDiscountType, setFrameDiscountType] = useState('amount'); // 'amount' or 'percentage'
const [frameDiscountValue, setFrameDiscountValue] = useState('');
const [lensDiscountType, setLensDiscountType] = useState('amount'); // 'amount' or 'percentage'
const [lensDiscountValue, setLensDiscountValue] = useState('');

// Additional Charges States
const [ownNylonCharge, setOwnNylonCharge] = useState(false);
const [ownRimlessCharge, setOwnRimlessCharge] = useState(false);
const [fittingCharge, setFittingCharge] = useState(false);
const [tintCharge, setTintCharge] = useState(false);
const [expressCharge, setExpressCharge] = useState(false);

// Fixed amounts
const OWN_NYLON_AMOUNT = 500;
const OWN_RIMLESS_AMOUNT = 500;
const FITTING_CHARGE_AMOUNT = 500;
const TINT_CHARGE_AMOUNT = 400;
const EXPRESS_CHARGE_AMOUNT = 450;





// Add this with your other state declarations
const [eyeCamps, setEyeCamps] = useState([]);
const [selectedEyeCamp, setSelectedEyeCamp] = useState('all');

// Add this with your other state declarations
const [applyVAT, setApplyVAT] = useState(false);
  // State for invoice number management
  const [currentInvoiceNumber, setCurrentInvoiceNumber] = useState('');
  



// Invoice number states
const [currentMainInvoiceNumber, setCurrentMainInvoiceNumber] = useState(''); // INV-XXX
const [currentTypeNumber, setCurrentTypeNumber] = useState(''); // RX or VIP number
const [invoiceType, setInvoiceType] = useState('RX'); // 'RX' or 'VIP'
const [lastRxNumber, setLastRxNumber] = useState(139370);
const [lastVipNumber, setLastVipNumber] = useState(7288);




  // State declarations
  const [showSuccess, setShowSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [frameSearchTerm, setFrameSearchTerm] = useState('');
  const [frameSuggestions, setFrameSuggestions] = useState([]);
  const [showFrameSuggestions, setShowFrameSuggestions] = useState(false);
  const [availableFrames, setAvailableFrames] = useState([]);
  const [lensOptions, setLensOptions] = useState([]);

  // Form data state
  const [formData, setFormData] = useState({
    // Customer Information
    salePerson: '',
    title: '',
    firstName: '',
    lastName: '',
    address: '',
    tpNo: '',
    email: '',
    age: '',
    
    // Prescription
  prescriptionDate: '',
  referredBy: 'OWN',
  pd: '',        // Right PD
  lpd: '',       // Left PD
  sh: '',
  fpd: '',       // Full PD
  rInsert: '',   // R-INSERT (auto-calculated, read-only)
  lInsert: '',   // L-INSERT (auto-calculated, read-only)
    
    // Right Eye
    rightVisualAcuity: '',
    rightSph: '',
    rightCyl: '',
    rightAxis: '',
    rightAdd: '',
    rightNearVA: '',
    
    // Left Eye
    leftVisualAcuity: '',
    leftSph: '',
    leftCyl: '',
    leftAxis: '',
    leftAdd: '',
    leftNearVA: '',
    
    // Lens & Frame
    leftLensModel: '',
    rightLensModel: '',

    lensModel: '',
    lensPrice: '',
    frameModel: '',
    framePrice: '',
    brand: '',
    colour: '',
    size: '',
    selectedFrameId: '',
    selectedLensId: '',
    
    // Pricing & Delivery
    deliveryDate: '',
    discount: '',
    advancePayment: '',
    billDescription: 'Frame and Lenses',
    paymentMethod: 'Cash'
  });







useEffect(() => {
  const init = async () => {
    await fetchFramesData();
    await fetchStockItems();
    
    // Generate main invoice number
    await generateNextInvoiceNumber();
    
    // Get next RX number (without incrementing)
    const rxNum = await getNextRxNumber();
    setCurrentTypeNumber(rxNum);
  };
  init();
}, []);








// Auto-calculate R-INSERT and L-INSERT
useEffect(() => {
  const rightPD = parseFloat(formData.pd) || 0;
  const leftPD = parseFloat(formData.lpd) || 0;
  const fpd = parseFloat(formData.fpd) || 0;

  if (fpd > 0 && rightPD > 0) {
    const rInsert =  (fpd / 2) - rightPD;
    setFormData(prev => ({
      ...prev,
      rInsert: rInsert.toFixed(2)
    }));
  }

  if (fpd > 0 && leftPD > 0) {
    const lInsert = (fpd / 2) - leftPD;
    setFormData(prev => ({
      ...prev,
      lInsert: lInsert.toFixed(2)
    }));
  }
}, [formData.pd, formData.lpd, formData.fpd]);




// Calculate totals with all discounts and charges
const calculateTotalWithAllCharges = () => {
  // Base prices
  const framePrice = parseFloat(formData.framePrice) || 0;
  const lensPrice = parseFloat(formData.lensPrice) || 0;
  const generalDiscount = parseFloat(formData.discount) || 0;
  
  // Frame Discount
  let frameDiscountAmount = 0;
  if (frameDiscountValue) {
    if (frameDiscountType === 'percentage') {
      frameDiscountAmount = framePrice * (parseFloat(frameDiscountValue) / 100);
    } else {
      frameDiscountAmount = parseFloat(frameDiscountValue) || 0;
    }
  }
  
  // Lens Discount
  let lensDiscountAmount = 0;
  if (lensDiscountValue) {
    if (lensDiscountType === 'percentage') {
      lensDiscountAmount = lensPrice * (parseFloat(lensDiscountValue) / 100);
    } else {
      lensDiscountAmount = parseFloat(lensDiscountValue) || 0;
    }
  }
  
  // Additional Charges
  let additionalCharges = 0;
  if (ownNylonCharge) additionalCharges += OWN_NYLON_AMOUNT;
  if (ownRimlessCharge) additionalCharges += OWN_RIMLESS_AMOUNT;
  if (fittingCharge) additionalCharges += FITTING_CHARGE_AMOUNT;
  if (tintCharge) additionalCharges += TINT_CHARGE_AMOUNT;
  if (expressCharge) additionalCharges += EXPRESS_CHARGE_AMOUNT;
  
  // Subtotal after item discounts
  const subtotal = framePrice + lensPrice;
  const totalDiscounts = frameDiscountAmount + lensDiscountAmount + generalDiscount;
  const subtotalAfterDiscount = subtotal - totalDiscounts;
  
  // VAT
  const vatAmount = applyVAT ? subtotalAfterDiscount * 0.18 : 0;
  
  // Final total
  const total = subtotalAfterDiscount + vatAmount + additionalCharges;



  
  return {
    framePrice,
    lensPrice,
    frameDiscountAmount,
    lensDiscountAmount,
    generalDiscount,
    subtotal,
    totalDiscounts,
    subtotalAfterDiscount,
    vatAmount,
    additionalCharges,
    total
  };
};

const totals = calculateTotalWithAllCharges();
const totalAmount = totals.total;





























  // Errors state
  const [errors, setErrors] = useState({});

 


  // Validate form
  const validateForm = () => {
    const newErrors = {};
    if (!formData.salePerson.trim()) newErrors.salePerson = 'sales Person is required';
    if (!formData.firstName.trim()) newErrors.firstName = 'First name is required';
    if (!formData.lastName.trim()) newErrors.lastName = 'Last name is required';
    if (!formData.address.trim()) newErrors.address = 'Address is required';
    if (!formData.tpNo.trim()) newErrors.tpNo = 'Phone number is required';
    
    return newErrors;
  };

  


// Generate next main invoice number (INV-XXX) - ALWAYS sequential
const generateNextInvoiceNumber = async () => {
  try {
    const invoicesRef = collection(db, 'invoices');
    const q = query(invoicesRef, orderBy('invoiceNumber', 'desc'), limit(1));
    const querySnapshot = await getDocs(q);
    
    let lastNumber = 0;
    
    if (!querySnapshot.empty) {
      const lastInvoice = querySnapshot.docs[0].data();
      const lastInvoiceNum = lastInvoice.invoiceNumber;
      
      // Extract numeric part from INV-XXX format
      const match = lastInvoiceNum.match(/INV-(\d+)/);
      if (match) {
        lastNumber = parseInt(match[1]);
      }
    }
    
    const nextNumber = lastNumber + 1;
    const formattedNumber = `INV-${nextNumber.toString().padStart(3, '0')}`;
    setCurrentMainInvoiceNumber(formattedNumber);
    return formattedNumber;
  } catch (error) {
    console.error('Error generating invoice number:', error);
    const fallbackNumber = `INV-${Date.now().toString().slice(-3)}`;
    setCurrentMainInvoiceNumber(fallbackNumber);
    return fallbackNumber;
  }
};






// =============================================
// THE REAL FIX - Use a counter document
// =============================================

const COUNTER_DOC_ID = 'invoiceCounters'; // Single document


// Update counter document with RX and VIP numbers
const initCounterDocument = async () => {
  const counterRef = doc(db, 'counters', COUNTER_DOC_ID);
  const counterDoc = await getDoc(counterRef);
  
  if (!counterDoc.exists()) {
    await setDoc(counterRef, {
      lastCLNumber: 4701,
      lastSNumber: 2722,
      lastRXNumber: 139370,
      lastVIPNumber: 7288,
      lastRNumber: 2880
    });
    console.log('✅ Counter document created');
  } else {
    const data = counterDoc.data();
    const updates = {};
    if (data.lastRXNumber === undefined) updates.lastRXNumber = 139370;
    if (data.lastVIPNumber === undefined) updates.lastVIPNumber = 7288;
    if (data.lastRNumber === undefined) updates.lastRNumber = 2880;
    
    if (Object.keys(updates).length > 0) {
      await updateDoc(counterRef, updates);
      console.log('✅ Added missing fields to counter');
    }
  }
};

// =============================================
// 3. GET NEXT RX NUMBER - From counter document
// =============================================

const getNextRxNumber = async () => {
  try {
    const counterRef = doc(db, 'counters', COUNTER_DOC_ID);
    const counterDoc = await getDoc(counterRef);
    
    if (!counterDoc.exists()) {
      await initCounterDocument();
      return '139371';
    }
    
    const data = counterDoc.data();
    const lastNumber = data.lastRXNumber || 139370;
    const nextNumber = lastNumber + 1;
    
    console.log(`📊 Next RX number: ${nextNumber}`);
    return nextNumber.toString();
  } catch (error) {
    console.error('Error getting RX number:', error);
    return '139371';
  }
};

// =============================================
// 4. GET NEXT VIP NUMBER - From counter document
// =============================================

const getNextVipNumber = async () => {
  try {
    const counterRef = doc(db, 'counters', COUNTER_DOC_ID);
    const counterDoc = await getDoc(counterRef);
    
    if (!counterDoc.exists()) {
      await initCounterDocument();
      return '007289';
    }
    
    const data = counterDoc.data();
    const lastNumber = data.lastVIPNumber || 7288;
    const nextNumber = lastNumber + 1;
    
    console.log(`📊 Next VIP number: ${String(nextNumber).padStart(6, '0')}`);
    return String(nextNumber).padStart(6, '0');
  } catch (error) {
    console.error('Error getting VIP number:', error);
    return '007289';
  }
};

// =============================================
// 5. GENERATE RX NUMBER - Update counter document
// =============================================

const generateAndIncrementRxNumber = async () => {
  try {
    const counterRef = doc(db, 'counters', COUNTER_DOC_ID);
    
    const result = await runTransaction(db, async (transaction) => {
      const counterDoc = await transaction.get(counterRef);
      
      if (!counterDoc.exists()) {
        transaction.set(counterRef, {
          lastCLNumber: 4701,
          lastSNumber: 2722,
          lastRXNumber: 139370,
          lastVIPNumber: 7288,
          lastRNumber: 2880
        });
        return 139371;
      }
      
      const data = counterDoc.data();
      const currentNumber = (data.lastRXNumber || 139370) + 1;
      
      transaction.update(counterRef, {
        lastRXNumber: currentNumber
      });
      
      return currentNumber;
    });
    
    setLastRxNumber(result);
    setCurrentTypeNumber((result + 1).toString());
    
    console.log(`✅ GENERATED RX: ${result}`);
    return result.toString();
    
  } catch (error) {
    console.error('Error generating RX number:', error);
    const currentNumber = lastRxNumber + 1;
    setLastRxNumber(currentNumber);
    setCurrentTypeNumber((currentNumber + 1).toString());
    return currentNumber.toString();
  }
};

// =============================================
// 6. GENERATE VIP NUMBER - Update counter document
// =============================================

const generateAndIncrementVipNumber = async () => {
  try {
    const counterRef = doc(db, 'counters', COUNTER_DOC_ID);
    
    const result = await runTransaction(db, async (transaction) => {
      const counterDoc = await transaction.get(counterRef);
      
      if (!counterDoc.exists()) {
        transaction.set(counterRef, {
          lastCLNumber: 4701,
          lastSNumber: 2722,
          lastRXNumber: 139370,
          lastVIPNumber: 7288,
          lastRNumber: 2880
        });
        return 7289;
      }
      
      const data = counterDoc.data();
      const currentNumber = (data.lastVIPNumber || 7288) + 1;
      
      transaction.update(counterRef, {
        lastVIPNumber: currentNumber
      });
      
      return currentNumber;
    });
    
    setLastVipNumber(result);
    setCurrentTypeNumber(String(result + 1).padStart(6, '0'));
    
    console.log(`✅ GENERATED VIP: ${String(result).padStart(6, '0')}`);
    return String(result).padStart(6, '0');
    
  } catch (error) {
    console.error('Error generating VIP number:', error);
    const currentNumber = lastVipNumber + 1;
    setLastVipNumber(currentNumber);
    setCurrentTypeNumber(String(currentNumber + 1).padStart(6, '0'));
    return String(currentNumber).padStart(6, '0');
  }
};

// =============================================
// 7. HANDLE INVOICE TYPE CHANGE - From counter
// =============================================

const handleInvoiceTypeChange = async (e) => {
  const type = e.target.value;
  setInvoiceType(type);
  
  if (type === 'RX') {
    const rxNum = await getNextRxNumber();
    setCurrentTypeNumber(rxNum);
  } else {
    const vipNum = await getNextVipNumber();
    setCurrentTypeNumber(vipNum);
  }
};

// =============================================
// 8. INITIALIZATION - From counter document
// =============================================

const initializeMainInvoiceNumbers = async () => {
  try {
    const counterRef = doc(db, 'counters', COUNTER_DOC_ID);
    const counterDoc = await getDoc(counterRef);
    
    let lastRX = 139370;
    let lastVIP = 7288;
    
    if (counterDoc.exists()) {
      const data = counterDoc.data();
      lastRX = data.lastRXNumber || 139370;
      lastVIP = data.lastVIPNumber || 7288;
    } else {
      await initCounterDocument();
    }
    
    setLastRxNumber(lastRX);
    setLastVipNumber(lastVIP);
    
    if (invoiceType === 'RX') {
      setCurrentTypeNumber((lastRX + 1).toString());
    } else {
      setCurrentTypeNumber(String(lastVIP + 1).padStart(6, '0'));
    }
    
    // Main invoice number
    const savedMain = localStorage.getItem('displayMainInvoice');
    if (savedMain) {
      setCurrentMainInvoiceNumber(savedMain);
    } else {
      const mainNum = await generateNextInvoiceNumber();
      setCurrentMainInvoiceNumber(mainNum);
      localStorage.setItem('displayMainInvoice', mainNum);
    }
    
    console.log(`✅ Main Initialized: RX=${lastRX + 1}, VIP=${String(lastVIP + 1).padStart(6, '0')}`);
    
  } catch (error) {
    console.error('Error initializing main invoice numbers:', error);
    setCurrentTypeNumber('139371');
  }
};




// =============================================
// 9. RECOVERY FUNCTION - From counter document
// =============================================

const recoverInvoiceNumbers = async () => {
  try {
    console.log("🔄 Running invoice number recovery...");
    
    const counterRef = doc(db, 'counters', COUNTER_DOC_ID);
    const counterDoc = await getDoc(counterRef);
    
    let maxRX = 139370;
    let maxVIP = 7288;
    
    if (counterDoc.exists()) {
      const data = counterDoc.data();
      maxRX = data.lastRXNumber || 139370;
      maxVIP = data.lastVIPNumber || 7288;
    }
    
    setLastRxNumber(maxRX);
    setLastVipNumber(maxVIP);
    
    if (invoiceType === 'RX') {
      setCurrentTypeNumber((maxRX + 1).toString());
    } else {
      setCurrentTypeNumber(String(maxVIP + 1).padStart(6, '0'));
    }
    
    console.log(`✅ Recovery: Next RX=${maxRX + 1}, Next VIP=${String(maxVIP + 1).padStart(6, '0')}`);
    
  } catch (error) {
    console.error("Recovery failed:", error);
  }
};

// =============================================
// 10. REFRESH FUNCTIONS - From counter document
// =============================================

const refreshInvoiceNumbers = async () => {
  try {
    const mainNum = await generateNextInvoiceNumber();
    setCurrentMainInvoiceNumber(mainNum);
    
    if (invoiceType === 'RX') {
      const rxNum = await getNextRxNumber();
      setCurrentTypeNumber(rxNum);
    } else {
      const vipNum = await getNextVipNumber();
      setCurrentTypeNumber(vipNum);
    }
  } catch (error) {
    console.error('Error refreshing invoice numbers:', error);
  }
};






// Call this when the component mounts or when switching to this tab
useEffect(() => {
  const init = async () => {
    await fetchFramesData();
    await fetchStockItems();
    await initCounterDocument();
    await initializeMainInvoiceNumbers();  // ✅ Changed name
    await refreshInvoiceNumbers();
  };
  init();
}, [selectedOption]);







  // Function to refresh/snapshot the invoice number
  const refreshInvoiceNumber = async () => {
    const newNumber = await generateNextInvoiceNumber();
    return newNumber;
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  // Reset form
  const handleResetForm = () => {
    setFormData({
      salePerson: '',
      title: '',
      firstName: '',
      lastName: '',
      address: '',
      tpNo: '',
      email: '',
      age: '',
      prescriptionDate: '',
      referredBy: 'OWN',
      pd: '',
      lpd: '',
      sh: '',
      fpd: '',
      rInsert: '',
      lInsert: '',
      rightVisualAcuity: '',
      rightSph: '',
      rightCyl: '',
      rightAxis: '',
      rightAdd: '',
      rightNearVA: '',
      leftVisualAcuity: '',
      leftSph: '',
      leftCyl: '',
      leftAxis: '',
      leftAdd: '',
      leftNearVA: '',
      lensModel: '',
      lensPrice: '',
      frameModel: '',
      framePrice: '',
      brand: '',
      colour: '',
      size: '',
      selectedFrameId: '',
      selectedLensId: '',
      deliveryDate: '',
      discount: '',
      advancePayment: '',
      billDescription: 'Frame and Lenses',
      paymentMethod: 'Cash'
    });
    setFrameSearchTerm('');
    setErrors({});
    setShowFrameSuggestions(false);
    setFrameSuggestions([]);
    

    setFrameDiscountType('amount');
  setFrameDiscountValue('');
  setLensDiscountType('amount');
  setLensDiscountValue('');
  setOwnNylonCharge(false);
  setOwnRimlessCharge(false);
  setFittingCharge(false);
  setTintCharge(false);
  setExpressCharge(false);
  setFrameSearchTerm('');
  setErrors({});
  setShowFrameSuggestions(false);
  setFrameSuggestions([]);

  };







const generateCustomerPrescriptionPDF = async (invoiceData) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a5"
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  let y = 12; // Reduced initial margin
  const lineHeight = 4.5; // Minimum space between lines
  const sectionGap = 2; // Gap between sections

  // Helper function to format date safely
  const formatDateSafe = (dateValue) => {
    if (!dateValue) return "-";
    try {
      if (dateValue.toDate) {
        return dateValue.toDate().toLocaleDateString();
      } else if (dateValue.seconds) {
        return new Date(dateValue.seconds * 1000).toLocaleDateString();
      } else if (typeof dateValue === 'string') {
        return new Date(dateValue).toLocaleDateString();
      } else if (dateValue instanceof Date) {
        return dateValue.toLocaleDateString();
      }
      return "Invalid Date";
    } catch (e) {
      return "Invalid Date";
    }
  };

  // Helper to add line with minimum spacing
  const addLine = (text, x, yPos, options = {}) => {
    doc.text(text, x, yPos, options);
    return yPos + lineHeight;
  };

  // ------------------------------
  // HEADER WITH LOGO
  // ------------------------------

  doc.setFontSize(9);

  doc.text(`Date: ${formatDateSafe(invoiceData.createdAt)}`, pageWidth - 8, y + 26, { align: "right" });

  y = 18;


  // ------------------------------
  // TITLE
  // ------------------------------
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("ORDER FORM", pageWidth / 2, y, { align: "center" });
  y += 5;



  // ------------------------------
  // PATIENT DETAILS - Compact
  // ------------------------------
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.text("Customer Details", 8, y);
  y += 5;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);

  // Two columns for patient details
  const leftCol = 8;
  const rightCol = pageWidth / 2 + 5;
  
   
  // Left column
  y = addLine(`Invoice: ${invoiceData.invoiceNumber}`, leftCol, y);
  if (invoiceData.invoiceType === 'RX') {
    y = addLine(`RX No: ${invoiceData.rxNumber}`, leftCol, y);
  } else {
    y = addLine(`VIP No: ${invoiceData.vipNumber}`, leftCol, y);
  }
  
 
  y = addLine(`Name: ${invoiceData.customer.fullName}`, leftCol, y);
 y = addLine(`Contact No: ${invoiceData.customer.tpNo}`, leftCol, y);
 y = addLine(`Address: ${invoiceData.customer.address}`, leftCol, y);



  y += sectionGap;
 doc.setFont("helvetica", "normal");






  // ------------------------------
  // FRAME DETAILS - Single line
  // ------------------------------
const frame = invoiceData.products || {};
const frameModel = frame.frameModel || frame.modelNo || "-";
const frameBrand = frame.brand || frame.frameBrand || "-";
const frameSize = frame.size || frame.frameSize || "-";
const frameColor = frame.colour || frame.frameColour || "-";

const framePrice = frame.framePrice || 0;

  y = addLine(`Frame: ${frameBrand}   /  ${frameModel}  /  ${frameSize}  /  ${frameColor}`, leftCol, y);
  doc.text(`Rs. ${framePrice.toFixed(2)}`, pageWidth - 8, y - lineHeight, { align: "right" });

  y += sectionGap;





  // ------------------------------
  // LENS DETAILS - Compact
  // ------------------------------
  const leftLens = invoiceData.products?.highIndexLens
    ? invoiceData.products.highIndexLeft
    : (invoiceData.products?.leftLens || {});

  const rightLens = invoiceData.products?.highIndexLens
    ? invoiceData.products.highIndexRight
    : (invoiceData.products?.rightLens || {});



      // RIGHT LENS
  const rightLensPrice = invoiceData.products?.highIndexLens
    ? (rightLens.price || 0)
    : ((rightLens.pairPrice || 0) / 2);

  const rightText = `R: ${rightLens.brand || "-"} ${rightLens.type || "-"} ${rightLens.name || "-"}`;
  y = addLine(rightText, leftCol, y);
  doc.text(`Rs. ${rightLensPrice.toFixed(2)}`, pageWidth - 8, y - lineHeight, { align: "right" });



  // LEFT LENS
  const leftLensPrice = invoiceData.products?.highIndexLens
    ? (leftLens.price || 0)
    : ((leftLens.pairPrice || 0) / 2);

  const leftText = `L: ${leftLens.brand || "-"} ${leftLens.type || "-"} ${leftLens.name || "-"}`;
  y = addLine(leftText, leftCol, y);
  doc.text(`Rs. ${leftLensPrice.toFixed(2)}`, pageWidth - 8, y - lineHeight, { align: "right" });







 
// ------------------------------ 
// PRESCRIPTION SECTION 
// ------------------------------ 
doc.setFillColor(255, 255, 255);
doc.rect(8, y - 3, pageWidth - 16, 5, "F");
doc.setTextColor(0, 0, 0);
doc.setFont("helvetica", "bold");
doc.setFontSize(7);
doc.text("Prescription", 7, y);
doc.setTextColor(0, 0, 0);
y += 5;
doc.setFont("helvetica", "normal");
doc.setFontSize(7);

// ------------------------------ 
// PRESCRIPTION TABLE FIRST - Compact 
// ------------------------------ 
const p = invoiceData.prescription || {};
const tableWidth = 100;
const tableStartX = (pageWidth - tableWidth) / 2;
const rowHeight = 4.5;
const eyeCol = 25;
const sphCol = 18;
const cylCol = 18;
const axisCol = 18;
const addCol = 18;

doc.setLineWidth(0.15);
doc.setFont("helvetica", "bold");
doc.setFontSize(6);

// Header 
doc.rect(tableStartX, y, tableWidth, rowHeight);
const headerTexts = ["Eye", "SPH", "CYL", "AXIS", "ADD"];
const headerPositions = [
  tableStartX + 3,
  tableStartX + eyeCol + 3,
  tableStartX + eyeCol + sphCol + 3,
  tableStartX + eyeCol + sphCol + cylCol + 3,
  tableStartX + eyeCol + sphCol + cylCol + axisCol + 3
];
headerTexts.forEach((text, i) => {
  doc.text(text, headerPositions[i], y + 3);
});
y += rowHeight;

doc.setFont("helvetica", "normal");

// Right Eye 
doc.rect(tableStartX, y, tableWidth, rowHeight);
const rightValues = ["Right Eye", p.rightEye?.sph || "-", p.rightEye?.cyl || "-", p.rightEye?.axis || "-", p.rightEye?.add || "-"];
rightValues.forEach((text, i) => {
  doc.text(text, headerPositions[i], y + 3);
});
[eyeCol, eyeCol + sphCol, eyeCol + sphCol + cylCol, eyeCol + sphCol + cylCol + axisCol].forEach(pos => {
  doc.line(tableStartX + pos, y, tableStartX + pos, y + rowHeight);
});
y += rowHeight;

// Left Eye 
doc.rect(tableStartX, y, tableWidth, rowHeight);
const leftValues = ["Left Eye", p.leftEye?.sph || "-", p.leftEye?.cyl || "-", p.leftEye?.axis || "-", p.leftEye?.add || "-"];
leftValues.forEach((text, i) => {
  doc.text(text, headerPositions[i], y + 3);
});
[eyeCol, eyeCol + sphCol, eyeCol + sphCol + cylCol, eyeCol + sphCol + cylCol + axisCol].forEach(pos => {
  doc.line(tableStartX + pos, y, tableStartX + pos, y + rowHeight);
});
y += 8;

// PD and SH in one line (AFTER TABLE)
doc.setFont("helvetica", "normal");
doc.setFontSize(7);
const pdData = [
  `R PD: ${invoiceData.prescription?.pd || "-"}`,
  `L PD: ${invoiceData.prescription?.lpd || "-"}`,
  `SH: ${invoiceData.prescription?.sh || "-"}`,
  `FPD: ${invoiceData.prescription?.fpd || "-"}`
];
let xPos = leftCol;
pdData.forEach((text, index) => {
  doc.text(text, xPos, y);
  xPos += 28;
});
y += lineHeight;

// INSERT values (AFTER PD/SH)
doc.text(`R-INSERT: ${invoiceData.prescription?.rInsert || "-"}`, leftCol, y);
doc.text(`L-INSERT: ${invoiceData.prescription?.lInsert || "-"}`, leftCol + 40, y);
y += 8;


// CORRECTED mapping based on your data structure
// INSERT values (AFTER PD/SH)
doc.text(`R-Prism: ${invoiceData.prescription?.rightEye?.visualAcuity || "-"}`, leftCol, y);
doc.text(`R Remark: ${invoiceData.prescription?.rightEye?.nearVA || "-"}`, leftCol + 20, y);
doc.text(`L-Prism: ${invoiceData.prescription?.leftEye?.visualAcuity || "-"}`, leftCol + 70, y);
doc.text(`L Remark: ${invoiceData.prescription?.leftEye?.nearVA || "-"}`, leftCol + 90, y);
y += 8;



// SIGNATURE LINES AT BOTTOM - CENTERED
doc.setFont("helvetica", "bold");
doc.setFontSize(7);

// Calculate center position
const centerX = pageWidth / 2; // A5 width is 148mm, center is 74mm

// Left side - Shorter signature line with label centered under it
const leftLineStart = centerX - 45;
const leftLineEnd = centerX - 5;
const leftLineMid = (leftLineStart + leftLineEnd) / 2;
doc.line(leftLineStart, y, leftLineEnd, y);  // Shorter signature line (40mm long)
doc.text("Lens Checked By:", leftLineMid, y + 3, { align: "center" });  // Label CENTERED under line

// Right side - Shorter signature line with label centered under it
const rightLineStart = centerX + 5;
const rightLineEnd = centerX + 45;
const rightLineMid = (rightLineStart + rightLineEnd) / 2;
doc.line(rightLineStart, y, rightLineEnd, y);  // Shorter signature line (40mm long)
doc.text("Fitting Checked By:", rightLineMid, y + 3, { align: "center" });  // Label CENTERED under line

y += 8;




  // ------------------------------
  // DISCOUNTS - Compact
  // ------------------------------
  const frameDiscount = invoiceData.financial?.frameDiscount || 0;
  const lensDiscount = invoiceData.financial?.lensDiscount || 0;
  const generalDiscount = invoiceData.financial?.generalDiscount || 0;

  if (frameDiscount > 0 || lensDiscount > 0 || generalDiscount > 0) {
    doc.setFillColor(255, 255, 255);
    doc.rect(8, y - 2, pageWidth - 16, 4, "F");

    doc.setTextColor(0, 0, 0);;
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    doc.text("Discounts", 10, y);

    doc.setTextColor(0, 0, 0);
    y += 4;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(6);

    const discountItems = [
      ["Frame Discount", frameDiscount],
      ["Lens Discount", lensDiscount],
      ["General Discount", generalDiscount]
    ];

    discountItems.forEach(([label, amount]) => {
      if (amount > 0) {
        y = addLine(label, leftCol, y);
        doc.text(`Rs. ${amount.toFixed(2)}`, pageWidth - 8, y - lineHeight, { align: "right" });
      }
    });
    y += 2;
  }

  // ------------------------------
  // SERVICE CHARGES - Compact
  // ------------------------------
  const additionalCharges = invoiceData.financial?.additionalCharges || {};
  const chargeItems = [
    ["Own Nylon", additionalCharges.ownNylon],
    ["Own Rimless", additionalCharges.ownRimless],
    ["Fitting", additionalCharges.fitting],
    ["Tint", additionalCharges.tint],
    ["Express", additionalCharges.express],
  ];

  const hasCharges = chargeItems.some(([_, amount]) => amount > 0);
  if (hasCharges) {
  doc.setFillColor(255, 255, 255);
    doc.rect(8, y - 2, pageWidth - 16, 4, "F");

    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    doc.text("Service Charges", 10, y);

    doc.setTextColor(0, 0, 0);
    y += 4;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(6);

    chargeItems.forEach(([label, amount]) => {
      if (amount > 0) {
        y = addLine(label, leftCol, y);
        doc.text(`Rs. ${amount.toFixed(2)}`, pageWidth - 8, y - lineHeight, { align: "right" });
      }
    });
    y += 2;
  }

  // ------------------------------
  // PAYMENT SUMMARY - Compact
  // ------------------------------
doc.setFillColor(255, 255, 255);
  doc.rect(8, y - 2, pageWidth - 16, 4, "F");

  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(7);
  doc.text("Payment Summary", 10, y);

  doc.setTextColor(0, 0, 0);
  y += 4;

  const subtotal = invoiceData.financial?.subtotal || 0;
  const discount = invoiceData.financial?.totalDiscounts || 0;
  const subtotalAfterDiscount = invoiceData.financial?.subtotalAfterDiscount || subtotal - discount;
  const vatEnabled = invoiceData.financial?.vatEnabled || false;
  const vatAmount = invoiceData.financial?.vatAmount || 0;
  const additionalChargesTotal = invoiceData.financial?.additionalCharges?.total || 0;
  const totalAmount = invoiceData.financial?.totalAmount || subtotalAfterDiscount + additionalChargesTotal + (vatEnabled ? vatAmount : 0);
  const advancePayment = invoiceData.financial?.advancePayment || 0;
  const balanceDue = totalAmount - advancePayment;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(6);

  const summaryRows = [
    ["Sub total", subtotal],
    ...(discount > 0 ? [["Discounts", discount]] : []),
    ...(discount > 0 ? [["Sub total After Discount", subtotalAfterDiscount]] : []),
    ...(additionalChargesTotal > 0 ? [["Additional Charges", additionalChargesTotal]] : []),
  ];

  summaryRows.forEach(([label, amount]) => {
    if (amount !== 0) {
      y = addLine(label, leftCol, y);
      doc.text(
        `${amount < 0 ? "-" : ""}Rs. ${Math.abs(amount).toFixed(2)}`,
        pageWidth - 8,
        y - lineHeight,
        { align: "right" }
      );
    }
  });

  if (vatEnabled) {
    y = addLine(`VAT (${invoiceData.financial?.vatRate || 18}%)`, leftCol, y);
    doc.text(`Rs. ${vatAmount.toFixed(2)}`, pageWidth - 8, y - lineHeight, { align: "right" });
  }

  doc.line(8, y, pageWidth - 8, y);
  y += 3;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);

  // Total Amount
  y = addLine("Total Amount", leftCol, y);
  doc.text(`Rs. ${totalAmount.toFixed(2)}`, pageWidth - 8, y - lineHeight, { align: "right" });

  // Advance Payment
  y = addLine("Advance Payment", leftCol, y);
  doc.text(`Rs. ${advancePayment.toFixed(2)}`, pageWidth - 8, y - lineHeight, { align: "right" });

  // Balance Due (highlighted)
  doc.setFontSize(7);
  doc.setTextColor(0, 0, 0);
  y = addLine("Balance Due", leftCol, y);
  doc.text(`Rs. ${balanceDue.toFixed(2)}`, pageWidth - 8, y - lineHeight, { align: "right" });
  doc.setTextColor(0, 0, 0);
  y += 2;


  // Served By & Delivery Date
doc.setFontSize(6);

doc.text(
  `Served By: ${invoiceData.salePerson || "-"}`,
  10,
  y
);

doc.text(`Rx By: ${invoiceData.prescription?.referredBy || "-"}`, 55, y);


doc.text(
  `Delivery Date: ${formatDateSafe(invoiceData.delivery?.date) || "-"}`,
  pageWidth - 10,
  y,
  { align: "right" }
);

y += 3;

  // ------------------------------
  // SAVE PDF
  // ------------------------------
  doc.save(`${invoiceData.invoiceNumber}_PRESCRIPTION.pdf`);
};











const generateFullInvoicePDF = async (invoiceData) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a5"
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  let y = 8;

  // Safe date formatting function
  const formatDateSafe = (dateValue) => {
    if (!dateValue) return "Not set";
    try {
      if (dateValue && typeof dateValue.toDate === 'function') {
        return dateValue.toDate().toLocaleDateString();
      }
      if (dateValue && dateValue.seconds) {
        return new Date(dateValue.seconds * 1000).toLocaleDateString();
      }
      if (dateValue instanceof Date) {
        return dateValue.toLocaleDateString();
      }
      if (typeof dateValue === 'string') {
        const parsedDate = new Date(dateValue);
        if (!isNaN(parsedDate.getTime())) {
          return parsedDate.toLocaleDateString();
        }
      }
      return "Invalid date";
    } catch (error) {
      console.error('Date formatting error:', error);
      return "Invalid date";
    }
  };

  // ------------------------------
  // HEADER WITH LOGO
  // ------------------------------

  doc.setFontSize(9);



  doc.text(`Date: ${formatDateSafe(invoiceData.createdAt)}`, pageWidth - 10, y + 29, { align: "right" });

  y = 42;

  // ------------------------------
  // DIVIDER LINE
  // ------------------------------
  doc.setLineWidth(0.3);
  doc.line(10, y, pageWidth - 10, y);
  y += 4;

  // ------------------------------
  // TITLE
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  doc.text("INVOICE", pageWidth / 2, y, { align: "center" });
  y += 5;


  // ------------------------------
  // PATIENT DETAILS
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(9);
  doc.text("Customer Details", 10, y);
  y += 5;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(8);
  // doc.text(`No: ${invoiceData.invoiceNumber}`, 10, y);
  // y += 5;



  doc.text(`Invoice No: ${invoiceData.invoiceNumber}`, 10, y);
y += 5;
if (invoiceData.invoiceType === 'RX') {
  doc.text(`RX No: ${invoiceData.rxNumber}`, 10, y);
} else {
  doc.text(`VIP No: ${invoiceData.vipNumber}`, 10, y);
}
y += 5;



  doc.text(`Name: ${invoiceData.customer.fullName}`, 10, y);
  y += 5;
  doc.text(`Tel: ${invoiceData.customer.tpNo}`, 10, y);
  y += 5;
  doc.text(`Address: ${invoiceData.customer.address || "-"}`, 10, y);
  y += 2;



  // Clean divider line
y += 1;
doc.line(10, y, pageWidth - 10, y);
y += 3;


  // ------------------------------
  // PRODUCT DETAILS SECTION
  // ------------------------------

  doc.setTextColor(0, 0, 0);
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(9);
  doc.text("Product Details", 12, y);
  
  doc.setTextColor(0, 0, 0);
  y += 6;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(7);

  const leftLens = invoiceData.products?.highIndexLens
    ? invoiceData.products.highIndexLeft
    : (invoiceData.products?.leftLens || {});

  const rightLens = invoiceData.products?.highIndexLens
    ? invoiceData.products.highIndexRight
    : (invoiceData.products?.rightLens || {});

  // LEFT LENS
  const leftLensPrice = invoiceData.products?.highIndexLens
    ? (leftLens.price || 0)
    : ((leftLens.pairPrice || 0) / 2);

  const leftText = `Left Lens : ${leftLens.brand || "-"}, ${leftLens.type || "-"}, ${leftLens.name || "-"}`;
  doc.text(leftText, 10, y);
  doc.text(`Rs. ${leftLensPrice.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 4;

  // RIGHT LENS
  const rightLensPrice = invoiceData.products?.highIndexLens
    ? (rightLens.price || 0)
    : ((rightLens.pairPrice || 0) / 2);

  const rightText = `Right Lens : ${rightLens.brand || "-"}, ${rightLens.type || "-"}, ${rightLens.name || "-"}`;
  doc.text(rightText, 10, y);
  doc.text(`Rs. ${rightLensPrice.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 4;

 // ------------------------------
// FRAME DETAILS - Single line
// ------------------------------
const frame = invoiceData.products?.frame || {};
const frameModel = frame.modelNo || invoiceData.products.frameModel || "-";
const frameBrand = frame.brand || invoiceData.products.frameBrand || "-";
const frameSize = frame.size || invoiceData.products.frameSize || "-";
const frameColor = frame.colour || invoiceData.products.frameColour || "-";
const framePrice = frame.sellingPrice || invoiceData.products.framePrice || 0;

// Use regular doc.text instead of addLine
doc.text(`Frame: ${frameBrand}  /  ${frameModel}  /  ${frameSize}  /  ${frameColor}`, 10, y);
doc.text(`Rs. ${framePrice.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
y += 5;




  // ------------------------------
  // DISCOUNTS SECTION
  // ------------------------------
  let hasDiscounts = false;
  const frameDiscount = invoiceData.financial?.frameDiscount || 0;
  const lensDiscount = invoiceData.financial?.lensDiscount || 0;
  const generalDiscount = invoiceData.financial?.generalDiscount || 0;

  if (frameDiscount > 0 || lensDiscount > 0 || generalDiscount > 0) {
    hasDiscounts = true;
    


      // Clean divider line

doc.line(10, y, pageWidth - 10, y);
y += 3;


    // doc.setFillColor(255, 255, 255);
    // doc.rect(10, y - 3, pageWidth - 20, 5, "F");
    
    doc.setTextColor(0, 0, 0);
    doc.setFont("Times New Roman", "bold");
    doc.setFontSize(9);
    doc.text("Discounts", 12, y);
    
    doc.setTextColor(0, 0, 0);
    y += 6;
    doc.setFont("Times New Roman", "normal");
    doc.setFontSize(7);




// In your PDF generation function
const frameDiscount = invoiceData.financial?.frameDiscount || 0;
const frameDiscountPercent = invoiceData.financial?.frameDiscountPercent || 0;
const lensDiscount = invoiceData.financial?.lensDiscount || 0;
const lensDiscountPercent = invoiceData.financial?.lensDiscountPercent || 0;

if (frameDiscount > 0) {
  const label = frameDiscountPercent > 0 ? `Frame Discount (${frameDiscountPercent}%)` : 'Frame Discount';
  doc.text(label, 10, y);
  doc.text(`Rs. ${frameDiscount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 4;
}

if (lensDiscount > 0) {
  const label = lensDiscountPercent > 0 ? `Lens Discount (${lensDiscountPercent}%)` : 'Lens Discount';
  doc.text(label, 10, y);
  doc.text(`Rs. ${lensDiscount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 4;
}






    if (generalDiscount > 0) {
      doc.text(`General Discount`, 10, y);
      doc.text(`Rs. ${generalDiscount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
      y += 4;
    }
  }

  // ------------------------------
  // ADDITIONAL CHARGES SECTION - INDIVIDUALLY
  // ------------------------------
  const additionalCharges = invoiceData.financial?.additionalCharges || {};
  const hasAdditionalCharges = 
    additionalCharges.ownNylon > 0 ||
    additionalCharges.ownRimless > 0 ||
    additionalCharges.fitting > 0 ||
    additionalCharges.tint > 0 ||
    additionalCharges.express > 0;

  if (hasAdditionalCharges) {
    // doc.setFillColor(255, 255, 255);
    // doc.rect(10, y - 3, pageWidth - 20, 5, "F");
    
      // Clean divider line

doc.line(10, y, pageWidth - 10, y);
y += 3;


    doc.setTextColor(0, 0, 0);
    doc.setFont("Times New Roman", "bold");
    doc.setFontSize(9);
    doc.text("Service Charges", 12, y);
    
    doc.setTextColor(0, 0, 0);
    y += 6;
    doc.setFont("Times New Roman", "normal");
    doc.setFontSize(7);

    if (additionalCharges.ownNylon > 0) {
      doc.text(`Own NYLON`, 10, y);
      doc.text(`Rs. ${additionalCharges.ownNylon.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
      y += 4;
    }

    if (additionalCharges.ownRimless > 0) {
      doc.text(`Own Rimless`, 10, y);
      doc.text(`Rs. ${additionalCharges.ownRimless.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
      y += 4;
    }

    if (additionalCharges.fitting > 0) {
      doc.text(`Fitting Charges`, 10, y);
      doc.text(`Rs. ${additionalCharges.fitting.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
      y += 4;
    }

    if (additionalCharges.tint > 0) {
      doc.text(`Tint Charges`, 10, y);
      doc.text(`Rs. ${additionalCharges.tint.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
      y += 4;
    }

    if (additionalCharges.express > 0) {
      doc.text(`Express Charge`, 10, y);
      doc.text(`Rs. ${additionalCharges.express.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
      y += 4;
    }
  }



    // Clean divider line

doc.line(10, y, pageWidth - 10, y);
y += 3;



  // ------------------------------
  // PAYMENT DETAILS SECTION
  // ------------------------------
  // doc.setFillColor(255, 255, 255);
  // doc.rect(10, y - 3, pageWidth - 20, 5, "F");
  
  doc.setTextColor(0, 0, 0);
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(9);
  doc.text("Payment Details", 12, y);
  
  doc.setTextColor(0, 0, 0);
  y += 6;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(8);

  // Calculate values properly
  const subtotal = invoiceData.financial.subtotal || 0;
  const discount = invoiceData.financial.totalDiscounts || 0;
  const subtotalAfterDiscount = invoiceData.financial.subtotalAfterDiscount || subtotal - discount;
  const vatEnabled = invoiceData.financial.vatEnabled || false;
  const vatAmount = invoiceData.financial.vatAmount || 0;
  const additionalChargesTotal = invoiceData.financial.additionalCharges?.total || 0;
  const totalAmount = invoiceData.financial.totalAmount || subtotalAfterDiscount + (vatEnabled ? vatAmount : 0) + additionalChargesTotal;
  const advancePayment = invoiceData.financial.advancePayment || 0;
  const balanceDue = totalAmount - advancePayment;

  // Subtotal
  doc.text("Subtotal", 10, y);
  doc.text(`Rs. ${subtotal.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 4;

  // Total Discounts
  if (discount > 0) {
    doc.text("Total Discounts", 10, y);
    doc.text(`Rs. ${discount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
    y += 4;
  }

  // Subtotal After Discount
  if (discount > 0) {
    doc.text("Subtotal (After Discount)", 10, y);
    doc.text(`Rs. ${subtotalAfterDiscount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
    y += 4;
  }

  // Additional Charges Total
  if (additionalChargesTotal > 0) {
    doc.text("Service Charges", 10, y);
    doc.text(`Rs. ${additionalChargesTotal.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
    y += 4;
  }

  // VAT Section
  if (vatEnabled) {
    doc.setFont("Times New Roman", "bold");
    doc.text(`VAT (${invoiceData.financial.vatRate || 18}%)`, 10, y);
    doc.text(`Rs. ${vatAmount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
    y += 4;
    doc.setFont("Times New Roman", "normal");
  }

  // Draw a separator line before total
  doc.setDrawColor(200, 200, 200);
  doc.line(10, y, pageWidth - 10, y);
  y += 4;

  // Total Amount
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(7);
  doc.text("Total Amount", 10, y);
  doc.text(`Rs. ${totalAmount.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 6;

  // Show VAT breakdown note if VAT was applied
  if (vatEnabled) {
    doc.setFont("Times New Roman", "italic");
    doc.setFontSize(6);
    doc.setTextColor(80, 80, 80);
    doc.text(`* Includes ${invoiceData.financial.vatRate || 18}% VAT of Rs. ${vatAmount.toFixed(2)}`, 10, y);
    y += 4;
    doc.setFont("Times New Roman", "normal");
    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0);
  }

  // Advance Payment
  doc.text("Advance Payment", 10, y);
  doc.text(`Rs. ${advancePayment.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 4;

  // Balance Due
  doc.setFont("Times New Roman", "bold");
  doc.setTextColor(0, 0, 0);
  doc.text("Balance Due", 10, y);
  doc.text(`Rs. ${balanceDue.toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 5;
  doc.setTextColor(0, 0, 0);
  doc.setFont("Times New Roman", "normal");

// ------------------------------
// DIVIDER
// ------------------------------
doc.line(10, y, pageWidth - 10, y);
y += 4;

// Served By, Referred By & Delivery Date - All in one line
doc.setFontSize(7);
doc.text(`Served By: ${invoiceData.salePerson || "-"}`, 10, y);
doc.text(`Delivery Date: ${formatDateSafe(invoiceData.delivery?.date) || "-"}`, 110, y);
y += 6;


  

  // ------------------------------
  // SAVE PDF
  // ------------------------------
  doc.save(`${invoiceData.invoiceNumber}_FULL_INVOICE.pdf`);
};







  const generateBothPDFs = async (invoiceData) => {
    await generateCustomerPrescriptionPDF(invoiceData);
    await generateFullInvoicePDF(invoiceData);
  };

  // Fetch frames data
  const fetchFramesData = async () => {
    try {
      const q = query(
        collection(db, "stock"),
        where("category", "==", "frame")
      );

      const querySnapshot = await getDocs(q);
      const framesList = [];

      querySnapshot.forEach(docSnap => {
        const data = docSnap.data();

        if (Array.isArray(data.items)) {
          data.items.forEach(item => {
            framesList.push({
              id: docSnap.id,
              ...item
            });
          });
        } else {
          framesList.push({
            id: docSnap.id,
            modelNo: data.modelNo,
            brand: data.brand,
            colour: data.colour,
            size: data.size,
            sellingPrice: data.sellingPrice,
            qty: data.quantity
          });
        }
      });

      setAvailableFrames(framesList);
    } catch (err) {
      console.log("Error loading frames:", err);
    }
  };

  // Fetch stock items (lenses)
  const fetchStockItems = async () => {
    try {
      const lensesQuery = query(collection(db, 'stock'), where('type', '==', 'lens'));
      const lensesSnapshot = await getDocs(lensesQuery);
      const lensesList = lensesSnapshot.docs.map(doc => ({ 
        id: doc.id, 
        ...doc.data(),
        availableQty: doc.data().quantity || 0
      }));
      setLensOptions(lensesList);
    } catch (error) {
      console.error('Error fetching lenses:', error);
    }
  };

  // Select frame
  const selectFrame = (frame) => {
    console.log('Selected frame:', frame);
    
    // Check if frame has sufficient quantity
    if (frame.qty <= 0) {
      alert(`Frame "${frame.modelNo}" is out of stock!`);
      return;
    }
    
    setFrameSearchTerm(frame.modelNo);
    setShowFrameSuggestions(false);
    setFrameSuggestions([]);

    // Auto-fill formData
    setFormData(prev => ({
      ...prev,
      frameModel: frame.modelNo,
      brand: frame.brand || "",
      colour: frame.colour || "",
      size: frame.size || "",
      framePrice: frame.sellingPrice || 0,
      selectedFrameId: frame.id || "",
      frameQty: frame.qty || 0
    }));
  };



   // Handle frame search
const handleFrameSearch = (text) => {
  console.log("Searching for:", text);

  setFrameSearchTerm(text);

  if (text.length < 2) {
    setShowFrameSuggestions(false);
    setFrameSuggestions([]);
    return;
  }

  const searchText = text.toLowerCase();

  const filtered = availableFrames.filter((frame) => {

    const modelMatch =
      frame.modelNo &&
      frame.modelNo.toLowerCase().includes(searchText);

    const brandMatch =
      frame.brand &&
      frame.brand.toLowerCase().includes(searchText);

    const colorMatch =
      frame.colour &&
      frame.colour.toLowerCase().includes(searchText);

    const sizeMatch =
      frame.size &&
      frame.size.toLowerCase().includes(searchText);

    const hasStock = Number(frame.qty) > 0;

    return (modelMatch || brandMatch || colorMatch || sizeMatch) && hasStock;
  });

  console.log("Filtered suggestions:", filtered);

  setFrameSuggestions(filtered);
  setShowFrameSuggestions(true);
};


  // Save order with specific invoice number
  const handleSaveOrderWithNumber = async (mainInvoiceNumber, typeNumber) => {

  const lensSelectValue = document.querySelector('select[name="lensModel"]')?.value || formData.lensModel;


    let frameStockDoc = null;
    let frameItemIndex = -1;
    let currentQty = 0;
    
    // Handle frame stock deduction
    if (formData.selectedFrameId) {
      const frameRef = doc(db, 'stock', formData.selectedFrameId);
      const frameDoc = await getDoc(frameRef);
      
      if (frameDoc.exists()) {
        const frameData = frameDoc.data();
        
        if (frameData.items && Array.isArray(frameData.items)) {
          const itemIndex = frameData.items.findIndex(item => item.modelNo === formData.frameModel);
          
          if (itemIndex !== -1) {
            currentQty = frameData.items[itemIndex].qty || 0;
            
            if (currentQty <= 0) {
              alert(`Frame "${formData.frameModel}" is out of stock!`);
              setIsLoading(false);
              return;
            }
            
            const updatedItems = [...frameData.items];
            updatedItems[itemIndex] = {
              ...updatedItems[itemIndex],
              qty: currentQty - 1
            };
            
            await updateDoc(frameRef, { items: updatedItems });
            frameStockDoc = frameData;
            frameItemIndex = itemIndex;
          } else {
            alert('Frame item not found in stock!');
            setIsLoading(false);
            return;
          }
        } else if (frameData.quantity !== undefined) {
          currentQty = frameData.quantity;
          
          if (currentQty <= 0) {
            alert(`Frame "${formData.frameModel}" is out of stock!`);
            setIsLoading(false);
            return;
          }
          
          await updateDoc(frameRef, { quantity: currentQty - 1 });
          frameStockDoc = frameData;
        }
      } else {
        alert('Frame document not found!');
        setIsLoading(false);
        return;
      }
    }
    







    // Handle lens stock deduction
    let lensStockDoc = null;
    if (formData.selectedLensId) {
      const lensRef = doc(db, 'stock', formData.selectedLensId);
      const lensDoc = await getDoc(lensRef);
      
      if (lensDoc.exists()) {
        const lensData = lensDoc.data();
        currentQty = lensData.quantity || 0;
        
        if (currentQty <= 0) {
          alert(`Lens "${formData.lensModel}" is out of stock!`);
          setIsLoading(false);
          return;
        }
        
        await updateDoc(lensRef, { quantity: currentQty - 1 });
        lensStockDoc = lensData;
      } else {
        alert('Lens document not found!');
        setIsLoading(false);
        return;
      }
    }
    
// Create invoice data with the permanent invoice number
// In handleSaveOrderWithNumber, ensure the financial object is correct
const subtotal = (parseFloat(formData.lensPrice) || 0) + (parseFloat(formData.framePrice) || 0);
const discount = parseFloat(formData.discount) || 0;
const subtotalAfterDiscount = subtotal - discount;
const vatAmountCalculated = applyVAT ? subtotalAfterDiscount * 0.18 : 0;
const totalWithVAT = subtotalAfterDiscount + vatAmountCalculated;





  const invoiceData = {
    type: "main-invoice",
    invoiceNumber: mainInvoiceNumber, // INV-XXX format - comes from parameter
    invoiceType: invoiceType, // 'RX' or 'VIP'
    rxNumber: invoiceType === 'RX' ? typeNumber : null, // comes from parameter
    vipNumber: invoiceType === 'VIP' ? typeNumber : null, // comes from parameter
  customer: {
    title: formData.title,
    firstName: formData.firstName,
    lastName: formData.lastName,
    fullName: `${formData.title || ''} ${formData.firstName} ${formData.lastName}`.trim(),
    address: formData.address,
    tpNo: formData.tpNo,
    email: formData.email,
    age: formData.age,
    // ❌ REMOVE salePerson from here - it doesn't belong in customer object
  },



prescription: {
  date: formData.prescriptionDate || new Date().toISOString().split('T')[0],
  referredBy: formData.referredBy,
  pd: formData.pd || '',
  lpd: formData.lpd || '',
  sh: formData.sh || '',
  fpd: formData.fpd || '',
  rInsert: formData.rInsert || '',
  lInsert: formData.lInsert || '',
  rightEye: {
    visualAcuity: formData.rightVisualAcuity,
    sph: formData.rightSph,
    cyl: formData.rightCyl,
    axis: formData.rightAxis,
    add: formData.rightAdd,
    nearVA: formData.rightNearVA
  },
  leftEye: {
    visualAcuity: formData.leftVisualAcuity,
    sph: formData.leftSph,
    cyl: formData.leftCyl,
    axis: formData.leftAxis,
    add: formData.leftAdd,
    nearVA: formData.leftNearVA
  }
},



  

  products: {
  leftLens: leftLens ? {
    brand: leftLensBrand,
    type: leftLensType,
    name: leftLens.name,
    pairPrice: leftLens.pairPrice,
    singlePrice: leftLens.pairPrice / 2
  } : null,

  rightLens: rightLens ? {
    brand: rightLensBrand,
    type: rightLensType,
    name: rightLens.name,
    pairPrice: rightLens.pairPrice,
    singlePrice: rightLens.pairPrice / 2
  } : null,

  // HIGH INDEX DATA
  highIndexLens: isHighIndexLens,

  highIndexLeft: isHighIndexLens
    ? {
        brand: highIndexLeftBrand,
        type: highIndexLeftType,
        name: highIndexLeftName,
        price: Number(highIndexLeftPrice || 0)
      }
    : null,

  highIndexRight: isHighIndexLens
    ? {
        brand: highIndexRightBrand,
        type: highIndexRightType,
        name: highIndexRightName,
        price: Number(highIndexRightPrice || 0)
      }
    : null,

  lensModel: formData.lensModel,
  lensPrice: parseFloat(formData.lensPrice) || 0,
  frameModel: formData.frameModel,
  framePrice: parseFloat(formData.framePrice) || 0,
  brand: formData.brand,
  colour: formData.colour,
  size: formData.size
},









  
// In handleSaveOrderWithNumber function, update the financial object:
financial: {
  subtotal: totals.subtotal,

// Frame discount - save BOTH amount and percentage
    frameDiscount: totals.frameDiscountAmount,
    frameDiscountType: frameDiscountType, // 'amount' or 'percentage'
    frameDiscountValue: parseFloat(frameDiscountValue) || 0,
    frameDiscountPercent: frameDiscountType === 'percentage' ? parseFloat(frameDiscountValue) : 0,
    
    // Lens discount - save BOTH amount and percentage
    lensDiscount: totals.lensDiscountAmount,
    lensDiscountType: lensDiscountType, // 'amount' or 'percentage'
    lensDiscountValue: parseFloat(lensDiscountValue) || 0,
    lensDiscountPercent: lensDiscountType === 'percentage' ? parseFloat(lensDiscountValue) : 0,



  generalDiscount: totals.generalDiscount,
  totalDiscounts: totals.totalDiscounts,
  subtotalAfterDiscount: totals.subtotalAfterDiscount,
  vatEnabled: applyVAT,
  vatAmount: totals.vatAmount,
  vatRate: 18,
  additionalCharges: {
    ownNylon: ownNylonCharge ? OWN_NYLON_AMOUNT : 0,
    ownRimless: ownRimlessCharge ? OWN_RIMLESS_AMOUNT : 0,
    fitting: fittingCharge ? FITTING_CHARGE_AMOUNT : 0,
    tint: tintCharge ? TINT_CHARGE_AMOUNT : 0,
    express: expressCharge ? EXPRESS_CHARGE_AMOUNT : 0,
    total: totals.additionalCharges
  },
  totalAmount: totals.total,
  advancePayment: parseFloat(formData.advancePayment) || 0,
  balanceDue: totals.total - (parseFloat(formData.advancePayment) || 0),
  billDescription: formData.billDescription,
  paymentMethod: formData.paymentMethod
},

  delivery: {
    date: formData.deliveryDate || ''
  },
  createdAt: new Date().toISOString(),
  invoiceNumber: mainInvoiceNumber,
  status: 'pending',
  salePerson: formData.salePerson,  // ✅ CORRECT - at root level, NOT inside customer
    eyeCamp: selectedEyeCamp || null  // Add this line
};






// Add this function to fetch eye camps
const fetchEyeCamps = async () => {
  try {
    const snapshot = await getDocs(collection(db, "eye_camps"));
    const camps = snapshot.docs.map(doc => ({
      id: doc.id,
      name: doc.data().name,
      city: doc.data().city
    }));
    setEyeCamps(camps);
  } catch (error) {
    console.error("Error fetching eye camps:", error);
  }
};







    // Save to Firestore
    await addDoc(collection(db, 'invoices'), invoiceData);
    
    // Create stock_out records
    const stockOutPromises = [];
    
    // Record frame stock out
    if (formData.selectedFrameId && formData.frameModel) {
      stockOutPromises.push(addDoc(collection(db, 'stock_out'), {
        productId: formData.selectedFrameId,
        productType: 'frame',
        productModel: formData.frameModel,
        brand: formData.brand,
        colour: formData.colour,
        size: formData.size,
        quantity: 1,
        price: parseFloat(formData.framePrice) || 0,
        invoiceNumber: mainInvoiceNumber,
        customerName: `${formData.firstName} ${formData.lastName}`,
        date: new Date(),
        type: 'sale',
        remainingStock: frameStockDoc ? (frameStockDoc.items ? 
          (frameStockDoc.items[frameItemIndex]?.qty - 1) : 
          (frameStockDoc.quantity - 1)) : 0
      }));
    }
    
    // Record lens stock out
    if (formData.selectedLensId && formData.lensModel) {
      stockOutPromises.push(addDoc(collection(db, 'stock_out'), {
        productId: formData.selectedLensId,
        productType: 'lens',
        productModel: formData.lensModel,
        quantity: 1,
        price: parseFloat(formData.lensPrice) || 0,
        invoiceNumber: mainInvoiceNumber,
        customerName: `${formData.firstName} ${formData.lastName}`,
        date: new Date(),
        type: 'sale',
        remainingStock: lensStockDoc ? (lensStockDoc.quantity - 1) : 0
      }));
    }
    
    await Promise.all(stockOutPromises);
    
    // Generate PDFs
    try {
      await generateBothPDFs(invoiceData);
    } catch (pdfError) {
      console.error('PDF generation error:', pdfError);
    }
    
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);
    handleResetForm();
    
    // Refresh stock data
    await fetchFramesData();
    await fetchStockItems();
    
    // Generate next invoice number for future use
    await generateNextInvoiceNumber();
    
    console.log(`Invoice ${mainInvoiceNumber} created successfully and cannot be modified`);
  };










// Main handleSaveOrder function
const handleSaveOrder = async () => {
  // Validation
  const validationErrors = validateForm();
  if (Object.keys(validationErrors).length > 0) {
    setErrors(validationErrors);
    return;
  }
  
  setIsLoading(true);
  
  try {
    // ✅ 1. Generate main invoice number
    const mainInvoiceNumber = await generateNextInvoiceNumber();
    
    // ✅ 2. Get the CURRENT number to use (generate and increment)
    let typeNumber;
    if (invoiceType === 'RX') {
      typeNumber = await generateAndIncrementRxNumber(); // Use this, NOT getNextRxNumber
    } else {
      typeNumber = await generateAndIncrementVipNumber(); // Use this, NOT getNextVipNumber
    }
    
    // ✅ 3. Verify main invoice number is unique
    const invoiceCheckQuery = query(
      collection(db, 'invoices'),
      where('invoiceNumber', '==', mainInvoiceNumber)
    );
    const existingInvoice = await getDocs(invoiceCheckQuery);
    
    if (!existingInvoice.empty) {
      console.warn('Duplicate invoice number detected, regenerating...');
      const newInvoiceNumber = await generateNextInvoiceNumber();
      // Note: typeNumber already generated, but we need to handle rollback
      // For simplicity, regenerate both
      let newTypeNumber;
      if (invoiceType === 'RX') {
        newTypeNumber = await generateAndIncrementRxNumber();
      } else {
        newTypeNumber = await generateAndIncrementVipNumber();
      }
      await handleSaveOrderWithNumber(newInvoiceNumber, newTypeNumber);
      return;
    }
    
    // ✅ 4. Save with the numbers
    await handleSaveOrderWithNumber(mainInvoiceNumber, typeNumber);
    
    // ✅ 5. Update main invoice number for next use
    const newMainInvoice = await generateNextInvoiceNumber();
    setCurrentMainInvoiceNumber(newMainInvoice);
    localStorage.setItem('displayMainInvoice', newMainInvoice);
    
    // ✅ 6. The type number is already updated by generateAndIncrement functions
    // No need to call them again - the display is already updated
    
    // ✅ Show success message
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);
    
    // Reset form
    handleResetForm();
    
    // Refresh stock data
    await fetchFramesData();
    await fetchStockItems();
    
  } catch (error) {
    console.error('Error saving order:', error);
    alert('Error saving order: ' + error.message);
  } finally {
    setIsLoading(false);
  }
};





  // Initialize invoice number on component mount
  useEffect(() => {
    const init = async () => {
      await fetchFramesData();
      await fetchStockItems();
      await generateNextInvoiceNumber();
    };
    init();
  }, []);

  // Invoice Number Display Component
  const InvoiceNumberDisplay = () => (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      backgroundColor: '#4CAF50',
      color: 'white',
      padding: '8px 12px',
      borderRadius: '4px',
      fontSize: '12px',
      fontWeight: 'bold',
      zIndex: 1000
    }}>
      Next Invoice: {currentInvoiceNumber}
    </div>
  );






// Update frame stock
const updateFrameStock = async (docId, modelNo, changeQty) => {
  const ref = doc(db, "stock", docId);
  const snap = await getDoc(ref);
  const data = snap.data();

  const updatedItems = data.items.map(item =>
    item.modelNo === modelNo
      ? { ...item, qty: (item.qty || 0) + changeQty }
      : item
  );

  await updateDoc(ref, { items: updatedItems });
};

// Handle lens selection

const handleLensSelect = (e) => {
  setFormData({...formData, lensModel: e.target.value});
};





// Fetch stock on component mount
useEffect(() => {
  fetchStockItems();
}, []);








useEffect(() => {

  const leftPrice = leftLens
    ? leftLens.pairPrice / 2
    : 0;

  const rightPrice = rightLens
    ? rightLens.pairPrice / 2
    : 0;

  const totalLensPrice =
    leftPrice + rightPrice;

  setFormData(prev => ({
    ...prev,

    lensPrice: totalLensPrice.toFixed(2),

    lensModel:
      `${leftLens ? `LEFT: ${leftLens.name}` : ""} ${
        rightLens ? `RIGHT: ${rightLens.name}` : ""
      }`.trim()
  }));

}, [leftLens, rightLens]);




///////////////////////////////////// high index /////////////////////////////
useEffect(() => {

  if (isHighIndexLens) {

    const totalLensPrice =
      Number(highIndexLeftPrice || 0) +
      Number(highIndexRightPrice || 0);

    setFormData(prev => ({
      ...prev,
      lensPrice: totalLensPrice
    }));

  } else {

    const totalLensPrice =
      (leftLens?.pairPrice || 0) / 2 +
      (rightLens?.pairPrice || 0) / 2;

    setFormData(prev => ({
      ...prev,
      lensPrice: totalLensPrice
    }));

  }

}, [
  isHighIndexLens,
  leftLens,
  rightLens,
  highIndexLeftPrice,
  highIndexRightPrice
]);






// Add this CSS for suggestions dropdown (add to your CSS file or styled-components)
const styles = `
  .suggestions-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
  
  .suggestion-item {
    padding: 10px;
    cursor: pointer;
    border-bottom: 1px solid #eee;
  }
  
  .suggestion-item:hover {
    background-color: #f5f5f5;
  }
  
  .suggestion-details {
    font-size: 12px;
    color: #666;
    margin-top: 4px;
  }
  
  .stock-badge {
    background: #4CAF50;
    color: white;
    padding: 2px 6px;
    border-radius: 3px;
    margin-left: 8px;
    font-size: 10px;
  }
  
  .readonly-field {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
  
  .toast-notification {
    position: fixed;
    top: 20px;
    right: 20px;
    background: #4CAF50;
    color: white;
    padding: 12px 20px;
    border-radius: 4px;
    z-index: 2000;
    animation: slideIn 0.3s ease;
  }
  
  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

// Inject styles (add this once in your component or in a CSS file)
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement("style");
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}





























//// direct sale states

const [directSaleSearch, setDirectSaleSearch] = useState('');
const [directSaleSuggestions, setDirectSaleSuggestions] = useState([]);
const [showDirectSaleSuggestions, setShowDirectSaleSuggestions] = useState(false);

const [availableDirectProducts, setAvailableDirectProducts] = useState([]);
const [directSaleItems, setDirectSaleItems] = useState([]);

const [discountType, setDiscountType] = useState("amount");

const [billingDate, setBillingDate] = useState(
  new Date().toISOString().split("T")[0]
);



const [saleForm, setSaleForm] = useState({salePerson: ""});








//////////////////////////////////////////// view stock - out/////////////////////////////////////////////////////

// Add state for stock-out data
const [stockOutRecords, setStockOutRecords] = useState([]);
const [filteredStockOut, setFilteredStockOut] = useState([]);
const [stockOutSearchTerm, setStockOutSearchTerm] = useState('');
const [stockOutFilterType, setStockOutFilterType] = useState('all');
const [stockOutDateRange, setStockOutDateRange] = useState({
  start: '',
  end: ''
});
const [isLoadingStockOut, setIsLoadingStockOut] = useState(false);

// Helper function to safely format date
const formatDateSafe = (dateValue) => {
  if (!dateValue) return 'Invalid Date';
  
  try {
    // Handle Firestore Timestamp
    if (dateValue?.toDate) {
      const d = dateValue.toDate();
      if (isNaN(d.getTime())) return 'Invalid Date';
      return d.toLocaleDateString('en-GB');
    }
    
    // Handle string or number
    const d = new Date(dateValue);
    if (isNaN(d.getTime())) return 'Invalid Date';
    return d.toLocaleDateString('en-GB');
  } catch (error) {
    console.error('Date formatting error:', error);
    return 'Invalid Date';
  }
};

const formatTimeSafe = (dateValue) => {
  if (!dateValue) return 'Invalid Time';
  
  try {
    if (dateValue?.toDate) {
      const d = dateValue.toDate();
      if (isNaN(d.getTime())) return 'Invalid Time';
      return d.toLocaleTimeString('en-GB');
    }
    
    const d = new Date(dateValue);
    if (isNaN(d.getTime())) return 'Invalid Time';
    return d.toLocaleTimeString('en-GB');
  } catch (error) {
    console.error('Time formatting error:', error);
    return 'Invalid Time';
  }
};





// Fetch stock-out history
const fetchStockOutHistory = async () => {
  try {
    setIsLoadingStockOut(true);

    const stockOutSnapshot = await getDocs(
      query(collection(db, "stock_out"), orderBy("date", "desc"))
    );

    const records = await Promise.all(
      stockOutSnapshot.docs.map(async (stockDoc) => {
        const stock = stockDoc.data();

        let dateObj = stock.date?.toDate
          ? stock.date.toDate()
          : new Date(stock.date);

        // Default invoice data
        let invoiceDetails = {
          invoiceType: "",
          directInvoiceType: "",
          type: "",
          rxNumber: "",
          vipNumber: "",
          clNumber: "",
          sNumber: "",
          rNumber: "",
          size: "",
          BaseCurve: "",
          rPower: "",
          lPower: ""
        };

        if (stock.invoiceNumber) {
          const invoiceQuery = query(
            collection(db, "invoices"),
            where("invoiceNumber", "==", stock.invoiceNumber),
            limit(1)
          );

          const invoiceSnap = await getDocs(invoiceQuery);

          if (!invoiceSnap.empty) {
const invoice = invoiceSnap.docs[0].data();

invoiceDetails = {
  customerName:
    invoice.customer?.fullName ||
    invoice.customer?.firstName ||
    "",

  invoiceType: invoice.invoiceType || "",
  directInvoiceType: invoice.directInvoiceType || "",
  type: invoice.type || "",
  rxNumber: invoice.rxNumber || "",
  vipNumber: invoice.vipNumber || "",
  clNumber: invoice.clNumber || "",
  sNumber: invoice.sNumber || "",
  rNumber: invoice.rNumber || "",

 size: stock.size || invoice.products?.[0]?.size || "",
  BaseCurve: invoice.products?.[0]?.BaseCurve || "",
  rPower: invoice.products?.[0]?.rPower || "",
  lPower: invoice.products?.[0]?.lPower || ""
};
          }
        }

        return {
          id: stockDoc.id,
          ...stock,
          ...invoiceDetails,
          rawDate: dateObj,
          dateFormatted: dateObj.toLocaleDateString("en-GB"),
          timeFormatted: dateObj.toLocaleTimeString("en-GB")
        };
      })
    );

    setStockOutRecords(records);
    setFilteredStockOut(records);
  } catch (error) {
    console.error(error);
  } finally {
    setIsLoadingStockOut(false);
  }
};





// Filter stock-out records
const filterStockOut = () => {
  let filtered = [...stockOutRecords];
  
  // Filter by search term
  if (stockOutSearchTerm) {
    const searchLower = stockOutSearchTerm.toLowerCase();
    filtered = filtered.filter(record => 
      record.invoiceNumber?.toLowerCase().includes(searchLower) ||
      record.productModel?.toLowerCase().includes(searchLower) ||
      record.brand?.toLowerCase().includes(searchLower) ||
      record.customerName?.toLowerCase().includes(searchLower) ||
      record.colour?.toLowerCase().includes(searchLower) ||
      record.size?.toLowerCase().includes(searchLower)
    );
  }
  
  // Filter by product type
  if (stockOutFilterType !== 'all') {
    filtered = filtered.filter(record => record.productType === stockOutFilterType);
  }
  
  // Filter by date range - using rawDate for comparison
  if (stockOutDateRange.start && stockOutDateRange.start !== '') {
    const startDate = new Date(stockOutDateRange.start);
    startDate.setHours(0, 0, 0, 0);
    filtered = filtered.filter(record => {
      if (!record.rawDate || isNaN(record.rawDate.getTime())) return false;
      return record.rawDate >= startDate;
    });
  }
  
  if (stockOutDateRange.end && stockOutDateRange.end !== '') {
    const endDate = new Date(stockOutDateRange.end);
    endDate.setHours(23, 59, 59, 999);
    filtered = filtered.filter(record => {
      if (!record.rawDate || isNaN(record.rawDate.getTime())) return false;
      return record.rawDate <= endDate;
    });
  }
  
  setFilteredStockOut(filtered);
};




const generateStockOutReportPDF = async () => {
  // ========================================================================
  // 1. PDF ENGINE CONFIGURATION - A4 PORTRAIT
  // ========================================================================
  const pdf = new jsPDF({
    orientation: "portrait",  // Fixed spelling
    unit: "mm",
    format: "a4",
    compress: true,
  });

  const pageWidth = pdf.internal.pageSize.getWidth();  // 210mm for A4
  const pageHeight = pdf.internal.pageSize.getHeight(); // 297mm for A4

  // ========================================================================
  // 2. DESIGN SYSTEM - A4 PORTRAIT OPTIMIZED
  // ========================================================================
  const DESIGN = {
    margins: {
      top: 15,
      bottom: 15,
      left: 10,
      right: 10,
    },
    table: {
      rowHeight: 7,
      headerHeight: 9,
      rowsPerPage: 35, // More rows for A4 portrait
      cellPadding: 2,
      borderWidth: 0.15,
    },
    fonts: {
      header: 8,
      body: 7,
      footer: 7,
    },
  };

  // ========================================================================
  // 3. DESIGN SYSTEM - COLOR PALETTE
  // ========================================================================
  const COLORS = {
    primary: {
      main: [26, 35, 126],
      light: [63, 81, 181],
      dark: [13, 20, 70],
    },
    secondary: {
      main: [198, 40, 40],
      light: [220, 80, 80],
    },
    neutral: {
      white: [255, 255, 255],
      black: [20, 20, 25],
      gray: [108, 117, 125],
      lightGray: [248, 249, 250],
      border: [210, 215, 220],
    },
    status: {
      success: [46, 125, 50],
      warning: [237, 180, 0],
      info: [21, 101, 192],
    },
  };

  // ========================================================================
  // 4. TABLE COLUMN DEFINITIONS - NEW ORDER: Ref | Empty | Brand | Model | Size | Color | Price
  // ========================================================================
  const TABLE = {
    columns: [
      { id: "ref", label: "Ref. No", width: 28, align: "center", type: "text" },
      { id: "empty", label: "", width: 8, align: "center", type: "text" }, // Empty column added here
      { id: "brand", label: "Brand", width: 30, align: "left", type: "text" },
      { id: "model", label: "Model", width: 32, align: "left", type: "text" },
      { id: "size", label: "Size", width: 20, align: "center", type: "text" },
      { id: "colour", label: "Color", width: 22, align: "left", type: "text" },
      { id: "price", label: "Price (Rs.)", width: 28, align: "right", type: "currency" },
    ],
  };

  // Calculate table positioning
  const totalTableWidth = TABLE.columns.reduce((sum, col) => sum + col.width, 0);
  const startX = (pageWidth - totalTableWidth) / 2;
  const endX = startX + totalTableWidth;

  // ========================================================================
  // 5. UTILITY FUNCTIONS
  // ========================================================================
  
  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return "—";
    return `${Number(amount).toLocaleString('en-LK', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })}`;
  };

  const formatReferenceNumber = (record) => {
    if (record.invoiceType === "RX" && record.rxNumber) return `RX-${record.rxNumber}`;
    if (record.invoiceType === "VIP" && record.vipNumber) return `VIP-${record.vipNumber}`;
    if (record.type === "direct-sale" && record.directInvoiceType === "CL") {
      return `CL-${record.clNumber || "—"}`;
    }
    if (record.type === "direct-sale" && record.directInvoiceType === "S") {
      return `S-${record.sNumber || "—"}`;
    }
    if (record.invoiceType === "R" && record.rNumber) return `R-${record.rNumber}`;
    return "—";
  };

  // ========================================================================
  // 6. HEADER RENDERER
  // ========================================================================
  const renderHeader = (pageNumber = 1) => {
    // Page Badge
    if (pageNumber > 1) {
      pdf.setFillColor(...COLORS.secondary.main);
      pdf.roundedRect(
        pageWidth - DESIGN.margins.right - 30,
        5,
        30,
        7,
        2,
        2,
        "F"
      );
      pdf.setFontSize(6.5);
      pdf.setTextColor(...COLORS.neutral.white);
      pdf.text(`Page ${pageNumber}`, pageWidth - DESIGN.margins.right - 15, 10, {
        align: "center",
      });
    }

    // Report Title
    pdf.setFontSize(12);
    pdf.setFont("helvetica", "bold");
    pdf.setTextColor(...COLORS.primary.main);
    pdf.text("FRAME STOCK OUT REPORT", pageWidth / 2, 12, { align: "center" });
    
    // Date line
    pdf.setFontSize(7);
    pdf.setFont("helvetica", "normal");
    pdf.setTextColor(...COLORS.neutral.gray);

    const generatedDate = new Date().toLocaleDateString("en-GB");

    const filterText =
      stockOutDateRange.start && stockOutDateRange.end
        ? `Report Period: ${stockOutDateRange.start} to ${stockOutDateRange.end}`
        : stockOutDateRange.start
        ? `Report From: ${stockOutDateRange.start}`
        : stockOutDateRange.end
        ? `Report Until: ${stockOutDateRange.end}`
        : "Report Period: All Records";

    pdf.text(`Generated: ${generatedDate}`, pageWidth / 2, 17, {
      align: "center",
    });

    pdf.setFontSize(7);
    pdf.text(filterText, pageWidth / 2, 21, {
      align: "center",
    });
  };

  // ========================================================================
  // 7. TABLE HEADER RENDERER
  // ========================================================================
  const renderTableHeader = (y) => {
    let x = startX;

    // Header Background
    pdf.setFillColor(...COLORS.primary.main);
    pdf.rect(startX, y, totalTableWidth, DESIGN.table.headerHeight, "F");

    // Left accent
    pdf.setFillColor(...COLORS.secondary.main);
    pdf.rect(startX, y, 3, DESIGN.table.headerHeight, "F");

    // Header Text
    pdf.setTextColor(...COLORS.neutral.white);
    pdf.setFontSize(DESIGN.fonts.header);
    pdf.setFont("helvetica", "bold");

    TABLE.columns.forEach((col) => {
      const textX = x + (col.align === "center" ? col.width / 2 :
                         col.align === "right" ? col.width - 2 : 2);
      const textAlign = col.align === "center" ? "center" :
                        col.align === "right" ? "right" : "left";
      
      pdf.text(col.label, textX, y + 6, { align: textAlign });
      x += col.width;
    });

    return y + DESIGN.table.headerHeight;
  };

  // ========================================================================
  // 8. TABLE ROW RENDERER
  // ========================================================================
  const renderTableRow = (record, y, rowIndex) => {
    let x = startX;
    
    // Prepare row data
    const rowData = {
      ref: formatReferenceNumber(record),
      empty: "", // Empty column - will display nothing
      brand: record.brand || "—",
      model: record.productModel || "—",
      size: record.size || "—",
      colour: record.colour || "—",
      price: record.price || 0,
    };

    const maxHeight = DESIGN.table.rowHeight;

    // Row Background - alternating colors
    if (rowIndex % 2 === 1) {
      pdf.setFillColor(...COLORS.neutral.lightGray);
      pdf.rect(startX, y, totalTableWidth, maxHeight, "F");
    }

    // Row Border
    pdf.setDrawColor(...COLORS.neutral.border);
    pdf.setLineWidth(DESIGN.table.borderWidth);

    // Render Each Cell in correct order
    TABLE.columns.forEach((col) => {
      const cellText = String(rowData[col.id] || "—");
      
      // Cell border
      pdf.rect(x, y, col.width, maxHeight);

      // Cell content
      pdf.setFontSize(DESIGN.fonts.body);
      
      // Special handling for empty column - skip rendering content
      if (col.id === "empty") {
        // Do nothing - leave cell empty
      }
      else if (col.type === "currency") {
        pdf.setFont("helvetica", "bold");
        pdf.setTextColor(...COLORS.primary.dark);
        const formatted = formatCurrency(rowData[col.id]);
        pdf.text(formatted, x + col.width - 2, y + 5, { align: "right" });
      } 
      else if (col.id === "ref") {
        pdf.setFont("helvetica", "bold");
        pdf.setTextColor(...COLORS.primary.main);
        pdf.text(cellText, x + col.width / 2, y + 5, { align: "center" });
      }
      else if (col.id === "brand") {
        pdf.setFont("helvetica", "bold");
        pdf.setTextColor(...COLORS.primary.light);
        pdf.text(cellText, x + 2, y + 5, { align: "left" });
      }
      else if (col.id === "model") {
        pdf.setFont("helvetica", "bold");
        pdf.setTextColor(...COLORS.primary.dark);
        pdf.text(cellText, x + 2, y + 5, { align: "left" });
      }
      else if (col.id === "size") {
        pdf.setFont("helvetica", "bold");
        pdf.setTextColor(...COLORS.status.info);
        pdf.text(cellText, x + col.width / 2, y + 5, { align: "center" });
      }
      else if (col.id === "colour") {
        pdf.setFont("helvetica", "normal");
        pdf.setTextColor(...COLORS.neutral.black);
        pdf.text(cellText, x + 2, y + 5, { align: "left" });
      }
      else {
        pdf.setFont("helvetica", "normal");
        pdf.setTextColor(...COLORS.neutral.black);
        const textX = x + (col.align === "center" ? col.width / 2 :
                           col.align === "right" ? col.width - 2 : 2);
        const textAlign = col.align === "center" ? "center" :
                          col.align === "right" ? "right" : "left";
        pdf.text(cellText, textX, y + 5, { align: textAlign });
      }

      x += col.width;
    });

    return maxHeight;
  };

  // ========================================================================
  // 9. FOOTER RENDERER
  // ========================================================================
  const renderFooter = (pageNumber, totalPages) => {
    const y = pageHeight - DESIGN.margins.bottom;
    // Footer implementation (if needed)
  };

  // ========================================================================
  // 10. MAIN GENERATION
  // ========================================================================

  // Calculate total pages
  const totalPages = Math.ceil(filteredStockOut.length / DESIGN.table.rowsPerPage) || 1;
  let currentPage = 1;

  // Start with first page
  renderHeader(1);
  let y = DESIGN.margins.top + 15;
  y = renderTableHeader(y);

  let rowIndex = 0;

  filteredStockOut.forEach((record) => {
    // Check if we need a new page
    if (rowIndex >= DESIGN.table.rowsPerPage) {
      currentPage++;
      pdf.addPage();
      renderHeader(currentPage);
      y = DESIGN.margins.top + 10;
      y = renderTableHeader(y);
      rowIndex = 0;
    }

    const rowHeight = renderTableRow(record, y, rowIndex);
    y += rowHeight;
    rowIndex++;
  });

  // Footer
  const totalPageCount = pdf.internal.getNumberOfPages();
  for (let i = 1; i <= totalPageCount; i++) {
    pdf.setPage(i);
    renderFooter(i, totalPages);
  }

  // ========================================================================
  // 11. SAVE
  // ========================================================================
  const dateString = new Date().toISOString().split("T")[0];
  const timeString = new Date().toTimeString().split(" ")[0].replace(/:/g, "");
  pdf.save(`FRAME_STOCK_OUT_REPORT_${dateString}_${timeString}.pdf`);
};







// Calculate summary statistics
const getStockOutSummary = () => {
  const totalItems = filteredStockOut.reduce((sum, record) => sum + (record.quantity || 0), 0);
  const totalValue = filteredStockOut.reduce((sum, record) => sum + ((record.price || 0) * (record.quantity || 0)), 0);
  const frameTotal = filteredStockOut.filter(r => r.productType === 'frame').reduce((sum, r) => sum + (r.quantity || 0), 0);
  const lensTotal = filteredStockOut.filter(r => r.productType === 'lens').reduce((sum, r) => sum + (r.quantity || 0), 0);
  
  return { totalItems, totalValue, frameTotal, lensTotal };
};

// Fetch stock-out on component mount
useEffect(() => {
  if (selectedOption === "viewStockOut") {
    fetchStockOutHistory();
  }
}, [selectedOption]);

// Apply filters when filter criteria change
useEffect(() => {
  if (stockOutRecords.length > 0) {
    filterStockOut();
  }
}, [stockOutSearchTerm, stockOutFilterType, stockOutDateRange.start, stockOutDateRange.end, stockOutRecords]);

// Reset filters
const resetStockOutFilters = () => {
  setStockOutSearchTerm('');
  setStockOutFilterType('all');
  setStockOutDateRange({ start: '', end: '' });
  setFilteredStockOut(stockOutRecords);
};

// Delete stock-out record (admin only)
const deleteStockOutRecord = async (recordId) => {
  if (window.confirm('Are you sure you want to delete this record?')) {
    try {
      await deleteDoc(doc(db, 'stock_out', recordId));
      await fetchStockOutHistory();
      alert('Record deleted successfully');
    } catch (error) {
      console.error('Error deleting record:', error);
      alert('Error deleting record: ' + error.message);
    }
  }
};




/////////////////////////////////////////////////// create balance invoice /////////////////////////////////////////////////////////////////

// State for balance invoice
const [showBalanceModal, setShowBalanceModal] = useState(false);
const [selectedInvoice, setSelectedInvoice] = useState(null);
const [balanceAmount, setBalanceAmount] = useState(0);
const [balancePaymentMethod, setBalancePaymentMethod] = useState('Cash');
const [balancePaidAmount, setBalancePaidAmount] = useState('');
const [balanceInvoices, setBalanceInvoices] = useState([]);
const [searchInvoiceNo, setSearchInvoiceNo] = useState('');
const [filteredInvoices, setFilteredInvoices] = useState([]);
const [isLoadingInvoices, setIsLoadingInvoices] = useState(false);
const [paymentDate, setPaymentDate] = useState(new Date().toISOString().split('T')[0]);


// Cache for balance invoice numbers
const balanceNumberCache = new Map();

// OPTIMIZED: Fetch pending balance invoices with pagination
const fetchPendingBalanceInvoices = async () => {
  try {
    setIsLoadingInvoices(true);
    
    // Add limit for faster loading
    const invoicesQuery = query(
      collection(db, 'invoices'),
      where('financial.balanceDue', '>', 0), // Only fetch pending invoices
      orderBy('createdAt', 'desc'),

    );
    
    const invoicesSnapshot = await getDocs(invoicesQuery);
    const invoicesList = [];
    
    // Process invoices in parallel
    const batchPromises = invoicesSnapshot.docs.map(async (docSnap) => {
      const invoiceData = { id: docSnap.id, ...docSnap.data() };
      const balanceDue = invoiceData.financial?.balanceDue || 0;
      
      // Only fetch balance records if needed
      let balanceRecords = [];
      if (balanceDue > 0) {
        const balanceInvoiceQuery = query(
          collection(db, 'balance_invoices'),
          where('originalInvoiceId', '==', docSnap.id),
          orderBy('balanceNumber', 'asc'),
          limit(5) // Limit balance records to last 5
        );
        const balanceSnapshot = await getDocs(balanceInvoiceQuery);
        balanceRecords = balanceSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      }
      
      return {
        ...invoiceData,
        docId: docSnap.id,
        balanceDue: balanceDue,
        hasBalanceInvoices: balanceRecords.length > 0,
        balanceRecords: balanceRecords,
        totalPaidBalance: balanceRecords.reduce((sum, record) => sum + (record.paidAmount || 0), 0)
      };
    });
    
    const results = await Promise.all(batchPromises);
    invoicesList.push(...results);
    
    setBalanceInvoices(invoicesList);
    setFilteredInvoices(invoicesList);
    setIsLoadingInvoices(false);
  } catch (error) {
    console.error('Error fetching invoices:', error);
    setIsLoadingInvoices(false);
    alert('Error fetching invoices: ' + error.message);
  }
};

// OPTIMIZED: Generate balance invoice number with caching
const generateBalanceInvoiceNumber = async (originalInvoiceNumber) => {
  // Check cache first
  if (balanceNumberCache.has(originalInvoiceNumber)) {
    const cached = balanceNumberCache.get(originalInvoiceNumber);
    const nextNumber = cached + 1;
    balanceNumberCache.set(originalInvoiceNumber, nextNumber);
    return {
      balanceInvoiceNumber: `${originalInvoiceNumber}-${nextNumber}`,
      balanceNumber: nextNumber
    };
  }

  try {
    const balanceInvoicesQuery = query(
      collection(db, 'balance_invoices'),
      where('originalInvoiceNumber', '==', originalInvoiceNumber)
    );

    const balanceSnapshot = await getDocs(balanceInvoicesQuery);
    let lastBalanceNumber = 0;

    balanceSnapshot.forEach((doc) => {
      const data = doc.data();
      if ((data.balanceNumber || 0) > lastBalanceNumber) {
        lastBalanceNumber = data.balanceNumber || 0;
      }
    });

    const nextBalanceNumber = lastBalanceNumber + 1;
    
    // Cache the result
    balanceNumberCache.set(originalInvoiceNumber, nextBalanceNumber);

    return {
      balanceInvoiceNumber: `${originalInvoiceNumber}-${nextBalanceNumber}`,
      balanceNumber: nextBalanceNumber
    };
  } catch (error) {
    console.error('Error generating balance invoice number:', error);
    return {
      balanceInvoiceNumber: `${originalInvoiceNumber}-1`,
      balanceNumber: 1
    };
  }
};

// OPTIMIZED: Search with debounce
useEffect(() => {
  const timeoutId = setTimeout(() => {
    if (searchInvoiceNo) {
      const filtered = balanceInvoices.filter(invoice => 
        invoice.invoiceNumber?.toLowerCase().includes(searchInvoiceNo.toLowerCase())
      );
      setFilteredInvoices(filtered);
    } else {
      setFilteredInvoices(balanceInvoices);
    }
  }, 300);
  
  return () => clearTimeout(timeoutId);
}, [searchInvoiceNo, balanceInvoices]);

// Optimized search handler
const handleInvoiceSearch = () => {
  if (!searchInvoiceNo.trim()) {
    setFilteredInvoices(balanceInvoices);
  } else {
    const filtered = balanceInvoices.filter(invoice => 
      invoice.invoiceNumber?.toLowerCase().includes(searchInvoiceNo.toLowerCase())
    );
    setFilteredInvoices(filtered);
  }
};

// Optimized open balance modal
const openBalanceModal = async (invoice) => {
  try {
    setIsLoading(true); // Show loading state
    const { balanceInvoiceNumber } = await generateBalanceInvoiceNumber(invoice.invoiceNumber);
    setNextBalanceInvoiceNo(balanceInvoiceNumber);
    setSelectedInvoice(invoice);
    setBalanceAmount(invoice.balanceDue);
    setBalancePaidAmount(invoice.balanceDue.toString());
    setBalancePaymentMethod('Cash');
    setPaymentDate(new Date().toISOString().split('T')[0]);
    setShowBalanceModal(true);
    setIsLoading(false);
  } catch (error) {
    console.error("Error opening modal:", error);
    setIsLoading(false);
    alert('Error opening modal: ' + error.message);
  }
};

// Fetch on component mount only once
useEffect(() => {
  if (selectedOption === "createBalanceInvoice") {
    fetchPendingBalanceInvoices();
  }
}, [selectedOption]);









// Create balance invoice
const handleCreateBalanceInvoice = async () => {
  if (!selectedInvoice) return;
  
  const paidAmount = parseFloat(balancePaidAmount);
  
  if (isNaN(paidAmount) || paidAmount <= 0) {
    alert('Please enter a valid amount');
    return;
  }
  
  if (paidAmount > selectedInvoice.balanceDue) {
    alert(`Amount cannot exceed balance due of Rs. ${selectedInvoice.balanceDue.toFixed(2)}`);
    return;
  }
  
  setIsLoading(true);
  
  try {
    // Generate balance invoice number
    const { balanceInvoiceNumber, balanceNumber } = await generateBalanceInvoiceNumber(selectedInvoice.invoiceNumber);
    
    const newBalanceDue = selectedInvoice.balanceDue - paidAmount;
    const paymentDateTime = new Date(paymentDate).toISOString();
    
    // Create balance invoice record
    const balanceInvoiceData = {
      originalInvoiceId: selectedInvoice.docId,
      originalInvoiceNumber: selectedInvoice.invoiceNumber,
      balanceNumber: balanceNumber,
      balanceInvoiceNumber: balanceInvoiceNumber,
      customerName: selectedInvoice.customer?.fullName,
      customerPhone: selectedInvoice.customer?.tpNo,
      customerAddress: selectedInvoice.customer?.address,
      originalAmount: selectedInvoice.financial?.totalAmount || 0,
      originalAdvance: selectedInvoice.financial?.advancePayment || 0,
      previousBalance: selectedInvoice.balanceDue,
      paidAmount: paidAmount,
      remainingBalance: newBalanceDue,
      paymentMethod: balancePaymentMethod,
      paymentDate: paymentDateTime,
      paymentDateOnly: paymentDate,
      status: newBalanceDue <= 0 ? 'settled' : 'partial',
      createdAt: new Date().toISOString()
    };
    
    // Save balance invoice to Firestore
    await addDoc(collection(db, 'balance_invoices'), balanceInvoiceData);
    
    // Update original invoice
    const invoiceRef = doc(db, 'invoices', selectedInvoice.docId);
    const updatedAdvancePayment = (selectedInvoice.financial?.advancePayment || 0) + paidAmount;
    const updatedBalanceDue = selectedInvoice.financial?.totalAmount - updatedAdvancePayment;
    
    await updateDoc(invoiceRef, {
      'financial.advancePayment': updatedAdvancePayment,
      'financial.balanceDue': updatedBalanceDue,
      status: updatedBalanceDue <= 0 ? 'paid' : 'pending'
    });
    
    // Generate balance invoice PDF (optional - remove if you don't have this function)
    if (typeof generateBalanceInvoicePDF === 'function') {
      await generateBalanceInvoicePDF(balanceInvoiceData, selectedInvoice);
    }
    
    alert(`Balance invoice created successfully!\nInvoice: ${balanceInvoiceNumber}\nDate: ${paymentDate}\nPaid: Rs. ${paidAmount.toFixed(2)}\nRemaining: Rs. ${newBalanceDue.toFixed(2)}`);
    
    setShowBalanceModal(false);
    setSelectedInvoice(null);
    setBalancePaidAmount('');
    setPaymentDate(new Date().toISOString().split('T')[0]);
    
    // Refresh the list
    await fetchPendingBalanceInvoices();
    
  } catch (error) {
    console.error('Error creating balance invoice:', error);
    alert('Error creating balance invoice: ' + error.message);
  } finally {
    setIsLoading(false);
  }
};



















// const generateBalanceInvoicePDF = async (balanceData, originalInvoice) => {
//   const doc = new jsPDF({
//     orientation: 'portrait',
//     unit: 'mm',
//     format: 'a5'
//   });

//   const pageWidth = doc.internal.pageSize.getWidth();
//   let y = 15;

//   // Helper function to add lines
//   const addLine = (text, x, yPos, fontSize = 9, fontStyle = "normal") => {
//     doc.setFont("Times New Roman", fontStyle);
//     doc.setFontSize(fontSize);
//     doc.text(text, x, yPos);
//     return yPos + 5;
//   };

//   doc.setFont("Times New Roman", "normal");
//   doc.setFontSize(8);

//   doc.text(`Date: ${new Date(balanceData.paymentDate).toLocaleDateString()}`, pageWidth - 10, 45, { align: "right" });

//   y = 58;

//   // ------------------------------
//   // DIVIDER LINE
//   // ------------------------------
//   doc.setLineWidth(0.3);
//   doc.line(10, y, pageWidth - 10, y);
//   y += 6;

//   // ------------------------------
//   // INVOICE TITLE
//   // ------------------------------
//   doc.setFont("Times New Roman", "bold");
//   doc.setFontSize(11);
//   doc.text("BALANCE INVOICE", pageWidth / 2, y, { align: "center" });
//   y += 8;

//   // ------------------------------
//   // CUSTOMER DETAILS - TWO COLUMN LAYOUT
//   // ------------------------------
//   const leftCol = 10;
//   const rightCol = pageWidth / 2 + 5;
//   let tempY = y;

//   // Left Column - Invoice Details
//   doc.setFont("Times New Roman", "bold");
//   doc.setFontSize(9);
//   doc.text("Invoice Details", leftCol, tempY);
//   tempY += 6;
  
//   doc.setFont("Times New Roman", "normal");
//   doc.setFontSize(9);
//   tempY = addLine(`Original Invoice: ${balanceData.originalInvoiceNumber || '-'}`, leftCol, tempY, 9, "normal");
  
//   // Add RX/VIP Number from original invoice
//   if (originalInvoice) {
//     if (originalInvoice.invoiceType === 'RX') {
//       tempY = addLine(`RX No: ${originalInvoice.rxNumber || '-'}`, leftCol, tempY, 9, "normal");
//     } else if (originalInvoice.invoiceType === 'VIP') {
//       tempY = addLine(`VIP No: ${originalInvoice.vipNumber || '-'}`, leftCol, tempY, 9, "normal");
//     }
//   }
  
//   tempY = addLine(`Sub-Invoice No: ${balanceData.balanceInvoiceNumber || '-'}`, leftCol, tempY, 9, "normal");

//   // Right Column - Customer Details
//   doc.setFont("Times New Roman", "bold");
//   doc.setFontSize(9);
//   doc.text("Customer Details", rightCol, y);
//   let rightY = y + 6;
  
//   doc.setFont("Times New Roman", "normal");
//   doc.setFontSize(9);
  
//   // Customer name with word wrap
//   const nameLines = doc.splitTextToSize(`Name: ${balanceData.customerName || '-'}`, 55);
//   doc.text(nameLines, rightCol, rightY);
//   rightY += nameLines.length * 4.5 + 2;
  
//   rightY = addLine(`Phone: ${balanceData.customerPhone || '-'}`, rightCol, rightY, 9, "normal");

//   // Update y to the maximum of both columns
//   y = Math.max(tempY, rightY);
//   y += 2;

//   // Add CL No or S No below both columns (if they exist)
//   if (originalInvoice) {
//     if (originalInvoice.directInvoiceType === 'CL') {
//       y = addLine(`CL No: ${originalInvoice.clNumber || originalInvoice.clNo || '-'}`, leftCol, y, 9, "normal");
//     } else if (originalInvoice.directInvoiceType === 'S') {
//       y = addLine(`S No: ${originalInvoice.sNumber || '-'}`, leftCol, y, 9, "normal");
//     }
//   }

//   y += 2;

//   // ------------------------------
//   // DIVIDER
//   // ------------------------------
//   doc.line(10, y, pageWidth - 10, y);
//   y += 8;









// doc.setTextColor(0, 0, 0);
// doc.setFont("Times New Roman", "bold");
// doc.setFontSize(10);
// doc.text("Description", 12, y);

// doc.setFont("Times New Roman", "normal");
// doc.setFontSize(9);

// // Print service description only for service invoices
// let description = "-";

// if (originalInvoice?.type === "service-invoice") {
//   description = originalInvoice?.service?.description || "-";
// } else {
//   // Your existing description logic for other invoice types
//   description = balanceData.serviceDescription || "-";
// }

// const descLines = doc.splitTextToSize(description, pageWidth - 25);
// doc.text(descLines, 12, y + 6);

// y += descLines.length * 5;









//   y += 6;



//   // ------------------------------
//   // DIVIDER
//   // ------------------------------
//   doc.line(10, y, pageWidth - 10, y);
//   y += 8;


//   // ------------------------------
//   // PAYMENT DETAILS SECTION WITH NAVY BLUE BAR
//   // ------------------------------
//   // doc.setFillColor(0, 0, 128);
//   // doc.rect(10, y - 4, pageWidth - 20, 6, "F");
  
//   doc.setTextColor(0, 0, 0);
//   doc.setFont("Times New Roman", "bold");
//   doc.setFontSize(10);
//   doc.text("Payment Details", 12, y);
  
//   doc.setTextColor(0, 0, 0);
//   y += 7;

//   doc.setFont("Times New Roman", "normal");
//   doc.setFontSize(9);
  
//   doc.text("Original Amount", 10, y);
//   doc.text(`Rs. ${(balanceData.originalAmount || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
//   y += 6;

//   doc.text("Previous Advance", 10, y);
//   doc.text(`Rs. ${(balanceData.originalAdvance || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
//   y += 6;

//   doc.text("Previous Balance", 10, y);
//   doc.text(`Rs. ${(balanceData.previousBalance || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
//   y += 8;

//   doc.setFont("Times New Roman", "bold");
//   doc.setTextColor(0, 0, 0);
//   doc.text("Amount Paid", 10, y);
//   doc.text(`Rs. ${(balanceData.paidAmount || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
//   y += 6;

//   doc.setFont("Times New Roman", "normal");
//   doc.setTextColor(0, 0, 0);
//   doc.text("Payment Method", 10, y);
//   doc.text(balanceData.paymentMethod || "-", pageWidth - 10, y, { align: "right" });
//   y += 8;

//   if ((balanceData.remainingBalance || 0) > 0) {
//     doc.setFont("Times New Roman", "bold");
//     doc.setTextColor(0, 0, 0);
//     doc.text("Remaining Balance", 10, y);
//     doc.text(`Rs. ${(balanceData.remainingBalance || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
//   } else {
//     doc.setFont("Times New Roman", "bold");
 

//   }
//   y += 10;

//   // ------------------------------
//   // DIVIDER
//   // ------------------------------
//   doc.line(10, y, pageWidth - 10, y);
//   y += 8;

 

//   y += 5;


//   // ------------------------------
//   // SAVE PDF
//   // ------------------------------
//   const fileName = `${balanceData.balanceInvoiceNumber}_BALANCE_INVOICE.pdf`;
//   doc.save(fileName);
// };



const generateBalanceInvoicePDF = async (balanceData, originalInvoice) => {
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a5'
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  let y = 15;

  // Helper function to add lines
  const addLine = (text, x, yPos, fontSize = 9, fontStyle = "normal") => {
    doc.setFont("Times New Roman", fontStyle);
    doc.setFontSize(fontSize);
    doc.text(text, x, yPos);
    return yPos + 5;
  };

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(8);

  doc.text(`Date: ${new Date(balanceData.paymentDate).toLocaleDateString()}`, pageWidth - 10, 45, { align: "right" });

  y = 58;

  // ------------------------------
  // DIVIDER LINE
  // ------------------------------
  doc.setLineWidth(0.3);
  doc.line(10, y, pageWidth - 10, y);
  y += 6;

  // ------------------------------
  // INVOICE TITLE
  // ------------------------------
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(11);
  doc.text("BALANCE INVOICE", pageWidth / 2, y, { align: "center" });
  y += 8;

  // ------------------------------
  // CUSTOMER DETAILS - TWO COLUMN LAYOUT
  // ------------------------------
  const leftCol = 10;
  const rightCol = pageWidth / 2 + 5;
  let tempY = y;

  // Left Column - Invoice Details
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(9);
  doc.text("Invoice Details", leftCol, tempY);
  tempY += 6;
  
  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  tempY = addLine(`Original Invoice: ${balanceData.originalInvoiceNumber || '-'}`, leftCol, tempY, 9, "normal");
  
  // Add RX/VIP Number from original invoice
  if (originalInvoice) {
    if (originalInvoice.invoiceType === 'RX') {
      tempY = addLine(`RX No: ${originalInvoice.rxNumber || '-'}`, leftCol, tempY, 9, "normal");
    } else if (originalInvoice.invoiceType === 'VIP') {
      tempY = addLine(`VIP No: ${originalInvoice.vipNumber || '-'}`, leftCol, tempY, 9, "normal");
    }
  }
  
  tempY = addLine(`Sub-Invoice No: ${balanceData.balanceInvoiceNumber || '-'}`, leftCol, tempY, 9, "normal");

  // Right Column - Customer Details
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(9);
  doc.text("Customer Details", rightCol, y);
  let rightY = y + 6;
  
  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  
  // Customer name with word wrap
  const nameLines = doc.splitTextToSize(`Name: ${balanceData.customerName || '-'}`, 55);
  doc.text(nameLines, rightCol, rightY);
  rightY += nameLines.length * 4.5 + 2;
  
  rightY = addLine(`Phone: ${balanceData.customerPhone || '-'}`, rightCol, rightY, 9, "normal");

  // Update y to the maximum of both columns
  y = Math.max(tempY, rightY);
  y += 2;

  // Add CL No or S No below both columns (if they exist)
  if (originalInvoice) {
    if (originalInvoice.directInvoiceType === 'CL') {
      y = addLine(`CL No: ${originalInvoice.clNumber || originalInvoice.clNo || '-'}`, leftCol, y, 9, "normal");
    } else if (originalInvoice.directInvoiceType === 'S') {
      y = addLine(`S No: ${originalInvoice.sNumber || '-'}`, leftCol, y, 9, "normal");
    }
  }

  y += 2;

  // ------------------------------
  // DIVIDER
  // ------------------------------
  doc.line(10, y, pageWidth - 10, y);
  y += 8;

  // ================================================================
  // CONTENT BASED ON INVOICE TYPE (SERVICE vs PRODUCT)
  // ================================================================
  
  if (originalInvoice?.type === "service-invoice") {
    // ==========================================
    // SERVICE INVOICE - Show Description
    // ==========================================
    doc.setTextColor(0, 0, 0);
    doc.setFont("Times New Roman", "bold");
    doc.setFontSize(10);
    doc.text("Service Description", 12, y);
    y += 6;

    doc.setFont("Times New Roman", "normal");
    doc.setFontSize(9);

    let description = originalInvoice?.service?.description || "-";
    const descLines = doc.splitTextToSize(description, pageWidth - 25);
    doc.text(descLines, 12, y);
    y += descLines.length * 5 + 4;

  } else {
    // ==========================================
    // PRODUCT INVOICE - Show Product Details
    // ==========================================
    
    // Get invoice data
    const invoiceData = originalInvoice?.invoiceData || originalInvoice || {};
    const directInvoiceType = originalInvoice?.directInvoiceType || '';
    
    // Check if we should show lens and frame
    // Show lens and frame ONLY for RX and VIP (regular optical invoices)
    // Skip for S (Direct Sale) and CL (Contact Lens)
    const showLensAndFrame = directInvoiceType === 'RX' || directInvoiceType === 'VIP' || !directInvoiceType;
    
    // ------------------------------
    // PRODUCT HEADER
    // ------------------------------
    doc.setTextColor(0, 0, 0);
    doc.setFont("Times New Roman", "bold");
    doc.setFontSize(10);
    doc.text("Product Details", 12, y);
    y += 6;

    doc.setFont("Times New Roman", "normal");
    doc.setFontSize(7);

    // ==========================================
    // SHOW LENS AND FRAME ONLY FOR RX/VIP
    // ==========================================
    if (showLensAndFrame) {
      // ------------------------------
      // LENS DETAILS
      // ------------------------------
      const leftLens = invoiceData.products?.highIndexLens
        ? invoiceData.products.highIndexLeft
        : (invoiceData.products?.leftLens || {});

      const rightLens = invoiceData.products?.highIndexLens
        ? invoiceData.products.highIndexRight
        : (invoiceData.products?.rightLens || {});

      // LEFT LENS
      const leftLensPrice = invoiceData.products?.highIndexLens
        ? (leftLens.price || 0)
        : ((leftLens.pairPrice || 0) / 2);

      const leftText = `Left Lens : ${leftLens.brand || "-"}, ${leftLens.type || "-"}, ${leftLens.name || "-"}`;
      doc.text(leftText, 10, y);
      y += 4;

      // RIGHT LENS
      const rightLensPrice = invoiceData.products?.highIndexLens
        ? (rightLens.price || 0)
        : ((rightLens.pairPrice || 0) / 2);

      const rightText = `Right Lens : ${rightLens.brand || "-"}, ${rightLens.type || "-"}, ${rightLens.name || "-"}`;
      doc.text(rightText, 10, y);
      y += 4;

      // ------------------------------
      // FRAME DETAILS
      // ------------------------------
      const frame = invoiceData.products?.frame || {};
      const frameModel = frame.modelNo || invoiceData.products?.frameModel || "-";
      const frameBrand = frame.brand || invoiceData.products?.frameBrand || "-";
      const frameSize = frame.size || invoiceData.products?.frameSize || "-";
      const frameColor = frame.colour || invoiceData.products?.frameColour || "-";
      const framePrice = frame.sellingPrice || invoiceData.products?.framePrice || 0;

      doc.text(`Frame: ${frameBrand}  /  ${frameModel}  /  ${frameSize}  /  ${frameColor}`, 10, y);
      y += 8;
    } else {
      // For S (Direct Sale) or CL (Contact Lens)
      let noteText = '';
      if (directInvoiceType === 'S') {
        noteText = 'Direct Sale Items';
      } else if (directInvoiceType === 'CL') {
        noteText = 'Contact Lens Items';
      }
      
      if (noteText) {
        doc.setFont("Times New Roman", "italic");
        doc.setFontSize(7);
        doc.text(noteText, 10, y);
        y += 6;
        doc.setFont("Times New Roman", "normal");
        doc.setFontSize(7);
      }
    }

    // ------------------------------
    // PRODUCT TABLE (for all product invoices)
    // ------------------------------
    if (invoiceData.products && Array.isArray(invoiceData.products) && invoiceData.products.length > 0) {
      const leftMargin = 10;
      const rightMargin = pageWidth - 10;
      
      // Check if it's a CL bill (for column headers)
      const isCL = directInvoiceType === 'CL';
      
      // Column Positions
      let cols;
      if (isCL) {
        cols = {
          num: leftMargin + 2,
          model: leftMargin + 6,
          brand: leftMargin + 32,
          color: leftMargin + 58,
          rPower: leftMargin + 78,
          lPower: leftMargin + 94,
          qty: leftMargin + 108,
          price: rightMargin - 2
        };
      } else {
        cols = {
          num: leftMargin + 5,
          model: leftMargin + 12,
          brand: leftMargin + 50,
          color: leftMargin + 87,
          qty: leftMargin + 114,
          price: rightMargin - 2
        };
      }

      // Header Background
      doc.setFillColor(240, 240, 240);
      doc.rect(leftMargin, y - 4, rightMargin - leftMargin, 6, "F");

      // Header
      doc.setFont("helvetica", "bold");
      doc.setFontSize(6);

      if (isCL) {
        doc.text("#", cols.num, y, { align: "center" });
        doc.text("Model", cols.model, y);
        doc.text("Brand", cols.brand, y);
        doc.text("Color", cols.color, y);
        doc.text("R Power", cols.rPower, y, { align: "center" });
        doc.text("L Power", cols.lPower, y, { align: "center" });
        doc.text("Qty", cols.qty, y, { align: "center" });
        doc.text("Price", cols.price, y, { align: "right" });
      } else {
        doc.text("#", cols.num, y, { align: "center" });
        doc.text("Model", cols.model, y);
        doc.text("Brand", cols.brand, y);
        doc.text("Color", cols.color, y);
        doc.text("Qty", cols.qty, y, { align: "center" });
        doc.text("Price", cols.price, y, { align: "right" });
      }

      y += 4;
      doc.setDrawColor(180);
      doc.line(leftMargin, y, rightMargin, y);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(6);

      // Loop through products
      invoiceData.products.forEach((item, index) => {
        if (y > pageHeight - 35) {
          doc.addPage();
          y = 15;
          // Repeat Header
          doc.setFillColor(240, 240, 240);
          doc.rect(leftMargin, y - 4, rightMargin - leftMargin, 6, "F");
          doc.setFont("helvetica", "bold");
          doc.setFontSize(6);
          if (isCL) {
            doc.text("#", cols.num, y, { align: "center" });
            doc.text("Model", cols.model, y);
            doc.text("Brand", cols.brand, y);
            doc.text("Color", cols.color, y);
            doc.text("R Power", cols.rPower, y, { align: "center" });
            doc.text("L Power", cols.lPower, y, { align: "center" });
            doc.text("Qty", cols.qty, y, { align: "center" });
            doc.text("Price", cols.price, y, { align: "right" });
          } else {
            doc.text("#", cols.num, y, { align: "center" });
            doc.text("Model", cols.model, y);
            doc.text("Brand", cols.brand, y);
            doc.text("Color", cols.color, y);
            doc.text("Qty", cols.qty, y, { align: "center" });
            doc.text("Price", cols.price, y, { align: "right" });
          }
          y += 4;
          doc.line(leftMargin, y, rightMargin, y);
          doc.setFont("helvetica", "normal");
          doc.setFontSize(6);
        }

        y += 4;

        const model = item.modelNo || "-";
        const brand = item.brand || "-";
        const colour = item.colour || "-";
        const qty = item.qty || 1;
        const price = Number(item.price || 0);
        const rPower = item.rPower || "-";
        const lPower = item.lPower || "-";

        if (isCL) {
          doc.text(String(index + 1), cols.num, y, { align: "center" });
          doc.text(model, cols.model, y);
          doc.text(brand, cols.brand, y);
          doc.text(colour, cols.color, y);
          doc.text(rPower, cols.rPower, y, { align: "center" });
          doc.text(lPower, cols.lPower, y, { align: "center" });
          doc.text(String(qty), cols.qty, y, { align: "center" });
          doc.text(`Rs. ${price.toFixed(0)}`, cols.price, y, { align: "right" });
        } else {
          doc.text(String(index + 1), cols.num, y, { align: "center" });
          doc.text(model, cols.model, y);
          doc.text(brand, cols.brand, y);
          doc.text(colour, cols.color, y);
          doc.text(String(qty), cols.qty, y, { align: "center" });
          doc.text(`Rs. ${price.toFixed(0)}`, cols.price, y, { align: "right" });
        }

        doc.setDrawColor(230);
        doc.line(leftMargin, y + 2, rightMargin, y + 2);
      });
      
      y += 8;
    }
  }

  // ================================================================
  // DIVIDER
  // ================================================================
  doc.line(10, y, pageWidth - 10, y);
  y += 8;

  // ------------------------------
  // PAYMENT DETAILS SECTION
  // ------------------------------
  doc.setTextColor(0, 0, 0);
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  doc.text("Payment Details", 12, y);
  
  doc.setTextColor(0, 0, 0);
  y += 7;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);
  
  doc.text("Original Amount", 10, y);
  doc.text(`Rs. ${(balanceData.originalAmount || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 6;

  doc.text("Previous Advance", 10, y);
  doc.text(`Rs. ${(balanceData.originalAdvance || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 6;

  doc.text("Previous Balance", 10, y);
  doc.text(`Rs. ${(balanceData.previousBalance || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 8;

  doc.setFont("Times New Roman", "bold");
  doc.setTextColor(0, 0, 0);
  doc.text("Amount Paid", 10, y);
  doc.text(`Rs. ${(balanceData.paidAmount || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  y += 6;

  doc.setFont("Times New Roman", "normal");
  doc.setTextColor(0, 0, 0);
  doc.text("Payment Method", 10, y);
  doc.text(balanceData.paymentMethod || "-", pageWidth - 10, y, { align: "right" });
  y += 8;

  if ((balanceData.remainingBalance || 0) > 0) {
    doc.setFont("Times New Roman", "bold");
    doc.setTextColor(0, 0, 0);
    doc.text("Remaining Balance", 10, y);
    doc.text(`Rs. ${(balanceData.remainingBalance || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
  }
  y += 10;

  // ------------------------------
  // DIVIDER
  // ------------------------------
  doc.line(10, y, pageWidth - 10, y);
  y += 8;

  y += 5;

  // ------------------------------
  // SAVE PDF
  // ------------------------------
  const fileName = `${balanceData.balanceInvoiceNumber}_BALANCE_INVOICE.pdf`;
  doc.save(fileName);
};













  // Fetch invoices when component mounts or when selectedOption changes
  useEffect(() => {
    if (selectedOption === "createBalanceInvoice") {
      fetchPendingBalanceInvoices();
    }
  }, [selectedOption]);











/////////////////////////////////////////////////////// view all balance invoices ////////////////////////////////////////////////////////////
// Add state for balance invoices list
const [allBalanceInvoices, setAllBalanceInvoices] = useState([]);
const [filteredBalanceInvoices, setFilteredBalanceInvoices] = useState([]);
const [balanceInvoiceSearchTerm, setBalanceInvoiceSearchTerm] = useState('');
const [balanceInvoiceFilterStatus, setBalanceInvoiceFilterStatus] = useState('all');
const [isLoadingBalanceInvoices, setIsLoadingBalanceInvoices] = useState(false);
const [selectedBalanceInvoice, setSelectedBalanceInvoice] = useState(null);
const [showBalanceInvoiceDetails, setShowBalanceInvoiceDetails] = useState(false);

// Fetch all balance invoices
const fetchAllBalanceInvoices = async () => {
  try {
    setIsLoadingBalanceInvoices(true);
    const balanceInvoicesQuery = query(
      collection(db, 'balance_invoices'),
      orderBy('createdAt', 'desc')
    );
    const balanceSnapshot = await getDocs(balanceInvoicesQuery);
    const balanceList = [];
    
    for (const doc of balanceSnapshot.docs) {
      const data = doc.data();
      balanceList.push({
        id: doc.id,
        ...data,
        formattedDate: new Date(data.createdAt).toLocaleDateString(),
        formattedTime: new Date(data.createdAt).toLocaleTimeString(),
        statusText: data.remainingBalance <= 0 ? 'Settled' : 'Partial',
        statusColor: data.remainingBalance <= 0 ? '#4CAF50' : '#ff9800'
      });
    }
    
    setAllBalanceInvoices(balanceList);
    setFilteredBalanceInvoices(balanceList);
    setIsLoadingBalanceInvoices(false);
  } catch (error) {
    console.error('Error fetching balance invoices:', error);
    setIsLoadingBalanceInvoices(false);
    alert('Error fetching balance invoices: ' + error.message);
  }
};

// Filter balance invoices
const filterBalanceInvoices = () => {
  let filtered = [...allBalanceInvoices];
  
  // Search filter
  if (balanceInvoiceSearchTerm) {
    const searchLower = balanceInvoiceSearchTerm.toLowerCase();
    filtered = filtered.filter(invoice => 
      invoice.balanceInvoiceNumber?.toLowerCase().includes(searchLower) ||
      invoice.originalInvoiceNumber?.toLowerCase().includes(searchLower) ||
      invoice.customerName?.toLowerCase().includes(searchLower) ||
      invoice.customerPhone?.toLowerCase().includes(searchLower)
    );
  }
  
  // Status filter
  if (balanceInvoiceFilterStatus !== 'all') {
    filtered = filtered.filter(invoice => 
      balanceInvoiceFilterStatus === 'settled' ? invoice.remainingBalance <= 0 : invoice.remainingBalance > 0
    );
  }
  
  setFilteredBalanceInvoices(filtered);
};





// Download balance invoice PDF
// Replace your existing downloadBalanceInvoicePDF function with this improved version

// REPLACE your existing downloadBalanceInvoicePDF with this

const downloadBalanceInvoicePDF = async (balanceInvoice) => {
  try {
    // Fetch ALL balance invoices (payment records) for this original invoice
    const allPaymentsQuery = query(
      collection(db, 'balance_invoices'),
      where('originalInvoiceNumber', '==', balanceInvoice.originalInvoiceNumber),
      orderBy('createdAt', 'asc')
    );
    
    const allPaymentsSnapshot = await getDocs(allPaymentsQuery);
    const allPayments = [];
    
    allPaymentsSnapshot.forEach(doc => {
      const data = doc.data();
      allPayments.push({
        id: doc.id,
        date: data.createdAt,
        paidAmount: data.paidAmount || 0,
        newBalance: data.remainingBalance || 0,
        paymentMethod: data.paymentMethod,
        balanceInvoiceNumber: data.balanceInvoiceNumber
      });
    });
    
    // Fetch original invoice details
    let originalInvoiceData = null;
    const originalInvoiceQuery = query(
      collection(db, 'invoices'),
      where('invoiceNumber', '==', balanceInvoice.originalInvoiceNumber)
    );
    const originalSnapshot = await getDocs(originalInvoiceQuery);
    
    if (!originalSnapshot.empty) {
      originalInvoiceData = originalSnapshot.docs[0].data();
    }
    
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a5"
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    let y = 13;

    // Helper function to add lines
    const addLine = (text, x, yPos, fontSize = 9, fontStyle = "normal") => {
      doc.setFont("Times New Roman", fontStyle);
      doc.setFontSize(fontSize);
      doc.text(text, x, yPos);
      return yPos + 5;
    };

    doc.setFont("Times New Roman", "normal");
    doc.setFontSize(8);

    doc.text(`Date: ${balanceInvoice.formattedDate || new Date().toLocaleDateString()}`, pageWidth - 10, 40, { align: "right" });

    y = 50;

    // Divider
    doc.setLineWidth(0.3);
    doc.line(10, y, pageWidth - 10, y);
    y += 6;

    // ------------------------------
    // INVOICE TITLE
    // ------------------------------
    doc.setFont("Times New Roman", "bold");
    doc.setFontSize(12);
    doc.text("Balance Invoice", pageWidth / 2, y, { align: "center" });
    y += 7;

    // ------------------------------
    // INVOICE AND CUSTOMER DETAILS WITH TWO COLUMNS
    // ------------------------------
    const leftCol = 10;
    const rightCol = pageWidth / 2 + 5;
    let tempY = y;

    // Left column - Invoice Details
    doc.setFont("Times New Roman", "normal");
    doc.setFontSize(9);
    
    y = addLine(`Original Invoice: ${balanceInvoice.originalInvoiceNumber}`, leftCol, y, 9, "normal");
    
    // Add RX/VIP Number from original invoice
    if (originalInvoiceData) {
      if (originalInvoiceData.invoiceType === 'RX') {
        y = addLine(`RX No: ${originalInvoiceData.rxNumber || '-'}`, leftCol, y, 9, "normal");
      } else if (originalInvoiceData.invoiceType === 'VIP') {
        y = addLine(`VIP No: ${originalInvoiceData.vipNumber || '-'}`, leftCol, y, 9, "normal");
      }
    }
    
    // Right column - Customer Details
    doc.setFont("Times New Roman", "normal");
    doc.setFontSize(10);
    const patientLines = doc.splitTextToSize(`Customer: ${balanceInvoice.customerName || '-'}`, 60);
    doc.text(patientLines, rightCol, tempY);
    tempY += patientLines.length * 5 + 2;
    
    doc.setFontSize(9);
    doc.text(`Phone: ${balanceInvoice.customerPhone || '-'}`, rightCol, tempY);
    tempY += 6;

    // Check if right column went further than left column
    y = Math.max(y, tempY);
    y += 2;

    // Add CL No or S No below both columns
    if (originalInvoiceData) {
      let extraLineY = y;
      
      if (originalInvoiceData.directInvoiceType === 'CL') {
        doc.setFont("Times New Roman", "normal");
        doc.setFontSize(9);
        doc.text(`CL No: ${originalInvoiceData.clNumber || originalInvoiceData.clNo || '-'}`, leftCol, extraLineY);
        y += 5;
      } else if (originalInvoiceData.directInvoiceType === 'S') {
        doc.setFont("Times New Roman", "normal");
        doc.setFontSize(9);
        doc.text(`S No: ${originalInvoiceData.sNumber || '-'}`, leftCol, extraLineY);
        y += 5;
      }
    }

    y += 2;





// Print Description ONLY for service invoices
if (originalInvoiceData?.type === "service-invoice") {
  doc.setFont("Times New Roman", "bold");
  doc.setFontSize(10);
  doc.text("Description", 10, y);

  y += 6;

  doc.setFont("Times New Roman", "normal");
  doc.setFontSize(9);

  const description =
    originalInvoiceData.service?.description || "-";

  const descriptionLines = doc.splitTextToSize(description, pageWidth - 20);
  doc.text(descriptionLines, 10, y);

  y += descriptionLines.length * 5 + 2;
}





    // ------------------------------
    // TABLE HEADER (BLUE)
    // ------------------------------
    // doc.setFillColor(32, 30, 244);
    // doc.rect(10, y, pageWidth - 20, 7, "F"); // Slightly taller

    doc.setTextColor(0, 0, 0);
    doc.setFont("Times New Roman", "bold");
    doc.setFontSize(9); // Increased
    doc.text("Payment Details", 12, y + 5);
    y += 11;
    doc.setTextColor(0, 0, 0);

    // ------------------------------
    // FINANCIAL SUMMARY
    // ------------------------------
    doc.setFont("Times New Roman", "normal");
    doc.setFontSize(9); // Increased
    
    doc.text("Original Amount:", 12, y);
    doc.text(`Rs ${(balanceInvoice.originalAmount || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
    y += 5;

    doc.text("Previous Advance:", 12, y);
    doc.text(`Rs ${(balanceInvoice.originalAdvance || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
    y += 5;

    doc.text("Previous Balance:", 12, y);
    doc.text(`Rs ${(balanceInvoice.originalBalance || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
    y += 5;

    doc.line(10, y, pageWidth - 10, y);
    y += 5;

    doc.setFont("Times New Roman", "bold");
    doc.text("Amount Paid:", 12, y);
    doc.text(`Rs ${(balanceInvoice.paidAmount || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
    y += 5;

    doc.setFont("Times New Roman", "normal");
    doc.text("Payment Method:", 12, y);
    doc.text(balanceInvoice.paymentMethod || "-", pageWidth - 10, y, { align: "right" });
    y += 5;

    if ((balanceInvoice.remainingBalance || 0) > 0) {
      doc.setFont("Times New Roman", "bold");
      doc.text("Remaining Balance:", 12, y);
      doc.text(`Rs ${(balanceInvoice.remainingBalance || 0).toFixed(2)}`, pageWidth - 10, y, { align: "right" });
    } else {
      doc.setFont("Times New Roman", "normal");
      // doc.text("Status:", 12, y);
      // doc.text("Fully Paid", pageWidth - 10, y, { align: "right" });
    }
    y += 7;
    doc.setTextColor(0, 0, 0);

    // ------------------------------
    // PAYMENT HISTORY SECTION
    // ------------------------------
    if (allPayments.length > 0) {
      // doc.setFillColor(32, 30, 244);
      // doc.rect(10, y, pageWidth - 20, 7, "F");
        doc.setTextColor(0, 0, 0);
      doc.setFont("Times New Roman", "bold");
      doc.setFontSize(9);
      doc.text("All Balance Payments", 12, y + 5);
      y += 10;
      doc.setTextColor(0, 0, 0);

      // Table headers for payment history
      doc.setFont("Times New Roman", "bold");
      doc.setFontSize(8);
      doc.text("No.", 10, y);
      doc.text("Date", 25, y);
      doc.text("Invoice No", 52, y);
      doc.text("Paid (Rs)", pageWidth - 58, y, { align: "center" });
      doc.text("Balance (Rs)", pageWidth - 20, y, { align: "right" });
      y += 5;
      
      doc.setLineWidth(0.2);
      doc.line(10, y, pageWidth - 10, y);
      y += 4;
      
      doc.setFont("Times New Roman", "normal");
      doc.setFontSize(8);
      
      // Display payments with adjusted spacing
      const displayPayments = allPayments.slice(0, 6); // Max 6 payments on one page
      
      displayPayments.forEach((payment, idx) => {
        const paymentDate = payment.date ? new Date(payment.date).toLocaleDateString() : "-";
        
        doc.text(`${idx + 1}`, 10, y);
        doc.text(paymentDate, 25, y);
        doc.text(payment.balanceInvoiceNumber || "-", 52, y);
        doc.text(`Rs ${payment.paidAmount.toFixed(2)}`, pageWidth - 58, y, { align: "center" });
        doc.text(`Rs ${payment.newBalance.toFixed(2)}`, pageWidth - 20, y, { align: "right" });
        y += 4.5;
        
        if (idx === 5 && allPayments.length > 6) {
          doc.setFont("Times New Roman", "italic");
          doc.setFontSize(7);
          doc.text(`+ ${allPayments.length - 6} more payments`, 10, y);
          doc.setFont("Times New Roman", "normal");
        }
      });
    }

    // ------------------------------
    // SAVE PDF
    // ------------------------------
    const fileName = `${balanceInvoice.balanceInvoiceNumber}_BALANCE_INVOICE.pdf`;
    doc.save(fileName);
    alert('PDF downloaded successfully!');
    
  } catch (error) {
    console.error('Error downloading PDF:', error);
    alert('Error downloading PDF: ' + error.message);
  }
};







// Delete balance invoice
const deleteBalanceInvoice = async (
  balanceInvoiceId,
  balanceInvoiceNumber
) => {

  // PASSWORD CHECK
  const password = prompt(
    `Enter authorized password to delete balance invoice ${balanceInvoiceNumber}`
  );

  // AUTH PASSWORD
  if (password !== "rayban@142") {
    alert("Unauthorized Password!");
    return;
  }

  // CONFIRM DELETE
  if (
    window.confirm(
      `Are you sure you want to delete balance invoice ${balanceInvoiceNumber}?\n\nThis action cannot be undone!`
    )
  ) {

    try {

      // Get balance invoice data
      const balanceInvoiceRef = doc(
        db,
        'balance_invoices',
        balanceInvoiceId
      );

      const balanceDoc = await getDoc(balanceInvoiceRef);

      const balanceData = balanceDoc.data();

      // Update original invoice
      if (balanceData && balanceData.originalInvoiceId) {

        const originalInvoiceRef = doc(
          db,
          'invoices',
          balanceData.originalInvoiceId
        );

        const originalDoc = await getDoc(originalInvoiceRef);

        if (originalDoc.exists()) {

          const originalData = originalDoc.data();

          const currentAdvance =
            originalData.financial?.advancePayment || 0;

          const updatedAdvance =
            currentAdvance - balanceData.paidAmount;

          const totalAmount =
            originalData.financial?.totalAmount || 0;

          const updatedBalanceDue =
            totalAmount - updatedAdvance;

          // Update original invoice
          await updateDoc(originalInvoiceRef, {
            'financial.advancePayment': updatedAdvance,
            'financial.balanceDue': updatedBalanceDue,
            status:
              updatedBalanceDue <= 0
                ? 'paid'
                : 'pending'
          });
        }
      }

      // Delete balance invoice
      await deleteDoc(balanceInvoiceRef);

      alert(
        `Balance invoice ${balanceInvoiceNumber} deleted successfully!`
      );

      await fetchAllBalanceInvoices();

    } catch (error) {

      console.error(
        'Error deleting balance invoice:',
        error
      );

      alert(
        'Error deleting balance invoice: ' +
        error.message
      );
    }
  }
};







// View balance invoice details
const viewBalanceInvoiceDetails = (invoice) => {
  setSelectedBalanceInvoice(invoice);
  setShowBalanceInvoiceDetails(true);
};



// Generate summary report
const generateBalanceSummaryReport = async () => {
  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a4'
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const primaryColor = [15, 23, 42];

  let yPosition = 0;
  let rowCount = 0;

  // Draw header on each page
  const drawHeader = (isFirstPage) => {
    // Compact header background
    doc.setFillColor(...primaryColor);
    doc.rect(0, 0, pageWidth, 28, "F");

    // Logo
    try {
      doc.addImage("/ray-ban-logo.png", "PNG", 10, 4, 18, 18);
    } catch (err) {}

    // Company details
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Ray Ban Opticians", 35, 11);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    doc.text("Ray Ban Building, 142, Kandy Road, Dalugama, Kiribathgoda", 35, 18);
    doc.text("Hotline: 0767873232 Tel: 0112912333 / 0112914949 Fax: 0112913933", 35, 23);
   doc.text("Email: info@raybanopticians.com | Web: raybanopticians.com", 35, 26);

    // Report title
    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    doc.setTextColor(0, 0, 0);
    
    if (isFirstPage) {
      doc.text("BALANCE PAYMENT REPORT", pageWidth / 2, 42, { align: "center" });
      doc.setFontSize(8);
      doc.setFont("helvetica", "normal");
      doc.text(`Generated: ${new Date().toLocaleString()}`, pageWidth / 2, 50, { align: "center" });
      return 58;
    } else {
      doc.text("BALANCE PAYMENT REPORT (Continued)", pageWidth / 2, 40, { align: "center" });
      return 48;
    }
  };

  // Draw compact summary row
  const drawSummaryRow = (startY) => {
    const totalPaid = filteredBalanceInvoices.reduce((sum, inv) => sum + (inv.paidAmount || 0), 0);
    const totalRemaining = filteredBalanceInvoices.reduce((sum, inv) => sum + (inv.remainingBalance || 0), 0);
    const settledCount = filteredBalanceInvoices.filter(inv => inv.remainingBalance <= 0).length;
    const partialCount = filteredBalanceInvoices.filter(inv => inv.remainingBalance > 0).length;

    const summaryItems = [
      { label: "Total Transactions", value: filteredBalanceInvoices.length, color: [59, 130, 246] },
      { label: "Settled", value: settledCount, color: [34, 197, 94] },
      { label: "Partial", value: partialCount, color: [245, 158, 11] },
      { label: "Total Paid", value: `Rs. ${totalPaid.toLocaleString()}`, color: [34, 197, 94] },
      { label: "Total Remaining", value: `Rs. ${totalRemaining.toLocaleString()}`, color: [239, 68, 68] }
    ];

    const itemWidth = (pageWidth - 20) / 5;
    let x = 10;

    summaryItems.forEach((item) => {
      doc.setFillColor(248, 250, 252);
      doc.rect(x, startY, itemWidth - 1, 12, "F");
      
      doc.setFillColor(...item.color);
      doc.rect(x, startY, itemWidth - 1, 2, "F");
      
      doc.setTextColor(100, 116, 139);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(6);
      doc.text(item.label, x + 3, startY + 6);
      
      doc.setTextColor(15, 23, 42);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.text(item.value.toString(), x + 3, startY + 11);
      
      x += itemWidth;
    });

    return startY + 16;
  };

  // Draw table headers
  const drawTableHeaders = (y) => {
    doc.setFillColor(...primaryColor);
    doc.rect(10, y, pageWidth - 20, 7, "F");

    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);

    doc.text("Balance Invoice", 13, y + 5);
    doc.text("Original Invoice", 55, y + 5);
    doc.text("Customer Name", 100, y + 5);
    doc.text("Paid Amount", 155, y + 5, { align: "right" });
    doc.text("Remaining", 195, y + 5, { align: "right" });
    doc.text("Payment Date", 235, y + 5, { align: "center" });

    return y + 7;
  };

  // Draw first page
  let startY = drawHeader(true);
  startY = drawSummaryRow(startY);
  yPosition = drawTableHeaders(startY);

  // Loop through balance invoices
  for (let invoice of filteredBalanceInvoices) {
    // Check if need new page
    if (yPosition > 170) {
      doc.addPage();
      startY = drawHeader(false);
      startY = drawSummaryRow(startY);
      yPosition = drawTableHeaders(startY);
      rowCount = 0;
    }

    // Alternate row background
    if (rowCount % 2 === 0) {
      doc.setFillColor(248, 250, 252);
      doc.rect(10, yPosition, pageWidth - 20, 6.5, "F");
    }

    // Draw row borders
    doc.setDrawColor(226, 232, 240);
    doc.rect(10, yPosition, pageWidth - 20, 6.5);

    const paidAmount = invoice.paidAmount || 0;
    const remainingBalance = invoice.remainingBalance || 0;
    const status = remainingBalance <= 0 ? "PAID" : "DUE";
    const statusColor = remainingBalance <= 0 ? [34, 197, 94] : [245, 158, 11];

    // Balance Invoice #
    doc.setTextColor(59, 130, 246);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    doc.text(invoice.balanceInvoiceNumber || '-', 13, yPosition + 5);

    // Original Invoice #
    doc.setTextColor(51, 65, 85);
    doc.setFont("helvetica", "normal");
    doc.text(invoice.originalInvoiceNumber || '-', 55, yPosition + 5);

    // Customer Name
    let customerName = invoice.customerName || '-';
    doc.text(customerName.length > 28 ? customerName.substring(0, 26) + '..' : customerName, 100, yPosition + 5);

    // Paid Amount
    doc.setTextColor(34, 197, 94);
    doc.setFont("helvetica", "bold");
    doc.text(`${paidAmount.toLocaleString()}`, 162, yPosition + 5, { align: "right" });

    // Remaining Balance
    if (remainingBalance > 0) {
      doc.setTextColor(239, 68, 68);
    } else {
      doc.setTextColor(34, 197, 94);
    }
    doc.text(`${remainingBalance.toLocaleString()}`, 202, yPosition + 5, { align: "right" });

    // Payment Date
    doc.setTextColor(100, 116, 139);
    doc.setFont("helvetica", "normal");
    doc.text(invoice.formattedDate || '-', 242, yPosition + 5, { align: "center" });

    // Status Badge
    doc.setFillColor(...statusColor);
    doc.roundedRect(270, yPosition + 1, 14, 5, 2, 2, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(5.5);
    doc.text(status, 277, yPosition + 4.5, { align: "center" });

    yPosition += 6.5;
    rowCount++;
  }

  // Add footer with page numbers
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(7);
    doc.setTextColor(148, 163, 184);
    doc.setFont("helvetica", "normal");
    doc.text(`Page ${i} of ${pageCount}`, pageWidth / 2, pageHeight - 10, { align: "center" });
  }

  doc.save(`BALANCE_PAYMENT_REPORT_${Date.now()}.pdf`);
};







// Fetch balance invoices when component mounts
useEffect(() => {
  if (selectedOption === "viewBalanceInvoice") {
    fetchAllBalanceInvoices();
  }
}, [selectedOption]);

// Apply filters when filter criteria change
useEffect(() => {
  filterBalanceInvoices();
}, [balanceInvoiceSearchTerm, balanceInvoiceFilterStatus, allBalanceInvoices]);

// Reset filters
const resetBalanceFilters = () => {
  setBalanceInvoiceSearchTerm('');
  setBalanceInvoiceFilterStatus('all');
  setFilteredBalanceInvoices(allBalanceInvoices);
};






 



////////////////////////////////////////////////////// view all invoice /////////////////////////////////////////////////////////////////////////




// Add these optimized state variables
const [allInvoices, setAllInvoices] = useState([]);
const [invoiceSearchTerm, setInvoiceSearchTerm] = useState('');
const [invoiceFilterStatus, setInvoiceFilterStatus] = useState('all');
const [invoiceFilterPaymentMethod, setInvoiceFilterPaymentMethod] = useState('all');
const [invoiceDateRange, setInvoiceDateRange] = useState({ start: '', end: '' });
const [selectedInvoiceDetails, setSelectedInvoiceDetails] = useState(null);
const [showInvoiceDetails, setShowInvoiceDetails] = useState(false);

// OPTIMIZED: Fetch invoices with pagination and caching
const fetchAllInvoices = async () => {
  try {
    setIsLoadingInvoices(true);
    
    // Use limit for faster initial load
    const invoicesQuery = query(
      collection(db, 'invoices'),
      orderBy('createdAt', 'desc'),
      limit(100) // Limit to last 100 invoices for faster load
    );
    
    const invoicesSnapshot = await getDocs(invoicesQuery);
    const invoicesList = [];
    
    // Batch process invoices
    const batchPromises = invoicesSnapshot.docs.map(async (doc) => {
      const data = doc.data();
      
      // Fetch balance invoices in parallel
      const balanceQuery = query(
        collection(db, 'balance_invoices'),
        where('originalInvoiceNumber', '==', data.invoiceNumber)
      );
      const balanceSnapshot = await getDocs(balanceQuery);
      
      const balancePayments = [];
      let totalBalancePaid = 0;
      
      balanceSnapshot.forEach(balanceDoc => {
        const balanceData = balanceDoc.data();
        balancePayments.push({
          id: balanceDoc.id,
          amount: balanceData.paidAmount,
          date: balanceData.createdAt,
          method: balanceData.paymentMethod,
          invoiceNumber: balanceData.balanceInvoiceNumber
        });
        totalBalancePaid += balanceData.paidAmount || 0;
      });
      
      return {
        id: doc.id,
        ...data,
        formattedDate: data.createdAt?.toDate ? 
          data.createdAt.toDate().toLocaleDateString() : 
          new Date(data.createdAt).toLocaleDateString(),
        formattedTime: data.createdAt?.toDate ?
          data.createdAt.toDate().toLocaleTimeString() :
          new Date(data.createdAt).toLocaleTimeString(),
        balancePayments: balancePayments,
        totalBalancePaid: totalBalancePaid,
        status: data.status || (data.financial?.balanceDue <= 0 ? 'paid' : 'pending'),
        statusColor: data.financial?.balanceDue <= 0 ? '#4CAF50' : '#ff9800'
      };
    });
    
    const results = await Promise.all(batchPromises);
    invoicesList.push(...results);
    
    setAllInvoices(invoicesList);
    setFilteredInvoices(invoicesList);
    setIsLoadingInvoices(false);
  } catch (error) {
    console.error('Error fetching invoices:', error);
    setIsLoadingInvoices(false);
    alert('Error fetching invoices: ' + error.message);
  }
};

// OPTIMIZED: Memoized filter function
const filterInvoices = useCallback(() => {
  let filtered = [...allInvoices];

  if (invoiceSearchTerm) {
    const searchLower = invoiceSearchTerm.toLowerCase();
    filtered = filtered.filter(invoice =>
      invoice.invoiceNumber?.toLowerCase().includes(searchLower) ||
      invoice.customer?.fullName?.toLowerCase().includes(searchLower) ||
      invoice.customer?.tpNo?.toLowerCase().includes(searchLower) ||
      invoice.customer?.email?.toLowerCase().includes(searchLower)
    );
  }

  if (invoiceFilterStatus !== 'all') {
    filtered = filtered.filter(invoice =>
      invoiceFilterStatus === 'paid'
        ? invoice.financial?.balanceDue <= 0
        : invoice.financial?.balanceDue > 0
    );
  }

  if (invoiceFilterPaymentMethod !== 'all') {
    filtered = filtered.filter(invoice =>
      invoice.financial?.paymentMethod === invoiceFilterPaymentMethod
    );
  }

  if (invoiceDateRange.start) {
    const startDate = new Date(invoiceDateRange.start);
    startDate.setHours(0, 0, 0, 0);
    filtered = filtered.filter(invoice => {
      const invoiceDate = invoice.createdAt?.toDate?.() || new Date(invoice.createdAt);
      return invoiceDate >= startDate;
    });
  }

  if (invoiceDateRange.end) {
    const endDate = new Date(invoiceDateRange.end);
    endDate.setHours(23, 59, 59, 999);
    filtered = filtered.filter(invoice => {
      const invoiceDate = invoice.createdAt?.toDate?.() || new Date(invoice.createdAt);
      return invoiceDate <= endDate;
    });
  }

  filtered.sort((a, b) => {
    const dateA = a.createdAt?.toDate?.() || new Date(a.createdAt);
    const dateB = b.createdAt?.toDate?.() || new Date(b.createdAt);
    return dateB - dateA; // Newest first for better UX
  });

  setFilteredInvoices(filtered);
}, [allInvoices, invoiceSearchTerm, invoiceFilterStatus, invoiceFilterPaymentMethod, invoiceDateRange]);

// Use debounce for search to improve performance
useEffect(() => {
  const timeoutId = setTimeout(() => {
    if (selectedOption === "viewInvoice") {
      filterInvoices();
    }
  }, 300);
  
  return () => clearTimeout(timeoutId);
}, [invoiceSearchTerm, invoiceFilterStatus, invoiceFilterPaymentMethod, invoiceDateRange, filterInvoices, selectedOption]);

// Fetch on mount only once
useEffect(() => {
  if (selectedOption === "viewInvoice") {
    fetchAllInvoices();
  }
}, [selectedOption]);

// Reset filters
const resetInvoiceFilters = () => {
  setInvoiceSearchTerm('');
  setInvoiceFilterStatus('all');
  setInvoiceFilterPaymentMethod('all');
  setInvoiceDateRange({ start: '', end: '' });
  setFilteredInvoices(allInvoices);
};

// View invoice details (memoized to prevent re-renders)
const viewInvoiceDetails = useCallback((invoice) => {
  setSelectedInvoiceDetails(invoice);
  setShowInvoiceDetails(true);
}, []);



// Add this function before the component return statement
// const deleteInvoice = async (invoiceId, invoiceNumber) => {
//   const password = prompt(
//     `Enter password to delete invoice ${invoiceNumber}`
//   );

//   if (password !== "Opex@514") {
//     alert("Incorrect password!");
//     return;
//   }

//   if (
//     window.confirm(
//       `Are you sure you want to delete invoice ${invoiceNumber}?\n\nThis will also delete all related balance invoices!\nThis action cannot be undone!`
//     )
//   ) {
//     try {
//       // Delete related balance invoices
//       const balanceQuery = query(
//         collection(db, 'balance_invoices'),
//         where('originalInvoiceNumber', '==', invoiceNumber)
//       );

//       const balanceSnapshot = await getDocs(balanceQuery);

//       for (const balanceDoc of balanceSnapshot.docs) {
//         await deleteDoc(doc(db, 'balance_invoices', balanceDoc.id));
//       }

//       // Delete main invoice
//       await deleteDoc(doc(db, 'invoices', invoiceId));

//       alert(`Invoice ${invoiceNumber} deleted successfully!`);

//       // Refresh the invoices list
//       await fetchAllInvoices();

//     } catch (error) {
//       console.error('Error deleting invoice:', error);
//       alert('Error deleting invoice: ' + error.message);
//     }
//   }
// };









// Add this function to restore stock when invoice is deleted
const restoreStockFromDeletedInvoice = async (invoiceData) => {
  try {
    const restorePromises = [];

    // 1. RESTORE FRAME STOCK
    if (invoiceData.products?.frameModel && invoiceData.products?.framePrice) {
      // Find the frame in stock
      const framesQuery = query(
        collection(db, "stock"),
        where("category", "==", "frame")
      );
      
      const framesSnapshot = await getDocs(framesQuery);
      let frameRestored = false;
      
      for (const stockDoc of framesSnapshot.docs) {
        const stockData = stockDoc.data();
        
        // Check if this stock document contains the frame
        if (stockData.items && Array.isArray(stockData.items)) {
          const frameIndex = stockData.items.findIndex(
            item => item.modelNo === invoiceData.products.frameModel &&
                    item.brand === invoiceData.products.brand &&
                    item.colour === invoiceData.products.colour
          );
          
          if (frameIndex !== -1) {
            // Restore quantity
            const updatedItems = [...stockData.items];
            updatedItems[frameIndex] = {
              ...updatedItems[frameIndex],
              qty: (updatedItems[frameIndex].qty || 0) + 1
            };
            
            await updateDoc(doc(db, "stock", stockDoc.id), { items: updatedItems });
            frameRestored = true;
            console.log(`Restored frame stock: ${invoiceData.products.frameModel}`);
            break;
          }
        } else if (stockData.modelNo === invoiceData.products.frameModel) {
          // Simple stock structure
          await updateDoc(doc(db, "stock", stockDoc.id), {
            quantity: (stockData.quantity || 0) + 1
          });
          frameRestored = true;
          console.log(`Restored frame stock: ${invoiceData.products.frameModel}`);
          break;
        }
      }
      
      if (!frameRestored) {
        console.warn(`Frame not found in stock: ${invoiceData.products.frameModel}`);
      }
    }
    
    // 2. RESTORE LENS STOCK
    if (invoiceData.products?.lensModel) {
      // Get lens brand and type from either regular or high index lens
      let lensBrand = null;
      let lensType = null;
      let lensName = null;
      
      // Check if it's high index lens
      if (invoiceData.products?.highIndexLens && invoiceData.products?.highIndexLeft) {
        lensBrand = invoiceData.products.highIndexLeft.brand;
        lensType = invoiceData.products.highIndexLeft.type;
        lensName = invoiceData.products.highIndexLeft.name;
      } else {
        // Regular lens - use left lens as reference (since both eyes are same type)
        const leftLens = invoiceData.products?.leftLens;
        if (leftLens) {
          lensBrand = leftLens.brand;
          lensType = leftLens.type;
          lensName = leftLens.name;
        }
      }
      
      if (lensBrand || lensName) {
        const lensesQuery = query(
          collection(db, 'stock'),
          where('type', '==', 'lens')
        );
        
        const lensesSnapshot = await getDocs(lensesQuery);
        let lensRestored = false;
        
        for (const stockDoc of lensesSnapshot.docs) {
          const stockData = stockDoc.data();
          
          // Try to match by multiple criteria
          let matched = false;
          
          if (lensBrand && stockData.brand === lensBrand) {
            matched = true;
          }
          if (lensName && stockData.name === lensName) {
            matched = true;
          }
          if (lensType && stockData.type === lensType) {
            matched = true;
          }
          
          if (matched || stockData.name === invoiceData.products.lensModel) {
            await updateDoc(doc(db, 'stock', stockDoc.id), {
              quantity: (stockData.quantity || 0) + 1
            });
            lensRestored = true;
            console.log(`Restored lens stock: ${stockData.name || invoiceData.products.lensModel}`);
            break;
          }
        }
        
        if (!lensRestored) {
          console.warn(`Lens not found in stock: ${invoiceData.products.lensModel}`);
        }
      }
    }
    
    // 3. DELETE ASSOCIATED STOCK_OUT RECORDS
    const stockOutQuery = query(
      collection(db, 'stock_out'),
      where('invoiceNumber', '==', invoiceData.invoiceNumber)
    );
    
    const stockOutSnapshot = await getDocs(stockOutQuery);
    
    for (const stockOutDoc of stockOutSnapshot.docs) {
      await deleteDoc(doc(db, 'stock_out', stockOutDoc.id));
      console.log(`Deleted stock_out record: ${stockOutDoc.id}`);
    }
    
    console.log('Stock restoration completed successfully');
    return true;
    
  } catch (error) {
    console.error('Error restoring stock:', error);
    throw error;
  }
};






// Replace your existing deleteInvoice function with this updated version
// Enhanced delete function that handles both regular and direct sale invoices
const deleteInvoice = async (invoiceId, invoiceNumber) => {
  const password = prompt(
    `Enter password to delete invoice ${invoiceNumber}`
  );

  if (password !== "rayban@142") {
    alert("Incorrect password!");
    return;
  }

  if (
    window.confirm(
      `Are you sure you want to delete invoice ${invoiceNumber}?\n\nThis will:\n- Restore all stock (frames, lenses, sunglass, other products)\n- Delete all related balance invoices\n- Delete stock_out records\n\nThis action cannot be undone!`
    )
  ) {
    try {
      // Get the invoice data first
      const invoiceRef = doc(db, 'invoices', invoiceId);
      const invoiceDoc = await getDoc(invoiceRef);
      
      if (!invoiceDoc.exists()) {
        alert('Invoice not found!');
        return;
      }
      
      const invoiceData = invoiceDoc.data();
      
      // Check if it's a direct sale or regular invoice
      const isDirectSale = invoiceData.type === 'direct-sale';
      
      if (isDirectSale) {
        // RESTORE STOCK FOR DIRECT SALE
        console.log('Restoring stock for direct sale invoice...');
        await restoreDirectSaleStock(invoiceData);
        
        // DELETE STOCK_OUT RECORDS FOR DIRECT SALE
        console.log('Deleting stock_out records...');
        await deleteDirectSaleStockOutRecords(invoiceNumber);
        
      } else {
        // RESTORE STOCK FOR REGULAR INVOICE (frames and lenses)
        console.log('Restoring stock for regular invoice...');
        
        // Restore Frame Stock
        if (invoiceData.products?.frameModel && invoiceData.products?.framePrice) {
          const framesQuery = query(
            collection(db, "stock"),
            where("category", "==", "frame")
          );
          
          const framesSnapshot = await getDocs(framesQuery);
          let frameRestored = false;
          
          for (const stockDoc of framesSnapshot.docs) {
            const stockData = stockDoc.data();
            const stockRef = doc(db, 'stock', stockDoc.id);
            
            if (stockData.items && Array.isArray(stockData.items)) {
              const frameIndex = stockData.items.findIndex(
                item => item.modelNo === invoiceData.products.frameModel &&
                        item.brand === invoiceData.products.brand &&
                        item.colour === invoiceData.products.colour
              );
              
              if (frameIndex !== -1) {
                const updatedItems = [...stockData.items];
                updatedItems[frameIndex] = {
                  ...updatedItems[frameIndex],
                  qty: (updatedItems[frameIndex].qty || 0) + 1
                };
                
                await updateDoc(stockRef, { items: updatedItems });
                frameRestored = true;
                console.log(`Restored frame stock: ${invoiceData.products.frameModel}`);
                break;
              }
            } else if (stockData.modelNo === invoiceData.products.frameModel) {
              await updateDoc(stockRef, {
                quantity: (stockData.quantity || 0) + 1
              });
              frameRestored = true;
              console.log(`Restored frame stock: ${invoiceData.products.frameModel}`);
              break;
            }
          }
          
          if (!frameRestored) {
            console.warn(`Frame not found in stock: ${invoiceData.products.frameModel}`);
          }
        }
        
        // Restore Lens Stock
        if (invoiceData.products?.lensModel) {
          let lensIdentifier = invoiceData.products.lensModel;
          
          const lensesQuery = query(
            collection(db, 'stock'),
            where('type', '==', 'lens')
          );
          
          const lensesSnapshot = await getDocs(lensesQuery);
          let lensRestored = false;
          
          for (const stockDoc of lensesSnapshot.docs) {
            const stockData = stockDoc.data();
            const stockRef = doc(db, 'stock', stockDoc.id);
            
            // Check for high index or regular lens
            if (invoiceData.products?.highIndexLens) {
              // High index lens restoration
              if (stockData.name === invoiceData.products.highIndexLeft?.name ||
                  stockData.name === invoiceData.products.highIndexRight?.name) {
                await updateDoc(stockRef, {
                  quantity: (stockData.quantity || 0) + 1
                });
                lensRestored = true;
                console.log(`Restored high index lens stock: ${stockData.name}`);
                break;
              }
            } else if (stockData.name === lensIdentifier || 
                       stockData.modelNo === lensIdentifier ||
                       (invoiceData.products?.leftLens && stockData.name === invoiceData.products.leftLens.name)) {
              
              await updateDoc(stockRef, {
                quantity: (stockData.quantity || 0) + 1
              });
              lensRestored = true;
              console.log(`Restored lens stock: ${stockData.name}`);
              break;
            }
          }
          
          if (!lensRestored) {
            console.warn(`Lens not found in stock: ${invoiceData.products.lensModel}`);
          }
        }
        
        // Delete stock_out records for regular invoice
        const stockOutQuery = query(
          collection(db, 'stock_out'),
          where('invoiceNumber', '==', invoiceNumber)
        );
        
        const stockOutSnapshot = await getDocs(stockOutQuery);
        
        for (const stockOutDoc of stockOutSnapshot.docs) {
          await deleteDoc(doc(db, 'stock_out', stockOutDoc.id));
          console.log(`Deleted stock_out record: ${stockOutDoc.id}`);
        }
      }
      
      // Delete related balance invoices (common for both types)
      const balanceQuery = query(
        collection(db, 'balance_invoices'),
        where('originalInvoiceNumber', '==', invoiceNumber)
      );
      
      const balanceSnapshot = await getDocs(balanceQuery);
      
      for (const balanceDoc of balanceSnapshot.docs) {
        await deleteDoc(doc(db, 'balance_invoices', balanceDoc.id));
        console.log(`Deleted balance invoice: ${balanceDoc.id}`);
      }
      
      // Delete main invoice
      await deleteDoc(doc(db, 'invoices', invoiceId));
      
      alert(`Invoice ${invoiceNumber} deleted successfully!\nStock has been restored.`);
      
      // Refresh the invoices list
      await fetchAllInvoices();
      
    } catch (error) {
      console.error('Error deleting invoice:', error);
      alert('Error deleting invoice: ' + error.message);
    }
  }
};









///////////////////////////////////// View invoice details //////////////


// Add these state variables
// State variables
const [showEditInvoiceModal, setShowEditInvoiceModal] = useState(false);
const [editCustomerName, setEditCustomerName] = useState('');
const [editCustomerPhone, setEditCustomerPhone] = useState('');
const [editCustomerAddress, setEditCustomerAddress] = useState('');
const [editSalesPerson, setEditSalesPerson] = useState('');
const [salespersonsList, setSalespersonsList] = useState([]);
const [showPasswordModal, setShowPasswordModal] = useState(false);
const [enteredPassword, setEnteredPassword] = useState('');
const [selectedNewSalesPerson, setSelectedNewSalesPerson] = useState('');
const [originalSalesPerson, setOriginalSalesPerson] = useState('');
const [isSalesPersonChangeAuthorized, setIsSalesPersonChangeAuthorized] = useState(false);




// Generate invoice summary report
const generateInvoiceSummaryReport = async () => {
  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a4'
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const primaryColor = [15, 23, 42];

  let yPosition = 0;
  let rowCount = 0;

  // Draw header on each page
  const drawHeader = (isFirstPage) => {
    // Compact header background
    doc.setFillColor(...primaryColor);
    doc.rect(0, 0, pageWidth, 28, "F");

    // Logo space
    try {
      doc.addImage("/ray-ban-logo.png", "PNG", 10, 4, 18, 18);
    } catch (err) {}

    // Company details
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("Ray Ban Opticians", 35, 11);

    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    doc.text("Ray Ban Building, 142, Kandy Road, Dalugama, Kiribathgoda", 35, 18);
    doc.text("Hotline: 0767873232 Tel: 0112912333 / 0112914949 Fax: 0112913933", 35, 23);
    // doc.text("Email: info@raybanopticians.com | Web: raybanopticians.com", 35, 23);



       // Report title
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.setTextColor(0, 0, 0);
    
    if (isFirstPage) {
      doc.text("INVOICE SUMMARY REPORT", pageWidth / 2, 42, { align: "center" });
      doc.setFontSize(8);
      doc.setFont("helvetica", "normal");
      doc.text(`Generated: ${new Date().toLocaleString()}`, pageWidth / 2, 50, { align: "center" });
      return 58;
    } else {
      doc.text("INVOICE SUMMARY REPORT (Continued)", pageWidth / 2, 40, { align: "center" });
      return 48;
    }
  };

  // Draw compact summary row
  const drawSummaryRow = (startY) => {
    const totalAmount = filteredInvoices.reduce((sum, inv) => sum + (inv.financial?.totalAmount || 0), 0);
    const totalPaid = filteredInvoices.reduce((sum, inv) => sum + (inv.financial?.advancePayment || 0), 0);
    const totalDue = filteredInvoices.reduce((sum, inv) => sum + (inv.financial?.balanceDue || 0), 0);
    const paidCount = filteredInvoices.filter(inv => inv.financial?.balanceDue <= 0).length;
    const pendingCount = filteredInvoices.filter(inv => inv.financial?.balanceDue > 0).length;

    const summaryItems = [
      { label: "Total Invoices", value: filteredInvoices.length, color: [59, 130, 246] },
      { label: "Paid", value: paidCount, color: [34, 197, 94] },
      { label: "Pending", value: pendingCount, color: [245, 158, 11] },
      { label: "Total Amount", value: `Rs. ${totalAmount.toLocaleString()}`, color: [15, 23, 42] },
      { label: "Paid Amount", value: `Rs. ${totalPaid.toLocaleString()}`, color: [34, 197, 94] },
      { label: "Due Amount", value: `Rs. ${totalDue.toLocaleString()}`, color: [239, 68, 68] }
    ];

    const itemWidth = (pageWidth - 20) / 6;
    let x = 10;

    summaryItems.forEach((item, idx) => {
      // Light background
      doc.setFillColor(248, 250, 252);
      doc.rect(x, startY, itemWidth - 1, 12, "F");
      
      // Top color bar
      doc.setFillColor(...item.color);
      doc.rect(x, startY, itemWidth - 1, 2, "F");
      
      // Label
      doc.setTextColor(100, 116, 139);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(6);
      doc.text(item.label, x + 3, startY + 6);
      
      // Value
      doc.setTextColor(15, 23, 42);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(9);
      doc.text(item.value.toString(), x + 3, startY + 11);
      
      x += itemWidth;
    });

    return startY + 16;
  };

  // Draw table headers - UPDATED with more space for Frame & Lens
  const drawTableHeaders = (y) => {
    doc.setFillColor(...primaryColor);
    doc.rect(10, y, pageWidth - 20, 8, "F");

    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(6.5);

    // Column widths - INCREASED for Frame and Lens
    const startX = 12;
    const colWidths = {
      invoice: 16,
      customer: 36,
      tpNo: 18,
      date: 26,
      frame: 28,      // INCREASED from 18 to 28
      lens: 70,       // INCREASED from 20 to 30
      total: 16,
      paid: 16,
      due: 16,
      status: 14
    };

    let currentX = startX;
    const colPositions = {
      invoice: currentX,
      customer: (currentX += colWidths.invoice),
      tpNo: (currentX += colWidths.customer),
      date: (currentX += colWidths.tpNo),
      frame: (currentX += colWidths.date),
      lens: (currentX += colWidths.frame),
      total: (currentX += colWidths.lens),
      paid: (currentX += colWidths.total),
      due: (currentX += colWidths.paid),
      status: (currentX += colWidths.due)
    };

    // Headers array
    const headers = [
      { text: "Invoice #", pos: colPositions.invoice },
      { text: "Customer", pos: colPositions.customer },
      { text: "TP No", pos: colPositions.tpNo },
      { text: "Date", pos: colPositions.date },
      { text: "Frame", pos: colPositions.frame },
      { text: "Lens", pos: colPositions.lens },
      { text: "Total", pos: colPositions.total },
      { text: "Paid", pos: colPositions.paid },
      { text: "Due", pos: colPositions.due },
      { text: "Status", pos: colPositions.status }
    ];

    // Draw each header
    headers.forEach(header => {
      doc.text(header.text, header.pos, y + 5.5);
    });

    return { y: y + 8, colPositions };
  };

  // Draw first page
  let startY = drawHeader(true);
  startY = drawSummaryRow(startY);
  const headerResult = drawTableHeaders(startY);
  yPosition = headerResult.y;
  const colPositions = headerResult.colPositions;

  // Loop through invoices
  for (let invoice of filteredInvoices) {
    // Check if need new page
    if (yPosition > 175) {
      doc.addPage();
      startY = drawHeader(false);
      startY = drawSummaryRow(startY);
      const newHeader = drawTableHeaders(startY);
      yPosition = newHeader.y;
      Object.assign(colPositions, newHeader.colPositions);
      rowCount = 0;
    }

    // Alternate row background
    if (rowCount % 2 === 0) {
      doc.setFillColor(248, 250, 252);
      doc.rect(10, yPosition, pageWidth - 20, 9, "F");
    }

    // Draw row borders
    doc.setDrawColor(226, 232, 240);
    doc.rect(10, yPosition, pageWidth - 20, 9);

    const totalAmount = invoice.financial?.totalAmount || 0;
    const dueAmount = invoice.financial?.balanceDue || 0;
    const status = dueAmount <= 0 ? "PAID" : "DUE";
    const statusColor = dueAmount <= 0 ? [34, 197, 94] : [239, 68, 68];

    // Invoice #
    doc.setTextColor(59, 130, 246);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7.5);
    doc.text(invoice.invoiceNumber || '-', colPositions.invoice, yPosition + 6);

    // Customer Name
    doc.setTextColor(51, 65, 85);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    let customerName = invoice.customer?.fullName || '-';
    doc.text(
      customerName.length > 22 ? customerName.substring(0, 20) + '..' : customerName,
      colPositions.customer,
      yPosition + 6
    );

    // TP No
    doc.setTextColor(51, 65, 85);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(6.5);
    const tpNo = invoice.customer?.tpNo || '-';
    doc.text(
      tpNo.length > 14 ? tpNo.substring(0, 12) + '..' : tpNo,
      colPositions.tpNo,
      yPosition + 6
    );

    // Date
    doc.setTextColor(15, 23, 42);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    if (invoice.formattedDate) {
      doc.text(invoice.formattedDate, colPositions.date, yPosition + 4.5);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(5.5);
      doc.setTextColor(100, 116, 139);
      doc.text(invoice.formattedTime || '', colPositions.date, yPosition + 8);
    } else {
      doc.text('-', colPositions.date, yPosition + 6);
    }

    // Frame - with increased character limit
    doc.setTextColor(51, 65, 85);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(6.5);
    
    const frameModel = invoice.products?.frameModel || '-';
    let frameDisplay = frameModel;
    if (frameModel === "Own Frame" || frameModel === "Own frame" || frameModel === "own frame") {
      frameDisplay = "Own Frame";
    } else if (frameModel !== '-') {
      frameDisplay = frameModel;
    }
    
    // Allow up to 28 characters before truncating
    doc.text(
      frameDisplay.length > 28 ? frameDisplay.substring(0, 26) + '..' : frameDisplay,
      colPositions.frame,
      yPosition + 6
    );

    // Lens - with increased character limit
    doc.setTextColor(51, 65, 85);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(6);
    
    let lensDisplay = '-';
    if (invoice.products?.highIndexLens) {
      const leftLensName = invoice.products?.highIndexLeft?.name || '';
      const rightLensName = invoice.products?.highIndexRight?.name || '';
      if (leftLensName && rightLensName) {
        lensDisplay = `${leftLensName} / ${rightLensName}`;
      } else if (leftLensName) {
        lensDisplay = leftLensName;
      } else if (rightLensName) {
        lensDisplay = rightLensName;
      } else {
        lensDisplay = '-';
      }
    } else {
      lensDisplay = invoice.products?.lensModel || '-';
      lensDisplay = lensDisplay.replace(/^(LEFT:|RIGHT:)\s*/, '');
    }
    
// Allow up to 60 characters before truncating
doc.text(
  lensDisplay.length > 68
    ? lensDisplay.substring(0, 68) + ".."
    : lensDisplay,
  colPositions.lens,
  yPosition + 6
);

    // Total Amount
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    doc.text(
      totalAmount.toLocaleString(),
      colPositions.total + 14,
      yPosition + 6,
      { align: "right" }
    );

    // Paid Amount
    doc.setTextColor(34, 197, 94);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    doc.text(
      (totalAmount - dueAmount).toLocaleString(),
      colPositions.paid + 14,
      yPosition + 6,
      { align: "right" }
    );

    // Due Amount
    doc.setTextColor(dueAmount > 0 ? 239 : 34, dueAmount > 0 ? 68 : 197, dueAmount > 0 ? 68 : 94);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    doc.text(
      dueAmount.toLocaleString(),
      colPositions.due + 14,
      yPosition + 6,
      { align: "right" }
    );

    // Status Badge
    doc.setFillColor(...statusColor);
    doc.roundedRect(colPositions.status + 1, yPosition + 2, 14, 5.5, 2, 2, "F");
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(5);
    doc.text(status, colPositions.status + 8, yPosition + 5.5, { align: "center" });

    yPosition += 9;
    rowCount++;
  }

  // Add footer
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(7);
    doc.setTextColor(148, 163, 184);
    doc.setFont("helvetica", "normal");
    doc.text(`Page ${i} of ${pageCount}`, pageWidth / 2, pageHeight - 10, { align: "center" });
  }

  doc.save(`INVOICES_SUMMARY_${Date.now()}.pdf`);
};








////////////////////////////// edit invoice sales person and invoice data ///////////////////////////////////




// Fetch salespersons from Firestore
const fetchSalespersons = async () => {
  try {
    const salespersonsQuery = query(
      collection(db, 'salespersons'),
      where('salespersonStatus', '==', 'Active')
    );
    const snapshot = await getDocs(salespersonsQuery);
    const list = [];
    snapshot.forEach(doc => {
      list.push({
        id: doc.id,
        ...doc.data()
      });
    });
    setSalespersonsList(list);
  } catch (error) {
    console.error('Error fetching salespersons:', error);
  }
};

// Call this when component mounts or when needed
useEffect(() => {
  if (selectedOption === "viewInvoice") {
    fetchSalespersons();
  }
}, [selectedOption]);






const openEditInvoiceModal = (invoice) => {
  console.log('Opening edit modal for invoice:', invoice.invoiceNumber);
  
  const currentSalesPerson = invoice.salePerson || invoice.invoiceData?.salePerson || '';
  console.log('Current sales person on invoice:', currentSalesPerson);
  
  // Find the salesperson's code for display
  const currentSP = salespersonsList.find(sp => sp.salespersonName === currentSalesPerson);
  
  setSelectedInvoiceForEdit(invoice);
  setEditCustomerName(invoice.customer?.fullName || '');
  setEditCustomerPhone(invoice.customer?.tpNo || '');
  setEditCustomerAddress(invoice.customer?.address || '');
  setEditSalesPerson(currentSalesPerson);
  setOriginalSalesPerson(currentSalesPerson);
  setSelectedNewSalesPerson(currentSalesPerson);
  setIsSalesPersonChangeAuthorized(false);
  setShowEditInvoiceModal(true);
  
  // Debug: Show the code
  if (currentSP) {
    console.log(`Current salesperson code: ${currentSP.salespersonCode}`);
  }
};




// Handle sales person change with password verification
// Handle sales person change - verify CURRENT sales person's code
const handleSalesPersonChange = (newSalesPerson) => {
  console.log('Attempting to change sales person to:', newSalesPerson);
  console.log('Current sales person (original):', originalSalesPerson);
  
  // If selecting the same person, just update
  if (newSalesPerson === originalSalesPerson) {
    setEditSalesPerson(newSalesPerson);
    setIsSalesPersonChangeAuthorized(false);
    return;
  }
  
  // Store the new selection
  setSelectedNewSalesPerson(newSalesPerson);
  
  // Find the CURRENT sales person to verify their code
  const currentSalesPerson = salespersonsList.find(
    sp => sp.salespersonName === originalSalesPerson
  );
  
  console.log('Current sales person object:', currentSalesPerson);
  console.log('Their salesperson code:', currentSalesPerson?.salespersonCode);
  
  if (!currentSalesPerson) {
    alert('Current sales person not found in system! Please contact admin.');
    return;
  }
  
  // Show password modal - will verify using salespersonCode
  setShowPasswordModal(true);
  setEnteredPassword('');
  setIsSalesPersonChangeAuthorized(false);
};







// Verify password and update

// Verify password - uses salespersonCode as password
const verifyCurrentSalesPersonPassword = async () => {
  console.log('Verifying password for:', originalSalesPerson);
  
  // Find the CURRENT sales person
  const currentSalesPerson = salespersonsList.find(
    sp => sp.salespersonName === originalSalesPerson
  );
  
  if (!currentSalesPerson) {
    alert('❌ Current sales person not found in system!');
    setShowPasswordModal(false);
    setEditSalesPerson(originalSalesPerson);
    return;
  }
  
  // Get the salespersonCode to use as password
  const actualPassword = currentSalesPerson.salespersonCode || '';
  
  console.log('Entered password:', enteredPassword);
  console.log('Salesperson Code (password):', actualPassword);
  console.log('Password match:', enteredPassword === actualPassword);
  
  // Check if entered password matches the salespersonCode
  if (enteredPassword === actualPassword) {
    // ✅ PASSWORD CORRECT
    console.log('✅ Password correct! Updating sales person to:', selectedNewSalesPerson);
    
    setEditSalesPerson(selectedNewSalesPerson);
    setIsSalesPersonChangeAuthorized(true);
    setShowPasswordModal(false);
    setEnteredPassword('');
    
    alert(`✅ Sales person changed from "${originalSalesPerson}" to "${selectedNewSalesPerson}"`);
    
  } else {
    // ❌ PASSWORD INCORRECT
    console.log('❌ Password incorrect!');
    alert(`❌ Incorrect password for ${originalSalesPerson}! Please use their salesperson code.`);
    
    setShowPasswordModal(false);
    setEnteredPassword('');
    setEditSalesPerson(originalSalesPerson);
    setSelectedNewSalesPerson(originalSalesPerson);
    setIsSalesPersonChangeAuthorized(false);
  }
};






// Save all edited data

// Save all edited data
const saveInvoiceEdits = async () => {
  try {
    console.log('Saving invoice edits...');
    console.log('Current editSalesPerson value:', editSalesPerson);
    console.log('Original sales person:', originalSalesPerson);
    console.log('Is change authorized:', isSalesPersonChangeAuthorized);
    
    if (!selectedInvoiceForEdit?.id) {
      alert('Invoice not found');
      return;
    }
    
    // Validate required fields
    if (!editCustomerName.trim()) {
      alert('Customer name is required');
      return;
    }
    
    if (!editCustomerPhone.trim()) {
      alert('Customer phone number is required');
      return;
    }
    
    // Check if sales person was changed and authorized
    if (editSalesPerson !== originalSalesPerson && !isSalesPersonChangeAuthorized) {
      alert('⚠️ Sales person change requires verification. Please enter their salesperson code.');
      return;
    }
    
    // Prepare data to save
    const updateData = {
      customer: {
        ...selectedInvoiceForEdit.customer,
        fullName: editCustomerName,
        tpNo: editCustomerPhone,
        address: editCustomerAddress
      },
      salePerson: editSalesPerson, // ✅ SAVE THE NEW SALES PERSON
      updatedAt: new Date(),
      lastModifiedBy: editSalesPerson,
      salesPersonChanged: editSalesPerson !== originalSalesPerson
    };
    
    // Add change log if sales person changed
    if (editSalesPerson !== originalSalesPerson) {
      updateData.salesPersonChangeLog = {
        from: originalSalesPerson,
        to: editSalesPerson,
        changedAt: new Date().toISOString(),
        verifiedByCode: true // Using salespersonCode for verification
      };
    }
    
    // Also update invoiceData if it exists
    if (selectedInvoiceForEdit.invoiceData) {
      updateData.invoiceData = {
        ...selectedInvoiceForEdit.invoiceData,
        salePerson: editSalesPerson
      };
    }
    
    console.log('Saving updateData:', updateData);
    
    // Save to Firestore
    await updateDoc(doc(db, 'invoices', selectedInvoiceForEdit.id), updateData);
    
    // Update local state
    const updatedInvoices = allInvoices.map(inv => 
      inv.id === selectedInvoiceForEdit.id
        ? {
            ...inv,
            customer: updateData.customer,
            salePerson: editSalesPerson,
            invoiceData: updateData.invoiceData || inv.invoiceData,
            lastModifiedBy: editSalesPerson,
            salesPersonChanged: editSalesPerson !== originalSalesPerson
          }
        : inv
    );
    
    setAllInvoices(updatedInvoices);
    
    alert('✅ Invoice updated successfully!');
    setShowEditInvoiceModal(false);
    setIsSalesPersonChangeAuthorized(false);
    
  } catch (error) {
    console.error('Error updating invoice:', error);
    alert('Failed to update invoice: ' + error.message);
  }
};









// ADD THIS FUNCTION - Run once to add passwords
const addPasswordsToSalespersons = async () => {
  try {
    const salespersonsQuery = query(
      collection(db, 'salespersons')
    );
    
    const snapshot = await getDocs(salespersonsQuery);
    
    for (const doc of snapshot.docs) {
      const data = doc.data();
      
      // Create a password based on salesperson name or code
      let password;
      
      // You can set passwords manually or generate them
      if (data.salespersonName === "Mr. Chanaka De Silva") {
        password = "Chanaka@123";
      } else if (data.salespersonName === "Mr. Chamri menaka") {
        password = "Chamri@123";
      } else {
        // Default: use salespersonCode + "123"
        password = data.salespersonCode + "123";
      }
      
      // Update the document with password
      await updateDoc(doc(db, 'salespersons', doc.id), {
        salespersonPassword: password
      });
      
      console.log(`✅ Added password for ${data.salespersonName}: ${password}`);
    }
    
    alert('✅ All salespersons updated with passwords!');
    
  } catch (error) {
    console.error('Error adding passwords:', error);
    alert('Error: ' + error.message);
  }
};












// Reset filters
// const resetInvoiceFilters = () => {
//   setInvoiceSearchTerm('');
//   setInvoiceFilterStatus('all');
//   setInvoiceFilterPaymentMethod('all');
//   setInvoiceDateRange({ start: '', end: '' });
//   setFilteredInvoices(allInvoices);
// };

//////////////////////////////////////////////////////////
// SORT OLD DATE TOP -> NEW DATE BOTTOM
//////////////////////////////////////////////////////////

useEffect(() => {

  if (allInvoices.length > 0) {

    const sortedInvoices = [...allInvoices].sort((a, b) => {

      const dateA = a.createdAt?.seconds
        ? new Date(a.createdAt.seconds * 1000)
        : new Date(a.createdAt || 0);

      const dateB = b.createdAt?.seconds
        ? new Date(b.createdAt.seconds * 1000)
        : new Date(b.createdAt || 0);

      return dateA - dateB;

    });

    setFilteredInvoices(sortedInvoices);

  }

}, [allInvoices]);

// Apply filters when filter criteria change
useEffect(() => {
  filterInvoices();
}, [invoiceSearchTerm, invoiceFilterStatus, invoiceFilterPaymentMethod, invoiceDateRange.start, invoiceDateRange.end, allInvoices]);




/////////////////////////////////////// NEW STATES ///////////////////////////////////////

const [showUpinReceiptModal, setShowUpinReceiptModal] = useState(false);
const [selectedInvoiceForEdit, setSelectedInvoiceForEdit] = useState(null);

const [upinNo, setUpinNo] = useState("");
const [receiptNo, setReceiptNo] = useState("");




/////////////////////////////////////// OPEN EDIT MODAL ///////////////////////////////////////

const openUpinReceiptEditor = (invoice) => {
  setSelectedInvoiceForEdit(invoice);
  setUpinNo(invoice.upinNo || "");
  setReceiptNo(invoice.receiptNo || "");
  setShowUpinReceiptModal(true);
};





/////////////////////////////////////// SAVE UPIN + RECEIPT //////////////////////////////////////

const saveUpinAndReceipt = async () => {
  try {
    if (!selectedInvoiceForEdit?.id) {
      alert("Invoice not found");
      return;
    }

    await updateDoc(doc(db, "invoices", selectedInvoiceForEdit.id), {
      upinNo: upinNo,
      receiptNo: receiptNo,
      updatedAt: new Date()
    });

    // UPDATE LOCAL STATE
    const updatedInvoices = allInvoices.map((inv) =>
      inv.id === selectedInvoiceForEdit.id
        ? {
            ...inv,
            upinNo,
            receiptNo
          }
        : inv
    );

    setAllInvoices(updatedInvoices);

    alert("2nd Frame Record updated successfully!");

    setShowUpinReceiptModal(false);

  } catch (error) {
    console.error("Error updating invoice:", error);
    alert("Failed to update data");
  }
};







/////////////////////////////////////// EXCEL DOWNLOAD ///////////////////////////////////////

const downloadUpinReceiptExcel = () => {

  // SORT OLDEST TOP -> LATEST BOTTOM
  const sortedInvoices = [...filteredInvoices].sort((a, b) => {
    const dateA = a.createdAt?.seconds
      ? new Date(a.createdAt.seconds * 1000)
      : new Date(a.date || 0);

    const dateB = b.createdAt?.seconds
      ? new Date(b.createdAt.seconds * 1000)
      : new Date(b.date || 0);

    return dateA - dateB;
  });

  const excelData = sortedInvoices.map((invoice, index) => ({
    "No": index + 1,
    "Date": invoice.formattedDate || "",
    "2nd Frame Details": invoice.upinNo || "",
    "Remark": invoice.receiptNo || "",

   
   
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "UPIN_RECEIPT_REPORT"
  );

  XLSX.writeFile(
    workbook,
    `UPIN_RECEIPT_REPORT_${Date.now()}.xlsx`
  );
};





/////////////////////////////////////////// create direct invoice direct sale////////////////////////////////////////////////////////
// =============================================
// 1. STATE DECLARATIONS
// =============================================
const [currentDirectMainInvoice, setCurrentDirectMainInvoice] = useState('');
const [directInvoiceType, setDirectInvoiceType] = useState('CL'); // 'CL' or 'S'
const [currentCLNumber, setCurrentCLNumber] = useState(''); // CL4690
const [currentSNumber, setCurrentSNumber] = useState('S2722'); // S134
const [lastCLNumber, setLastCLNumber] = useState(4701);
const [lastSNumber, setLastSNumber] = useState(2722);
const [isSavingDirectSale, setIsSavingDirectSale] = useState(false);
const [isInitialized, setIsInitialized] = useState(false); // Track initialization

// NEW: Split payment states
const [paymentMethod, setPaymentMethod] = useState('Cash'); // 'Cash', 'Card', 'Split'
const [cashAmount, setCashAmount] = useState();
const [cardAmount, setCardAmount] = useState();
const [splitPaymentDetails, setSplitPaymentDetails] = useState([]);

// =============================================
// 2. PRODUCT FETCHING FUNCTIONS
// =============================================
const fetchDirectSaleProducts = async () => {
  try {
    const q = query(collection(db, "stock"));
    const snap = await getDocs(q);
    let products = [];

    snap.forEach((docSnap) => {
      const data = docSnap.data();
      if (["other", "sunglass"].includes(data.category)) {
        if (Array.isArray(data.items)) {
          data.items.forEach((item) => {
            products.push({
              stockDocId: docSnap.id,
              category: data.category,
              ...item
            });
          });
        }
      }
    });

    console.log("DIRECT PRODUCTS LOADED:", products);
    setAvailableDirectProducts(products);
  } catch (err) {
    console.log("fetch error", err);
  }
};





// // ✅ RENAME THIS - was 'initializeCounter'
// const initCounterDocument = async () => {
//   const counterRef = doc(db, 'counters', COUNTER_DOC_ID);
//   const counterDoc = await getDoc(counterRef);
  
//   if (!counterDoc.exists()) {
//     await setDoc(counterRef, {
//       lastCLNumber: 4701,
//       lastSNumber: 2712,
//       lastRXNumber: 139370,
//       lastVIPNumber: 7288,
//       lastRNumber: 2880
//     });
//     console.log('✅ Counter document created');
//   }
// };

// =============================================
// GET NEXT S NUMBER - From counter document
// =============================================

const getNextSNumber = async () => {
  try {
    const counterRef = doc(db, 'counters', COUNTER_DOC_ID);
    const counterDoc = await getDoc(counterRef);
    
    if (!counterDoc.exists()) {
      await initCounterDocument();
      return 'S2723';
    }
    
    const data = counterDoc.data();
    const lastNumber = data.lastSNumber || 2722;
    const nextNumber = lastNumber + 1;
    
    console.log(`📊 Next S number: S${nextNumber}`);
    return `S${nextNumber}`;
  } catch (error) {
    console.error('Error getting S number:', error);
    return 'S2723';
  }
};

// =============================================
// GENERATE S NUMBER - Update counter document
// =============================================

const generateAndIncrementSNumber = async () => {
  try {
    const counterRef = doc(db, 'counters', COUNTER_DOC_ID);
    
    // ✅ Use Firestore transaction to increment atomically
    const result = await runTransaction(db, async (transaction) => {
      const counterDoc = await transaction.get(counterRef);
      
      if (!counterDoc.exists()) {
        // Initialize if doesn't exist
        transaction.set(counterRef, {
          lastCLNumber: 4701,
          lastSNumber: 2722,
          lastRXNumber: 139370,
          lastVIPNumber: 7288,
          lastRNumber: 2880
        });
        return 2723; // First S number
      }
      
      const data = counterDoc.data();
      const currentNumber = (data.lastSNumber || 2722) + 1;
      
      // ✅ Update the counter
      transaction.update(counterRef, {
        lastSNumber: currentNumber
      });
      
      return currentNumber;
    });
    
    // ✅ Update React state
    setLastSNumber(result);
    setCurrentSNumber(`S${result + 1}`);
    
    console.log(`✅ GENERATED: S${result}`);
    return `S${result}`;
    
  } catch (error) {
    console.error('Error generating S number:', error);
    const currentNumber = lastSNumber + 1;
    setLastSNumber(currentNumber);
    setCurrentSNumber(`S${currentNumber + 1}`);
    return `S${currentNumber}`;
  }
};

// =============================================
// SAME FOR CL NUMBER
// =============================================

const generateAndIncrementCLNumber = async () => {
  try {
    const counterRef = doc(db, 'counters', COUNTER_DOC_ID);
    
    const result = await runTransaction(db, async (transaction) => {
      const counterDoc = await transaction.get(counterRef);
      
      if (!counterDoc.exists()) {
        transaction.set(counterRef, {
          lastCLNumber: 4701,
          lastSNumber: 2722,
          lastRXNumber: 139370,
          lastVIPNumber: 7288,
          lastRNumber: 2880
        });
        return 4702; // First CL number
      }
      
      const data = counterDoc.data();
      const currentNumber = (data.lastCLNumber || 4701) + 1;
      
      transaction.update(counterRef, {
        lastCLNumber: currentNumber
      });
      
      return currentNumber;
    });
    
    setLastCLNumber(result);
    setCurrentCLNumber(`CL${result + 1}`);
    
    console.log(`✅ GENERATED: CL${result}`);
    return `CL${result}`;
    
  } catch (error) {
    console.error('Error generating CL number:', error);
    const currentNumber = lastCLNumber + 1;
    setLastCLNumber(currentNumber);
    setCurrentCLNumber(`CL${currentNumber + 1}`);
    return `CL${currentNumber}`;
  }
};

// =============================================
// INITIALIZATION - From counter document
// =============================================

const initializeInvoiceNumbers = async () => {
  try {
    const counterRef = doc(db, 'counters', COUNTER_DOC_ID);
    const counterDoc = await getDoc(counterRef);
    
    let lastCL = 4701;
    let lastS = 2722;
    
    if (counterDoc.exists()) {
      const data = counterDoc.data();
      lastCL = data.lastCLNumber || 4701;
      lastS = data.lastSNumber || 2722;
    } else {
      // Create counter document
      await setDoc(counterRef, {
        lastCLNumber: 4701,
        lastSNumber: 2722,
        lastRXNumber: 139370,
        lastVIPNumber: 7288,
        lastRNumber: 2880
      });
    }
    
    setLastCLNumber(lastCL);
    setLastSNumber(lastS);
    setCurrentCLNumber(`CL${lastCL + 1}`);
    setCurrentSNumber(`S${lastS + 1}`);
    
    console.log(`✅ Initialized: CL${lastCL + 1}, S${lastS + 1}`);
    
  } catch (error) {
    console.error('Error initializing:', error);
    setCurrentCLNumber('CL4702');
    setCurrentSNumber('S2723');
  }
};

// =============================================
// RECOVERY FUNCTION - From counter document
// =============================================

const recoverDuplicateNumbers = async () => {
  try {
    console.log("🔄 Running number recovery...");
    
    const counterRef = doc(db, 'counters', COUNTER_DOC_ID);
    const counterDoc = await getDoc(counterRef);
    
    let maxCL = 4701;
    let maxS = 2722;
    
    if (counterDoc.exists()) {
      const data = counterDoc.data();
      maxCL = data.lastCLNumber || 4701;
      maxS = data.lastSNumber || 2722;
    }
    
    setLastCLNumber(maxCL);
    setLastSNumber(maxS);
    setCurrentCLNumber(`CL${maxCL + 1}`);
    setCurrentSNumber(`S${maxS + 1}`);
    
    console.log(`✅ Recovery: Next CL=CL${maxCL + 1}, Next S=S${maxS + 1}`);
    return { nextCL: `CL${maxCL + 1}`, nextS: `S${maxS + 1}` };
    
  } catch (error) {
    console.error("Recovery failed:", error);
    return null;
  }
};






// =============================================
// 6. EVENT HANDLERS
// =============================================

// Handle direct invoice type change - SIMPLE, NO FETCHING
const handleDirectInvoiceTypeChange = (e) => {
  const type = e.target.value;
  setDirectInvoiceType(type);
  // That's it! Numbers are already loaded and won't change
};

// Handle product search
const handleDirectSaleSearch = (text) => {
  setDirectSaleSearch(text);

  if (text.trim().length < 1) {
    setShowDirectSaleSuggestions(false);
    setDirectSaleSuggestions([]);
    return;
  }

  const search = text.toLowerCase();
  const filtered = availableDirectProducts.filter((item) => {
    const model = item.modelNo?.toLowerCase().includes(search);
    const brand = item.brand?.toLowerCase().includes(search);
    const colour = item.colour?.toLowerCase().includes(search);
    const size = item.size?.toLowerCase().includes(search);
    const BaseCurve = item.BaseCurve?.toLowerCase().includes(search);
    const rPower = item.rPower?.toLowerCase().includes(search);
    const lPower = item.lPower?.toLowerCase().includes(search);

    return (
      (model || brand || colour || size || BaseCurve || rPower || lPower ) &&
      Number(item.qty) > 0
    );
  });

  setDirectSaleSuggestions(filtered);
  setShowDirectSaleSuggestions(true);
};

// Select product
const selectDirectProduct = (item) => {
  const existing = directSaleItems.find(
    (p) => p.modelNo === item.modelNo && p.colour === item.colour
  );

  if (existing) {
    setDirectSaleItems(prev =>
      prev.map(p =>
        p.modelNo === item.modelNo && p.colour === item.colour
          ? {
              ...p,
              qty: p.qty + 1,
              total: (p.qty + 1) * p.sellingPrice
            }
          : p
      )
    );
  } else {
    setDirectSaleItems(prev => [
      ...prev,
      {
        stockDocId: item.stockDocId,
        modelNo: item.modelNo,
        brand: item.brand,
        size: item.size,
        colour: item.colour,
        BaseCurve: item.BaseCurve,
        rPower: item.rPower,
        lPower: item.lPower,
        category: item.category || "other",
        sellingPrice: Number(item.sellingPrice),
        qty: 1,
        stockQty: Number(item.qty),
        total: Number(item.sellingPrice)
      }
    ]);
  }

  setDirectSaleSearch("");
  setShowDirectSaleSuggestions(false);
};

// Update quantity
const updateDirectSaleQty = (index, qty) => {
  const updated = [...directSaleItems];
  const item = updated[index];
  let numericQty = Number(qty);

  if (isNaN(numericQty) || numericQty < 1) {
    numericQty = 1;
  }

  if (numericQty > item.stockQty) {
    alert(`Only ${item.stockQty} items available in stock`);
    numericQty = item.stockQty;
  }

  updated[index] = {
    ...item,
    qty: numericQty,
    total: numericQty * Number(item.sellingPrice)
  };

  setDirectSaleItems(updated);
};

// Remove item
const removeDirectSaleItem = (index) => {
  const updated = [...directSaleItems];
  updated.splice(index, 1);
  setDirectSaleItems(updated);
};

// =============================================
// 7. CALCULATIONS
// =============================================
const directSaleSubtotal = directSaleItems.reduce(
  (sum, item) => sum + item.total,
  0
);

const calculatedDiscount =
  discountType === "percentage"
    ? (directSaleSubtotal * (Number(formData.discount || 0) / 100))
    : Number(formData.discount || 0);

const directSaleTotal = directSaleSubtotal - calculatedDiscount;

// NEW: Calculate payment amounts based on method
let totalPaid = 0;
let paymentBreakdown = [];

if (paymentMethod === 'Cash') {
  totalPaid = Number(formData.advancePayment || 0);
  paymentBreakdown = [{ method: 'Cash', amount: totalPaid }];
} else if (paymentMethod === 'Card') {
  totalPaid = Number(formData.advancePayment || 0);
  paymentBreakdown = [{ method: 'Card', amount: totalPaid }];
} else if (paymentMethod === 'Split') {
  const cash = Number(cashAmount);
  const card = Number(cardAmount);
  totalPaid = cash + card;
  paymentBreakdown = [
    { method: 'Cash', amount: cash },
    { method: 'Card', amount: card }
  ].filter(p => p.amount > 0);
}

const directSaleAdvanceAmount = totalPaid;
const directSaleBalance = Math.max(0, directSaleTotal - directSaleAdvanceAmount);

const paymentStatus =
  directSaleAdvanceAmount >= directSaleTotal
    ? "fully-paid"
    : directSaleAdvanceAmount > 0
    ? "advance-paid"
    : "pending";

// =============================================
// 8. SAVE FUNCTION
// =============================================

// const handleSaveDirectSale = async () => {
//   if (isSavingDirectSale) return;
//   setIsSavingDirectSale(true);

//   try {
//     if (directSaleItems.length === 0) {
//       alert("Please add at least one product");
//       return;
//     }

//     if (!saleForm.salePerson) {
//       alert("Please select sales person");
//       return;
//     }

//     // Validate split payments
//     if (paymentMethod === 'Split') {
//       const cash = Number(cashAmount) || 0;
//       const card = Number(cardAmount) || 0;
//       const total = cash + card;
      
//       if (total === 0) {
//         alert("Please enter payment amounts for both cash and card");
//         return;
//       }
      
//       if (total > directSaleTotal) {
//         alert(`Total payment (${total}) cannot exceed total amount (${directSaleTotal})`);
//         return;
//       }
//     } else {
//       if (Number(formData.advancePayment || 0) > Number(directSaleTotal)) {
//         alert("Payment cannot exceed total amount");
//         return;
//       }
//     }

//     // Get the next available type number (READ ONLY)
//     let typeNumber;
//     if (directInvoiceType === 'CL') {
//       typeNumber = await getNextCLNumber();
//     } else {
//       typeNumber = await getNextSNumber();
//     }

//     // Get main invoice number
//     const invoiceNumber = await generateNextInvoiceNumber();
//     setCurrentDirectMainInvoice(invoiceNumber);

//     // Calculate advance payment based on payment method
//     let advancePayment = 0;
//     let paymentDetails = {};

//     if (paymentMethod === 'Split') {
//       const cash = Number(cashAmount) || 0;
//       const card = Number(cardAmount) || 0;
//       advancePayment = cash + card;
//       paymentDetails = {
//         type: 'split',
//         breakdown: [
//           { method: 'Cash', amount: cash },
//           { method: 'Card', amount: card }
//         ].filter(p => p.amount > 0)
//       };
//     } else {
//       advancePayment = Number(formData.advancePayment) || 0;
//       paymentDetails = {
//         type: paymentMethod.toLowerCase(),
//         amount: advancePayment
//       };
//     }

//     const invoiceData = {
//       type: "direct-sale",
//       invoiceNumber: invoiceNumber,
//       directInvoiceType: directInvoiceType,
//       clNumber: directInvoiceType === 'CL' ? typeNumber : null,
//       sNumber: directInvoiceType === 'S' ? typeNumber : null,
      
//       salePerson: saleForm.salePerson || "",
//       billingDate: billingDate || "",
      
//       customer: {
//         title: formData.title || "",
//         firstName: formData.firstName,
//         lastName: formData.lastName,
//         fullName: `${formData.title} ${formData.firstName} ${formData.lastName}`,
//         tpNo: formData.tpNo,
//         address: formData.address || ""
//       },
      
//       // ✅ FIXED: Include all product fields
//       products: directSaleItems.map(item => ({
//         stockDocId: item.stockDocId,
//         modelNo: item.modelNo,
//         brand: item.brand,
//         colour: item.colour,
//         category: item.category || "other",
//         qty: Number(item.qty) || 1,
//         price: Number(item.sellingPrice) || 0,
//         total: Number(item.total) || 0,
//         // ✅ CRITICAL FIX: Add these fields for CL bills
//         BaseCurve: item.BaseCurve || "",
//         lPower: item.lPower || "",
//         rPower: item.rPower || item.rpower || "",
//         size: item.size || "" // For S bills
//       })),
      
//       financial: {
//         subtotal: directSaleSubtotal,
//         discountType: discountType,
//         discount: Number(formData.discount) || 0,
//         calculatedDiscount: calculatedDiscount,
//         totalAmount: directSaleTotal,
//         advancePayment: advancePayment,
//         balanceDue: directSaleBalance,
//         paymentType: paymentMethod,
//         paymentMethod: paymentMethod,
//         paymentDetails: paymentDetails
//       },
      
//       paymentStatus: paymentStatus,
//       createdAt: new Date().toISOString(),
//       status: directSaleBalance <= 0 ? "fully-paid" : "advance-paid"
//     };

//     const cleanData = JSON.parse(JSON.stringify(invoiceData));
//     console.log('Saving direct sale with product data:', cleanData.products);
//     await addDoc(collection(db, "invoices"), cleanData);

//     await reduceDirectSaleStock();
//     await createStockOutForDirectSale(invoiceNumber);
//     await generateDirectSaleInvoicePDF(cleanData);

//     alert("Direct Sale Saved");

//     // Increment the numbers
//     let nextTypeNumber;
//     if (directInvoiceType === 'CL') {
//       nextTypeNumber = await generateAndIncrementCLNumber();
//     } else {
//       nextTypeNumber = await generateAndIncrementSNumber();
//     }

//     // Update main invoice number
//     const newMainInvoice = await generateNextInvoiceNumber();
//     setCurrentDirectMainInvoice(newMainInvoice);
//     localStorage.setItem('displayMainInvoice', newMainInvoice);

//     handleResetForm();

//   } catch (error) {
//     console.log(error);
//     alert("Error saving direct sale");
//   } finally {
//     setIsSavingDirectSale(false);
//   }
// };



// =============================================
// 8. SAVE FUNCTION - FIXED
// =============================================

// =============================================
// 8. SAVE FUNCTION - COMPLETE FIX
// =============================================

const handleSaveDirectSale = async () => {

  if (isSavingDirectSale) return;
  setIsSavingDirectSale(true);

  try {
    if (directSaleItems.length === 0) {
      alert("Please add at least one product");
      setIsSavingDirectSale(false);
      return;
    }

    if (!saleForm.salePerson) {
      alert("Please select sales person");
      setIsSavingDirectSale(false);
      return;
    }

    // Validate split payments
    if (paymentMethod === 'Split') {
      const cash = Number(cashAmount) || 0;
      const card = Number(cardAmount) || 0;
      const total = cash + card;
      
      if (total === 0) {
        alert("Please enter payment amounts for both cash and card");
        setIsSavingDirectSale(false);
        return;
      }
      
      if (total > directSaleTotal) {
        alert(`Total payment (${total}) cannot exceed total amount (${directSaleTotal})`);
        setIsSavingDirectSale(false);
        return;
      }
    } else {
      if (Number(formData.advancePayment || 0) > Number(directSaleTotal)) {
        alert("Payment cannot exceed total amount");
        setIsSavingDirectSale(false);
        return;
      }
    }

    // ✅ Get the number using generate functions
    let typeNumber;
    if (directInvoiceType === 'CL') {
      typeNumber = await generateAndIncrementCLNumber();
    } else {
      typeNumber = await generateAndIncrementSNumber();
    }

    // Get main invoice number
    const invoiceNumber = await generateNextInvoiceNumber();
    setCurrentDirectMainInvoice(invoiceNumber);

    // Calculate advance payment based on payment method
    let advancePayment = 0;
    let paymentDetails = {};

    if (paymentMethod === 'Split') {
      const cash = Number(cashAmount) || 0;
      const card = Number(cardAmount) || 0;
      advancePayment = cash + card;
      paymentDetails = {
        type: 'split',
        breakdown: [
          { method: 'Cash', amount: cash },
          { method: 'Card', amount: card }
        ].filter(p => p.amount > 0)
      };
    } else {
      advancePayment = Number(formData.advancePayment) || 0;
      paymentDetails = {
        type: paymentMethod.toLowerCase(),
        amount: advancePayment
      };
    }

    const invoiceData = {
      type: "direct-sale",
      invoiceNumber: invoiceNumber,
      directInvoiceType: directInvoiceType,
      clNumber: directInvoiceType === 'CL' ? typeNumber : null,
      sNumber: directInvoiceType === 'S' ? typeNumber : null,
      
      salePerson: saleForm.salePerson || "",
      billingDate: billingDate || "",
      
      customer: {
        title: formData.title || "",
        firstName: formData.firstName,
        lastName: formData.lastName,
        fullName: `${formData.title} ${formData.firstName} ${formData.lastName}`,
        tpNo: formData.tpNo,
        address: formData.address || ""
      },
      
      products: directSaleItems.map(item => ({
        stockDocId: item.stockDocId,
        modelNo: item.modelNo,
        brand: item.brand,
        colour: item.colour,
        category: item.category || "other",
        qty: Number(item.qty) || 1,
        price: Number(item.sellingPrice) || 0,
        total: Number(item.total) || 0,
        BaseCurve: item.BaseCurve || "",
        lPower: item.lPower || "",
        rPower: item.rPower || item.rpower || "",
        size: item.size || ""
      })),
      
      financial: {
        subtotal: directSaleSubtotal,
        discountType: discountType,
        discount: Number(formData.discount) || 0,
        calculatedDiscount: calculatedDiscount,
        totalAmount: directSaleTotal,
        advancePayment: advancePayment,
        balanceDue: directSaleBalance,
        paymentType: paymentMethod,
        paymentMethod: paymentMethod,
        paymentDetails: paymentDetails
      },
      
      paymentStatus: paymentStatus,
      createdAt: new Date().toISOString(),
      status: directSaleBalance <= 0 ? "fully-paid" : "advance-paid"
    };

    const cleanData = JSON.parse(JSON.stringify(invoiceData));
    console.log('Saving direct sale with product data:', cleanData.products);
    await addDoc(collection(db, "invoices"), cleanData);

    await reduceDirectSaleStock();
    await createStockOutForDirectSale(invoiceNumber);
    await generateDirectSaleInvoicePDF(cleanData);

    alert(`Direct Sale ${directInvoiceType}${typeNumber} Saved Successfully!`);

    // ✅ Update main invoice number for next use
    const newMainInvoice = await generateNextInvoiceNumber();
    setCurrentDirectMainInvoice(newMainInvoice);

  

    handleResetForm();

  } catch (error) {
    console.log(error);
    alert("Error saving direct sale");
  } finally {
    setIsSavingDirectSale(false);
  }
};




useEffect(() => {
  const init = async () => {
    await initializeInvoiceNumbers();
    await fetchDirectSaleProducts();
  };
  init();
}, []);




// =============================================
// 9. STOCK MANAGEMENT FUNCTIONS
// =============================================

const reduceDirectSaleStock = async () => {
  console.log("Starting stock reduction for items:", directSaleItems);

  for (const item of directSaleItems) {
    try {
      const stockRef = doc(db, "stock", item.stockDocId);
      const snap = await getDoc(stockRef);

      if (!snap.exists()) {
        console.error(`Stock document ${item.stockDocId} not found!`);
        continue;
      }

      const data = snap.data();
      
      if (data.items && Array.isArray(data.items)) {
        let itemFound = false;
        
        const updatedItems = data.items.map(stockItem => {
          const matchByModelAndColor = 
            stockItem.modelNo === item.modelNo && 
            stockItem.colour === item.colour;
          
          const matchByModelOnly = 
            stockItem.modelNo === item.modelNo && 
            (!item.colour || item.colour === "");
          
          const matchByBrandAndModel = 
            stockItem.brand === item.brand && 
            stockItem.modelNo === item.modelNo;
          
          const isMatch = matchByModelAndColor || matchByModelOnly || matchByBrandAndModel;
          
          if (isMatch) {
            itemFound = true;
            const currentQty = stockItem.qty || 0;
            const newQty = currentQty - item.qty;
            
            if (newQty < 0) {
              console.warn(`Warning: Stock would become negative for ${item.modelNo}! Current: ${currentQty}, Reducing by: ${item.qty}`);
            }
            
            console.log(`Reducing stock: ${item.modelNo} from ${currentQty} to ${Math.max(0, newQty)}`);
            
            return {
              ...stockItem,
              qty: Math.max(0, newQty)
            };
          }
          return stockItem;
        });
        
        if (!itemFound) {
          console.error(`Item not found in stock: ${item.modelNo}, Color: ${item.colour}`);
          console.log("Available items:", data.items.map(i => ({modelNo: i.modelNo, colour: i.colour, brand: i.brand})));
          throw new Error(`Product ${item.modelNo} not found in stock`);
        }
        
        await updateDoc(stockRef, { items: updatedItems });
        console.log(`Successfully updated stock for ${item.modelNo}`);
        
      } else if (data.quantity !== undefined) {
        const currentQty = data.quantity || 0;
        const newQty = currentQty - item.qty;
        
        if (newQty < 0) {
          console.warn(`Warning: Stock would become negative for ${item.modelNo}! Current: ${currentQty}, Reducing by: ${item.qty}`);
        }
        
        await updateDoc(stockRef, { 
          quantity: Math.max(0, newQty)
        });
        console.log(`Updated simple stock: ${item.modelNo} from ${currentQty} to ${Math.max(0, newQty)}`);
        
      } else {
        console.error(`Unknown stock structure for ${item.stockDocId}`);
      }
      
    } catch (error) {
      console.error(`Error reducing stock for item ${item.modelNo}:`, error);
      throw error;
    }
  }
  
  console.log("Stock reduction completed successfully");
};

const createStockOutForDirectSale = async (invoiceNumber) => {
  console.log("Creating stock_out records for invoice:", invoiceNumber);
  
  for (const item of directSaleItems) {
    try {
      const stockRef = doc(db, "stock", item.stockDocId);
      const snap = await getDoc(stockRef);
      
      let remainingStock = 0;
      
      if (snap.exists()) {
        const data = snap.data();
        if (data.items && Array.isArray(data.items)) {
          const foundItem = data.items.find(
            i => i.modelNo === item.modelNo && i.colour === item.colour
          );
          remainingStock = foundItem ? (foundItem.qty || 0) : 0;
        } else if (data.quantity !== undefined) {
          remainingStock = data.quantity || 0;
        }
      }
      
      const stockOutRecord = {
        productId: item.stockDocId,
        productModel: item.modelNo,
        brand: item.brand,
        colour: item.colour,
        quantity: item.qty,
        price: item.sellingPrice,
        remainingStock: remainingStock,
        invoiceNumber: invoiceNumber,
        type: "sale",
        date: new Date().toISOString(),
        createdAt: new Date().toISOString()
      };
      
      console.log("Creating stock_out record:", stockOutRecord);
      await addDoc(collection(db, "stock_out"), stockOutRecord);
      
    } catch (error) {
      console.error(`Error creating stock_out for ${item.modelNo}:`, error);
      throw error;
    }
  }
  
  console.log("Stock_out records created successfully");
};

// =============================================
// 10. PDF GENERATION FUNCTION
// =============================================

// const generateDirectSaleInvoicePDF = async (invoiceData) => {
//   const doc = new jsPDF({
//     orientation: "portrait",
//     unit: "mm",
//     format: "a5"
//   });

//   const pageWidth = doc.internal.pageSize.getWidth();
//   const pageHeight = doc.internal.pageSize.getHeight();
//   let y = 12;
//   const leftMargin = 8;
//   const rightMargin = pageWidth - 8;

//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(7);

//   doc.text(`Date: ${new Date(invoiceData.createdAt).toLocaleDateString()}`, rightMargin, y + 25, { align: "right" });

//   y = 48;

//   // Divider
//   doc.setLineWidth(0.2);
//   doc.line(leftMargin, y, rightMargin, y);
//   y += 3.5;

//   // Title
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(9);
//   doc.text("INVOICE", pageWidth / 2, y, { align: "center" });
//   y += 4;

//   // Invoice Details
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(8);
//   doc.text(`Invoice: ${invoiceData.invoiceNumber}`, leftMargin, y);
  
//   if (invoiceData.directInvoiceType === 'CL') {
//     doc.text(`CL No: ${invoiceData.clNumber || '-'}`, 70, y);
//   } else if (invoiceData.directInvoiceType === 'S') {
//     doc.text(`S No: ${invoiceData.sNumber || '-'}`, 70, y);
//   }
//   y += 4.5;



//   // Customer Details
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(8);
//   doc.text("Customer", leftMargin, y);
//   y += 4.5;

//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(8);
//   doc.text(`Name: ${invoiceData.customer.fullName}`, leftMargin, y);
//   doc.text(`TP: ${invoiceData.customer.tpNo}`, 70, y);
//   y += 4.5;
//   doc.text(`Address: ${invoiceData.customer.address || "-"}`, leftMargin, y);
//   y += 4;

//   doc.line(leftMargin, y, rightMargin, y);
//   y += 4;





// // ------------------------------
// // PRODUCT DETAILS
// // ------------------------------
// // ------------------------------
// // PRODUCT DETAILS
// // ------------------------------
// doc.setTextColor(0, 0, 0);
// doc.setFont("helvetica", "bold");
// doc.setFontSize(8);
// doc.text("Product Details", leftMargin + 2, y);
// y += 6;

// // Column Positions (A5)
// const cols = {
//   num: leftMargin + 5,
//   model: leftMargin + 12,
//   brand: leftMargin + 50,
//   color: leftMargin + 87,
//   qty: leftMargin + 114,
//   price: rightMargin - 2
// };

// // Header Background
// doc.setFillColor(240, 240, 240);
// doc.rect(leftMargin, y - 4, rightMargin - leftMargin, 6, "F");

// // Header
// doc.setFont("helvetica", "bold");
// doc.setFontSize(6);

// doc.text("#", cols.num, y, { align: "center" });
// doc.text("Model", cols.model, y);
// doc.text("Brand", cols.brand, y);
// doc.text("Color", cols.color, y);
// doc.text("Qty", cols.qty, y, { align: "center" });
// doc.text("Price", cols.price, y, { align: "right" });

// y += 4;

// // Header Line
// doc.setDrawColor(180);
// doc.line(leftMargin, y, rightMargin, y);

// doc.setFont("helvetica", "normal");
// doc.setFontSize(6);

// invoiceData.products.forEach((item, index) => {

//   if (y > pageHeight - 35) {
//     doc.addPage();
//     y = 15;

//     // Repeat Header
//     doc.setFillColor(240, 240, 240);
//     doc.rect(leftMargin, y - 4, rightMargin - leftMargin, 6, "F");

//     doc.setFont("helvetica", "bold");
//     doc.setFontSize(6);

//     doc.text("#", cols.num, y, { align: "center" });
//     doc.text("Model", cols.model, y);
//     doc.text("Brand", cols.brand, y);
//     doc.text("Color", cols.color, y);
//     doc.text("Qty", cols.qty, y, { align: "center" });
//     doc.text("Price", cols.price, y, { align: "right" });

//     y += 4;
//     doc.line(leftMargin, y, rightMargin, y);

//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(6);
//   }

//   y += 4;

//   const model = item.modelNo || "-";
//   const brand = item.brand || "-";
//   const colour = item.colour || "-";
//   const qty = item.qty || 1;
//   const price = Number(item.price || 0);

//   doc.text(String(index + 1), cols.num, y, { align: "center" });
//   doc.text(model, cols.model, y);
//   doc.text(brand, cols.brand, y);
//   doc.text(colour, cols.color, y);
//   doc.text(String(qty), cols.qty, y, { align: "center" });
//   doc.text(`Rs. ${price.toFixed(0)}`, cols.price, y, {
//     align: "right",
//   });

//   // Row Separator
//   doc.setDrawColor(230);
//   doc.line(leftMargin, y + 2, rightMargin, y + 2);
// }

// );

// y += 5;
// doc.setDrawColor(0);
// doc.line(leftMargin, y, rightMargin, y);
// y += 4;






//   // Payment Summary
//   doc.setTextColor(0, 0, 0);
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(8);
//   doc.text("Payment", leftMargin + 2, y);
//   doc.setTextColor(0, 0, 0);
//   y += 5;

//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(7);

//   const discountAmount = invoiceData.financial.calculatedDiscount || 0;
//   const discountType = invoiceData.financial.discountType || 'amount';
//   const discountValue = invoiceData.financial.discount || 0;

//   // Format discount display with percentage in the label
//   let discountDisplayText = `Rs. ${Number(discountAmount).toFixed(2)}`;
//   let discountLabelText = 'Discount';

//   if (discountType === 'percentage' && discountValue > 0) {
//     discountLabelText = `Discount (${discountValue}%)`;
//     discountDisplayText = `Rs. ${Number(discountAmount).toFixed(2)}`;
//   }

//   // Build payment summary items
//   const summaryItems = [
//     ["Subtotal", invoiceData.financial.subtotal || 0],
//     [discountLabelText, discountDisplayText, false, true],
//     ["Grand Total", invoiceData.financial.totalAmount || 0, true]
//   ];

//   // Check for split payment details
//   const paymentDetails = invoiceData.financial.paymentDetails || {};
  
//   if (paymentDetails.type === 'split' && paymentDetails.breakdown) {
//     // Add each payment method from breakdown
//     paymentDetails.breakdown.forEach(p => {
//       const label = p.method || 'Payment';
//       summaryItems.push([label, `Rs. ${Number(p.amount).toFixed(2)}`]);
//     });
    
//     // Calculate and add total paid
//     const totalPaid = paymentDetails.breakdown.reduce((sum, p) => sum + Number(p.amount), 0);
//     summaryItems.push(["Total Paid", `Rs. ${totalPaid.toFixed(2)}`, true]);
//   } else {
//     // Regular single payment method
//     summaryItems.push(["Paid", invoiceData.financial.advancePayment || 0]);
//   }

//   // Add balance
//   summaryItems.push(["Balance", invoiceData.financial.balanceDue || 0, true]);

//   // Render summary items
//   summaryItems.forEach(([label, amount, bold = false, isCustomDisplay = false]) => {
//     if (y > 250) {
//       doc.addPage();
//       y = 15;
//     }
    
//     if (bold) {
//       doc.setFont("helvetica", "bold");
//     } else {
//       doc.setFont("helvetica", "normal");
//     }
    
//     // For discount and custom displays
//     if (isCustomDisplay && label.includes('Discount')) {
//       doc.text(`${label}:`, leftMargin, y);
//       doc.text(amount, rightMargin, y, { align: "right" });
//     } else if (typeof amount === 'string' && amount.startsWith('Rs.')) {
//       // For string amounts (like split payment displays)
//       doc.text(label, leftMargin, y);
//       doc.text(amount, rightMargin, y, { align: "right" });
//     } else {
//       doc.text(label, leftMargin, y);
//       doc.text(`Rs. ${Number(amount).toFixed(2)}`, rightMargin, y, { align: "right" });
//     }
//     y += 4.5;
//   });

//   y += 1;
//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(7);
//   doc.text(`Served By: ${invoiceData.salePerson || "-"}`, leftMargin, y);
//   y += 5;



//   // Save the PDF
//   doc.save(`${invoiceData.invoiceNumber}_DIRECT_SALE.pdf`);
// };



const generateDirectSaleInvoicePDF = async (invoiceData) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a5"
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  let y = 12;
  const leftMargin = 8;
  const rightMargin = pageWidth - 8;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);

  doc.text(`Date: ${new Date(invoiceData.createdAt).toLocaleDateString()}`, rightMargin, y + 25, { align: "right" });

  y = 48;

  // Divider
  doc.setLineWidth(0.2);
  doc.line(leftMargin, y, rightMargin, y);
  y += 3.5;

  // Title
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text("INVOICE", pageWidth / 2, y, { align: "center" });
  y += 4;

  // Invoice Details
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.text(`Invoice: ${invoiceData.invoiceNumber}`, leftMargin, y);
  
  if (invoiceData.directInvoiceType === 'CL') {
    doc.text(`CL No: ${invoiceData.clNumber || invoiceData.clNo || '-'}`, 70, y);
  } else if (invoiceData.directInvoiceType === 'S') {
    doc.text(`S No: ${invoiceData.sNumber || '-'}`, 70, y);
  }
  y += 4.5;

  // Customer Details
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.text("Customer", leftMargin, y);
  y += 4.5;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.text(`Name: ${invoiceData.customer?.fullName || '-'}`, leftMargin, y);
  doc.text(`TP: ${invoiceData.customer?.tpNo || '-'}`, 70, y);
  y += 4.5;
  doc.text(`Address: ${invoiceData.customer?.address || "-"}`, leftMargin, y);
  y += 4;

  // Divider
  doc.line(leftMargin, y, rightMargin, y);
  y += 4;

  // ------------------------------
  // PRODUCT DETAILS
  // ------------------------------
  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.text("Product Details", leftMargin + 2, y);
  y += 6;

  // Check if it's a CL bill to add R Power and L Power columns
  const isCL = invoiceData.directInvoiceType === 'CL';
  
  // Column Positions (A5) - Adjusted for additional columns
  let cols;
 if (isCL) {
  cols = {
    num: leftMargin + 2,        // # column (reduced from 3)
    model: leftMargin + 6,      // Model column (reduced from 8)
    brand: leftMargin + 32,     // Brand column (reduced from 40)
    color: leftMargin + 58,     // Color column (reduced from 72)
    rPower: leftMargin + 78,    // R Power column (reduced from 96)
    lPower: leftMargin + 94,    // L Power column (reduced from 114)
    qty: leftMargin + 108,      // Qty column (reduced from 132)
    price: rightMargin - 2      // Price column
  };
} else {
    // For non-CL bills - original columns
    cols = {
      num: leftMargin + 5,
      model: leftMargin + 12,
      brand: leftMargin + 50,
      color: leftMargin + 87,
      qty: leftMargin + 114,
      price: rightMargin - 2
    };
  }

  // Header Background
  doc.setFillColor(240, 240, 240);
  doc.rect(leftMargin, y - 4, rightMargin - leftMargin, 6, "F");

  // Header
  doc.setFont("helvetica", "bold");
  doc.setFontSize(6);

  if (isCL) {
    // CL Bill Header with R Power and L Power
    doc.text("#", cols.num, y, { align: "center" });
    doc.text("Model", cols.model, y);
    doc.text("Brand", cols.brand, y);
    doc.text("Color", cols.color, y);
    doc.text("R Power", cols.rPower, y, { align: "center" });
    doc.text("L Power", cols.lPower, y, { align: "center" });
    doc.text("Qty", cols.qty, y, { align: "center" });
    doc.text("Price", cols.price, y, { align: "right" });
  } else {
    // Regular Header
    doc.text("#", cols.num, y, { align: "center" });
    doc.text("Model", cols.model, y);
    doc.text("Brand", cols.brand, y);
    doc.text("Color", cols.color, y);
    doc.text("Qty", cols.qty, y, { align: "center" });
    doc.text("Price", cols.price, y, { align: "right" });
  }

  y += 4;

  // Header Line
  doc.setDrawColor(180);
  doc.line(leftMargin, y, rightMargin, y);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(6);

  invoiceData.products.forEach((item, index) => {
    if (y > pageHeight - 35) {
      doc.addPage();
      y = 15;

      // Repeat Header
      doc.setFillColor(240, 240, 240);
      doc.rect(leftMargin, y - 4, rightMargin - leftMargin, 6, "F");

      doc.setFont("helvetica", "bold");
      doc.setFontSize(6);

      if (isCL) {
        doc.text("#", cols.num, y, { align: "center" });
        doc.text("Model", cols.model, y);
        doc.text("Brand", cols.brand, y);
        doc.text("Color", cols.color, y);
        doc.text("R Power", cols.rPower, y, { align: "center" });
        doc.text("L Power", cols.lPower, y, { align: "center" });
        doc.text("Qty", cols.qty, y, { align: "center" });
        doc.text("Price", cols.price, y, { align: "right" });
      } else {
        doc.text("#", cols.num, y, { align: "center" });
        doc.text("Model", cols.model, y);
        doc.text("Brand", cols.brand, y);
        doc.text("Color", cols.color, y);
        doc.text("Qty", cols.qty, y, { align: "center" });
        doc.text("Price", cols.price, y, { align: "right" });
      }

      y += 4;
      doc.line(leftMargin, y, rightMargin, y);

      doc.setFont("helvetica", "normal");
      doc.setFontSize(6);
    }

    y += 4;

    const model = item.modelNo || "-";
    const brand = item.brand || "-";
    const colour = item.colour || "-";
    const qty = item.qty || 1;
    const price = Number(item.price || 0);
    const rPower = item.rPower || "-";
    const lPower = item.lPower || "-";

    if (isCL) {
      // CL Bill Row with R Power and L Power
      doc.text(String(index + 1), cols.num, y, { align: "center" });
      doc.text(model, cols.model, y);
      doc.text(brand, cols.brand, y);
      doc.text(colour, cols.color, y);
      doc.text(rPower, cols.rPower, y, { align: "center" });
      doc.text(lPower, cols.lPower, y, { align: "center" });
      doc.text(String(qty), cols.qty, y, { align: "center" });
      doc.text(`Rs. ${price.toFixed(0)}`, cols.price, y, { align: "right" });
    } else {
      // Regular Row
      doc.text(String(index + 1), cols.num, y, { align: "center" });
      doc.text(model, cols.model, y);
      doc.text(brand, cols.brand, y);
      doc.text(colour, cols.color, y);
      doc.text(String(qty), cols.qty, y, { align: "center" });
      doc.text(`Rs. ${price.toFixed(0)}`, cols.price, y, { align: "right" });
    }

    // Row Separator
    doc.setDrawColor(230);
    doc.line(leftMargin, y + 2, rightMargin, y + 2);
  });

  y += 5;
  doc.setDrawColor(0);
  doc.line(leftMargin, y, rightMargin, y);
  y += 4;

  // Payment Summary
  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.text("Payment", leftMargin + 2, y);
  doc.setTextColor(0, 0, 0);
  y += 5;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);

  const discountAmount = invoiceData.financial?.calculatedDiscount || 0;
  const discountType = invoiceData.financial?.discountType || 'amount';
  const discountValue = invoiceData.financial?.discount || 0;

  // Format discount display with percentage in the label
  let discountDisplayText = `Rs. ${Number(discountAmount).toFixed(2)}`;
  let discountLabelText = 'Discount';

  if (discountType === 'percentage' && discountValue > 0) {
    discountLabelText = `Discount (${discountValue}%)`;
    discountDisplayText = `Rs. ${Number(discountAmount).toFixed(2)}`;
  }

  // Build payment summary items
  const summaryItems = [
    ["Subtotal", invoiceData.financial?.subtotal || 0],
    [discountLabelText, discountDisplayText, false, true],
    ["Grand Total", invoiceData.financial?.totalAmount || 0, true]
  ];

  // Check for split payment details
  const paymentDetails = invoiceData.financial?.paymentDetails || {};
  
  if (paymentDetails.type === 'split' && paymentDetails.breakdown) {
    // Add each payment method from breakdown
    paymentDetails.breakdown.forEach(p => {
      const label = p.method || 'Payment';
      summaryItems.push([label, `Rs. ${Number(p.amount).toFixed(2)}`]);
    });
    
    // Calculate and add total paid
    const totalPaid = paymentDetails.breakdown.reduce((sum, p) => sum + Number(p.amount), 0);
    summaryItems.push(["Total Paid", `Rs. ${totalPaid.toFixed(2)}`, true]);
  } else {
    // Regular single payment method
    summaryItems.push(["Paid", invoiceData.financial?.advancePayment || 0]);
  }

  // Add balance
  summaryItems.push(["Balance", invoiceData.financial?.balanceDue || 0, true]);

  // Render summary items
  summaryItems.forEach(([label, amount, bold = false, isCustomDisplay = false]) => {
    if (y > 250) {
      doc.addPage();
      y = 15;
    }
    
    if (bold) {
      doc.setFont("helvetica", "bold");
    } else {
      doc.setFont("helvetica", "normal");
    }
    
    // For discount and custom displays
    if (isCustomDisplay && label.includes('Discount')) {
      doc.text(`${label}:`, leftMargin, y);
      doc.text(amount, rightMargin, y, { align: "right" });
    } else if (typeof amount === 'string' && amount.startsWith('Rs.')) {
      // For string amounts (like split payment displays)
      doc.text(label, leftMargin, y);
      doc.text(amount, rightMargin, y, { align: "right" });
    } else {
      doc.text(label, leftMargin, y);
      doc.text(`Rs. ${Number(amount).toFixed(2)}`, rightMargin, y, { align: "right" });
    }
    y += 4.5;
  });

  y += 1;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(7);
  doc.text(`Served By: ${invoiceData.salePerson || "-"}`, leftMargin, y);
  y += 5;

  // Save the PDF
  doc.save(`${invoiceData.invoiceNumber}_DIRECT_SALE.pdf`);
};




// =============================================
// 11. RESTORE FUNCTIONS (For reference)
// =============================================

const restoreDirectSaleStock = async (invoiceData) => {
  try {
    if (!invoiceData.products || invoiceData.products.length === 0) {
      console.log('No products to restore');
      return;
    }

    console.log('Restoring stock for direct sale invoice:', invoiceData.invoiceNumber);

    for (const product of invoiceData.products) {
      const stockRef = doc(db, "stock", product.stockDocId);
      const stockSnap = await getDoc(stockRef);

      if (!stockSnap.exists()) {
        console.warn(`Stock document not found for product: ${product.modelNo}`);
        continue;
      }

      const stockData = stockSnap.data();

      if (stockData.items && Array.isArray(stockData.items)) {
        const updatedItems = stockData.items.map(stockItem => {
          const match = 
            stockItem.modelNo === product.modelNo &&
            stockItem.colour === product.colour &&
            stockItem.category === product.category;

          if (match) {
            const restoredQty = (stockItem.qty || 0) + (product.qty || 0);
            console.log(`Restoring ${product.qty} units of ${product.modelNo} (Current: ${stockItem.qty}, New: ${restoredQty})`);
            return {
              ...stockItem,
              qty: restoredQty
            };
          }
          return stockItem;
        });

        await updateDoc(stockRef, { items: updatedItems });
        console.log(`Stock restored for product: ${product.modelNo}`);
      } else {
        const currentQty = stockData.quantity || 0;
        const restoredQty = currentQty + (product.qty || 0);
        await updateDoc(stockRef, { quantity: restoredQty });
        console.log(`Stock restored for simple product: ${product.modelNo}`);
      }
    }

    console.log('Direct sale stock restoration completed');
    return true;

  } catch (error) {
    console.error('Error restoring direct sale stock:', error);
    throw error;
  }
};

const deleteDirectSaleStockOutRecords = async (invoiceNumber) => {
  try {
    const stockOutQuery = query(
      collection(db, 'stock_out'),
      where('invoiceNumber', '==', invoiceNumber)
    );

    const stockOutSnapshot = await getDocs(stockOutQuery);
    let deletedCount = 0;

    for (const stockOutDoc of stockOutSnapshot.docs) {
      await deleteDoc(doc(db, 'stock_out', stockOutDoc.id));
      deletedCount++;
      console.log(`Deleted stock_out record: ${stockOutDoc.id}`);
    }

    console.log(`Deleted ${deletedCount} stock_out records`);
    return deletedCount;

  } catch (error) {
    console.error('Error deleting stock_out records:', error);
    throw error;
  }
};

// =============================================
// 12. useEffect HOOKS - SINGLE initialization
// =============================================

useEffect(() => {
  // Initialize everything when component mounts
  const init = async () => {
    await fetchDirectSaleProducts();
    await initializeInvoiceNumbers();
  };
  
  init();
}, []); // Empty dependency array - runs once on mount











///////////////////////////////////////// service invoice  service bill ///////////////////////////////////////////////
// Service Invoice States


// =============================================
// 1. SERVICE INVOICE STATE DECLARATIONS
// =============================================
// =============================================
// 1. SERVICE INVOICE STATE DECLARATIONS - FIXED
// =============================================
const [currentServiceMainInvoice, setCurrentServiceMainInvoice] = useState('');
const [currentRNumber, setCurrentRNumber] = useState(''); 
const [lastRNumber, setLastRNumber] = useState(2880); 
const [isSavingServiceInvoice, setIsSavingServiceInvoice] = useState(false);
const [isServiceInitialized, setIsServiceInitialized] = useState(false);

// NEW: Service split payment states
const [servicePaymentMethod, setServicePaymentMethod] = useState('Cash');
const [serviceCashAmount, setServiceCashAmount] = useState();
const [serviceCardAmount, setServiceCardAmount] = useState();

// =============================================
// 2. COUNTER DOCUMENT - Add R number
// =============================================





// =============================================
// 3. GET NEXT R NUMBER - From counter document
// =============================================

const getNextRNumber = async () => {
  try {
    const counterRef = doc(db, 'counters', COUNTER_DOC_ID);
    const counterDoc = await getDoc(counterRef);
    
    if (!counterDoc.exists()) {
      await initCounterDocument();
      return 'R2881';
    }
    
    const data = counterDoc.data();
    const lastNumber = data.lastRNumber || 2880;
    const nextNumber = lastNumber + 1;
    
    console.log(`📊 Next R number: R${nextNumber}`);
    return `R${nextNumber}`;
  } catch (error) {
    console.error('Error getting R number:', error);
    return 'R2881';
  }
};

// =============================================
// 4. GENERATE R NUMBER - Update counter document
// =============================================

const generateAndIncrementRNumber = async () => {
  try {
    const counterRef = doc(db, 'counters', COUNTER_DOC_ID);
    
    // ✅ Use Firestore transaction to increment atomically
    const result = await runTransaction(db, async (transaction) => {
      const counterDoc = await transaction.get(counterRef);
      
      if (!counterDoc.exists()) {
        // Initialize if doesn't exist
        transaction.set(counterRef, {
          lastCLNumber: 4701,
          lastSNumber: 2722,
          lastRXNumber: 139370,
          lastVIPNumber: 7288,
          lastRNumber: 2880
        });
        return 2881; // First R number
      }
      
      const data = counterDoc.data();
      const currentNumber = (data.lastRNumber || 2880) + 1;
      
      // ✅ Update the counter
      transaction.update(counterRef, {
        lastRNumber: currentNumber
      });
      
      return currentNumber;
    });
    
    // ✅ Update React state
    setLastRNumber(result);
    setCurrentRNumber(`R${result + 1}`);
    
    console.log(`✅ GENERATED: R${result}`);
    return `R${result}`;
    
  } catch (error) {
    console.error('Error generating R number:', error);
    const currentNumber = lastRNumber + 1;
    setLastRNumber(currentNumber);
    setCurrentRNumber(`R${currentNumber + 1}`);
    return `R${currentNumber}`;
  }
};

// =============================================
// 5. INITIALIZATION - From counter document
// =============================================

const initializeServiceInvoiceNumbers = async () => {
  try {
    const counterRef = doc(db, 'counters', COUNTER_DOC_ID);
    const counterDoc = await getDoc(counterRef);
    
    let lastR = 2880;
    
    if (counterDoc.exists()) {
      const data = counterDoc.data();
      lastR = data.lastRNumber || 2880;
    } else {
      // Create counter document
      await initCounterDocument();
    }
    
    // ✅ Display the NEXT number (lastR + 1)
    const nextR = lastR + 1;
    setLastRNumber(lastR);
    setCurrentRNumber(`R${nextR}`);
    
    // Main invoice
    const savedMain = localStorage.getItem('displayServiceMainInvoice');
    if (savedMain) {
      setCurrentServiceMainInvoice(savedMain);
    } else {
      const mainInvoice = await generateNextInvoiceNumber();
      setCurrentServiceMainInvoice(mainInvoice);
      localStorage.setItem('displayServiceMainInvoice', mainInvoice);
    }
    
    setIsServiceInitialized(true);
    console.log(`✅ Service Initialized: Next R=R${nextR}`);
    
  } catch (error) {
    console.error('Error initializing service invoice numbers:', error);
    setCurrentRNumber('R2881');
    setIsServiceInitialized(true);
  }
};

// =============================================
// 6. CALCULATIONS - Keep as is
// =============================================
const serviceSubtotal = Number(serviceAmount || 0);

const serviceCalculatedDiscount =
  discountType === "percentage"
    ? (serviceSubtotal * (Number(formData.discount || 0) / 100))
    : Number(formData.discount || 0);

const serviceGrandTotal = serviceSubtotal - serviceCalculatedDiscount;

// NEW: Calculate payment amounts based on method
let serviceTotalPaid = 0;
let servicePaymentBreakdown = [];

if (servicePaymentMethod === 'Cash') {
  serviceTotalPaid = Number(formData.advancePayment || 0);
  servicePaymentBreakdown = [{ method: 'Cash', amount: serviceTotalPaid }];
} else if (servicePaymentMethod === 'Card') {
  serviceTotalPaid = Number(formData.advancePayment || 0);
  servicePaymentBreakdown = [{ method: 'Card', amount: serviceTotalPaid }];
} else if (servicePaymentMethod === 'Split') {
  const cash = Number(serviceCashAmount) || 0;
  const card = Number(serviceCardAmount) || 0;
  serviceTotalPaid = cash + card;
  servicePaymentBreakdown = [
    { method: 'Cash', amount: cash },
    { method: 'Card', amount: card }
  ].filter(p => p.amount > 0);
}

const serviceAdvanceAmount = serviceTotalPaid;
const serviceBalance = Math.max(0, serviceGrandTotal - serviceAdvanceAmount);

// =============================================
// 7. SAVE FUNCTION - FIXED (remove duplicate calls)
// =============================================

const handleSaveServiceInvoice = async () => {
  if (isSavingServiceInvoice) return;
  setIsSavingServiceInvoice(true);

  try {
    if (!serviceDescription) {
      alert("Please enter service description");
      setIsSavingServiceInvoice(false);
      return;
    }

    if (!serviceAmount) {
      alert("Please enter service amount");
      setIsSavingServiceInvoice(false);
      return;
    }

    // Validate split payments
    if (servicePaymentMethod === 'Split') {
      const cash = Number(serviceCashAmount) || 0;
      const card = Number(serviceCardAmount) || 0;
      const total = cash + card;
      
      if (total === 0) {
        alert("Please enter payment amounts for both cash and card");
        setIsSavingServiceInvoice(false);
        return;
      }
      
      if (total > serviceGrandTotal) {
        alert(`Total payment (${total}) cannot exceed total amount (${serviceGrandTotal})`);
        setIsSavingServiceInvoice(false);
        return;
      }
    } else {
      if (Number(formData.advancePayment || 0) > Number(serviceGrandTotal)) {
        alert("Payment cannot exceed total amount");
        setIsSavingServiceInvoice(false);
        return;
      }
    }

    // ✅ Generate R number - this updates the display
    const rNumber = await generateAndIncrementRNumber();

    // Get main invoice number
    const invoiceNumber = await generateNextInvoiceNumber();
    setCurrentServiceMainInvoice(invoiceNumber);

    // Calculate advance payment based on payment method
    let advancePayment = 0;
    let servicePaymentDetails = {};

    if (servicePaymentMethod === 'Split') {
      const cash = Number(serviceCashAmount) || 0;
      const card = Number(serviceCardAmount) || 0;
      advancePayment = cash + card;
      servicePaymentDetails = {
        type: 'split',
        breakdown: [
          { method: 'Cash', amount: cash },
          { method: 'Card', amount: card }
        ].filter(p => p.amount > 0)
      };
    } else {
      advancePayment = Number(formData.advancePayment) || 0;
      servicePaymentDetails = {
        type: servicePaymentMethod.toLowerCase(),
        amount: advancePayment
      };
    }

    const invoiceData = {
      type: "service-invoice",
      invoiceNumber: invoiceNumber,
      rNumber: rNumber,
      
      salePerson: formData.salePerson || "",  
      billingDate: billingDate || "",
      
      customer: {
        title: formData.title || "",
        firstName: formData.firstName || "",
        lastName: formData.lastName || "",
        fullName: `${formData.title} ${formData.firstName} ${formData.lastName}`,
        tpNo: formData.tpNo || "",
        address: formData.address || ""
      },
      
      service: {
        description: serviceDescription || "",
        amount: Number(serviceAmount) || 0
      },
      
      financial: {
        paymentType: servicePaymentMethod,
        subtotal: Number(serviceSubtotal) || 0,
        discountType: discountType || "amount",
        discount: Number(formData.discount) || 0,
        calculatedDiscount: Number(serviceCalculatedDiscount) || 0,
        advancePayment: Number(advancePayment) || 0,
        paymentMethod: servicePaymentMethod,
        totalAmount: Number(serviceGrandTotal) || 0,
        balanceDue: Number(serviceBalance) || 0,
        paymentDetails: servicePaymentDetails
      },
      
      createdAt: new Date().toISOString(),
      status: serviceBalance <= 0 ? "fully-paid" : "advance-paid"
    };

    const cleanData = JSON.parse(JSON.stringify(invoiceData));
    console.log('Saving service invoice:', cleanData.financial);
    await addDoc(collection(db, "invoices"), cleanData);
    await generateServiceInvoicePDF(cleanData);

    alert(`Service Invoice R${rNumber} Saved Successfully!`);

    // ✅ Update main invoice number for next use (NO localStorage)
    const newMainInvoice = await generateNextInvoiceNumber();
    setCurrentServiceMainInvoice(newMainInvoice);

    // ✅ NO SECOND CALL to getNextRNumber - generate function already updated display!

    setServiceDescription("");
    setServiceAmount("");
    handleResetForm();

  } catch (error) {
    console.log(error);
    alert("Error saving service invoice");
  } finally {
    setIsSavingServiceInvoice(false);
  }
};

// =============================================
// 8. RECOVERY FUNCTION - From counter document
// =============================================

const recoverServiceNumbers = async () => {
  try {
    console.log("🔄 Running service number recovery...");
    
    const counterRef = doc(db, 'counters', COUNTER_DOC_ID);
    const counterDoc = await getDoc(counterRef);
    
    let maxR = 2880;
    
    if (counterDoc.exists()) {
      const data = counterDoc.data();
      maxR = data.lastRNumber || 2880;
    }
    
    setLastRNumber(maxR);
    setCurrentRNumber(`R${maxR + 1}`);
    
    console.log(`✅ Service Recovery: Next R=R${maxR + 1}`);
    return { nextR: `R${maxR + 1}` };
    
  } catch (error) {
    console.error("Service recovery failed:", error);
    return null;
  }
};

// =============================================
// 9. USE EFFECT - Initialize on mount
// =============================================

useEffect(() => {
  const init = async () => {
    await initCounterDocument(); // Ensure counter exists
    await initializeServiceInvoiceNumbers();
  };
  init();
}, []);


// =============================================
// 7. PDF GENERATION - WITH SPLIT PAYMENT SUPPORT
// =============================================

const generateServiceInvoicePDF = async (invoiceData) => {
  const doc = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a5"
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  let y = 15;



  doc.setFont("times", "normal");
  doc.setFontSize(8);

  doc.text(`Date: ${new Date(invoiceData.createdAt).toLocaleDateString()}`, pageWidth - 10, 45, { align: "right" });

  y = 54;

  // Divider
  doc.setLineWidth(0.3);
  doc.line(10, y, pageWidth - 10, y);
  y += 6;

  // Title
  doc.setFont("times", "bold");
  doc.setFontSize(14);
  doc.text("SERVICE INVOICE", pageWidth / 2, y, { align: "center" });
  y += 4;

  // Invoice Details
  doc.setFont("times", "bold");
  doc.setFontSize(9);
  doc.text(`Invoice No: ${invoiceData.invoiceNumber}`, 10, y);
  y += 6;
  doc.text(`R No: ${invoiceData.rNumber || '-'}`, 10, y);
  y += 6;



  // Customer Details
  doc.setFont("times", "bold");
  doc.setFontSize(9);
  doc.text("Customer Details", 10, y);
  y += 6;

  doc.setFont("times", "normal");
  doc.setFontSize(9);
  doc.text(`Name: ${invoiceData.customer.fullName}`, 10, y);
  y += 6;
  doc.text(`TP: ${invoiceData.customer.tpNo}`, 10, y);
  y += 4;

  doc.line(10, y, pageWidth - 10, y);
  y += 8;

  // Service Details
  doc.setFont("times", "bold");
  doc.setFontSize(9);
  doc.text("Service Details", 10, y);
  y += 6;

  doc.setFont("times", "normal");
  doc.setFontSize(9);
  
  const splitText = doc.splitTextToSize(invoiceData.service.description, pageWidth - 20);
  doc.text(splitText, 10, y);
  y += splitText.length * 5 + 5;

  doc.text(`Service Charge: Rs. ${Number(invoiceData.service.amount).toFixed(2)}`, 10, y);
  y += 4;

  doc.line(10, y, pageWidth - 10, y);
  y += 8;

  // Payment Summary - WITH SPLIT PAYMENT SUPPORT
  doc.setFont("times", "bold");
  doc.setFontSize(9);
  doc.text("Payment Summary", 10, y);
  y += 6;

  doc.setFont("times", "normal");
  doc.setFontSize(9);

  // Get discount details
  const discountAmount = invoiceData.financial.calculatedDiscount || 0;
  const discountType = invoiceData.financial.discountType || 'amount';
  const discountValue = invoiceData.financial.discount || 0;

  // Create discount label with percentage
  let discountLabel = 'Discount';
  if (discountType === 'percentage' && discountValue > 0) {
    discountLabel = `Discount (${discountValue}%)`;
  }

  // Build payment items array
  const paymentItems = [
    { 
      label: "Subtotal", 
      amount: invoiceData.financial.subtotal || 0,
      bold: false
    },
    { 
      label: discountLabel, 
      amount: discountAmount,
      bold: false
    },
    { 
      label: "Grand Total", 
      amount: invoiceData.financial.totalAmount || 0,
      bold: true
    }
  ];

  // Check for split payment details
  const paymentDetails = invoiceData.financial.paymentDetails || {};
  
  if (paymentDetails.type === 'split' && paymentDetails.breakdown) {
    // Add each payment method from breakdown
    paymentDetails.breakdown.forEach(p => {
      const label = p.method || 'Payment';
      paymentItems.push({
        label: label,
        amount: p.amount,
        bold: false
      });
    });
    
    // Calculate and add total paid
    const totalPaid = paymentDetails.breakdown.reduce((sum, p) => sum + Number(p.amount), 0);
    paymentItems.push({
      label: "Total Paid",
      amount: totalPaid,
      bold: true
    });
  } else {
    // Regular single payment method
    paymentItems.push({
      label: "Amount Paid",
      amount: invoiceData.financial.advancePayment || 0,
      bold: false
    });
  }

  // Add balance
  paymentItems.push({
    label: "Balance Due",
    amount: invoiceData.financial.balanceDue || 0,
    bold: true
  });

  // Render payment items
  paymentItems.forEach((item) => {
    if (y > 250) {
      doc.addPage();
      y = 15;
    }
    
    if (item.bold) {
      doc.setFont("times", "bold");
    } else {
      doc.setFont("times", "normal");
    }
    
    doc.text(item.label, 10, y);
    
    // Format amount with currency
    const formattedAmount = `Rs. ${Number(item.amount).toFixed(2)}`;
    doc.text(formattedAmount, pageWidth - 10, y, { align: "right" });
    
    y += 6;
  });

  y += 2;
  
  // Served By
  doc.setFont("times", "normal");
  doc.setFontSize(9);
  doc.text(`Served By: ${invoiceData.salePerson || "-"}`, 10, y); 
  y += 6;

  
  y += 5;

  // Footer


  doc.save(`${invoiceData.invoiceNumber}_SERVICE_INVOICE.pdf`);
};

// =============================================
// 8. RESET FORM FUNCTION
// =============================================

const handleResetServiceForm = () => {
  setFormData({
    title: "",
    firstName: "",
    lastName: "",
    address: "",
    tpNo: "",
    discount: "",
    advancePayment: "",
    paymentMethod: "Cash"
  });
  
  // Reset service payment states
  setServicePaymentMethod('Cash');
  setServiceCashAmount(0);
  setServiceCardAmount(0);
  
  // Reset other fields
  setDiscountType("amount");
  setBillingDate(new Date().toISOString().split('T')[0]);
};

// =============================================
// 9. useEffect - Initialize on mount
// =============================================

useEffect(() => {
  const init = async () => {
    await initializeServiceInvoiceNumbers();
  };
  init();
}, []);





////////////////////////////////////////////////////// view all patient //////////////////////////////////////////////////////////////////////////

// Add state for patient directory
const [patients, setPatients] = useState([]);
const [filteredPatients, setFilteredPatients] = useState([]);
const [patientSearchTerm, setPatientSearchTerm] = useState('');
const [patientFilterAge, setPatientFilterAge] = useState('all');
const [patientFilterGender, setPatientFilterGender] = useState('all');
const [selectedPatient, setSelectedPatient] = useState(null);
const [showPatientDetails, setShowPatientDetails] = useState(false);
const [isLoadingPatients, setIsLoadingPatients] = useState(false);
const [patientDateRange, setPatientDateRange] = useState({ start: '', end: '' });

// Fetch all patients from invoices
// Fetch and group all patients with their invoices
// Fetch all patients from invoices and group them
// Fetch all patients (keeps separate rows per invoice)
const fetchAllPatients = async () => {
  try {
    setIsLoadingPatients(true);

    const invoiceSnap = await getDocs(
      query(collection(db, "invoices"), orderBy("createdAt", "desc"))
    );

    const qcSnap = await getDocs(collection(db, "patient_qc"));
    const trackSnap = await getDocs(collection(db, "track_spectacles"));

    // QC map (invoiceNumber -> qc)
    const qcMap = new Map();
    qcSnap.forEach(doc => {
      const d = doc.data();
      qcMap.set(d.invoiceNumber, d);
    });

    // Tracking map (invoiceNumber -> tracking)
    const trackMap = new Map();
    trackSnap.forEach(doc => {
      const d = doc.data();
      trackMap.set(d.invoiceNumber, d);
    });

    const invoiceList = [];

    invoiceSnap.forEach(docSnap => {
      const data = docSnap.data();
      const customer = data.customer || {};

      const invoiceNumber = data.invoiceNumber;
      const createdAt = data.createdAt || new Date();
      const totalAmount = Number(data.financial?.totalAmount || 0);
      const paidAmount = Number(data.financial?.advancePayment || 0) + Number(data.totalBalancePaid || 0);
      const balanceDue = Number(data.financial?.balanceDue || 0);

      // Create single invoice object for this row
      const singleInvoice = {
        id: docSnap.id,
        invoiceNumber: invoiceNumber,
        date: createdAt,
        totalAmount: totalAmount,
        paidAmount: paidAmount,
        balanceDue: balanceDue,
        status: balanceDue <= 0 ? "paid" : "pending",
        products: data.products || {},
        spectacleTracking: trackMap.get(invoiceNumber) || null,
        qcData: qcMap.get(invoiceNumber) || null
      };

      invoiceList.push({
        // Basic info (for table row)
        id: docSnap.id,
        invoiceNumber: invoiceNumber,
        date: createdAt,
        fullName: customer.fullName || `${customer.title || ""} ${customer.firstName || ""} ${customer.lastName || ""}`.trim(),
        tpNo: customer.tpNo || "",
        email: customer.email || "",
        age: customer.age || "",
        gender: customer.gender || "",
        address: customer.address || "",
        title: customer.title || "",
        
        // Financial (for table)
        totalAmount: totalAmount,
        paidAmount: paidAmount,
        balanceDue: balanceDue,
        status: balanceDue <= 0 ? "paid" : "pending",
        
        // For summary cards and modal
        totalSpent: totalAmount,      // This invoice amount
        totalDue: balanceDue,         // This invoice balance
        totalInvoices: 1,             // Each row is 1 invoice
        
        // For modal invoice history (wrap as array with 1 item)
        invoices: [singleInvoice],
        
        // For visit dates (same for this single invoice)
        firstVisit: createdAt,
        lastVisit: createdAt,
        
        // Tracking & QC
        spectacleTracking: trackMap.get(invoiceNumber) || null,
        qcData: qcMap.get(invoiceNumber) || null
      });
    });

    setPatients(invoiceList);
    setFilteredPatients(invoiceList);

  } catch (error) {
    console.error(error);
    alert(error.message);
  } finally {
    setIsLoadingPatients(false);
  }
};


// Filter patients
const filterPatients = () => {
  let filtered = [...patients];
  
  // Search filter
  if (patientSearchTerm) {
    const searchLower = patientSearchTerm.toLowerCase();
    filtered = filtered.filter(patient => 
      patient.fullName?.toLowerCase().includes(searchLower) ||
      patient.tpNo?.toLowerCase().includes(searchLower) ||
      patient.email?.toLowerCase().includes(searchLower) ||
      patient.address?.toLowerCase().includes(searchLower)
    );
  }
  
  // Age filter
  if (patientFilterAge !== 'all') {
    filtered = filtered.filter(patient => {
      const age = parseInt(patient.age);
      if (patientFilterAge === 'child') return age < 18;
      if (patientFilterAge === 'adult') return age >= 18 && age < 60;
      if (patientFilterAge === 'senior') return age >= 60;
      return true;
    });
  }
  
  // Gender filter
  if (patientFilterGender !== 'all') {
    filtered = filtered.filter(patient => 
      patient.gender?.toLowerCase() === patientFilterGender.toLowerCase()
    );
  }
  
  // Date range filter (last visit)
  if (patientDateRange.start) {
    const startDate = new Date(patientDateRange.start);
    startDate.setHours(0, 0, 0, 0);
    filtered = filtered.filter(patient => new Date(patient.lastVisit) >= startDate);
  }
  
  if (patientDateRange.end) {
    const endDate = new Date(patientDateRange.end);
    endDate.setHours(23, 59, 59, 999);
    filtered = filtered.filter(patient => new Date(patient.lastVisit) <= endDate);
  }
  
  setFilteredPatients(filtered);
};

// View patient details
const viewPatientDetails = (patient) => {
  setSelectedPatient(patient);
  setShowPatientDetails(true);
};



// QC STATES
const [showQCModal, setShowQCModal] = useState(false);
const [selectedQCPatient, setSelectedQCPatient] = useState(null);

const [qcForm, setQcForm] = useState({
  qcPerson: '',
  qcDate: '',
  qcTime: ''
});

// OPEN QC MODAL
const openQCModal = (patient) => {
  const now = new Date();
  const currentDate = now.toISOString().split("T")[0];
  const currentTime = now.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit"
  });

  setSelectedQCPatient(patient);
  
  // Get the latest invoice number
  const latestInvoice = patient.invoices && patient.invoices.length > 0 
    ? patient.invoices[patient.invoices.length - 1] 
    : null;

  setQcForm({
    qcPerson: '',
    qcDate: currentDate,
    qcTime: currentTime,
    invoiceNumber: latestInvoice?.invoiceNumber || ''  // Store invoice number
  });

  setShowQCModal(true);
};

// SAVE QC - FIXED VERSION
const saveQC = async () => {
  try {
    if (!qcForm.qcPerson || !qcForm.qcDate) {
      alert("Please fill all QC details");
      return;
    }

    // Get the patient ID correctly - check multiple possible field names
    let patientId = null;
    
    if (selectedQCPatient) {
      // Try different possible field names for patient ID
      patientId = selectedQCPatient.patientKey || 
                  selectedQCPatient.id || 
                  selectedQCPatient._id ||
                  selectedQCPatient.patientId ||
                  selectedQCPatient.userId;
      
      // If still no ID, try to generate from email or name
      if (!patientId && selectedQCPatient.email) {
        patientId = selectedQCPatient.email.replace(/[^a-zA-Z0-9]/g, '_');
      } else if (!patientId && selectedQCPatient.fullName) {
        patientId = selectedQCPatient.fullName.replace(/\s/g, '_').toLowerCase();
      }
    }

    // Validate we have a patient ID
    if (!patientId) {
      console.error("Patient data:", selectedQCPatient);
      alert("Error: Could not find patient ID. Please check patient data.");
      return;
    }

    const qcData = {
      patientId: patientId,
      patientName: selectedQCPatient.fullName || selectedQCPatient.name || 'Unknown',
      tpNo: selectedQCPatient.tpNo || selectedQCPatient.phone || selectedQCPatient.mobile || '',
      invoiceNumber: qcForm.invoiceNumber || '',
      qcPerson: qcForm.qcPerson,
      qcDate: qcForm.qcDate,
      qcTime: qcForm.qcTime,
      createdAt: new Date(),
      status: 'pending' // Add status for tracking
    };

    // Remove any undefined values
    Object.keys(qcData).forEach(key => {
      if (qcData[key] === undefined) {
        delete qcData[key];
      }
    });

    console.log("Saving QC Data:", qcData); // Debug log
    await addDoc(collection(db, "patient_qc"), qcData);
    alert("QC Saved Successfully");
    setShowQCModal(false);
    
    // Reset form
    setQcForm({
      qcPerson: '',
      qcDate: '',
      qcTime: ''
    });
    setSelectedQCPatient(null);
    
    // Refresh patient data
    if (typeof fetchAllPatients === 'function') {
      fetchAllPatients();
    }
  } catch (error) {
    console.error("QC Save Error:", error);
    alert("Error saving QC: " + error.message);
  }
};









// Generate patient report PDF
// Generate patient report PDF
const generatePatientReportPDF = async () => {
  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a4'
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const primaryColor = [15, 23, 42];

  let currentPage = 1;
  let rowCount = 0;
  let y = 0;

  // Function to draw complete header for any page
  const drawFullHeader = (isFirstPage) => {
    // Header background
    doc.setFillColor(...primaryColor);
    doc.rect(0, 0, pageWidth, 38, "F");
    
    // Logo
    try {
      doc.addImage("/ray-ban-logo.png", "PNG", 12, 5, 26, 26);
    } catch (err) {}
    
    // Company details
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(18);
    doc.text("Ray Ban Opticians", 45, 14);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text("Ray Ban Building, 142, Kandy Road, Dalugama, Kiribathgoda", 45, 21);
    doc.text("Hotline: 0767873232 Tel: 0112912333 / 0112914949 Fax: 0112913933", 45, 27);
    doc.text("Email: info@raybanopticians.com | Web: raybanopticians.com", 45, 33);
    
    // Title
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(20);
    
    if (isFirstPage) {
      doc.text("PATIENT DIRECTORY", pageWidth / 2, 52, { align: "center" });
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.text(`Generated: ${new Date().toLocaleString()}`, pageWidth / 2, 60, { align: "center" });
      
      // Summary
      // const totalPatients = filteredPatients.length;
      // const totalRevenue = filteredPatients.reduce((sum, p) => sum + (p.totalSpent || 0), 0);
      // const totalDue = filteredPatients.reduce((sum, p) => sum + (p.totalDue || 0), 0);
      
      // doc.setFontSize(10);
      // doc.setTextColor(0, 0, 0);
      // doc.text(`Total Patients: ${totalPatients}`, 10, 72);
      // doc.text(`Total Revenue: Rs. ${totalRevenue.toLocaleString()}`, 80, 72);
      // doc.text(`Total Due: Rs. ${totalDue.toLocaleString()}`, 160, 72);
      
      return 82; // Return Y position after summary
    } else {
      doc.text("PATIENT DIRECTORY (Continued)", pageWidth / 2, 52, { align: "center" });
      return 62; // Return Y position for continued pages
    }
  };

  // Function to draw table headers
  const drawTableHeaders = (y) => {
    doc.setFillColor(...primaryColor);
    doc.rect(10, y, 40, 8, 'F');
    doc.rect(52, y, 45, 8, 'F');
    doc.rect(99, y, 35, 8, 'F');
    doc.rect(136, y, 25, 8, 'F');
    doc.rect(163, y, 20, 8, 'F');
    doc.rect(185, y, 35, 8, 'F');
    doc.rect(222, y, 35, 8, 'F');
    doc.rect(259, y, 30, 8, 'F');

    doc.setTextColor(255, 255, 255);
    doc.setFontSize(8);
    doc.setFont("helvetica", "bold");

    doc.text("Invoice No.", 12, y + 5);
    doc.text("Patient Name", 54, y + 5);
    doc.text("Address", 101, y + 5);
    doc.text("Phone", 138, y + 5);
    doc.text("Age", 165, y + 5);
    doc.text("Total Spent", 187, y + 5);
    doc.text("Balance Due", 224, y + 5);
    doc.text("Last Visit", 261, y + 5);

    return y + 8;
  };

  // Draw first page
  let startY = drawFullHeader(true);
  y = drawTableHeaders(startY);
  
  // Loop through patients
  for (let patient of filteredPatients) {
    // Check if need new page
    if (y > 200) {
      doc.addPage();
      startY = drawFullHeader(false);
      y = drawTableHeaders(startY);
      rowCount = 0;
    }
    
    // Alternate row background
    if (rowCount % 2 === 0) {
      doc.setFillColor(245, 248, 250);
      doc.rect(10, y, 280, 7, 'F');
    }
    
    // Draw borders
    doc.setDrawColor(200, 200, 200);
    doc.rect(10, y, 40, 7);
    doc.rect(52, y, 45, 7);
    doc.rect(99, y, 35, 7);
    doc.rect(136, y, 25, 7);
    doc.rect(163, y, 20, 7);
    doc.rect(185, y, 35, 7);
    doc.rect(222, y, 35, 7);
    doc.rect(259, y, 30, 7);
    
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(7);
    
    doc.text((patient.invoiceNumber || '-').substring(0, 15), 12, y + 5);
    
    let name = patient.fullName || '-';
    doc.text(name.length > 20 ? name.substring(0, 18) + '..' : name, 54, y + 5);
    
    let address = patient.address || '-';
    doc.text(address.length > 18 ? address.substring(0, 16) + '..' : address, 101, y + 5);
    
    doc.text(patient.tpNo || '-', 138, y + 5);
    doc.text(patient.age ? patient.age.toString() : '-', 165, y + 5);
    doc.text(`Rs. ${(patient.totalSpent || 0).toLocaleString()}`, 218, y + 5, { align: 'right' });
    
    if ((patient.totalDue || 0) > 0) {
      doc.setTextColor(220, 38, 38);
      doc.setFont("helvetica", "bold");
    }
    doc.text(`Rs. ${(patient.totalDue || 0).toLocaleString()}`, 255, y + 5, { align: 'right' });
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");
    
    let lastVisit = patient.lastVisit ? new Date(patient.lastVisit).toLocaleDateString() : '-';
    doc.text(lastVisit, 261, y + 5);
    
    y += 7;
    rowCount++;
  }

  // Add page numbers

const pageCount = doc.internal.getNumberOfPages();
for (let i = 1; i <= pageCount; i++) {
  doc.setPage(i);
  doc.setFontSize(8);
  doc.setTextColor(128, 128, 128);
  doc.text(`Page ${i} of ${pageCount}`, pageWidth / 2, pageHeight - 3, { align: "center" });
}

  doc.save(`PATIENT_REPORT_${Date.now()}.pdf`);
};




// Reset filters
const resetPatientFilters = () => {
  setPatientSearchTerm('');
  setPatientFilterAge('all');
  setPatientFilterGender('all');
  setPatientDateRange({ start: '', end: '' });
  setFilteredPatients(patients);
};

// Fetch patients when component mounts
useEffect(() => {
  if (selectedOption === "viewPatient") {
    fetchAllPatients();
  }
}, [selectedOption]);

// Apply filters when filter criteria change
useEffect(() => {
  filterPatients();
}, [patientSearchTerm, patientFilterAge, patientFilterGender, patientDateRange.start, patientDateRange.end, patients]);

// Get age group label
const getAgeGroup = (age) => {
  const ageNum = parseInt(age);
  if (ageNum < 18) return 'Child';
  if (ageNum >= 18 && ageNum < 60) return 'Adult';
  if (ageNum >= 60) return 'Senior';
  return 'Unknown';
};










//////////////////////////////////////////////   dashboard panel    /////////////////////////////////////////////////////////////////////////



// OPTIMIZED STATE with caching
const [dashboardStats, setDashboardStats] = useState({
  totalRevenue: 0,
  totalReceived: 0,
  totalInvoices: 0,
  totalPatients: 0,
  pendingBalance: 0,
  monthlyRevenue: Array(12).fill(0),
  topProducts: [],
  recentInvoices: [],
  paymentMethods: [],
  dailySales: [],
  framesSold: 0,
  lensesSold: 0,
  averageInvoiceValue: 0
});
const [isLoadingDashboard, setIsLoadingDashboard] = useState(false);
const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
const [dashboardCache, setDashboardCache] = useState({});

// OPTIMIZED: Fetch only current month's data with date range filter

const fetchDashboardData = async () => {
  try {
    setIsLoadingDashboard(true);
    
    // Get ALL invoices first (no date filter in query)
    const invoicesSnapshot = await getDocs(collection(db, 'invoices'));
    
    console.log(`Total invoices in DB: ${invoicesSnapshot.size}`);
    
    if (invoicesSnapshot.empty) {
      console.log("No invoices found");
      setIsLoadingDashboard(false);
      return;
    }
    
    const invoices = [];
    const invoiceNumbers = [];
    
    for (const doc of invoicesSnapshot.docs) {
      const data = doc.data();
      
      // Get the date from the invoice
      let createdDate = null;
      if (data.createdAt?.toDate) {
        createdDate = data.createdAt.toDate();
      } else if (data.createdAt) {
        createdDate = new Date(data.createdAt);
      } else if (data.date) {
        createdDate = new Date(data.date);
      }
      
      if (!createdDate || isNaN(createdDate.getTime())) {
        console.log(`Skipping invoice ${data.invoiceNumber} - invalid date`);
        continue;
      }
      
      const year = createdDate.getFullYear();
      const month = createdDate.getMonth() + 1;
      
      // Filter by selected month/year in JavaScript
      if (year === selectedYear && month === selectedMonth) {
        console.log(`✅ Including invoice ${data.invoiceNumber} (${createdDate.toLocaleDateString()})`);
        invoiceNumbers.push(data.invoiceNumber);
        invoices.push({
          ...data,
          id: doc.id,
          createdAt: createdDate,
          year,
          month,
          day: createdDate.getDate()
        });
      }
    }
    
    console.log(`Found ${invoices.length} invoices for ${selectedMonth}/${selectedYear}`);
    
    if (invoices.length === 0) {
      setDashboardStats({
        totalRevenue: 0,
        totalReceived: 0,
        totalInvoices: 0,
        totalPatients: 0,
        pendingBalance: 0,
        monthlyRevenue: Array(12).fill(0),
        topProducts: [],
        recentInvoices: [],
        paymentMethods: [],
        dailySales: Array(new Date(selectedYear, selectedMonth, 0).getDate()).fill(0),
        framesSold: 0,
        lensesSold: 0,
        averageInvoiceValue: 0
      });
      setIsLoadingDashboard(false);
      return;
    }
    
    // Fetch balance invoices for these invoice numbers
    let balancePaymentsMap = new Map();
    
    if (invoiceNumbers.length > 0) {
      for (let i = 0; i < invoiceNumbers.length; i += 30) {
        const batch = invoiceNumbers.slice(i, i + 30);
        const balanceQuery = query(
          collection(db, 'balance_invoices'),
          where('originalInvoiceNumber', 'in', batch)
        );
        const balanceSnapshot = await getDocs(balanceQuery);
        
        balanceSnapshot.forEach((balanceDoc) => {
          const balanceData = balanceDoc.data();
          const invNum = balanceData.originalInvoiceNumber;
          const paidAmount = balanceData.paidAmount || 0;
          balancePaymentsMap.set(invNum, (balancePaymentsMap.get(invNum) || 0) + paidAmount);
        });
      }
    }
    
    // Calculate all metrics
    let totalRevenue = 0;
    let totalReceived = 0;
    let pendingBalance = 0;
    let framesSold = 0;
    let lensesSold = 0;
    const uniquePatients = new Map();
    const productSales = new Map();
    const paymentMethods = new Map();
    const daysInMonth = new Date(selectedYear, selectedMonth, 0).getDate();
    const dailySales = Array(daysInMonth).fill(0);
    const monthlyRevenue = Array(12).fill(0);
    
    for (const inv of invoices) {
      const totalPaid = (inv.financial?.advancePayment || 0);
      const totalAmount = inv.financial?.totalAmount || 0;
      
      totalRevenue += totalAmount;
      totalReceived += totalPaid;
      pendingBalance += (totalAmount - totalPaid);
      
      if (inv.products?.frameModel) {
        framesSold++;
        productSales.set(inv.products.frameModel, (productSales.get(inv.products.frameModel) || 0) + 1);
      }
      if (inv.products?.lensModel) {
        lensesSold++;
        productSales.set(inv.products.lensModel, (productSales.get(inv.products.lensModel) || 0) + 1);
      }
      
      const patientKey = `${inv.customer?.fullName || inv.customer?.firstName || ''}_${inv.customer?.tpNo || ''}`;
      if (patientKey !== '_') uniquePatients.set(patientKey, inv.customer);
      
      const method = inv.financial?.paymentMethod || 'Cash';
      paymentMethods.set(method, (paymentMethods.get(method) || 0) + totalPaid);
      
      const dayIndex = inv.day - 1;
      if (dayIndex >= 0 && dayIndex < dailySales.length) {
        dailySales[dayIndex] += totalPaid;
      }
      
      if (inv.year === selectedYear) {
        monthlyRevenue[inv.month - 1] += totalPaid;
      }
    }
    
    const dashboardData = {
      totalRevenue,
      totalReceived,
      totalInvoices: invoices.length,
      totalPatients: uniquePatients.size,
      pendingBalance,
      monthlyRevenue,
      topProducts: Array.from(productSales.entries()).map(([name, count]) => ({ name, count })).sort((a, b) => b.count - a.count).slice(0, 5),
      recentInvoices: invoices.slice(0, 5).map(inv => ({
        invoiceNumber: inv.invoiceNumber,
        customerName: inv.customer?.fullName || inv.customer?.firstName || '-',
        totalAmount: inv.financial?.totalAmount || 0,
        paidAmount: (inv.financial?.advancePayment || 0) + (balancePaymentsMap.get(inv.invoiceNumber) || 0),
        balanceDue: (inv.financial?.totalAmount || 0) - ((inv.financial?.advancePayment || 0) + (balancePaymentsMap.get(inv.invoiceNumber) || 0)),
        date: inv.createdAt
      })),
      paymentMethods: Array.from(paymentMethods.entries()).map(([name, value]) => ({ name, value })),
      dailySales,
      framesSold,
      lensesSold,
      averageInvoiceValue: invoices.length > 0 ? totalRevenue / invoices.length : 0
    };
    
    console.log("Dashboard Data Summary:", {
      totalRevenue,
      totalInvoices: invoices.length,
      framesSold,
      lensesSold
    });
    
    setDashboardStats(dashboardData);
    setIsLoadingDashboard(false);
    
  } catch (error) {
    console.error('Error fetching dashboard data:', error);
    setIsLoadingDashboard(false);
    alert('Error loading dashboard: ' + error.message);
  }
};

const debugAllInvoiceDates = async () => {
  try {
    console.log("=== CHECKING ALL INVOICE DATES IN DATABASE ===");
    const invoicesSnapshot = await getDocs(collection(db, 'invoices'));
    
    if (invoicesSnapshot.empty) {
      console.log("No invoices found at all!");
      return;
    }
    
    console.log(`Total invoices in database: ${invoicesSnapshot.size}`);
    
    const yearMonthMap = new Map();
    
    invoicesSnapshot.docs.forEach((doc) => {
      const data = doc.data();
      let createdDate = null;
      
      // Try different date formats
      if (data.createdAt?.toDate) {
        createdDate = data.createdAt.toDate();
      } else if (data.createdAt) {
        createdDate = new Date(data.createdAt);
      } else if (data.date) {
        createdDate = new Date(data.date);
      } else if (data.invoiceDate) {
        createdDate = new Date(data.invoiceDate);
      }
      
      if (createdDate && !isNaN(createdDate.getTime())) {
        const year = createdDate.getFullYear();
        const month = createdDate.getMonth() + 1;
        const key = `${year}-${month}`;
        yearMonthMap.set(key, (yearMonthMap.get(key) || 0) + 1);
        
        console.log(`Invoice ${data.invoiceNumber}: ${createdDate.toLocaleDateString()} (Year: ${year}, Month: ${month})`);
      } else {
        console.log(`Invoice ${data.invoiceNumber}: NO VALID DATE found. Raw createdAt:`, data.createdAt);
      }
    });
    
    console.log("\n=== SUMMARY BY YEAR/MONTH ===");
    const sortedKeys = Array.from(yearMonthMap.keys()).sort();
    sortedKeys.forEach(key => {
      console.log(`${key}: ${yearMonthMap.get(key)} invoices`);
    });
    
    // Also check if there are any invoices with the current year
    const currentYear = new Date().getFullYear();
    const currentYearInvoices = invoicesSnapshot.docs.filter(doc => {
      const data = doc.data();
      let date = data.createdAt?.toDate ? data.createdAt.toDate() : new Date(data.createdAt);
      return date.getFullYear() === currentYear;
    });
    console.log(`\nInvoices from ${currentYear}: ${currentYearInvoices.length}`);
    
  } catch (error) {
    console.error("Debug error:", error);
  }
};

// Call this in useEffect
useEffect(() => {
  if (selectedOption === "dashboard") {
    debugAllInvoiceDates(); // This will show you what dates you actually have
  }
}, [selectedOption]);



// OPTIMIZED: Fetch products with pagination and limit
const [productSearch, setProductSearch] = useState("");
const [allProducts, setAllProducts] = useState([]);
const [filteredProducts, setFilteredProducts] = useState([]);
const [isLoadingProducts, setIsLoadingProducts] = useState(false);

// OPTIMIZED: Fetch only necessary products with limit
useEffect(() => {
  const fetchProducts = async () => {
    if (selectedOption !== "dashboard") return;

    setIsLoadingProducts(true);

    try {
      const snap = await getDocs(collection(db, "stock"));

      const data = [];

      snap.forEach((doc) => {
        const d = doc.data();

        if (d.items && Array.isArray(d.items)) {
          d.items.forEach((item) => {
            data.push({
              id: doc.id,
              category: d.category,
              supplierName: d.supplierName,
              purchaseDate: d.purchaseDate,
              purchaseOrderNo: d.purchaseOrderNo,
              modelNo: item.modelNo,
              brand: item.brand,
              itemCode: item.itemCode,
              colour: item.colour,
              sex: item.sex,
              qty: item.qty || 0,
              supplyQty: item.supplyQty || 0,
              sellingPrice: item.sellingPrice || 0,
            });
          });
        }
      });

      setAllProducts(data);
      setFilteredProducts(data);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoadingProducts(false);
    }
  };

  fetchProducts();
}, [selectedOption]);

// Debounced product search
useEffect(() => {
  const timeoutId = setTimeout(() => {
    const term = productSearch.toLowerCase();
    const filtered = allProducts.filter(p =>
      p.modelNo?.toLowerCase().includes(term) ||
      p.brand?.toLowerCase().includes(term) ||
      p.itemCode?.toLowerCase().includes(term) ||
      p.colour?.toLowerCase().includes(term)
    );
    setFilteredProducts(filtered);
  }, 300);
  
  return () => clearTimeout(timeoutId);
}, [productSearch, allProducts]);

// Chart configurations (move these inside component)
const revenueChartData = {
  labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  datasets: [{
    label: 'Monthly Revenue (Rs.)',
    data: dashboardStats.monthlyRevenue,
    backgroundColor: 'rgba(41, 128, 185, 0.8)',
    borderColor: 'rgba(41, 128, 185, 1)',
    borderWidth: 2,
    borderRadius: 5,
  }],
};

const revenueChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: 'top' },
    title: { display: true, text: `Monthly Revenue - ${selectedYear}` }
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: { callback: (value) => `Rs. ${value.toLocaleString()}` }
    }
  }
};

const paymentMethodChartData = {
  labels: dashboardStats.paymentMethods.map(m => m.name),
  datasets: [{
    data: dashboardStats.paymentMethods.map(m => m.value),
    backgroundColor: ['#4CAF50', '#2196F3', '#FF9800', '#9C27B0', '#F44336'],
    borderWidth: 0,
  }],
};

const paymentMethodOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: 'bottom' },
    title: { display: true, text: 'Payment Methods Distribution' }
  }
};

const dailySalesChartData = {
  labels: Array.from({ length: dashboardStats.dailySales.length }, (_, i) => i + 1),
  datasets: [{
    label: `Daily Sales - ${selectedMonth}/${selectedYear}`,
    data: dashboardStats.dailySales,
    backgroundColor: 'rgba(76, 175, 80, 0.6)',
    borderColor: 'rgba(76, 175, 80, 1)',
    borderWidth: 1,
    fill: true,
  }],
};

const dailySalesOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: 'top' },
    title: { display: true, text: `Daily Sales Performance` }
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: { callback: (value) => `Rs. ${value.toLocaleString()}` }
    }
  }
};

// Fetch data on component mount and when year/month changes
useEffect(() => {
  if (selectedOption === "dashboard") {
    fetchDashboardData();
  }
}, [selectedOption, selectedYear, selectedMonth]);

// Format currency
const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'LKR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};









///////////////////////////////////////////////////////// view consultation ////////////////////////////////////////////////////////////////////

// Add state for consultations
const [consultations, setConsultations] = useState([]);
const [filteredConsultations, setFilteredConsultations] = useState([]);
const [consultationSearchTerm, setConsultationSearchTerm] = useState('');
const [consultationFilterStatus, setConsultationFilterStatus] = useState('all');
const [consultationDateRange, setConsultationDateRange] = useState({ start: '', end: '' });
const [isLoadingConsultations, setIsLoadingConsultations] = useState(false);
const [selectedConsultation, setSelectedConsultation] = useState(null);
const [showConsultationDetails, setShowConsultationDetails] = useState(false);
const [showUpdateStatusModal, setShowUpdateStatusModal] = useState(false);
const [selectedItemForStatus, setSelectedItemForStatus] = useState(null);
const [newStatus, setNewStatus] = useState('');

// Fetch all consultations
const fetchAllConsultations = async () => {
  try {
    setIsLoadingConsultations(true);
    const consultationsQuery = query(
      collection(db, 'consultations'),
      orderBy('createdAt', 'desc')
    );
    const consultationsSnapshot = await getDocs(consultationsQuery);
    const consultationsList = [];
    
    for (const doc of consultationsSnapshot.docs) {
      const data = doc.data();
      const items = data.items || [];
      
      // Calculate totals
      const totalAmount = items.reduce((sum, item) => sum + (item.price || 0), 0);
      const completedItems = items.filter(item => item.status === 'completed').length;
      const pendingItems = items.filter(item => item.status === 'pending').length;
      const cancelledItems = items.filter(item => item.status === 'cancelled').length;
      
      consultationsList.push({
        id: doc.id,
        ...data,
        items: items,
        totalAmount: totalAmount,
        completedItems: completedItems,
        pendingItems: pendingItems,
        cancelledItems: cancelledItems,
        formattedDate: data.createdAt ? new Date(data.createdAt.toDate()).toLocaleDateString() : '-',
        formattedTime: data.createdAt ? new Date(data.createdAt.toDate()).toLocaleTimeString() : '-',
        fullDate: data.createdAt ? new Date(data.createdAt.toDate()) : new Date()
      });
    }
    
    setConsultations(consultationsList);
    setFilteredConsultations(consultationsList);
    setIsLoadingConsultations(false);
  } catch (error) {
    console.error('Error fetching consultations:', error);
    setIsLoadingConsultations(false);
    alert('Error fetching consultations: ' + error.message);
  }
};

// Filter consultations
const filterConsultations = () => {
  let filtered = [...consultations];
  
  // Search filter
  if (consultationSearchTerm) {
    const searchLower = consultationSearchTerm.toLowerCase();
    filtered = filtered.filter(consultation => 
      consultation.customerName?.toLowerCase().includes(searchLower) ||
      consultation.id?.toLowerCase().includes(searchLower)
    );
  }
  
  // Status filter
  if (consultationFilterStatus !== 'all') {
    filtered = filtered.filter(consultation => {
      if (consultationFilterStatus === 'completed') {
        return consultation.pendingItems === 0 && consultation.cancelledItems === 0;
      } else if (consultationFilterStatus === 'pending') {
        return consultation.pendingItems > 0;
      } else if (consultationFilterStatus === 'cancelled') {
        return consultation.cancelledItems > 0;
      }
      return true;
    });
  }
  
  // Date range filter
  if (consultationDateRange.start) {
    const startDate = new Date(consultationDateRange.start);
    startDate.setHours(0, 0, 0, 0);
    filtered = filtered.filter(consultation => consultation.fullDate >= startDate);
  }
  
  if (consultationDateRange.end) {
    const endDate = new Date(consultationDateRange.end);
    endDate.setHours(23, 59, 59, 999);
    filtered = filtered.filter(consultation => consultation.fullDate <= endDate);
  }
  
  setFilteredConsultations(filtered);
};

// Update consultation item status
const updateConsultationItemStatus = async (consultationId, itemId, status) => {
  try {
    const consultationRef = doc(db, 'consultations', consultationId);
    const consultationDoc = await getDoc(consultationRef);
    
    if (consultationDoc.exists()) {
      const data = consultationDoc.data();
      const updatedItems = data.items.map(item => 
        item.id === itemId ? { ...item, status: status } : item
      );
      
      await updateDoc(consultationRef, { items: updatedItems });
      alert(`Item status updated to ${status}`);
      await fetchAllConsultations(); // Refresh the list
      setShowUpdateStatusModal(false);
      setSelectedItemForStatus(null);
    }
  } catch (error) {
    console.error('Error updating item status:', error);
    alert('Error updating item status: ' + error.message);
  }
};

// Delete consultation
const deleteConsultation = async (consultationId, customerName) => {
  if (window.confirm(`Are you sure you want to delete consultation for ${customerName}?\n\nThis action cannot be undone!`)) {
    try {
      await deleteDoc(doc(db, 'consultations', consultationId));
      alert('Consultation deleted successfully!');
      await fetchAllConsultations();
    } catch (error) {
      console.error('Error deleting consultation:', error);
      alert('Error deleting consultation: ' + error.message);
    }
  }
};

// Generate consultation report PDF
const generateConsultationReportPDF = async () => {
  const pdf = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a4'
  });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const primaryColor = [41, 128, 185];

  // Header
  pdf.setFillColor(...primaryColor);
  pdf.rect(0, 0, pageWidth, 25, "F");

  pdf.setFontSize(18);
  pdf.setTextColor(255, 255, 255);
  pdf.text("CONSULTATIONS REPORT", pageWidth / 2, 10, { align: "center" });

  pdf.setFontSize(10);
  pdf.text(`Generated: ${new Date().toLocaleString()}`, pageWidth / 2, 18, { align: "center" });

  let y = 35;

  // Summary stats
  const totalConsultations = filteredConsultations.length;
  const totalRevenue = filteredConsultations.reduce((sum, c) => sum + c.totalAmount, 0);
  const completedCount = filteredConsultations.filter(c => c.pendingItems === 0 && c.cancelledItems === 0).length;
  const pendingCount = filteredConsultations.filter(c => c.pendingItems > 0).length;

  pdf.setFontSize(12);
  pdf.setTextColor(...primaryColor);
  pdf.text("SUMMARY", 10, y);

  y += 7;
  pdf.setFontSize(10);
  pdf.setTextColor(0, 0, 0);
  pdf.text(`Total Consultations: ${totalConsultations}`, 10, y);
  pdf.text(`Total Revenue: Rs. ${totalRevenue.toFixed(2)}`, 80, y);
  pdf.text(`Completed: ${completedCount}`, 150, y);
  pdf.text(`Pending: ${pendingCount}`, 200, y);

  y += 15;

  // Table headers
  pdf.setFillColor(...primaryColor);
  pdf.rect(10, y, 30, 8, 'F');
  pdf.rect(40, y, 40, 8, 'F');
  pdf.rect(80, y, 30, 8, 'F');
  pdf.rect(110, y, 25, 8, 'F');
  pdf.rect(135, y, 25, 8, 'F');
  pdf.rect(160, y, 25, 8, 'F');
  pdf.rect(185, y, 30, 8, 'F');

  pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(9);
  pdf.text("Date", 12, y + 5);
  pdf.text("Customer", 42, y + 5);
  pdf.text("Delivery Date", 82, y + 5);
  pdf.text("Items", 112, y + 5);
  pdf.text("Total", 137, y + 5);
  pdf.text("Completed", 162, y + 5);
  pdf.text("Status", 187, y + 5);

  y += 8;

  // Table rows
  pdf.setTextColor(0, 0, 0);
  for (let consultation of filteredConsultations.slice(0, 20)) {
    if (y > 250) {
      pdf.addPage();
      y = 20;
    }
    
    pdf.rect(10, y, 30, 7);
    pdf.rect(40, y, 40, 7);
    pdf.rect(80, y, 30, 7);
    pdf.rect(110, y, 25, 7);
    pdf.rect(135, y, 25, 7);
    pdf.rect(160, y, 25, 7);
    pdf.rect(185, y, 30, 7);
    
    pdf.text(consultation.formattedDate, 12, y + 5);
    pdf.text(consultation.customerName.substring(0, 20), 42, y + 5);
    pdf.text(consultation.deliveryDate || '-', 82, y + 5);
    pdf.text(consultation.items.length.toString(), 112, y + 5);
    pdf.text(`Rs. ${consultation.totalAmount.toFixed(2)}`, 137, y + 5);
    pdf.text(consultation.completedItems.toString(), 162, y + 5);
    
    const status = consultation.pendingItems === 0 && consultation.cancelledItems === 0 ? 'Completed' : 
                   consultation.cancelledItems > 0 ? 'Cancelled' : 'Pending';
    pdf.text(status, 187, y + 5);
    
    y += 7;
  }

  pdf.save(`CONSULTATIONS_REPORT_${Date.now()}.pdf`);
};

// Reset filters
const resetConsultationFilters = () => {
  setConsultationSearchTerm('');
  setConsultationFilterStatus('all');
  setConsultationDateRange({ start: '', end: '' });
  setFilteredConsultations(consultations);
};

// Fetch consultations when component mounts
useEffect(() => {
  if (selectedOption === "viewConsultation") {
    fetchAllConsultations();
  }
}, [selectedOption]);

// Apply filters when filter criteria change
useEffect(() => {
  filterConsultations();
}, [consultationSearchTerm, consultationFilterStatus, consultationDateRange.start, consultationDateRange.end, consultations]);

// Get status badge color
const getStatusBadge = (consultation) => {
  if (consultation.pendingItems === 0 && consultation.cancelledItems === 0) {
    return { text: 'Completed', color: '#4CAF50' };
  } else if (consultation.cancelledItems > 0) {
    return { text: 'Partially Cancelled', color: '#f44336' };
  } else {
    return { text: 'Pending', color: '#ff9800' };
  }
};



/////////////////////////////////////////// customer card - optica membership /////////////////////////////////////////////////////////

const [membershipData, setMembershipData] = useState({
  customerName: '',
  telephone: '',
  issueDate: '',
  expireDate: '',
  discount: 15, // 15% discount
  status: 'active',
  cardNumber: ''
});

const [membershipErrors, setMembershipErrors] = useState({});
const [isSavingCard, setIsSavingCard] = useState(false);
const [cardSuccess, setCardSuccess] = useState(false);

// Function to generate unique card number
const generateCardNumber = () => {
  const prefix = 'OPT';
  const timestamp = Date.now().toString().slice(-8);
  const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
  return `${prefix}-${timestamp}-${random}`;
};
// Handle membership form input changes
const handleMembershipInputChange = (e) => {
  const { name, value } = e.target;
  
  setMembershipData(prev => ({
    ...prev,
    [name]: value
  }));
  
  // Auto-calculate expire date when issue date is selected
  if (name === 'issueDate' && value) {
    const issueDateObj = new Date(value);
    const expireDateObj = new Date(issueDateObj);
    expireDateObj.setFullYear(expireDateObj.getFullYear() + 1);
    
    const expireDateStr = expireDateObj.toISOString().split('T')[0];
    
    setMembershipData(prev => ({
      ...prev,
      issueDate: value,
      expireDate: expireDateStr
    }));
  }
  
  // Clear error when user starts typing
  if (membershipErrors[name]) {
    setMembershipErrors(prev => ({
      ...prev,
      [name]: ''
    }));
  }
};

// Validate membership form
const validateMembershipForm = () => {
  const errors = {};
  
  if (!membershipData.customerName.trim()) {
    errors.customerName = 'Customer name is required';
  }
  
  if (!membershipData.telephone.trim()) {
    errors.telephone = 'Telephone number is required';
  } else if (!/^[0-9+\-\s]{10,15}$/.test(membershipData.telephone)) {
    errors.telephone = 'Valid phone number is required';
  }
  
  if (!membershipData.issueDate) {
    errors.issueDate = 'Issue date is required';
  }
  
  if (!membershipData.expireDate) {
    errors.expireDate = 'Expire date is required';
  } else {
    const expireDateObj = new Date(membershipData.expireDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    if (expireDateObj < today) {
      errors.expireDate = 'Expire date cannot be in the past';
    }
  }
  
  return errors;
};

// Reset membership form
const handleResetMembershipForm = () => {
  setMembershipData({
    customerName: '',
    telephone: '',
    issueDate: '',
    expireDate: '',
    discount: 15,
    status: 'active',
    cardNumber: ''
  });
  setMembershipErrors({});
};

// Save membership card to Firestore
const handleSaveMembershipCard = async () => {
  // Validate form
  const errors = validateMembershipForm();
  if (Object.keys(errors).length > 0) {
    setMembershipErrors(errors);
    return;
  }
  
  setIsSavingCard(true);
  
  try {
    // Check if customer already has an active card
    const cardsRef = collection(db, 'customer-cards');
    const q = query(
      cardsRef,
      where('telephone', '==', membershipData.telephone),
      where('status', '==', 'active')
    );
    const existingCards = await getDocs(q);
    
    if (!existingCards.empty) {
      const confirmReplace = window.confirm(
        'This customer already has an active membership card. Do you want to deactivate the old card and create a new one?'
      );
      
      if (confirmReplace) {
        // Deactivate old cards
        const updatePromises = [];
        existingCards.forEach(doc => {
          updatePromises.push(updateDoc(doc.ref, { status: 'inactive' }));
        });
        await Promise.all(updatePromises);
      } else {
        setIsSavingCard(false);
        return;
      }
    }
    
    // Generate unique card number
    const cardNumber = generateCardNumber();
    
    // Prepare card data
    const cardData = {
      cardNumber: cardNumber,
      customerName: membershipData.customerName.trim(),
      telephone: membershipData.telephone.trim(),
      issueDate: membershipData.issueDate,
      expireDate: membershipData.expireDate,
      discount: 15, // 15% discount
      status: 'active',
      createdAt: new Date(),
      updatedAt: new Date(),
      isActive: true
    };
    
    // Save to Firestore
    await addDoc(collection(db, 'customer-cards'), cardData);
    
    // Show success message
    setCardSuccess(true);
    setTimeout(() => setCardSuccess(false), 3000);
    
    // Reset form
    handleResetMembershipForm();
    
    // Show alert with card number
    alert(`✅ Membership card created successfully!\n\nCard Number: ${cardNumber}\nCustomer: ${cardData.customerName}\nValid until: ${cardData.expireDate}\nDiscount: 15%`);
    
  } catch (error) {
    console.error('Error saving membership card:', error);
    alert('❌ Error saving membership card: ' + error.message);
  } finally {
    setIsSavingCard(false);
  }
};

// CSS Styles
const membershipCardStyles = `
  .membership-card-container {
    max-width: 600px;
    margin: 0 auto;
    padding: 20px;
    background: #f5f5f5;
    border-radius: 10px;
  }
  
  .membership-card-container h1 {
    text-align: center;
    color: #2c3e50;
    margin-bottom: 30px;
  }
  
  .info-text {
    background: #e8f4f8;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 20px;
    font-size: 14px;
    color: #2980b9;
  }
  
  .membership-form {
    background: white;
    padding: 20px;
    border-radius: 8px;
  }
  
  .membership-form-group {
    margin-bottom: 20px;
  }
  
  .membership-form-group label {
    display: block;
    margin-bottom: 8px;
    font-weight: bold;
    color: #333;
  }
  
  .membership-form-group input {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 14px;
  }
  
  .membership-form-group input:focus {
    outline: none;
    border-color: #27ae60;
  }
  
  .membership-form-group input.error-input {
    border-color: #e74c3c;
  }
  
  .membership-error-message {
    color: #e74c3c;
    font-size: 12px;
    margin-top: 5px;
    display: block;
  }
  
  .membership-card-actions {
    display: flex;
    gap: 10px;
    margin-top: 20px;
  }
  
  .btn-save-card {
    background: #27ae60;
    color: white;
    padding: 12px 24px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    flex: 1;
  }
  
  .btn-save-card:hover:not(:disabled) {
    background: #229954;
  }
  
  .btn-save-card:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  
  .btn-reset-card {
    background: #95a5a6;
    color: white;
    padding: 12px 24px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    flex: 1;
  }
  
  .btn-reset-card:hover {
    background: #7f8c8d;
  }
  
  .card-success-toast {
    position: fixed;
    top: 20px;
    right: 20px;
    background: #27ae60;
    color: white;
    padding: 15px 20px;
    border-radius: 5px;
    z-index: 1000;
    animation: slideIn 0.3s ease;
  }
  
  @keyframes slideIn {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }
`;




////////////////////////// view customer card ////////////////////////////////////////////////////////
// Add these state declarations with your other states
const [allMembershipCards, setAllMembershipCards] = useState([]);
const [filteredCards, setFilteredCards] = useState([]);
const [isLoadingCards, setIsLoadingCards] = useState(false);
const [searchFilters, setSearchFilters] = useState({
  customerName: '',
  telephone: '',
  issueYear: ''
});
const [selectedCard, setSelectedCard] = useState(null);
const [showCardDetails, setShowCardDetails] = useState(false);

// Fetch all membership cards from Firestore
const fetchMembershipCards = async () => {
  setIsLoadingCards(true);
  try {
    const cardsRef = collection(db, 'customer-cards');
    const q = query(cardsRef, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    
    const cards = [];
    querySnapshot.forEach(doc => {
      cards.push({
        id: doc.id,
        ...doc.data()
      });
    });
    
    setAllMembershipCards(cards);
    setFilteredCards(cards);
  } catch (error) {
    console.error('Error fetching membership cards:', error);
    alert('Error loading membership cards: ' + error.message);
  } finally {
    setIsLoadingCards(false);
  }
};

// Load cards when component mounts
useEffect(() => {
  if (selectedOption === "viewMembershipCard") {
    fetchMembershipCards();
  }
}, [selectedOption]);

// Handle search filter changes
const handleSearchFilterChange = (e) => {
  const { name, value } = e.target;
  setSearchFilters(prev => ({
    ...prev,
    [name]: value
  }));
};

// Apply filters to cards
const applyFilters = () => {
  let filtered = [...allMembershipCards];
  
  // Filter by customer name
  if (searchFilters.customerName) {
    filtered = filtered.filter(card => 
      card.customerName.toLowerCase().includes(searchFilters.customerName.toLowerCase())
    );
  }
  
  // Filter by telephone
  if (searchFilters.telephone) {
    filtered = filtered.filter(card => 
      card.telephone.includes(searchFilters.telephone)
    );
  }
  
  // Filter by issue year
  if (searchFilters.issueYear) {
    filtered = filtered.filter(card => {
      const issueYear = card.issueDate ? new Date(card.issueDate).getFullYear().toString() : '';
      return issueYear === searchFilters.issueYear;
    });
  }
  
  setFilteredCards(filtered);
};

// Reset filters
const resetFilters = () => {
  setSearchFilters({
    customerName: '',
    telephone: '',
    issueYear: ''
  });
  setFilteredCards(allMembershipCards);
  setSelectedSalesPerson("all");
  setSelectedEyeCamp("all");
};

// Get unique years from cards for year filter dropdown
const getAvailableYears = () => {
  const years = new Set();
  allMembershipCards.forEach(card => {
    if (card.issueDate) {
      const year = new Date(card.issueDate).getFullYear();
      years.add(year);
    }
  });
  return Array.from(years).sort().reverse();
};

// Format date for display
const formatDate = (dateString) => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString();
};

// Check if card is expired
const isCardExpired = (expireDate) => {
  if (!expireDate) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const expire = new Date(expireDate);
  return expire < today;
};

// Get days until expiry
const getDaysUntilExpiry = (expireDate) => {
  if (!expireDate) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const expire = new Date(expireDate);
  const diffTime = expire - today;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

// View card details
const viewCardDetails = (card) => {
  setSelectedCard(card);
  setShowCardDetails(true);
};

// Close card details modal
const closeCardDetails = () => {
  setShowCardDetails(false);
  setSelectedCard(null);
};

// Deactivate card
const deactivateCard = async (cardId, cardNumber) => {
  const confirm = window.confirm(`Are you sure you want to deactivate card ${cardNumber}?`);
  if (!confirm) return;
  
  try {
    const cardRef = doc(db, 'customer-cards', cardId);
    await updateDoc(cardRef, {
      status: 'inactive',
      isActive: false,
      updatedAt: new Date()
    });
    
    alert('Card deactivated successfully!');
    fetchMembershipCards(); // Refresh the list
  } catch (error) {
    console.error('Error deactivating card:', error);
    alert('Error deactivating card: ' + error.message);
  }
};


const reactivateCard = async (cardId, cardNumber) => {
  const confirm = window.confirm(`Reactivate card ${cardNumber} and extend expiry?`);
  if (!confirm) return;

  try {
    const cardRef = doc(db, 'customer-cards', cardId);

    // 🔑 Set NEW expiry date (1 year from today)
    const newExpireDate = new Date();
    newExpireDate.setFullYear(newExpireDate.getFullYear() + 1);

    await updateDoc(cardRef, {
      status: 'active',
      isActive: true,
      expireDate: newExpireDate.toISOString(), // ✅ update expiry
      updatedAt: new Date()
    });

    alert('Card reactivated and renewed successfully!');
    fetchMembershipCards();
  } catch (error) {
    console.error('Error reactivating card:', error);
    alert('Error reactivating card: ' + error.message);
  }
};







// Delete card permanently
const deleteCard = async (cardId, cardNumber) => {
  const confirm = window.confirm(`⚠️ WARNING: This will permanently delete card ${cardNumber}. This action cannot be undone. Are you sure?`);
  if (!confirm) return;
  
  try {
    const cardRef = doc(db, 'customer-cards', cardId);
    await deleteDoc(cardRef);
    
    alert('Card deleted permanently!');
    fetchMembershipCards(); // Refresh the list
  } catch (error) {
    console.error('Error deleting card:', error);
    alert('Error deleting card: ' + error.message);
  }
}; 

const viewMembershipCardStyles = `
  .view-membership-card-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  }
  
  .view-membership-card-container h1 {
    color: #2c3e50;
    margin-bottom: 10px;
  }
  
  .filters-section {
    background: white;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  .filters-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    color: #333;
  }
  
  .filters-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 15px;
    margin-bottom: 15px;
  }
  
  .filter-group {
    display: flex;
    flex-direction: column;
  }
  
  .filter-group label {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 5px;
    color: #555;
  }
  
  .filter-group input,
  .filter-group select {
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 14px;
  }
  
  .filter-group input:focus,
  .filter-group select:focus {
    outline: none;
    border-color: #27ae60;
  }
  
  .filter-buttons {
    display: flex;
    gap: 10px;
    margin-top: 10px;
  }
  
  .btn-apply-filters {
    background: #27ae60;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .btn-reset-filters {
    background: #95a5a6;
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .stats-badge {
    background: #ecf0f1;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 20px;
    font-size: 14px;
  }
  
  .cards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 20px;
  }
  
  .card-item {
    background: white;
    border-radius: 10px;
    padding: 15px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    transition: transform 0.2s;
    cursor: pointer;
  }
  
  .card-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }
  
  .card-item.expired {
    background: #fef5f5;
    border-left: 4px solid #e74c3c;
  }
  
  .card-item.active {
    border-left: 4px solid #27ae60;
  }
  
  .card-item.inactive {
    background: #f5f5f5;
    opacity: 0.7;
  }
  
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .card-number {
    font-weight: bold;
    color: #2c3e50;
    font-size: 14px;
  }
  
  .card-status {
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: bold;
  }
  
  .status-active {
    background: #27ae60;
    color: white;
  }
  
  .status-inactive {
    background: #95a5a6;
    color: white;
  }
  
  .status-expired {
    background: #e74c3c;
    color: white;
  }
  
  .card-name {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 8px;
    color: #333;
  }
  
  .card-details {
    font-size: 13px;
    color: #666;
    margin-top: 8px;
  }
  
  .card-details div {
    margin-bottom: 5px;
  }
  
  .expiry-warning {
    color: #e74c3c;
    font-weight: bold;
    margin-top: 8px;
    font-size: 12px;
  }
  
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .modal-content {
    background: white;
    padding: 25px;
    border-radius: 10px;
    max-width: 500px;
    width: 90%;
    max-height: 80vh;
    overflow-y: auto;
  }
  
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .modal-close {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #999;
  }
  
  .modal-actions {
    display: flex;
    gap: 10px;
    margin-top: 20px;
    justify-content: flex-end;
  }
  
  .loading-spinner {
    text-align: center;
    padding: 40px;
    font-size: 18px;
    color: #666;
  }
  
  .no-results {
    text-align: center;
    padding: 40px;
    color: #999;
  }
`;








//////////////////////////////////////////////////// sales report //////////////////////////////////////////////////////////


const [eyeCampsList, setEyeCampsList] = useState([]);
const [selectedSalesPerson, setSelectedSalesPerson] = useState("all");

// Add these state variables at the top of your component
const [report, setReport] = useState([]);
const [startDate, setStartDate] = useState('');
const [endDate, setEndDate] = useState('');
const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('all');
const [dateFilterType, setDateFilterType] = useState('month'); // 'month' or 'range'

// Update fetchData to get all invoices
useEffect(() => {
  fetchData();
}, []);

const fetchData = async () => {
  setLoading(true);
  try {
    const invoiceSnap = await getDocs(collection(db, "invoices"));
    const balanceSnap = await getDocs(collection(db, "balance_invoices"));

    const invoices = invoiceSnap.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    const balances = balanceSnap.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    generateReport(invoices, balances);
    setLoading(false);
  } catch (err) {
    console.error("Error fetching data:", err);
    setLoading(false);
  }
};

// const generateReport = (invoices, balances) => {
//   const rows = invoices.map(inv => {
//     const invoiceNumber = inv.invoiceNumber || inv.financial?.invoiceNumber || "";
//     const customer = inv.customer?.fullName || "-";
//     const totalAmount = inv.financial?.totalAmount || 0;
//     const advancePaid = inv.financial?.advancePayment || 0;
//     const paymentMethod = inv.financial?.paymentMethod || inv.paymentMethod || "-";
    
//     // Handle date safely
//     let invoiceDate = "";
//     if (inv.createdAt) {
//       if (inv.createdAt.toDate) {
//         invoiceDate = inv.createdAt.toDate();
//       } else if (inv.createdAt.seconds) {
//         invoiceDate = new Date(inv.createdAt.seconds * 1000);
//       } else {
//         invoiceDate = new Date(inv.createdAt);
//       }
//     } else {
//       invoiceDate = new Date();
//     }

//     const related = balances.filter(
//       b => (b.originalInvoiceNumber || "").trim() === invoiceNumber.trim()
//     );

//     const laterPayments = related.reduce(
//       (sum, b) => sum + (b.paidAmount || 0),
//       0
//     );

//     const totalPaid = advancePaid + laterPayments;
//     const remaining = totalAmount - totalPaid;

//     return {
//       invoiceNumber,
//       customer,
//       totalAmount,
//       advancePaid,
//       laterPayments,
//       totalPaid,
//       remaining,
//       status: remaining <= 0 ? "Settled" : "Pending",
//       date: invoiceDate,
//       paymentMethod: paymentMethod,
//       salePerson: inv.salePerson || "-",
//       eyeCamp: inv.eyeCamp || "-"
//     };
//   });

//   // Sort by date descending (newest first)
//   rows.sort((a, b) => b.date - a.date);
//   setReport(rows);
// };


const generateReport = (invoices, balances) => {
  const rows = invoices.map(inv => {
    const invoiceNumber = inv.invoiceNumber || inv.financial?.invoiceNumber || "";
    const customer = inv.customer?.fullName || "-";
    const totalAmount = inv.financial?.totalAmount || 0;
    const advancePaid = inv.financial?.advancePayment || 0;
    const paymentMethod = inv.financial?.paymentMethod || inv.paymentMethod || "-";
    const paymentType = inv.financial?.paymentType || inv.paymentType || paymentMethod;
    
    // Handle split payment details
    const paymentDetails = inv.financial?.paymentDetails || {};
    let cashAmount = 0;
    let cardAmount = 0;
    
    if (paymentDetails.type === 'split' && paymentDetails.breakdown) {
      paymentDetails.breakdown.forEach(p => {
        if (p.method === 'Cash') {
          cashAmount = p.amount || 0;
        } else if (p.method === 'Card') {
          cardAmount = p.amount || 0;
        }
      });
    } else {
      // For non-split payments, check the payment method
      if (paymentMethod === 'Cash') {
        cashAmount = advancePaid;
      } else if (paymentMethod === 'Card') {
        cardAmount = advancePaid;
      }
    }
    
    // Handle date safely
    let invoiceDate = "";
    if (inv.createdAt) {
      if (inv.createdAt.toDate) {
        invoiceDate = inv.createdAt.toDate();
      } else if (inv.createdAt.seconds) {
        invoiceDate = new Date(inv.createdAt.seconds * 1000);
      } else {
        invoiceDate = new Date(inv.createdAt);
      }
    } else {
      invoiceDate = new Date();
    }

    const related = balances.filter(
      b => (b.originalInvoiceNumber || "").trim() === invoiceNumber.trim()
    );

    const laterPayments = related.reduce(
      (sum, b) => sum + (b.paidAmount || 0),
      0
    );

    const totalPaid = advancePaid + laterPayments;
    const remaining = totalAmount - totalPaid;

    return {
      invoiceNumber,
      customer,
      totalAmount,
      advancePaid,
      laterPayments,
      totalPaid,
      remaining,
      status: remaining <= 0 ? "Settled" : "Pending",
      date: invoiceDate,
      paymentMethod: paymentType === 'split' ? 'Split (Cash + Card)' : paymentMethod,
      paymentType: paymentType,
      cashAmount: cashAmount,
      cardAmount: cardAmount,
      salePerson: inv.salePerson || "-",
      eyeCamp: inv.eyeCamp || "-"
    };
  });

  // Sort by date descending (newest first)
  rows.sort((a, b) => b.date - a.date);
  setReport(rows);
};








const salesPersons = [
  ...new Set(
    report
      .map(r => r.salePerson)
      .filter(Boolean)
  )
];


const eyeCamp = [
  ...new Set(
    report
      .map(r => r.eyeCamp)
      .filter(Boolean)
  )
];

// Add this function to fetch eye camps for filter
const fetchEyeCampsForFilter = async () => {
  try {
    const snapshot = await getDocs(collection(db, "eye_camps"));
    const camps = snapshot.docs.map(doc => ({
      id: doc.id,
      name: doc.data().name
    }));
    setEyeCampsList(camps);
  } catch (error) {
    console.error("Error fetching eye camps:", error);
  }
};

// Call this in your existing useEffect
useEffect(() => {
  fetchEyeCampsForFilter();
}, []);







// Filter the report based on all criteria
// const filteredReport = report.filter(r => {
//   if (!r.date) return false;
  
//   let matchesDate = true;
  
//   // Date range filter
//   if (dateFilterType === 'range' && startDate && endDate) {
//     const invoiceDate = new Date(r.date);
//     const start = new Date(startDate);
//     const end = new Date(endDate);
//     end.setHours(23, 59, 59);
//     matchesDate = invoiceDate >= start && invoiceDate <= end;
//   } 
//   // Month/Year filter
//   else if (dateFilterType === 'month') {
//     const month = r.date.getMonth() + 1;
//     const year = r.date.getFullYear();
//     const matchMonth = selectedMonth === "all" || month === parseInt(selectedMonth);
//     const matchYear = selectedYear === "all" || year === parseInt(selectedYear);
//     matchesDate = matchMonth && matchYear;
//   }
  
//   // Payment method filter
//   const matchesPayment = selectedPaymentMethod === "all" || 
//                          r.paymentMethod === selectedPaymentMethod;
  
//   // Sales person filter
//   const matchesSalesPerson = selectedSalesPerson === "all" || 
//                              r.salePerson === selectedSalesPerson;
  
//   // Eye camp filter
//   const matchesEyeCamp = selectedEyeCamp === "all" || 
//                          r.eyeCamp === selectedEyeCamp;
  
//   // Return ALL filters combined
//   return matchesDate && matchesPayment && matchesSalesPerson && matchesEyeCamp;
// });

// Filter the report based on all criteria
const filteredReport = report.filter(r => {
  if (!r.date) return false;
  
  let matchesDate = true;
  
  // Date range filter
  if (dateFilterType === 'range' && startDate && endDate) {
    const invoiceDate = new Date(r.date);
    const start = new Date(startDate);
    const end = new Date(endDate);
    end.setHours(23, 59, 59);
    matchesDate = invoiceDate >= start && invoiceDate <= end;
  } 
  // Month/Year filter
  else if (dateFilterType === 'month') {
    const month = r.date.getMonth() + 1;
    const year = r.date.getFullYear();
    const matchMonth = selectedMonth === "all" || month === parseInt(selectedMonth);
    const matchYear = selectedYear === "all" || year === parseInt(selectedYear);
    matchesDate = matchMonth && matchYear;
  }
  
  // Payment method filter - handle split payment
  let matchesPayment = true;
  if (selectedPaymentMethod !== "all") {
    if (selectedPaymentMethod === "Split") {
      matchesPayment = r.paymentType === "split";
    } else {
      matchesPayment = r.paymentMethod === selectedPaymentMethod;
    }
  }
  
  // Sales person filter
  const matchesSalesPerson = selectedSalesPerson === "all" || 
                             r.salePerson === selectedSalesPerson;
  
  // Eye camp filter
  const matchesEyeCamp = selectedEyeCamp === "all" || 
                         r.eyeCamp === selectedEyeCamp;
  
  return matchesDate && matchesPayment && matchesSalesPerson && matchesEyeCamp;
});







// Update downloadExcel function
// const downloadExcel = () => {
//   const exportData = filteredReport.map(r => ({
//     'Invoice Number': r.invoiceNumber,
//     'Customer Name': r.customer,
//     'Payment Method': r.paymentMethod,
//     'Invoice Date': r.date.toLocaleDateString(),
//     'Total Amount (Rs.)': r.totalAmount.toLocaleString(),
//     'Advance Payment (Rs.)': (r.advancePaid - r.laterPayments).toLocaleString(),
//     'Later Payments (Rs.)': r.laterPayments.toLocaleString(),
//     'Total Paid (Rs.)': r.advancePaid.toLocaleString(),
//     'Remaining Balance (Rs.)': (r.totalAmount - r.advancePaid).toLocaleString(),
//     // 'Status': r.status
//   }));
  
//   const worksheet = XLSX.utils.json_to_sheet(exportData);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Sales Report");
//   XLSX.writeFile(workbook, `Sales_Report_${Date.now()}.xlsx`);
// };




const downloadExcel = () => {
  const exportData = filteredReport.map(r => ({
    'Invoice Number': r.invoiceNumber,
    'Customer Name': r.customer,
    'Sales Person': r.salePerson || "-",
    'Eye Camp': r.eyeCamp || "-",
    'Payment Method': r.paymentMethod,
    'Invoice Date': r.date.toLocaleDateString(),
    'Total Amount (Rs.)': r.totalAmount.toLocaleString(),
    'Cash (Rs.)': r.cashAmount.toLocaleString(),
    'Card (Rs.)': r.cardAmount.toLocaleString(),
    'Total Paid (Rs.)': r.totalPaid.toLocaleString(),
    'Remaining Balance (Rs.)': r.remaining.toLocaleString()
  }));
  
  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sales Report");
  XLSX.writeFile(workbook, `Sales_Report_${Date.now()}.xlsx`);
};




// Update downloadPDF function to include all filters
// const downloadPDF = () => {
//   const doc = new jsPDF("landscape");
//   const pageWidth = doc.internal.pageSize.getWidth();
//   const pageHeight = doc.internal.pageSize.getHeight();
//   const leftMargin = 12;
//   const rightMargin = 12;

//   // Header Background
//   doc.setFillColor(15, 23, 42);
//   doc.rect(0, 0, pageWidth, 38, "F");

//   // Logo
//   try {
//     doc.addImage("/ray-ban-logo.png", "PNG", 12, 5, 26, 26);
//   } catch (err) {
//     console.log("Logo not found");
//   }

//   // Company Details
//   doc.setTextColor(255, 255, 255);
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(18);
//   doc.text("Ray Ban Opticians", 45, 14);
//   doc.setFont("helvetica", "normal");
//   doc.setFontSize(10);
//   doc.text("Ray Ban Building, 142, Kandy Road, Dalugama, Kiribathgoda", 45, 21);
//   doc.text("Hotline: 0767873232 Tel: 0112912333 / 0112914949 Fax: 0112913933", 45, 27);
//   doc.text("Email: info@raybanopticians.com | Web: raybanopticians.com", 45, 33);

//   // Report Title
//   doc.setTextColor(0, 0, 0);
//   doc.setFont("helvetica", "bold");
//   doc.setFontSize(20);
//   doc.text("SALES REPORT", pageWidth / 2, 52, { align: "center" });

//   // Filter Info
//   let filterText = "";
//   if (dateFilterType === 'range' && startDate && endDate) {
//     filterText = `Date Range: ${new Date(startDate).toLocaleDateString()} - ${new Date(endDate).toLocaleDateString()}`;
//   } else if (dateFilterType === 'month') {
//     if (selectedMonth !== "all" && selectedYear !== "all") {
//       const monthNames = ["", "January", "February", "March", "April", "May", "June",
//         "July", "August", "September", "October", "November", "December"];
//       filterText = `${monthNames[selectedMonth]} ${selectedYear}`;
//     } else if (selectedYear !== "all") {
//       filterText = `Year ${selectedYear}`;
//     } else {
//       filterText = "All Records";
//     }
//   }
  
//   if (selectedPaymentMethod !== "all") {
//     filterText += filterText ? ` | Payment: ${selectedPaymentMethod}` : `Payment: ${selectedPaymentMethod}`;
//   }
//   if (!filterText) filterText = "All Records";

//   doc.setFontSize(10);
//   doc.setFont("helvetica", "normal");
//   doc.text(`Report Filter: ${filterText}`, leftMargin, 62);
//   doc.text(`Generated Date: ${new Date().toLocaleDateString()}`, pageWidth - rightMargin, 62, { align: "right" });

//   // Summary Section
//   const totalSales = filteredReport.reduce((sum, r) => sum + (r.totalAmount || 0), 0);
//   const totalPaid = filteredReport.reduce((sum, r) => sum + (r.advancePaid || 0), 0);
//   const totalPending = filteredReport.reduce((sum, r) => sum + (r.totalAmount - r.advancePaid || 0), 0);
//   const settledCount = filteredReport.filter(r => r.status === "Settled").length;
//   const pendingCount = filteredReport.filter(r => r.status === "Pending").length;

//   const summaryY = 72;
//   const boxWidth = 52;
//   const boxHeight = 22;
//   const gap = 8;

//   const boxes = [
//     { title: "Total Sales", value: `Rs. ${totalSales.toLocaleString()}` },
//     { title: "Total Received", value: `Rs. ${totalPaid.toLocaleString()}` },
//     { title: "Pending Amount", value: `Rs. ${totalPending.toLocaleString()}` },
//     {title: "Invoices Count", value: `${dashboardStats.totalInvoices}`},
//   ];

//   boxes.forEach((box, i) => {
//     const x = leftMargin + (i * (boxWidth + gap));
//     doc.setFillColor(241, 245, 249);
//     doc.roundedRect(x, summaryY, boxWidth, boxHeight, 3, 3, "F");
//     doc.setFontSize(10);
//     doc.setFont("helvetica", "bold");
//     doc.text(box.title, x + 4, summaryY + 8);
//     doc.setFont("helvetica", "normal");
//     doc.setFontSize(11);
//     doc.text(box.value, x + 4, summaryY + 16);
//   });

//   // Table
//   const tableRows = filteredReport.map(r => [
//     r.invoiceNumber,
//     r.customer,
//     r.paymentMethod,
//     r.date.toLocaleDateString(),
//     `Rs. ${Number(r.totalAmount).toLocaleString()}`,
//     `Rs. ${Number(r.advancePaid).toLocaleString()}`,
//     `Rs. ${Number(r.laterPayments).toLocaleString()}`,
//     `Rs. ${Number(r.advancePaid - r.laterPayments).toLocaleString()}`,
//     `Rs. ${Number(r.totalAmount - r.advancePaid).toLocaleString()}`,
//     // r.status
//   ]);


// autoTable(doc, {
//   startY: 105,
//   head: [[
//     "Invoice", "Customer", "Sales Person", "Eye Camp", "Payment Type", "Date", 
//     "Total", "Cash", "Card", "Total Paid", "Remaining"
//   ]],
//   body: tableRows,
//   theme: "grid",
//   headStyles: {
//     fillColor: [15, 23, 42],
//     textColor: [255, 255, 255],
//     fontStyle: "bold",
//     halign: "center"
//   },
//   bodyStyles: { fontSize: 8, cellPadding: 2 },
//   styles: { overflow: "linebreak" },
//   columnStyles: {
//     0: { cellWidth: 25 },
//     1: { cellWidth: 40 },
//     2: { cellWidth: 30 },
//     3: { cellWidth: 25 },
//     4: { cellWidth: 30 },
//     5: { cellWidth: 22 },
//     6: { halign: "right", cellWidth: 25 },
//     7: { halign: "right", cellWidth: 22 },
//     8: { halign: "right", cellWidth: 22 },
//     9: { halign: "right", cellWidth: 25 },
//     10: { halign: "right", cellWidth: 25 }
//   }
// });





//   // Footer
//   const pageCount = doc.internal.getNumberOfPages();
//   for (let i = 1; i <= pageCount; i++) {
//     doc.setPage(i);
//     doc.setFontSize(9);
//     doc.setTextColor(120);
//     doc.text(`Generated by  Optical Management System`, leftMargin, pageHeight - 8);
//     doc.text(`Page ${i} of ${pageCount}`, pageWidth - rightMargin, pageHeight - 8, { align: "right" });
//   }

//   doc.save(`Sales_Report_${Date.now()}.pdf`);
// };


const downloadPDF = () => {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a4"
  });
  
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const leftMargin = 10;
  const rightMargin = 10;
  const topMargin = 10;

  // Header Background
  doc.setFillColor(15, 23, 42);
  doc.rect(0, 0, pageWidth, 32, "F");

  // Logo - Smaller size
  try {
    doc.addImage("/ray-ban-logo.png", "PNG", 10, 4, 20, 20);
  } catch (err) {
    console.log("Logo not found");
  }

  // Company Details - Smaller font
  doc.setTextColor(255, 255, 255);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("Ray Ban Opticians", 35, 10);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  doc.text("Ray Ban Building, 142, Kandy Road, Dalugama, Kiribathgoda", 35, 16);
  doc.text("Hotline: 0767873232 Tel: 0112912333 / 0112914949 Fax: 0112913933", 35, 21);
  doc.text("Email: info@raybanopticians.com | Web: raybanopticians.com", 35, 26);

  // Report Title - Smaller
  doc.setTextColor(0, 0, 0);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("SALES REPORT", pageWidth / 2, 42, { align: "center" });

  // Filter Info - Smaller
  let filterText = "";
  if (dateFilterType === 'range' && startDate && endDate) {
    filterText = `Date Range: ${new Date(startDate).toLocaleDateString()} - ${new Date(endDate).toLocaleDateString()}`;
  } else if (dateFilterType === 'month') {
    if (selectedMonth !== "all" && selectedYear !== "all") {
      const monthNames = ["", "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"];
      filterText = `${monthNames[parseInt(selectedMonth)]} ${selectedYear}`;
    } else if (selectedYear !== "all") {
      filterText = `Year ${selectedYear}`;
    } else {
      filterText = "All Records";
    }
  }
  
  if (selectedPaymentMethod !== "all") {
    filterText += filterText ? ` | Payment: ${selectedPaymentMethod}` : `Payment: ${selectedPaymentMethod}`;
  }
  if (selectedSalesPerson !== "all") {
    filterText += filterText ? ` | Sales Person: ${selectedSalesPerson}` : `Sales Person: ${selectedSalesPerson}`;
  }
  if (selectedEyeCamp !== "all") {
    filterText += filterText ? ` | Eye Camp: ${selectedEyeCamp}` : `Eye Camp: ${selectedEyeCamp}`;
  }
  if (!filterText) filterText = "All Records";

  doc.setFontSize(8);
  doc.setFont("helvetica", "normal");
  doc.text(`Report Filter: ${filterText}`, leftMargin, 50);
  doc.text(`Generated Date: ${new Date().toLocaleDateString()}`, pageWidth - rightMargin, 50, { align: "right" });

  // Summary Section - Smaller boxes
  const totalSales = filteredReport.reduce((sum, r) => sum + (r.totalAmount || 0), 0);
  const totalPaid = filteredReport.reduce((sum, r) => sum + (r.totalPaid || 0), 0);
  const totalPending = filteredReport.reduce((sum, r) => sum + (r.remaining || 0), 0);
  const totalCash = filteredReport.reduce((sum, r) => sum + (r.cashAmount || 0), 0);
  const totalCard = filteredReport.reduce((sum, r) => sum + (r.cardAmount || 0), 0);

  const summaryY = 58;
  const boxWidth = 50;
  const boxHeight = 18;
  const gap = 4;

  const boxes = [
    { title: "Total Sales", value: `Rs. ${totalSales.toLocaleString()}` },
    { title: "Total Received", value: `Rs. ${totalPaid.toLocaleString()}` },
    { title: "Pending Amount", value: `Rs. ${totalPending.toLocaleString()}` },
    { title: "Total Cash", value: `Rs. ${totalCash.toLocaleString()}` },
    { title: "Total Card", value: `Rs. ${totalCard.toLocaleString()}` },
  ];

  // Calculate total width of boxes to center them
  const totalBoxesWidth = boxes.length * (boxWidth + gap) - gap;
  const startX = (pageWidth - totalBoxesWidth) / 2;

  boxes.forEach((box, i) => {
    const x = startX + (i * (boxWidth + gap));
    doc.setFillColor(241, 245, 249);
    doc.roundedRect(x, summaryY, boxWidth, boxHeight, 2, 2, "F");
    doc.setFontSize(7);
    doc.setFont("helvetica", "bold");
    doc.text(box.title, x + 3, summaryY + 6);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.text(box.value, x + 3, summaryY + 13);
  });

  // Table with optimized column widths for A4 Landscape
  const tableRows = filteredReport.map(r => [
    r.invoiceNumber || "-",
    r.customer || "-",
    r.salePerson || "-",
    r.eyeCamp || "-",
    r.paymentMethod || "-",
    r.date ? r.date.toLocaleDateString() : "-",
    Number(r.totalAmount || 0),
    Number(r.cashAmount || 0),
    Number(r.cardAmount || 0),
    Number(r.totalPaid || 0),
    Number(r.remaining || 0),
  ]);

  autoTable(doc, {
    startY: summaryY + boxHeight + 8,
    head: [[
      "Invoice", "Customer", "Sales Person", "Eye Camp", "Payment", "Date", 
      "Total", "Cash", "Card", "Paid", "Balance"
    ]],
    body: tableRows,
    theme: "grid",
    headStyles: {
      fillColor: [15, 23, 42],
      textColor: [255, 255, 255],
      fontStyle: "bold",
      halign: "center",
      fontSize: 7
    },
    bodyStyles: { 
      fontSize: 6.5, 
      cellPadding: 1.5 
    },
    styles: { 
      overflow: "linebreak",
      fontSize: 6.5
    },
    columnStyles: {
      0: { cellWidth: 22, halign: "center" },
      1: { cellWidth: 38, halign: "left" },
      2: { cellWidth: 28, halign: "left" },
      3: { cellWidth: 25, halign: "left" },
      4: { cellWidth: 25, halign: "center" },
      5: { cellWidth: 20, halign: "center" },
      6: { halign: "right", cellWidth: 22 },
      7: { halign: "right", cellWidth: 20 },
      8: { halign: "right", cellWidth: 20 },
      9: { halign: "right", cellWidth: 22 },
      10: { halign: "right", cellWidth: 22 }
    },
    didDrawPage: function (data) {
      // Footer
      const pageCount = doc.internal.getNumberOfPages();
      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(7);
        doc.setTextColor(120);
        doc.text(`Generated by Optical Management System`, leftMargin, pageHeight - 6);
        doc.text(`Page ${i} of ${pageCount}`, pageWidth - rightMargin, pageHeight - 6, { align: "right" });
      }
    }
  });

  doc.save(`Sales_Report_${Date.now()}.pdf`);
};













//////////////////////////////////////////////// track spectacles /////////////////////////////////////////////////////////


/* =========================================================
TRACK SPECTACLES - UPDATED VERSION
========================================================= */

/* STATES */
const [trackInvoices, setTrackInvoices] = useState([]);
const [trackLoading, setTrackLoading] = useState(false);
const [trackDataMap, setTrackDataMap] = useState({});

/* FILTER STATES */
const [trackSearchInvoice, setTrackSearchInvoice] = useState("");
const [trackFilterStatus, setTrackFilterStatus] = useState("all");
const [trackFilterDate, setTrackFilterDate] = useState("");
const [trackFilterMonth, setTrackFilterMonth] = useState("");
const [trackFilterYear, setTrackFilterYear] = useState("");

/* =========================================================
FETCH INVOICES + TRACK DATA
========================================================= */
const fetchTrackSpectacles = async () => {
  try {
    setTrackLoading(true);

    const invoiceSnap = await getDocs(
      query(collection(db, "invoices"), orderBy("createdAt", "desc"))
    );

    const invoiceList = invoiceSnap.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    const trackSnap = await getDocs(collection(db, "track_spectacles"));

    const map = {};

    trackSnap.forEach((doc) => {
      const data = doc.data();
      map[data.invoiceId] = {
        docId: doc.id,
        ...data,
      };
    });

    setTrackInvoices(invoiceList);
    setTrackDataMap(map);
    setTrackLoading(false);
  } catch (error) {
    console.error(error);
    setTrackLoading(false);
  }
};

useEffect(() => {
  if (selectedOption === "trackSpectacle") {
    fetchTrackSpectacles();
  }
}, [selectedOption]);

/* =========================================================
SAVE SAME DOCUMENT (status1,status2,status3...)
========================================================= */
const saveTrackStatus = async (invoice, newStatus, newDate) => {
  try {
    if (!newStatus || !newDate) {
      alert("Select status and date");
      return;
    }

    const existing = trackDataMap[invoice.id];

    if (existing?.docId) {
      const updateData = {};
      let count = existing.totalSteps || 0;
      count += 1;

      updateData[`status${count}`] = newStatus;
      updateData[`date${count}`] = newDate;
      updateData.totalSteps = count;
      updateData.latestStatus = newStatus;
      updateData.latestDate = newDate;

      await updateDoc(
        doc(db, "track_spectacles", existing.docId),
        updateData
      );
    } else {
      await addDoc(collection(db, "track_spectacles"), {
        invoiceId: invoice.id,
        invoiceNumber: invoice.invoiceNumber,
        
        customerName: invoice.customer?.fullName || "",
        totalSteps: 1,
        status1: newStatus,
        date1: newDate,
        latestStatus: newStatus,
        latestDate: newDate,
        createdAt: serverTimestamp(),
      });
    }

    fetchTrackSpectacles();
    alert("Saved");
  } catch (error) {
    console.error(error);
    alert("Error");
  }
};

/* =========================================================
FILTER DATA
========================================================= */
const filteredTrackInvoices = trackInvoices.filter((inv) => {
  const track = trackDataMap[inv.id];

  const invoiceOk =
    trackSearchInvoice === "" ||
    inv.invoiceNumber
      ?.toLowerCase()
      .includes(trackSearchInvoice.toLowerCase());

  const statusOk =
    trackFilterStatus === "all" ||
    track?.latestStatus === trackFilterStatus;

  const dateOk =
    trackFilterDate === "" ||
    track?.latestDate === trackFilterDate;

  const monthOk =
    trackFilterMonth === "" ||
    (track?.latestDate &&
      new Date(track.latestDate).getMonth() + 1 ===
        Number(trackFilterMonth));

  const yearOk =
    trackFilterYear === "" ||
    (track?.latestDate &&
      new Date(track.latestDate).getFullYear() ===
        Number(trackFilterYear));

  return invoiceOk && statusOk && dateOk && monthOk && yearOk;
});




const sendWhatsAppMessage = (invoice) => {
  let phone = invoice.customer?.tpNo || "";

  // Remove spaces and special characters
  phone = phone.replace(/\D/g, "");

  // Convert 0771234567 -> 94771234567
  if (phone.startsWith("0")) {
    phone = "94" + phone.substring(1);
  }

  const customerName = invoice.customer?.fullName || "Customer";



const message = `Dear ${customerName},

Greetings from *RAY BAN OPTICIANS - Kiribathgoda*.

We are pleased to inform you that your spectacles are now ready for collection.

Thank you for choosing Ray Ban Opticians. We appreciate your trust and look forward to serving you.

Best regards,
RAY BAN OPTICIANS
Kiribathgoda`;







  const whatsappUrl = `https://wa.me/${phone}?text=${encodeURIComponent(
    message
  )}`;

  window.open(whatsappUrl, "_blank");
};







////////////////////////////////////////////// View Purchasing order //////////////////////////////////////////////////////////



const [loadingPO, setLoadingPO] = useState(false);

useEffect(() => {
  if (selectedOption === "viewPurchasingOrders") {
    fetchPurchasingOrders();
  }
}, [selectedOption]);

const fetchPurchasingOrders = async () => {
  try {
    setLoadingPO(true);

    const q = query(
      collection(db, "purchasing_order"),
      orderBy("createdAt", "desc")
    );

    const snapshot = await getDocs(q);

    const data = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setPurchaseOrders(data);
  } catch (error) {
    console.error("Error fetching purchase orders:", error);
  } finally {
    setLoadingPO(false);
  }
};









/////////////////////////////  Create Eye Examination Report ///////////////////////////////////////////////////////////////////////////////////////////////

  // Patient Information
  const [patientName, setPatientName] = useState('');
  const [examDate, setExamDate] = useState('');
  const [patientId, setPatientId] = useState('');
  const [dob, setDob] = useState('');
  const [age, setAge] = useState('');
  const [gender, setGender] = useState('');
  const [contactNo, setContactNo] = useState('');
  const [email, setEmail] = useState('');
  const [fundi, setFundi] = useState('');
  const [addition, setAddition] = useState("");

  // History Taking
  const [chiefComplaint, setChiefComplaint] = useState('');
  const [hpc, setHpc] = useState('');
  const [pastOcularHistory, setPastOcularHistory] = useState('');
  const [medicalHistory, setMedicalHistory] = useState('');
  const [familyOcularHistory, setFamilyOcularHistory] = useState('');
  const [socialHistory, setSocialHistory] = useState('');




const [lids, setLids] = useState('');
const [conjunctiva, setConjunctiva] = useState('');
const [cornea, setCornea] = useState('');
const [sclera, setSclera] = useState('');
const [ac, setAc] = useState('');
const [vitreous, setVitreous] = useState('');


// External Examination (Left and Right Eye - separate states)
const [lidsLeft, setLidsLeft] = useState('');
const [lidsRight, setLidsRight] = useState('');

const [conjunctivaLeft, setConjunctivaLeft] = useState('');
const [conjunctivaRight, setConjunctivaRight] = useState('');

const [corneaLeft, setCorneaLeft] = useState('');
const [corneaRight, setCorneaRight] = useState('');

const [scleraLeft, setScleraLeft] = useState('');
const [scleraRight, setScleraRight] = useState('');

const [acLeft, setAcLeft] = useState('');
const [acRight, setAcRight] = useState('');

const [lensLeft, setLensLeft] = useState('');
const [lensRight, setLensRight] = useState('');

const [vitreousLeft, setVitreousLeft] = useState('');
const [vitreousRight, setVitreousRight] = useState('');



  // Family History
  const [familyHistory, setFamilyHistory] = useState({
    poag: false,
    amd: false,
    dm: false,
    other: '',
  });

  // Visual Acuity
  const [visualAcuity, setVisualAcuity] = useState({
    od_cg: '',
    od_sg: '',
    od_ph: '',
    od_pd: '',
    os_cg: '',
    os_sg: '',
    os_ph: '',
    os_pd: '',
    seg_va: '',
    ct: '',
    npc: '',
    om: '',
  });


  //HbRx

  const [hbrx, setHbrx] = useState({
    hb_od_sph: '',
    hb_od_cyl: '',
    hb_od_axis: '',
    hb_od_vision: '',
    rx_os_sph: '',
    rx_os_cyl: '',
    rx_os_axis: '',
    rx_os_vision: '',
    add: '',
  });




  // Refraction
  const [refraction, setRefraction] = useState({
    od_sph: '',
    od_cyl: '',
    od_axis: '',
    od_vision: '',
    os_sph: '',
    os_cyl: '',
    os_axis: '',
    os_vision: '',
  });

  // Follow Up
  const [needsFollowUp, setNeedsFollowUp] = useState(false);
  const [followUpDate, setFollowUpDate] = useState('');
  const [remarks, setRemarks] = useState('');

  const handleFamilyHistoryChange = (e) => {
    const { name, checked, value } = e.target;
    if (name === 'other') {
      setFamilyHistory({ ...familyHistory, other: value });
    } else {
      setFamilyHistory({ ...familyHistory, [name]: checked });
    }
  };

  const handleVisualAcuityChange = (e) => {
    const { name, value } = e.target;
    setVisualAcuity({ ...visualAcuity, [name]: value });
  };

  const handleHbrxChange = (e) => {
    const { name, value } = e.target;
    setHbrx({ ...hbrx, [name]: value });
  };


  const handleRefractionChange = (e) => {
    const { name, value } = e.target;
    setRefraction({ ...refraction, [name]: value });
  };

  const handleEyeExamSubmit = async (e) => {
    e.preventDefault();

    if (!patientName || !examDate) {
      alert('Please fill in patient name and date');
      return;
    }

    const eyeExamData = {
      patientInfo: {
       
        name: patientName,
        date: examDate,
        id: patientId,
        dob: dob,
        age,
        gender,
        contactNo,
        email,
        fundi,
      },
      history: {
        chiefComplaint,
        hpc,
        pastOcularHistory,
        medicalHistory,
        familyOcularHistory,
        socialHistory,
        addition,
      },

      externalExam: {
        lids,
        conjunctiva,
        cornea,
        sclera,
        ac,
        lens,
        vitreous,
      },


      familyHistory,
      visualAcuity,
      hbrx,
      refraction,
      followUp: {
        needed: needsFollowUp,
        date: followUpDate,
        remarks,
      },
      createdAt: new Date(),
    };

    try {
      // Save to Firestore
      await addDoc(collection(db, 'eyeExams'), eyeExamData);
      
      // Generate PDF
      generateEyeExamPDF(eyeExamData);
      
    // Reset form after everything is done
    resetForm();

      alert('Eye exam report saved successfully!');
    } catch (error) {
      console.error('Error saving eye exam: ', error);
      alert('Failed to save eye exam');
    }
  };


const resetForm = () => {
  setPatientName('');
  setExamDate('');
  setPatientId('');
  setDob('');
  setAge('');
  setGender('');
  setContactNo('');
  setEmail('');
  setFundi('');

  setChiefComplaint('');
  setHpc('');
  setPastOcularHistory('');
  setMedicalHistory('');
  setFamilyOcularHistory('');
  setSocialHistory('');

  setLids('');
  setConjunctiva('');
  setCornea('');
  setSclera('');
  setAc('');
  setLens('');
  setVitreous('');

  setLidsLeft('');
  setLidsRight('');
  setConjunctivaLeft('');
  setConjunctivaRight('');
  setCorneaLeft('');
  setCorneaRight('');
  setScleraLeft('');
  setScleraRight('');
  setAcLeft('');
  setAcRight('');
  setLensLeft('');
  setLensRight('');
  setVitreousLeft('');
  setVitreousRight('');

  setFamilyHistory({
    poag: false,
    amd: false,
    dm: false,
    other: '',
  });

  setVisualAcuity({
    od_cg: '',
    od_sg: '',
    od_ph: '',
    od_pd: '',
    os_cg: '',
    os_sg: '',
    os_ph: '',
    os_pd: '',
    seg_va: '',
    ct: '',
    npc: '',
    om: '',
  });

  setHbrx({
    hb_od_sph: '',
    hb_od_cyl: '',
    hb_od_axis: '',
    hb_od_vision: '',
    rx_os_sph: '',
    rx_os_cyl: '',
    rx_os_axis: '',
    rx_os_vision: '',
    add: '',
  });

  setRefraction({
    od_sph: '',
    od_cyl: '',
    od_axis: '',
    od_vision: '',
    os_sph: '',
    os_cyl: '',
    os_axis: '',
    os_vision: '',

  });

  setNeedsFollowUp(false);
  setFollowUpDate('');
  setRemarks('');
};





  const generateEyeExamPDF = (data) => {
    const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
    });

    // Set default font styles
    doc.setFont('helvetica');
    doc.setTextColor(0, 0, 0); // Black text



    // Constants for layout
const leftMargin = 15;
const rightMargin = 15;
const pageWidth = 210 - leftMargin - rightMargin;
const column1 = leftMargin;
const column2 = 100;
const columnWidth = 80;

// Header settings
const headerHeight = 50;
const logoWidth = 35;
const logoHeight = 35;

// Vertically center logo inside header
const logoY = (headerHeight - logoHeight) / 2;

// Header Section
doc.addImage(
  '/ray-ban-logo.png',
  'PNG',
  leftMargin,
  logoY,
  logoWidth,
  logoHeight
);



    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('Ray Ban Opticians', leftMargin + 55, 18);
    doc.setFontSize(10);
    doc.text('Ray Ban Building, 142, Kandy Road, Dalugama, Kiribathgoda', leftMargin + 55, 23);
    doc.text('Hotline: 0767873232 Tel: 0112912333 / 0112914949 Fax: 0112913933', leftMargin + 55, 28);
    doc.text('Email: info@raybanopticians.com | Web: raybanopticians.com', leftMargin + 55, 33);
    doc.text(`Date: ${data.patientInfo.date}`, 180, 33, { align: 'right' });

    // Horizontal line moved slightly down
    // doc.line(leftMargin, 34, 210 - rightMargin, 34);
    // Report Title
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text('EYE EXAMINATION REPORT', 105, 42, { align: 'center' });
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');

    // Patient Information (Two Columns)
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('PATIENT INFORMATION', leftMargin, 50);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    
    // Column 1
    
    doc.text(`Name: ${data.patientInfo.name}`, column1, 56);
    // doc.text(`Patient ID: ${data.patientInfo.id || '-'}`, column1, 62);
    doc.text(`Age: ${data.patientInfo.age || '-'}`, column1, 62);
    doc.text(`Gender: ${data.patientInfo.gender || '-'}`, column1, 68);
    
    // Column 2
    
    doc.text(`Job No: ${data.patientInfo.jobNo || '-'}`, column2, 56);
    doc.text(`DOB: ${data.patientInfo.dob || '-'}`, column2, 62);
    doc.text(`Contact: ${data.patientInfo.contactNo || '-'}`, column2, 66);
    doc.line(leftMargin, 78, 210 - rightMargin, 78); // Divider line

    // Helper functions
    const addSection = (title, content, y, maxWidth = pageWidth) => {
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.text(title.toUpperCase(), leftMargin, y);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        
        const lines = doc.splitTextToSize(content || '-', maxWidth);
        doc.text(lines, leftMargin + 5, y + 6);
        return y + (lines.length * 5) + 10;
    };

    const addExamTable = (title, data, y, columns) => {
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.text(title.toUpperCase(), leftMargin, y);
        y += 6;
        
        // Table header
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        columns.forEach((col, i) => {
            doc.text(col.label, leftMargin + (i * 40), y);
        });
        y += 6;
        
        // Table data
        doc.setFont('helvetica', 'normal');
        data.forEach(row => {
            columns.forEach((col, i) => {
                doc.text(row[col.key] || '-', leftMargin + (i * 40), y);
            });
            y += 6;
        });
        
        return y + 6;
    };

    let yPos = 82;

// History Sections (inline, label + value)
doc.setFontSize(10);
doc.setFont('helvetica', 'normal');

doc.text(`Chief Complaint : ${data.history.chiefComplaint || '-'}`, leftMargin, yPos);
yPos += 6;
doc.text(`History Of Present Complaint : ${data.history.hpc || '-'}`, leftMargin, yPos);
yPos += 6;
doc.text(`Past Ocular History : ${data.history.pastOcularHistory || '-'}`, leftMargin, yPos);
yPos += 6;
doc.text(`Medical History : ${data.history.medicalHistory || '-'}`, leftMargin, yPos);
yPos += 6;
doc.text(`Family Ocular History : ${data.history.familyOcularHistory || '-'}`, leftMargin, yPos);
yPos += 6;
doc.text(`Social History : ${data.history.socialHistory || '-'}`, leftMargin, yPos);
yPos += 10; // small gap after history section

    // Check for page break
    if (yPos > 250) {
        doc.addPage();
        yPos = 20;
    }

 // External Examination Table
yPos = addExamTable('External Examination', [
  { structure: 'Lids', left: lidsLeft || '-', right: lidsRight || '-' },
  { structure: 'Conjunctiva', left: conjunctivaLeft || '-', right: conjunctivaRight || '-' },
  { structure: 'Cornea', left: corneaLeft || '-', right: corneaRight || '-' },
  { structure: 'Sclera', left: scleraLeft || '-', right: scleraRight || '-' },
  { structure: 'A/C', left: acLeft || '-', right: acRight || '-' },
  { structure: 'Lens', left: lensLeft || '-', right: lensRight || '-' },
  { structure: 'Vitreous', left: vitreousLeft || '-', right: vitreousRight || '-' }
], yPos, [
  { label: 'Structure', key: 'structure' },
  { label: 'Left Eye', key: 'left' },
  { label: 'Right Eye', key: 'right' }
]);





    // Family History
    yPos = addSection('Family History', 
        `POAG: ${data.familyHistory.poag ? 'Yes' : 'No'}, ` +
        `AMD: ${data.familyHistory.amd ? 'Yes' : 'No'}, ` +
        `DM: ${data.familyHistory.dm ? 'Yes' : 'No'}` +
        (data.familyHistory.other ? `, Other: ${data.familyHistory.other}` : ''), 
        yPos);

    // Visual Acuity
    yPos = addExamTable('Visual Acuity', [
        { test: 'C/C', od: data.visualAcuity.od_cg, os: data.visualAcuity.os_cg },
        { test: 'S/C', od: data.visualAcuity.od_sg, os: data.visualAcuity.os_sg },
        { test: 'P/H', od: data.visualAcuity.od_ph, os: data.visualAcuity.os_ph },
        { test: 'PD', od: data.visualAcuity.od_pd, os: data.visualAcuity.os_pd },
       { test: 'SEG', od: data.visualAcuity.seg_va, os: '-' }
    ], yPos, [
        { label: 'Test', key: 'test' },
        { label: 'OD', key: 'od' },
        { label: 'OS', key: 'os' }
    ]);


// After Visual Acuity + Accessory Tests
if (
  (data.visualAcuity.ct && data.visualAcuity.ct.trim() !== '') ||
  (data.visualAcuity.npc && data.visualAcuity.npc.trim() !== '') ||
  (data.visualAcuity.om && data.visualAcuity.om.trim() !== '')
) {
  yPos = addSection('Accessory Tests',
      `CT: ${data.visualAcuity.ct || '-'}, ` +
      `NPC: ${data.visualAcuity.npc || '-'}, ` +
      `OM: ${data.visualAcuity.om || '-'}`, 
      yPos
  );
}


doc.addPage();
yPos = 20;




    // Fundus Examination
    if (data.patientInfo.fundi) {
        yPos = addSection('Fundus Examination', data.patientInfo.fundi, yPos);
    }


      //Hb Rx

      if (data.hbrx) {
       const hbRxData = [
  { eye: 'OD',
    sph: data.hbrx.hb_od_sph,
    cyl: data.hbrx.hb_od_cyl,
    axis: data.hbrx.hb_od_axis,
    vision: data.hbrx.hb_od_vision },
  { eye: 'OS',
    sph: data.hbrx.rx_os_sph,   // ✅ use rx_os_* here
    cyl: data.hbrx.rx_os_cyl,
    axis: data.hbrx.rx_os_axis,
    vision: data.hbrx.rx_os_vision }
];
        yPos = addExamTable('Hb Rx', hbRxData, yPos, [
            { label: 'Eye', key: 'eye' },
            { label: 'Sph', key: 'sph' },
            { label: 'Cyl', key: 'cyl' },
            { label: 'Axis', key: 'axis' },
            { label: 'Vision', key: 'vision' }
        ]);

        
      }

doc.text(`Addition (Near) : ${data.hbrx.add  || '-'}`, leftMargin, yPos);
yPos += 6;

    // Refraction and Hb Rx
    const refractionData = [
        { eye: 'OD', 
          sph: data.refraction.od_sph, 
          cyl: data.refraction.od_cyl, 
          axis: data.refraction.od_axis, 
          vision: data.refraction.od_vision },
        { eye: 'OS', 
          sph: data.refraction.os_sph, 
          cyl: data.refraction.os_cyl, 
          axis: data.refraction.os_axis, 
          vision: data.refraction.os_vision }
    ];

    yPos = addExamTable('Refraction', refractionData, yPos, [
        { label: 'Eye', key: 'eye' },
        { label: 'Sph', key: 'sph' },
        { label: 'Cyl', key: 'cyl' },
        { label: 'Axis', key: 'axis' },
        { label: 'Vision', key: 'vision' }
    ]);


doc.setFontSize(10);
doc.setFont('helvetica', 'bold');

doc.text(`Near Vision (ADD) : ${data.history.addition || '-'}`, leftMargin, yPos);
yPos += 6;



    // Follow Up
    yPos = addSection('Follow Up', 
        `Needed: ${data.followUp.needed ? 'Yes' : 'No'}` +
        (data.followUp.needed ? `, Date: ${data.followUp.date}` : '') +
        (data.followUp.remarks ? `\nRemarks: ${data.followUp.remarks}` : ''), 
        yPos);

    // Footer
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text('"All kinds of Eye wear, Sunglasses, Color Lenses, Contact Lenses, and All Eyeware accessories"', 105, 287, { align: 'center' });
    doc.text('© RAY BAN OPTICIANS', 105, 292, { align: 'center' });

    // Save PDF
    doc.save(`EyeExam_${data.patientInfo.name.replace(/\s+/g, '_')}_${data.patientInfo.date.replace(/\//g, '-')}.pdf`);
};













//fetch all the eye exam report

useEffect(() => {
  const fetchEyeExamRecords = async () => {
    if (selectedOption === "viewEyeExamReport") {
      try {
        const querySnapshot = await getDocs(collection(db, 'eyeExams'));
        const records = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setEyeExamRecords(records);
      } catch (error) {
        console.error("Error fetching eye exam records: ", error);
      }
    }
  };

  fetchEyeExamRecords();
}, [selectedOption]);






const filteredRecords = eyeExamRecords.filter(record => {
  // Search term filtering
  const matchesSearch = 
    record.patientInfo?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    record.patientInfo?.id?.toLowerCase().includes(searchTerm.toLowerCase());
  
  // Date filtering
  const recordDate = new Date(record.patientInfo?.date);
  const today = new Date();
  
  let matchesDate = true;
  if (filterOption === 'today') {
    matchesDate = recordDate.toDateString() === today.toDateString();
  } else if (filterOption === 'week') {
    const weekAgo = new Date();
    weekAgo.setDate(weekAgo.getDate() - 7);
    matchesDate = recordDate >= weekAgo;
  } else if (filterOption === 'month') {
    const monthAgo = new Date();
    monthAgo.setMonth(monthAgo.getMonth() - 1);
    matchesDate = recordDate >= monthAgo;
  }
  
  return matchesSearch && matchesDate;
});








//patient's eye examination report
const generatePatientEyeExam = (data) => {

  const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4',
    });

    // Set default font styles
    doc.setFont('helvetica');
    doc.setTextColor(0, 0, 0); // Black text

    // Constants for layout
    // const leftMargin = 15;
    // const rightMargin = 15;
    // const pageWidth = 210 - leftMargin - rightMargin;
    // const column1 = leftMargin;
    // const column2 = 100;
    // const columnWidth = 80;

    // // Header Section
    // doc.addImage('/eye-world-logo.png', 'PNG', leftMargin, 12, 40, 40); // Larger logo


    // Constants for layout
const leftMargin = 15;
const rightMargin = 15;
const pageWidth = 210 - leftMargin - rightMargin;
const column1 = leftMargin;
const column2 = 100;
const columnWidth = 80;

// Header settings
const headerHeight = 50;
const logoWidth = 35;
const logoHeight = 35;

// Vertically center logo inside header
const logoY = (headerHeight - logoHeight) / 2;

// Header Section
doc.addImage(
  '/ray-ban-logo.png',
  'PNG',
  leftMargin,
  logoY,
  logoWidth,
  logoHeight
);


    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('Ray Ban Opticians', leftMargin + 55, 18);
    doc.setFontSize(10);
    doc.text('Ray Ban Building, 142, Kandy Road, Dalugama, Kiribathgoda', leftMargin + 55, 23);
    doc.text('Hotline: 0767873232 Tel: 0112912333 / 0112914949 Fax: 0112913933', leftMargin + 55, 28);
    doc.text('Email: info@raybanopticians.com | Web: raybanopticians.com', leftMargin + 55, 33);
    doc.text(`Date: ${data.patientInfo.date}`, 180, 33, { align: 'right' });



    // doc.line(leftMargin, 32, 210 - rightMargin, 32); // Horizontal line
    // Horizontal line moved slightly down
    // doc.line(leftMargin, 34, 210 - rightMargin, 34);

    // Report Title
    doc.setFontSize(16);
    doc.setFont('helvetica', 'bold');
    doc.text('EYE EXAMINATION REPORT', 105, 42, { align: 'center' });
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');

    // Patient Information (Two Columns)
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text('PATIENT INFORMATION', leftMargin, 50);
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    
    // Column 1
    doc.text(`Name: ${data.patientInfo.name}`, column1, 56);
    doc.text(`Age: ${data.patientInfo.age || '-'}`, column1, 62);
    doc.text(`Gender: ${data.patientInfo.gender || '-'}`, column1, 68);
    
    // Column 2
    doc.text(`Contact: ${data.patientInfo.contactNo || '-'}`, column2, 56);
    doc.text(`DOB: ${data.patientInfo.dob || '-'}`, column2, 62);
    doc.line(leftMargin, 78, 210 - rightMargin, 78); // Divider line

    // Helper functions
    const addSection = (title, content, y, maxWidth = pageWidth) => {
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.text(title.toUpperCase(), leftMargin, y);
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        
        const lines = doc.splitTextToSize(content || '-', maxWidth);
        doc.text(lines, leftMargin + 5, y + 6);
        return y + (lines.length * 5) + 10;
    };

    const addExamTable = (title, data, y, columns) => {
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.text(title.toUpperCase(), leftMargin, y);
        y += 6;
        
        // Table header
        doc.setFontSize(10);
        doc.setFont('helvetica', 'bold');
        columns.forEach((col, i) => {
            doc.text(col.label, leftMargin + (i * 40), y);
        });
        y += 6;
        
        // Table data
        doc.setFont('helvetica', 'normal');
        data.forEach(row => {
            columns.forEach((col, i) => {
                doc.text(row[col.key] || '-', leftMargin + (i * 40), y);
            });
            y += 6;
        });
        
        return y + 6;
    };

    let yPos = 82;

    // History Sections (inline, label + value)
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');

    doc.text(`Chief Complaint : ${data.history?.chiefComplaint || '-'}`, leftMargin, yPos);
    yPos += 6;
    doc.text(`History Of Present Complaint : ${data.history?.hpc || '-'}`, leftMargin, yPos);
    yPos += 6;
    doc.text(`Past Ocular History : ${data.history?.pastOcularHistory || '-'}`, leftMargin, yPos);
    yPos += 6;


    // Visual Acuity
    yPos = addExamTable('Visual Acuity', [
        { test: 'C/C', od: data.visualAcuity?.od_cg || '-', os: data.visualAcuity?.os_cg || '-' },
        { test: 'S/C', od: data.visualAcuity?.od_sg || '-', os: data.visualAcuity?.os_sg || '-' },
        { test: 'P/H', od: data.visualAcuity?.od_ph || '-', os: data.visualAcuity?.os_ph || '-' },
        { test: 'PD', od: data.visualAcuity?.od_pd || '-', os: data.visualAcuity?.os_pd || '-' },
        { test: 'SEG', od: data.visualAcuity?.seg_va || '-', os: '-' }
    ], yPos, [
        { label: 'Test', key: 'test' },
        { label: 'OD', key: 'od' },
        { label: 'OS', key: 'os' }
    ]);

    // Accessory Tests (CT, NPC, OM)
    if (
        (data.visualAcuity?.ct && data.visualAcuity.ct.trim() !== '') ||
        (data.visualAcuity?.npc && data.visualAcuity.npc.trim() !== '') ||
        (data.visualAcuity?.om && data.visualAcuity.om.trim() !== '')
    ) {
        yPos = addSection('Accessory Tests',
            `CT: ${data.visualAcuity.ct || '-'}, ` +
            `NPC: ${data.visualAcuity.npc || '-'}, ` +
            `OM: ${data.visualAcuity.om || '-'}`, 
            yPos
        );
    }

    // Check if we need a new page before Hb Rx and Refraction
    if (yPos > 200) {
        doc.addPage();
        yPos = 20;
    }

    // Hb Rx
    if (data.hbrx) {
        const hbRxData = [
            { 
                eye: 'OD',
                sph: data.hbrx.hb_od_sph || '-',
                cyl: data.hbrx.hb_od_cyl || '-',
                axis: data.hbrx.hb_od_axis || '-',
                vision: data.hbrx.hb_od_vision || '-' 
            },
            { 
                eye: 'OS',
                sph: data.hbrx.rx_os_sph || '-',
                cyl: data.hbrx.rx_os_cyl || '-',
                axis: data.hbrx.rx_os_axis || '-',
                vision: data.hbrx.rx_os_vision || '-' 
            }
        ];
        
        yPos = addExamTable('Hb Rx', hbRxData, yPos, [
            { label: 'Eye', key: 'eye' },
            { label: 'Sph', key: 'sph' },
            { label: 'Cyl', key: 'cyl' },
            { label: 'Axis', key: 'axis' },
            { label: 'Vision', key: 'vision' }
        ]);
    }

    // Refraction
    if (data.refraction) {
        const refractionData = [
            { 
                eye: 'OD', 
                sph: data.refraction.od_sph || '-', 
                cyl: data.refraction.od_cyl || '-', 
                axis: data.refraction.od_axis || '-', 
                vision: data.refraction.od_vision || '-' 
            },
            { 
                eye: 'OS', 
                sph: data.refraction.os_sph || '-', 
                cyl: data.refraction.os_cyl || '-', 
                axis: data.refraction.os_axis || '-', 
                vision: data.refraction.os_vision || '-' 
            }
        ];

        yPos = addExamTable('Refraction', refractionData, yPos, [
            { label: 'Eye', key: 'eye' },
            { label: 'Sph', key: 'sph' },
            { label: 'Cyl', key: 'cyl' },
            { label: 'Axis', key: 'axis' },
            { label: 'Vision', key: 'vision' }
        ]);
    }


doc.setFontSize(10);
doc.setFont('helvetica', 'bold');

doc.text(`Near Vision (ADD) : ${data.history.addition || '-'}`, leftMargin, yPos);
yPos += 6;


    // Follow Up
    if (yPos > 260) {
        doc.addPage();
        yPos = 20;
    }

    yPos = addSection('Follow Up', 
        `Needed: ${data.followUp?.needed ? 'Yes' : 'No'}` +
        (data.followUp?.needed ? `, Date: ${data.followUp.date || '-'}` : '') +
        (data.followUp?.remarks ? `\nRemarks: ${data.followUp.remarks}` : ''), 
        yPos);

    // Footer
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text('"All kinds of Eye wear, Sunglasses, Color Lenses, Contact Lenses, and All Eyeware accessories"', 105, 287, { align: 'center' });
    doc.text('© Ray Ban Opticians', 105, 292, { align: 'center' });

    // Save PDF
    doc.save(`EyeExam_${data.patientInfo.name.replace(/\s+/g, '_')}_${data.patientInfo.date.replace(/\//g, '-')}.pdf`);
};

// ADD THIS FUNCTION INSIDE COMPONENT
const handleDeleteEyeExam = async (recordId) => {
  const password = prompt("Enter authorization password to delete this record");

  if (password !== "rayban@142") {
    alert("Invalid authorization password");
    return;
  }

  const confirmDelete = window.confirm(
    "Are you sure you want to permanently delete this eye examination record?"
  );

  if (!confirmDelete) return;

  try {
    await deleteDoc(doc(db, "eyeExams", recordId));

    alert("Record deleted successfully");

    // Update main records state
    setEyeExamRecords((prev) =>
      prev.filter((item) => item.id !== recordId)
    );

  } catch (error) {
    console.error("Delete error:", error);
    alert("Failed to delete record");
  }
};











//////////////////////////////////////// patient follow up ///////////////////////////////////////////////

const [followUpPatients, setFollowUpPatients] = useState([]);
const [loadingFollowUps, setLoadingFollowUps] = useState(true);

const loadFollowUps = async () => {
  try {
    setLoadingFollowUps(true);

    const snapshot = await getDocs(collection(db, "eyeExams"));

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const patients = snapshot.docs
      .map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      .filter((exam) => {
        if (!exam.followUp?.needed) return false;
        if (!exam.followUp?.date) return false;

        const followDate = new Date(exam.followUp.date);

        // Hide expired follow-ups
        return followDate >= today;
      })
      .sort(
        (a, b) =>
          new Date(a.followUp.date) -
          new Date(b.followUp.date)
      );

    setFollowUpPatients(patients);
  } catch (error) {
    console.error("Error loading follow-ups:", error);
  } finally {
    setLoadingFollowUps(false);
  }
};




useEffect(() => {
  loadFollowUps();

  const interval = setInterval(() => {
    loadFollowUps();
  }, 60000);

  return () => clearInterval(interval);
}, []);



const sendFollowUpWhatsApp = (patient) => {
  const patientName = patient.patientInfo?.name || "";
  const phone = patient.patientInfo?.contactNo || "";

  const cleaned = phone.replace(/\D/g, "");

  const isMobile =
    cleaned.startsWith("07") &&
    cleaned.length === 10;

  if (!isMobile) {
    alert(
      "This number is not WhatsApp enabled. Please make a normal call."
    );
    return;
  }

  const whatsappNo = `94${cleaned.substring(1)}`;

  const message = `Dear ${patientName},

This is a kindly reminder from *RAY BAN OPTICIANS - Kiribathgoda* regarding your upcoming eye examination follow-up.

Follow-up Date: ${patient.followUp?.date}

Follow-Up Description: ${patient.followUp?.remarks || ""}

Please contact us if you need any assistance.

Thank you.`;

  window.open(
    `https://wa.me/${whatsappNo}?text=${encodeURIComponent(
      message
    )}`,
    "_blank"
  );
};











/////////////////////////////////////////////////////// birthday wish ////////////////////////////////////////////

const [birthdayPatients, setBirthdayPatients] = useState([]);
const [loadingBirthdays, setLoadingBirthdays] = useState(true);


const loadBirthdays = async () => {
  try {
    setLoadingBirthdays(true);

    const snapshot = await getDocs(
      collection(db, "eyeExams")
    );

    const patients = snapshot.docs
      .map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))
      .filter(
        (patient) =>
          patient.patientInfo?.dob
      );

    setBirthdayPatients(patients);
  } catch (error) {
    console.error(error);
  } finally {
    setLoadingBirthdays(false);
  }
};

useEffect(() => {
  loadBirthdays();
}, []);







const sendBirthdayWish = (patient) => {
  const patientName =
    patient.patientInfo?.name || "";

  const phone =
    patient.patientInfo?.contactNo || "";

  const cleaned = phone.replace(/\D/g, "");

  const isMobile =
    cleaned.startsWith("07") &&
    cleaned.length === 10;

  if (!isMobile) {
    alert(
      "This number is not WhatsApp enabled. Please make a normal call."
    );
    return;
  }

  const whatsappNo = `94${cleaned.substring(
    1
  )}`;

  const message = `Dear ${patientName},

Happy Birthday!

Wishing you a wonderful day filled with happiness, good health, and success.

Warm wishes from all of us at *RAY BAN OPTICIANS - Kiribathgoda*.

Have a fantastic birthday!`;

  window.open(
    `https://wa.me/${whatsappNo}?text=${encodeURIComponent(
      message
    )}`,
    "_blank"
  );
};






const isBirthdayMatch = (
  dob,
  targetDate
) => {
  if (!dob) return false;

  const birthDate = new Date(dob);

  return (
    birthDate.getDate() ===
      targetDate.getDate() &&
    birthDate.getMonth() ===
      targetDate.getMonth()
  );
};

const today = new Date();

const tomorrow = new Date();
tomorrow.setDate(today.getDate() + 1);

const dayAfterTomorrow = new Date();
dayAfterTomorrow.setDate(
  today.getDate() + 2
);

const todayBirthdays =
  birthdayPatients.filter((p) =>
    isBirthdayMatch(
      p.patientInfo?.dob,
      today
    )
  );

const tomorrowBirthdays =
  birthdayPatients.filter((p) =>
    isBirthdayMatch(
      p.patientInfo?.dob,
      tomorrow
    )
  );

const dayAfterTomorrowBirthdays =
  birthdayPatients.filter((p) =>
    isBirthdayMatch(
      p.patientInfo?.dob,
      dayAfterTomorrow
    )
  );



  const BirthdayCard = ({
  patient,
  color,
}) => (
  <div
    style={{
      background: "#fff",
      borderRadius: "14px",
      padding: "14px",
      marginBottom: "10px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      border: "1px solid #e2e8f0",
      boxShadow:
        "0 2px 8px rgba(0,0,0,.05)",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
      }}
    >
      <div
        style={{
          width: "15px",
          height: "15px",
          borderRadius: "50%",
          background: color,
        }}
      />

      <div>
        <div
          style={{
            fontWeight: 600,
            color: "#0f172a",
          }}
        >
          {patient.patientInfo?.name}
        </div>

        <div
          style={{
            color: "#64748b",
            fontSize: "13px",
          }}
        >
          🎂 {patient.patientInfo?.dob}
        </div>
      </div>
    </div>

    <button
      onClick={() =>
        sendBirthdayWish(patient)
      }
      style={{
        background: "#25D366",
        color: "#fff",
        border: "none",
        borderRadius: "8px",
        padding: "8px 12px",
        cursor: "pointer",
        fontWeight: "600",
      }}
    >
      {patient.patientInfo?.contactNo}
    </button>
  </div>
);





/////////////////////////////////// Add Eye Camp ////////////////////////////////////

// Add these state variables at the top of your component with other states
const [eyeCampName, setEyeCampName] = useState('');
const [eyeCampCity, setEyeCampCity] = useState('');
const [addingEyeCamp, setAddingEyeCamp] = useState(false);

// Function to add eye camp
const handleAddEyeCamp = async () => {
  // Validation
  if (!eyeCampName.trim()) {
    alert("Please enter Eye Camp Name");
    return;
  }
  
  if (!eyeCampCity.trim()) {
    alert("Please enter City");
    return;
  }

  setAddingEyeCamp(true);
  
  try {
    // Create eye camp object
    const eyeCampData = {
      name: eyeCampName.trim(),
      city: eyeCampCity.trim(),
      createdAt: new Date(),
      updatedAt: new Date(),
      status: "active"
    };
    
    // Save to Firestore
    const docRef = await addDoc(collection(db, "eye_camps"), eyeCampData);
    
    console.log("Eye Camp added with ID: ", docRef.id);
    alert("Eye Camp added successfully!");
    
    // Clear form
    handleClearEyeCamp();
    
  } catch (error) {
    console.error("Error adding eye camp:", error);
    alert("Error adding eye camp: " + error.message);
  } finally {
    setAddingEyeCamp(false);
  }
};

// Function to clear form
const handleClearEyeCamp = () => {
  setEyeCampName('');
  setEyeCampCity('');
};




/////////////////////////////////////////////////// view  eye camp ////////////////////////


/////////////////////////////////////////////////// view eye camp ////////////////////////

const fetchEyeCamps = async () => {
  try {
    const snapshot = await getDocs(collection(db, "eye_camps"));
    const camps = snapshot.docs.map(doc => ({
      id: doc.id,
      name: doc.data().name,
      city: doc.data().city
    }));
    setEyeCamps(camps);
  } catch (error) {
    console.error("Error fetching eye camps:", error);
    showErrorMessage("Failed to load eye camps");
  }
};

useEffect(() => {
  fetchEyeCamps();
}, []);

const filteredCamps = eyeCamps.filter(camp => 
  camp.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  camp.city.toLowerCase().includes(searchTerm.toLowerCase())
);

// Handle edit eye camp
const handleEditEyeCamp = (camp) => {
  setEditingEyeCampId(camp.id);
  setEditEyeCampForm({
    name: camp.name || '',
    city: camp.city || ''
  });
};

// Handle edit form changes
const handleEditEyeCampChange = (event) => {
  const { name, value } = event.target;
  setEditEyeCampForm(prev => ({
    ...prev,
    [name]: value
  }));
};

// Handle save eye camp edit
const handleSaveEyeCampEdit = async (campId) => {
  try {
    const campRef = doc(db, 'eye_camps', campId);
    await updateDoc(campRef, {
      name: editEyeCampForm.name,
      city: editEyeCampForm.city,
      updatedAt: new Date().toISOString()
    });
    
    showSuccessMessage('Eye camp updated successfully!');
    setEditingEyeCampId(null);
    setEditEyeCampForm({ name: '', city: '' });
    await fetchEyeCamps();
  } catch (error) {
    console.error('Error updating eye camp:', error);
    showErrorMessage('Failed to update eye camp');
  }
};

// Handle delete eye camp
const handleDeleteEyeCamp = (campId) => {
  const enteredPassword = prompt('Enter admin password to delete:');
  
  if (enteredPassword === null) return;
  
  if (enteredPassword === 'rayban@142') {
    deleteEyeCampConfirm(campId);
  } else {
    showErrorMessage('Incorrect password. Delete cancelled.');
  }
};

// Confirm delete eye camp
const deleteEyeCampConfirm = async (campId) => {
  try {
    const campRef = doc(db, 'eye_camps', campId);
    await deleteDoc(campRef);
    showSuccessMessage('Eye camp deleted successfully!');
    await fetchEyeCamps();
  } catch (error) {
    console.error('Error deleting eye camp:', error);
    showErrorMessage('Failed to delete eye camp');
  }
};

// Reset edit mode
const resetEyeCampEditMode = () => {
  setEditingEyeCampId(null);
  setEditEyeCampForm({ name: '', city: '' });
};

// Add these states with other states
const [editingEyeCampId, setEditingEyeCampId] = useState(null);
const [editEyeCampForm, setEditEyeCampForm] = useState({
  name: '',
  city: ''
});








/////////////////////////////////////// fetch direct sale ///////////////////////////////////////////////////////////////////

const [directSaleInvoices, setDirectSaleInvoices] = useState([]);
const [invoiceSearch, setInvoiceSearch] = useState("");


const fetchDirectSaleInvoices = async () => {
  try {
const q = query(
  collection(db, "invoices"),
  where("type", "==", "direct-sale"),
  orderBy("createdAt", "desc")
);

    const snapshot = await getDocs(q);

    const invoices = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    setDirectSaleInvoices(invoices);

  } catch (error) {
    console.log(error);
  }
};


const filteredDirectSaleInvoices = directSaleInvoices.filter((invoice) => {
  const invoiceNo = (invoice.invoiceNumber || "")
    .replace("INV-", "")
    .toLowerCase();

  const search = invoiceSearch
    .replace("INV-", "")
    .toLowerCase();

  return invoiceNo.includes(search);
});


useEffect(() => {
  if (selectedOption === "downloadDirectSaleInvoice") {
    fetchDirectSaleInvoices();
  }
}, [selectedOption]);




const handleViewInvoice = (invoice) => {
  setSelectedInvoice(invoice);
};


















///////////////////////////////// download service invoice //////////////////////////


const [serviceInvoices, setServiceInvoices] = useState([]);
const [serviceInvoiceSearch, setServiceInvoiceSearch] = useState("");




const fetchServiceInvoices = async () => {
  try {
    const q = query(
      collection(db, "invoices"),
      where("type", "==", "service-invoice")
    );

    const snapshot = await getDocs(q);

    const invoices = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    setServiceInvoices(invoices);

  } catch (error) {
    console.log(error);
  }
};

useEffect(() => {
  if (selectedOption === "downloadServiceInvoice") {
    fetchServiceInvoices();
  }
}, [selectedOption]);





const filteredServiceInvoices = serviceInvoices.filter((invoice) => {
  const invoiceNo = (invoice.invoiceNumber || "")
    .replace("INV-", "")
    .toLowerCase();

  const search = serviceInvoiceSearch
    .replace("INV-", "")
    .toLowerCase();

  return invoiceNo.includes(search);
});











///////////////////////////////// Download main invoice //////////////////////////

// Add these state variables with your other states
const [mainInvoices, setMainInvoices] = useState([]);
const [mainInvoiceSearch, setMainInvoiceSearch] = useState("");

// Add this function with your other fetch functions
const fetchMainInvoices = async () => {
  try {
    const q = query(
      collection(db, "invoices"),
      where("type", "==", "main-invoice")
    );

    const snapshot = await getDocs(q);

    const invoices = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    // Sort by createdAt descending (newest first)
    invoices.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    setMainInvoices(invoices);
    console.log("Fetched main invoices:", invoices.length); // Debug log

  } catch (error) {
    console.error("Error fetching main invoices:", error);
  }
};

// Add this filtered logic
const filteredMainInvoices = mainInvoices.filter((invoice) => {
  const invoiceNo = (invoice.invoiceNumber || "")
    .replace("INV-", "")
    .toLowerCase();

  const search = mainInvoiceSearch
    .replace("INV-", "")
    .toLowerCase();

  return invoiceNo.includes(search);
});

// Add this to your existing useEffect
useEffect(() => {
  if (selectedOption === "downloadServiceInvoice") {
    fetchServiceInvoices();
  }
  if (selectedOption === "downloadMainInvoice") {
    fetchMainInvoices();
  }
}, [selectedOption]);








//////////////////////////////////////// add doctors ////////////////////////////////////

 const [doctorFormData, setDoctorFormData] = useState({
    drName: '',
    contactNo: '',
    address: '',
    channelingCharge: '',
    practice: 'Specific'
  });


  const [successMsg, setSuccessMsg] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  // Use a unique name for the change handler
  const handleDoctorChange = (e) => {
    const { name, value } = e.target;
    setDoctorFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  // Use a unique name for the submit handler
  const handleDoctorSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setSuccessMsg('');
    setErrorMsg('');

    try {
      const docRef = await addDoc(collection(db, 'doctors'), {
        drName: doctorFormData.drName,
        contactNo: doctorFormData.contactNo,
        address: doctorFormData.address,
        channelingCharge: parseFloat(doctorFormData.channelingCharge) || 0,
        practice: doctorFormData.practice,
        createdAt: new Date().toISOString()
      });

      console.log('Doctor added with ID: ', docRef.id);
      setSuccessMsg('Doctor added successfully!');
      
      setDoctorFormData({
        drName: '',
        contactNo: '',
        address: '',
        channelingCharge: '',
        practice: 'Specific'
      });

    } catch (error) {
      console.error('Error adding doctor: ', error);
      setErrorMsg('Failed to add doctor. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };












  /////////////////////////////////// manage doctors  //////////////////////////////////////////

  // State variables with unique names
  const [doctorList, setDoctorList] = useState([]);
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [editingDoctorId, setEditingDoctorId] = useState(null);
  const [editDoctorForm, setEditDoctorForm] = useState({
    doctorName: '',
    doctorContact: '',
    doctorAddress: '',
    doctorCharge: '',
    doctorPractice: ''
  });
  const [successNotification, setSuccessNotification] = useState('');
  const [errorNotification, setErrorNotification] = useState('');
  const [deleteConfirmationId, setDeleteConfirmationId] = useState(null);

  // Admin password constant
  const ADMIN_PASSWORD = 'rayban@142';

  // Function to fetch all doctors from Firestore
  const fetchAllDoctorsData = async () => {
    try {
      const doctorsCollection = collection(db, 'doctors');
      const doctorsQuery = query(doctorsCollection, orderBy('createdAt', 'desc'));
      const doctorsSnapshot = await getDocs(doctorsQuery);
      
      const doctorsList = doctorsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      return doctorsList;
    } catch (error) {
      console.error('Error in fetchAllDoctorsData:', error);
      throw error;
    }
  };

  // Function to update doctor data
  const updateDoctorDataInFirestore = async (doctorId, updatedData) => {
    try {
      const doctorRef = doc(db, 'doctors', doctorId);
      await updateDoc(doctorRef, updatedData);
    } catch (error) {
      console.error('Error in updateDoctorDataInFirestore:', error);
      throw error;
    }
  };

  // Function to delete doctor data
  const deleteDoctorDataFromFirestore = async (doctorId) => {
    try {
      const doctorRef = doc(db, 'doctors', doctorId);
      await deleteDoc(doctorRef);
    } catch (error) {
      console.error('Error in deleteDoctorDataFromFirestore:', error);
      throw error;
    }
  };

  // Function to validate admin password
  const validateAdminPassword = (enteredPassword) => {
    return enteredPassword === ADMIN_PASSWORD;
  };

  // Load doctors on component mount
  useEffect(() => {
    loadAllDoctors();
  }, []);

  // Function to load all doctors
  const loadAllDoctors = async () => {
    try {
      setIsLoadingData(true);
      const doctorsData = await fetchAllDoctorsData();
      setDoctorList(doctorsData);
      showSuccessMessage('Doctors loaded successfully!');
    } catch (error) {
      console.error('Error loading doctors:', error);
      showErrorMessage('Failed to load doctors. Please try again.');
    } finally {
      setIsLoadingData(false);
    }
  };

  // Handle edit button click
  const handleEditDoctorClick = (doctor) => {
    setEditingDoctorId(doctor.id);
    setEditDoctorForm({
      doctorName: doctor.drName || '',
      doctorContact: doctor.contactNo || '',
      doctorAddress: doctor.address || '',
      doctorCharge: doctor.channelingCharge || '',
      doctorPractice: doctor.practice || ''
    });
  };

  // Handle edit form field changes
  const handleEditDoctorChange = (event) => {
    const { name, value } = event.target;
    setEditDoctorForm(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  // Handle save edited doctor
  const handleSaveDoctorEdit = async (doctorId) => {
    try {
      const updatedData = {
        drName: editDoctorForm.doctorName,
        contactNo: editDoctorForm.doctorContact,
        address: editDoctorForm.doctorAddress,
        channelingCharge: parseFloat(editDoctorForm.doctorCharge) || 0,
        practice: editDoctorForm.doctorPractice,
        updatedAt: new Date().toISOString()
      };

      await updateDoctorDataInFirestore(doctorId, updatedData);
      showSuccessMessage('Doctor updated successfully!');
      
      // Refresh the list and reset edit mode
      await loadAllDoctors();
      resetEditMode();
    } catch (error) {
      console.error('Error updating doctor:', error);
      showErrorMessage('Failed to update doctor. Please try again.');
    }
  };

  // Handle delete button click
  const handleDeleteDoctorClick = (doctorId) => {
    setDeleteConfirmationId(doctorId);
    handleDeleteDoctorConfirm(doctorId);
  };

  // Handle delete confirmation with password
  const handleDeleteDoctorConfirm = async (doctorId) => {
    const enteredPassword = prompt('Enter admin password to delete:');
    
    if (enteredPassword === null) {
      setDeleteConfirmationId(null);
      return;
    }

    const isValidPassword = validateAdminPassword(enteredPassword);
    
    if (isValidPassword) {
      try {
        await deleteDoctorDataFromFirestore(doctorId);
        showSuccessMessage('Doctor deleted successfully!');
        await loadAllDoctors();
        setDeleteConfirmationId(null);
      } catch (error) {
        console.error('Error deleting doctor:', error);
        showErrorMessage('Failed to delete doctor. Please try again.');
      }
    } else {
      showErrorMessage('Incorrect password. Delete cancelled.');
      setDeleteConfirmationId(null);
    }
  };

  // Reset edit mode
  const resetEditMode = () => {
    setEditingDoctorId(null);
    setEditDoctorForm({
      doctorName: '',
      doctorContact: '',
      doctorAddress: '',
      doctorCharge: '',
      doctorPractice: ''
    });
  };

  // Show success message
  const showSuccessMessage = (message) => {
    setSuccessNotification(message);
    setTimeout(() => setSuccessNotification(''), 3000);
  };

  // Show error message
  const showErrorMessage = (message) => {
    setErrorNotification(message);
    setTimeout(() => setErrorNotification(''), 3000);
  };




///////////////////////////////////// Add Sales Person  //////////////////////////////////////////////////

  // State with unique names to avoid conflicts
  const [salespersonFormData, setSalespersonFormData] = useState({
    salespersonName: '',
    joinDate: '',
    salespersonCode: '',
    salespersonEmail: '',
    salespersonPhone: '',
    salespersonStatus: 'Active'
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // Handle form field changes
  const handleSalespersonChange = (e) => {
    const { name, value } = e.target;
    setSalespersonFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Generate random salesperson code
  const generateSalespersonCode = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let code = 'SP-';
    for (let i = 0; i < 8; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setSalespersonFormData(prev => ({
      ...prev,
      salespersonCode: code
    }));
  };

  // Handle form submission
  const handleSalespersonSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSuccessMsg('');
    setErrorMsg('');

    // Validation
    if (!salespersonFormData.salespersonName.trim()) {
      setErrorMsg('Salesperson name is required.');
      setIsSubmitting(false);
      return;
    }

    if (!salespersonFormData.joinDate) {
      setErrorMsg('Join date is required.');
      setIsSubmitting(false);
      return;
    }

    if (!salespersonFormData.salespersonCode.trim()) {
      setErrorMsg('Salesperson code is required.');
      setIsSubmitting(false);
      return;
    }

    try {
      // Add salesperson data to Firestore
      const docRef = await addDoc(collection(db, 'salespersons'), {
        salespersonName: salespersonFormData.salespersonName,
        joinDate: salespersonFormData.joinDate,
        salespersonCode: salespersonFormData.salespersonCode,
        salespersonEmail: salespersonFormData.salespersonEmail || '',
        salespersonPhone: salespersonFormData.salespersonPhone || '',
        salespersonStatus: salespersonFormData.salespersonStatus || 'Active',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      });

      console.log('Salesperson added with ID: ', docRef.id);
      setSuccessMsg('Salesperson added successfully!');
      
      // Reset form
      setSalespersonFormData({
        salespersonName: '',
        joinDate: '',
        salespersonCode: '',
        salespersonEmail: '',
        salespersonPhone: '',
        salespersonStatus: 'Active'
      });

      // Auto-generate new code for next entry
      generateSalespersonCode();

    } catch (error) {
      console.error('Error adding salesperson: ', error);
      setErrorMsg('Failed to add salesperson. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };





///////////////////////////////////////// manage sales Person /////////////////////////////////////////
  // State variables with unique names
  const [salespersonList, setSalespersonList] = useState([]);
  const [editingSalespersonId, setEditingSalespersonId] = useState(null);
  const [editSalespersonForm, setEditSalespersonForm] = useState({
    salespersonName: '',
    joinDate: '',
    salespersonCode: '',
    salespersonEmail: '',
    salespersonPhone: '',
    salespersonStatus: ''
  });



  // Function to fetch all salespersons from Firestore
  const fetchAllSalespersonsData = async () => {
    try {
      const salespersonsCollection = collection(db, 'salespersons');
      const salespersonsQuery = query(salespersonsCollection, orderBy('createdAt', 'desc'));
      const salespersonsSnapshot = await getDocs(salespersonsQuery);
      
      const salespersonsList = salespersonsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      return salespersonsList;
    } catch (error) {
      console.error('Error in fetchAllSalespersonsData:', error);
      throw error;
    }
  };

  // Function to update salesperson data
  const updateSalespersonDataInFirestore = async (salespersonId, updatedData) => {
    try {
      const salespersonRef = doc(db, 'salespersons', salespersonId);
      await updateDoc(salespersonRef, updatedData);
    } catch (error) {
      console.error('Error in updateSalespersonDataInFirestore:', error);
      throw error;
    }
  };

  // Function to delete salesperson data
  const deleteSalespersonDataFromFirestore = async (salespersonId) => {
    try {
      const salespersonRef = doc(db, 'salespersons', salespersonId);
      await deleteDoc(salespersonRef);
    } catch (error) {
      console.error('Error in deleteSalespersonDataFromFirestore:', error);
      throw error;
    }
  };



  // Load salespersons on component mount
  useEffect(() => {
    loadAllSalespersons();
  }, []);

  // Function to load all salespersons
  const loadAllSalespersons = async () => {
    try {
      setIsLoadingData(true);
      const salespersonsData = await fetchAllSalespersonsData();
      setSalespersonList(salespersonsData);
      showSuccessMessage('Salespersons loaded successfully!');
    } catch (error) {
      console.error('Error loading salespersons:', error);
      showErrorMessage('Failed to load salespersons. Please try again.');
    } finally {
      setIsLoadingData(false);
    }
  };

  // Handle edit button click
  const handleEditSalespersonClick = (salesperson) => {
    setEditingSalespersonId(salesperson.id);
    setEditSalespersonForm({
      salespersonName: salesperson.salespersonName || '',
      joinDate: salesperson.joinDate || '',
      salespersonCode: salesperson.salespersonCode || '',
      salespersonEmail: salesperson.salespersonEmail || '',
      salespersonPhone: salesperson.salespersonPhone || '',
      salespersonStatus: salesperson.salespersonStatus || 'Active'
    });
  };

  // Handle edit form field changes
  const handleEditSalespersonChange = (event) => {
    const { name, value } = event.target;
    // Don't allow editing of salespersonCode
    if (name === 'salespersonCode') return;
    
    setEditSalespersonForm(prevState => ({
      ...prevState,
      [name]: value
    }));
  };



  // Handle save edited salesperson
// Handle save edited salesperson
const handleSaveSalespersonEdit = async (salespersonId) => {
  try {
    const updatedData = {
      salespersonName: editSalespersonForm.salespersonName,
      joinDate: editSalespersonForm.joinDate,
      salespersonEmail: editSalespersonForm.salespersonEmail,
      salespersonPhone: editSalespersonForm.salespersonPhone,
      salespersonStatus: editSalespersonForm.salespersonStatus,
      updatedAt: new Date().toISOString()
    };

    await updateSalespersonDataInFirestore(salespersonId, updatedData);
    showSuccessMessage('Salesperson updated successfully!');
    
    // Use the unique name
    resetSalespersonEditMode();
    
    // Refresh the list
    await loadAllSalespersons();
    
  } catch (error) {
    console.error('Error updating salesperson:', error);
    showErrorMessage('Failed to update salesperson. Please try again.');
  }
};









  // Handle delete button click
  const handleDeleteSalespersonClick = (salespersonId) => {
    setDeleteConfirmationId(salespersonId);
    handleDeleteSalespersonConfirm(salespersonId);
  };

  // Handle delete confirmation with password
  const handleDeleteSalespersonConfirm = async (salespersonId) => {
    const enteredPassword = prompt('Enter admin password to delete:');
    
    if (enteredPassword === null) {
      setDeleteConfirmationId(null);
      return;
    }

    const isValidPassword = validateAdminPassword(enteredPassword);
    
    if (isValidPassword) {
      try {
        await deleteSalespersonDataFromFirestore(salespersonId);
        showSuccessMessage('Salesperson deleted successfully!');
        await loadAllSalespersons();
        setDeleteConfirmationId(null);
      } catch (error) {
        console.error('Error deleting salesperson:', error);
        showErrorMessage('Failed to delete salesperson. Please try again.');
      }
    } else {
      showErrorMessage('Incorrect password. Delete cancelled.');
      setDeleteConfirmationId(null);
    }
  };



  
// Add this state at the top with other states
const [showCodeInTable, setShowCodeInTable] = useState({});

// Add this function to mask the code
const maskCode = (code) => {
  if (!code) return '●●●●●●●●';
  return '●'.repeat(Math.min(code.length, 8));
};


 
// Reset edit mode - use a unique name
const resetSalespersonEditMode = () => {
  setEditingSalespersonId(null);
  setEditSalespersonForm({
    salespersonName: '',
    joinDate: '',
    salespersonCode: '',
    salespersonEmail: '',
    salespersonPhone: '',
    salespersonStatus: ''
  });
};




///////////////////////////////////////////// create appointment /////////////////////////////////////////////////////

const [appointmentFormData, setAppointmentFormData] = useState({
  appointmentNo: '',
  patientName: '',
  patientContact: '',
  appointmentDate: '',
  appointmentTime: '',
  referredBy: '',
  remark: ''
});
const [doctorListData, setDoctorListData] = useState([]);
const [isSubmittingAppointment, setIsSubmittingAppointment] = useState(false);
const [appointmentSuccessMsg, setAppointmentSuccessMsg] = useState('');
const [appointmentErrorMsg, setAppointmentErrorMsg] = useState('');

// Fetch doctors for referral list
const fetchDoctorListData = async () => {
  try {
    const doctorsCollection = collection(db, 'doctors');
    const doctorsSnapshot = await getDocs(doctorsCollection);
    const doctors = doctorsSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    setDoctorListData(doctors);
  } catch (error) {
    console.error('Error fetching doctors:', error);
    setAppointmentErrorMsg('Failed to load doctors list');
  }
};

// Handle form changes
const handleAppointmentFormChange = (e) => {
  const { name, value } = e.target;
  setAppointmentFormData(prev => ({
    ...prev,
    [name]: value
  }));
};

// Handle form submit
const handleAppointmentFormSubmit = async (e) => {
  e.preventDefault();
  setIsSubmittingAppointment(true);
  setAppointmentSuccessMsg('');
  setAppointmentErrorMsg('');

  // Validation
  if (!appointmentFormData.appointmentNo.trim()) {
    setAppointmentErrorMsg('Please enter appointment number');
    setIsSubmittingAppointment(false);
    return;
  }
  if (!appointmentFormData.patientName.trim()) {
    setAppointmentErrorMsg('Please enter patient name');
    setIsSubmittingAppointment(false);
    return;
  }
  if (!appointmentFormData.patientContact.trim()) {
    setAppointmentErrorMsg('Please enter patient contact number');
    setIsSubmittingAppointment(false);
    return;
  }
  if (!appointmentFormData.appointmentDate) {
    setAppointmentErrorMsg('Please select appointment date');
    setIsSubmittingAppointment(false);
    return;
  }
  if (!appointmentFormData.appointmentTime) {
    setAppointmentErrorMsg('Please select appointment time');
    setIsSubmittingAppointment(false);
    return;
  }
  if (!appointmentFormData.referredBy) {
    setAppointmentErrorMsg('Please select a doctor');
    setIsSubmittingAppointment(false);
    return;
  }

  try {
    // Get selected doctor name
    const selectedDoctor = doctorListData.find(doc => doc.id === appointmentFormData.referredBy);
    
    await addDoc(collection(db, 'appointments'), {
      appointmentNo: appointmentFormData.appointmentNo,
      patientName: appointmentFormData.patientName,
      patientContact: appointmentFormData.patientContact,
      appointmentDate: appointmentFormData.appointmentDate,
      appointmentTime: appointmentFormData.appointmentTime,
      referredBy: appointmentFormData.referredBy,
      referredByName: selectedDoctor ? selectedDoctor.drName : '',
      remark: appointmentFormData.remark || '',
      status: 'Scheduled',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    });

    setAppointmentSuccessMsg(`Appointment #${appointmentFormData.appointmentNo} created successfully!`);
    
    // Reset form after successful submission
    setAppointmentFormData({
      appointmentNo: '',
      patientName: '',
      patientContact: '',
      appointmentDate: '',
      appointmentTime: '',
      referredBy: '',
      remark: ''
    });

  } catch (error) {
    console.error('Error creating appointment:', error);
    setAppointmentErrorMsg('Failed to create appointment. Please try again.');
  } finally {
    setIsSubmittingAppointment(false);
  }
};

// Reset form
const resetAppointmentFormData = () => {
  setAppointmentFormData({
    appointmentNo: '',
    patientName: '',
    patientContact: '',
    appointmentDate: '',
    appointmentTime: '',
    referredBy: '',
    remark: ''
  });
  setAppointmentSuccessMsg('');
  setAppointmentErrorMsg('');
};


useEffect(() => {
  fetchDoctorListData();
}, []);




/////////////////////////////////////////////////  manage view appointments //////////////////////////////////////////
// Add these states with your other states
const [appointmentDateFrom, setAppointmentDateFrom] = useState('');
const [appointmentDateTo, setAppointmentDateTo] = useState('');
const [appointmentFilterDoctor, setAppointmentFilterDoctor] = useState(''); // New state for doctor filter
const [appointmentDataList, setAppointmentDataList] = useState([]);
const [isAppointmentLoading, setIsAppointmentLoading] = useState(true);
const [appointmentCurrentPage, setAppointmentCurrentPage] = useState(1);
const [appointmentTotalPages, setAppointmentTotalPages] = useState(0);
const [appointmentEditingId, setAppointmentEditingId] = useState(null);
const [appointmentEditForm, setAppointmentEditForm] = useState({
  patientName: '',
  patientContact: '',
  appointmentDate: '',
  appointmentTime: '',
  referredBy: '',
  referredByName: '',
  remark: ''
});
const [appointmentDoctorList, setAppointmentDoctorList] = useState([]);
const [appointmentSearchTerm, setAppointmentSearchTerm] = useState('');
const [appointmentDateFilter, setAppointmentDateFilter] = useState('today'); // 'today', 'all', 'custom'
const [appointmentGroupedData, setAppointmentGroupedData] = useState({});

const APPOINTMENT_ITEMS_PER_PAGE = 50;
const APPOINTMENT_ADMIN_PASSWORD = 'rayban@142';

// Fetch doctors for referral list
const fetchAppointmentDoctors = async () => {
  try {
    const doctorsCollection = collection(db, 'doctors');
    const doctorsSnapshot = await getDocs(doctorsCollection);
    const doctors = doctorsSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    setAppointmentDoctorList(doctors);
  } catch (error) {
    console.error('Error fetching doctors:', error);
  }
};

// Modified fetchAppointmentData with date filtering and doctor filter
const fetchAppointmentData = async (page = 1, dateFrom = null, dateTo = null, doctorId = null) => {
  try {
    setIsAppointmentLoading(true);
    const appointmentsCollection = collection(db, 'appointments');
    
    let constraints = [orderBy('appointmentDate', 'desc')];
    
    if (dateFrom) {
      constraints.push(where('appointmentDate', '>=', dateFrom));
    }
    if (dateTo) {
      constraints.push(where('appointmentDate', '<=', dateTo));
    }
    if (doctorId) {
      constraints.push(where('referredBy', '==', doctorId));
    }
    
    const countQuery = query(appointmentsCollection, ...constraints);
    const totalSnapshot = await getDocs(countQuery);
    const totalCount = totalSnapshot.size;
    setAppointmentTotalPages(Math.ceil(totalCount / APPOINTMENT_ITEMS_PER_PAGE));
    
    constraints.push(limit(APPOINTMENT_ITEMS_PER_PAGE));
    
    let q;
    if (page === 1) {
      q = query(appointmentsCollection, ...constraints);
    } else {
      const previousConstraints = [...constraints];
      previousConstraints.pop();
      previousConstraints.push(limit((page - 1) * APPOINTMENT_ITEMS_PER_PAGE));
      
      const previousPageQuery = query(appointmentsCollection, ...previousConstraints);
      const previousSnapshot = await getDocs(previousPageQuery);
      
      if (previousSnapshot.docs.length === 0) {
        q = query(appointmentsCollection, ...constraints);
      } else {
        const lastVisible = previousSnapshot.docs[previousSnapshot.docs.length - 1];
        const paginationConstraints = [...constraints];
        paginationConstraints.pop();
        paginationConstraints.push(startAfter(lastVisible));
        paginationConstraints.push(limit(APPOINTMENT_ITEMS_PER_PAGE));
        q = query(appointmentsCollection, ...paginationConstraints);
      }
    }

    const snapshot = await getDocs(q);
    const appointments = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));

    setAppointmentDataList(appointments);
  } catch (error) {
    console.error('Error fetching appointments:', error);
    setAppointmentErrorMsg('Failed to load appointments');
  } finally {
    setIsAppointmentLoading(false);
  }
};








// Group appointments by doctor
const groupAppointmentsByDoctor = (appointments) => {
  const grouped = {};
  appointments.forEach(app => {
    const doctorName = app.referredByName || 'Unassigned';
    if (!grouped[doctorName]) {
      grouped[doctorName] = [];
    }
    grouped[doctorName].push(app);
  });
  setAppointmentGroupedData(grouped);
};

// Load today's appointments by default
const loadTodayAppointments = async () => {
  const today = new Date().toISOString().split('T')[0];
  setAppointmentDateFrom(today);
  setAppointmentDateTo(today);
  setAppointmentDateFilter('today');
  setAppointmentFilterDoctor('');
  await fetchAppointmentData(1, today, today, null);
};

// Function to apply date filters
const applyDateFilter = () => {
  setAppointmentCurrentPage(1);
  setAppointmentDateFilter('custom');
  const doctorId = appointmentFilterDoctor || null;
  fetchAppointmentData(1, appointmentDateFrom || null, appointmentDateTo || null, doctorId);
};

// Function to apply doctor filter
const applyDoctorFilter = (doctorId) => {
  setAppointmentFilterDoctor(doctorId);
  setAppointmentCurrentPage(1);
  const dateFrom = appointmentDateFrom || null;
  const dateTo = appointmentDateTo || null;
  fetchAppointmentData(1, dateFrom, dateTo, doctorId || null);
};

// Function to clear date filters
const clearDateFilter = () => {
  setAppointmentDateFrom('');
  setAppointmentDateTo('');
  setAppointmentFilterDoctor('');
  setAppointmentCurrentPage(1);
  setAppointmentDateFilter('all');
  fetchAppointmentData(1, null, null, null);
};

// Load initial data - show today's appointments
useEffect(() => {
  fetchAppointmentDoctors();
  loadTodayAppointments();
}, []);

// Export to Excel
const exportAppointmentToExcel = () => {
  try {
    const dataToExport = appointmentDataList.map((app, index) => ({
      'SL No': index + 1,
      'Appointment No': app.appointmentNo || '',
      'Patient Name': app.patientName || '',
      'Contact': app.patientContact || '',
      'Date': app.appointmentDate || '',
      'Time': app.appointmentTime || '',
      'Doctor': app.referredByName || '',
      'Remark': app.remark || '',
      'Status': app.status || 'Scheduled'
    }));

    const ws = XLSX.utils.json_to_sheet(dataToExport);
    
    // Auto column widths
    const colWidths = [
      { wch: 8 },  // SL No
      { wch: 18 }, // Appointment No
      { wch: 25 }, // Patient Name
      { wch: 15 }, // Contact
      { wch: 15 }, // Date
      { wch: 12 }, // Time
      { wch: 20 }, // Doctor
      { wch: 25 }, // Remark
      { wch: 12 }  // Status
    ];
    ws['!cols'] = colWidths;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Appointments');
    
    // Generate filename with date range
    let filename = 'Appointments_';
    if (appointmentDateFrom && appointmentDateTo) {
      filename += `${appointmentDateFrom}_to_${appointmentDateTo}`;
    } else {
      filename += new Date().toISOString().split('T')[0];
    }
    filename += '.xlsx';
    
    XLSX.writeFile(wb, filename);
    setAppointmentSuccessMsg('Excel file exported successfully!');
    setTimeout(() => setAppointmentSuccessMsg(''), 3000);
  } catch (error) {
    console.error('Error exporting to Excel:', error);
    setAppointmentErrorMsg('Failed to export Excel file');
    setTimeout(() => setAppointmentErrorMsg(''), 3000);
  }
};








  // Load initial data
  useEffect(() => {
    fetchAppointmentDoctors();
    fetchAppointmentData(1);
  }, []);

  // Handle edit click
  const handleAppointmentEditClick = (appointment) => {
    setAppointmentEditingId(appointment.id);
    setAppointmentEditForm({
      patientName: appointment.patientName || '',
      patientContact: appointment.patientContact || '',
      appointmentDate: appointment.appointmentDate || '',
      appointmentTime: appointment.appointmentTime || '',
      referredBy: appointment.referredBy || '',
      referredByName: appointment.referredByName || '',
      remark: appointment.remark || ''
    });
  };

  // Handle edit change
  const handleAppointmentEditChange = (e) => {
    const { name, value } = e.target;
    setAppointmentEditForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle save edit
  const handleAppointmentSaveEdit = async (id) => {
    try {
      const selectedDoctor = appointmentDoctorList.find(doc => doc.id === appointmentEditForm.referredBy);
      
      const appointmentRef = doc(db, 'appointments', id);
      await updateDoc(appointmentRef, {
        patientName: appointmentEditForm.patientName,
        patientContact: appointmentEditForm.patientContact,
        appointmentDate: appointmentEditForm.appointmentDate,
        appointmentTime: appointmentEditForm.appointmentTime,
        referredBy: appointmentEditForm.referredBy,
        referredByName: selectedDoctor ? selectedDoctor.drName : '',
        remark: appointmentEditForm.remark || '',
        updatedAt: new Date().toISOString()
      });

      setAppointmentSuccessMsg('Appointment updated successfully!');
      setAppointmentEditingId(null);
      await fetchAppointmentData(appointmentCurrentPage);
      setTimeout(() => setAppointmentSuccessMsg(''), 3000);
    } catch (error) {
      console.error('Error updating appointment:', error);
      setAppointmentErrorMsg('Failed to update appointment');
      setTimeout(() => setAppointmentErrorMsg(''), 3000);
    }
  };

  // Handle delete with password
  const handleAppointmentDelete = (id) => {
    const enteredPassword = prompt('Enter admin password to delete:');
    if (enteredPassword === null) return;
    
    if (enteredPassword === APPOINTMENT_ADMIN_PASSWORD) {
      confirmAppointmentDelete(id);
    } else {
      setAppointmentErrorMsg('Incorrect password. Delete cancelled.');
      setTimeout(() => setAppointmentErrorMsg(''), 3000);
    }
  };

  // Confirm delete
  const confirmAppointmentDelete = async (id) => {
    try {
      await deleteDoc(doc(db, 'appointments', id));
      setAppointmentSuccessMsg('Appointment deleted successfully!');
      await fetchAppointmentData(appointmentCurrentPage);
      setTimeout(() => setAppointmentSuccessMsg(''), 3000);
    } catch (error) {
      console.error('Error deleting appointment:', error);
      setAppointmentErrorMsg('Failed to delete appointment');
      setTimeout(() => setAppointmentErrorMsg(''), 3000);
    }
  };

  const sendAppointmentReminderWhatsApp = (appointment) => {
  // Format phone number properly for WhatsApp
  let phoneNumber = appointment.patientContact || '';
  
  // Remove any non-numeric characters
  phoneNumber = phoneNumber.replace(/\D/g, '');
  
  // If number starts with 0, replace with 94 (Sri Lanka country code)
  if (phoneNumber.startsWith('0')) {
    phoneNumber = '94' + phoneNumber.substring(1);
  }
  
  // If number doesn't start with 94, add it
  if (!phoneNumber.startsWith('94') && phoneNumber.length > 0) {
    phoneNumber = '94' + phoneNumber;
  }
  
  // If no number, use default
  if (!phoneNumber || phoneNumber.length < 10) {
    phoneNumber = '94771234567';
  }

  const message = `*RAY BAN EYE CLINIC - Kiribathgoda* 

Dear Patient, 
This is regarding your appointment reminder.
Your appointment details:

Patient: ${appointment.patientName || '-'}
Date: ${appointment.appointmentDate}
Time: ${appointment.appointmentTime}
Apponiment No: ${appointment.appointmentNo}
Doctor: ${appointment.referredByName || '-'}

Please come on time.

Thank you!
RAY BAN EYE CLINIC 
Kiribathgoda`;

  const encodedMessage = encodeURIComponent(message);
  const url = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  
  // Open in new window
  window.open(url, '_blank');
};

// WhatsApp cancellation message - Simple English with proper formatting
const sendAppointmentCancellationWhatsApp = (appointment) => {
  // Format phone number properly for WhatsApp
  let phoneNumber = appointment.patientContact || '';
  
  // Remove any non-numeric characters
  phoneNumber = phoneNumber.replace(/\D/g, '');
  
  // If number starts with 0, replace with 94 (Sri Lanka country code)
  if (phoneNumber.startsWith('0')) {
    phoneNumber = '94' + phoneNumber.substring(1);
  }
  
  // If number doesn't start with 94, add it
  if (!phoneNumber.startsWith('94') && phoneNumber.length > 0) {
    phoneNumber = '94' + phoneNumber;
  }
  
  // If no number, use default
  if (!phoneNumber || phoneNumber.length < 10) {
    phoneNumber = '94771234567';
  }

  const message = `*RAY BAN EYE CLINIC  - Kiribathgoda*

Dear Patient,

Your appointment has been CANCELLED.

Patient: ${appointment.patientName || '-'}
Date: ${appointment.appointmentDate}
Time: ${appointment.appointmentTime}
Apponiment No: ${appointment.appointmentNo}
Doctor: ${appointment.referredByName || '-'}

Reason: Doctor is not available.

Please contact us to reschedule.

Sorry for the inconvenience.
RAY BAN EYE CLINIC 
Kiribathgoda`;

  const encodedMessage = encodeURIComponent(message);
  const url = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
  
  // Open in new window
  window.open(url, '_blank');
};






  // Page navigation
  const goToAppointmentPage = (page) => {
    if (page >= 1 && page <= appointmentTotalPages) {
      setAppointmentCurrentPage(page);
      fetchAppointmentData(page);
    }
  };

  // Cancel edit
  const cancelAppointmentEdit = () => {
    setAppointmentEditingId(null);
    setAppointmentEditForm({
      patientName: '',
      patientContact: '',
      appointmentDate: '',
      appointmentTime: '',
      referredBy: '',
      referredByName: '',
      remark: ''
    });
  };

  // Filter appointments
  const filteredAppointmentData = appointmentDataList.filter(appointment =>
    appointment.appointmentNo?.includes(appointmentSearchTerm) ||
    appointment.patientName?.toLowerCase().includes(appointmentSearchTerm.toLowerCase()) ||
    appointment.referredByName?.toLowerCase().includes(appointmentSearchTerm.toLowerCase())
  );














/////////////////////////////////// create consultation invoice ray ban clinic  ///////////////////////
// States with unique names
  const [consultationForm, setConsultationForm] = useState({
    billNumber: '',
    salesPerson: '',
    date: '',
    patientName: '',
    appointmentNumber: '',
    consultant: '',
    patientContact: '',
    appointmentTime: '',
    clinicCharge: '',
    doctorFee: '',
    total: ''
  });

  const [salesPersonList, setSalesPersonList] = useState([]);
  const [isSubmittingConsultation, setIsSubmittingConsultation] = useState(false);
  const [consultationSuccessMsg, setConsultationSuccessMsg] = useState('');
  const [consultationErrorMsg, setConsultationErrorMsg] = useState('');
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [isGeneratingBill, setIsGeneratingBill] = useState(false);
  const [counterInitialized, setCounterInitialized] = useState(false);
  const [nextBillNumber, setNextBillNumber] = useState('');

  // Initialize counter with correct starting number
  const initializeCounter = async () => {
    try {
      const counterRef = doc(db, 'counters', 'consultationBillCounter');
      const counterDoc = await getDoc(counterRef);
      
      if (!counterDoc.exists()) {
        // Create counter with starting number 34424 (first invoice will be 34425)
        await setDoc(counterRef, { count: 34424 });
        console.log('Counter initialized with count: 34424');
      } else {
        console.log('Counter exists with count:', counterDoc.data().count);
      }
      return true;
    } catch (error) {
      console.error('Error initializing counter:', error);
      return false;
    }
  };

  // Get the NEXT bill number without incrementing it
  const getNextBillNumber = async () => {
    try {
      const counterRef = doc(db, 'counters', 'consultationBillCounter');
      const counterDoc = await getDoc(counterRef);
      
      let currentCount = 34424;
      if (counterDoc.exists()) {
        currentCount = counterDoc.data().count || 34424;
      }
      
      const nextNumber = currentCount + 1;
      return String(nextNumber).padStart(5, '0');
    } catch (error) {
      console.error('Error getting next bill number:', error);
      const timestamp = Date.now().toString().slice(-5);
      return timestamp.padStart(5, '0');
    }
  };

  // Generate unique bill number ONLY when creating invoice
  const generateUniqueBillNumber = async () => {
    try {
      setIsGeneratingBill(true);
      
      const counterRef = doc(db, 'counters', 'consultationBillCounter');
      
      const newBillNumber = await runTransaction(db, async (transaction) => {
        const counterDoc = await transaction.get(counterRef);
        
        let currentCount = 34424;
        if (counterDoc.exists()) {
          currentCount = counterDoc.data().count || 34424;
        } else {
          transaction.set(counterRef, { count: 34424 });
        }
        
        const newCount = currentCount + 1;
        transaction.set(counterRef, { count: newCount });
        
        return newCount;
      });
      
      return String(newBillNumber).padStart(5, '0');
    } catch (error) {
      console.error('Error generating bill number:', error);
      const timestamp = Date.now().toString().slice(-5);
      return timestamp.padStart(5, '0');
    } finally {
      setIsGeneratingBill(false);
    }
  };

  // Fetch sales persons
  const fetchSalesPersons = async () => {
    try {
      const salesPersonsCollection = collection(db, 'salespersons');
      const salesPersonsSnapshot = await getDocs(salesPersonsCollection);
      const salesPersons = salesPersonsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setSalesPersonList(salesPersons);
    } catch (error) {
      console.error('Error fetching sales persons:', error);
    }
  };

  // Fetch doctors
  const fetchConsultationDoctors = async () => {
    try {
      const doctorsCollection = collection(db, 'doctors');
      const doctorsSnapshot = await getDocs(doctorsCollection);
      const doctors = doctorsSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setDoctorList(doctors);
    } catch (error) {
      console.error('Error fetching doctors:', error);
    }
  };

  // Load initial data - ONLY ONCE - get next bill number without incrementing
  useEffect(() => {
    const loadConsultationData = async () => {
      if (counterInitialized) return;
      
      await initializeCounter();
      await fetchSalesPersons();
      await fetchConsultationDoctors();
      
      // Get next bill number WITHOUT incrementing
      const nextNumber = await getNextBillNumber();
      setNextBillNumber(nextNumber);
      setConsultationForm(prev => ({
        ...prev,
        billNumber: nextNumber,
        date: new Date().toISOString().split('T')[0]
      }));
      
      setCounterInitialized(true);
    };
    loadConsultationData();
  }, [counterInitialized]);

  // Handle form changes
  const handleConsultationChange = (e) => {
    const { name, value } = e.target;
    setConsultationForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Calculate total
  const calculateConsultationTotal = () => {
    const clinicCharge = parseFloat(consultationForm.clinicCharge) || 0;
    const doctorFee = parseFloat(consultationForm.doctorFee) || 0;
    const total = clinicCharge + doctorFee;
    setConsultationForm(prev => ({
      ...prev,
      total: total.toFixed(2)
    }));
  };

  // Auto-calculate on change
  useEffect(() => {
    calculateConsultationTotal();
  }, [consultationForm.clinicCharge, consultationForm.doctorFee]);

  // Generate PDF Invoice with Watermark
  const generateConsultationPDF = (invoiceData) => {
    try {
      setIsGeneratingPDF(true);
      const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a5"
      });

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      let y = 15;

      // WATERMARK
      try {
        const imgProps = doc.getImageProperties("/consultation_watermark.png");
        const watermarkWidth = 120;
        const watermarkHeight = (imgProps.height * watermarkWidth) / imgProps.width;
        const centerX = pageWidth / 2 - watermarkWidth / 2;
        const centerY = pageHeight / 2 - watermarkHeight / 2;
        
        doc.setGState(new doc.GState({ opacity: 0.05 }));
        doc.addImage("/consultation_watermark.png", "PNG", centerX, centerY, watermarkWidth, watermarkHeight);
        doc.setGState(new doc.GState({ opacity: 1 }));
      } catch (watermarkError) {
        console.error("Watermark not found");
      }

      const formatDate = (dateValue) => {
        if (!dateValue) return "-";
        try {
          return new Date(dateValue).toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
          });
        } catch (e) {
          return "Invalid Date";
        }
      };

      const selectedDoctor = doctorList.find(doc => doc.id === consultationForm.consultant);
      const doctorName = selectedDoctor ? selectedDoctor.drName : consultationForm.consultantName || '-';

      // HEADER
      // try {
      //   doc.addImage("/ray-ban-clinic-logo.png", "PNG", 10, y, 35, 35);
      // } catch (logoError) {
      //   console.error("Logo not found");
      // }

      // doc.setFont("Times New Roman", "bold");
      // doc.setFontSize(14);
   

      // doc.setFont("Times New Roman", "normal");
      // doc.setFontSize(8);
      // doc.text("Ray Ban Building, 142, Kandy Road, Dalugama, Kiribathgoda", pageWidth - 10, 27, { align: "right" });
      // doc.text("Hotline: 0767873232 Tel: 0112912333 / 0112914949", pageWidth - 10, 33, { align: "right" });
      // doc.text("Email: info@raybanopticians.com | Web: raybanopticians.com", pageWidth - 10, 39, { align: "right" });

      y = 55;
      doc.setFont("Times New Roman", "bold");
      doc.setFontSize(14);
      doc.text("CONSULTATION INVOICE", pageWidth / 2, y, { align: "center" });

      y += 10;
      doc.setFont("Times New Roman", "normal");
      doc.setFontSize(10);
      doc.text(`Bill No: ${consultationForm.billNumber || '-'}`, 15, y);
      doc.text(`Date: ${formatDate(consultationForm.date)}`, pageWidth - 15, y, { align: "right" });

      y += 8;
      doc.setDrawColor(0);
      doc.setLineWidth(0.5);
      doc.line(15, y, pageWidth - 15, y);

      y += 10;
      doc.setFont("Times New Roman", "bold");
      doc.setFontSize(10);
      doc.text("Served By:", 15, y);
      doc.setFont("Times New Roman", "normal");
      doc.text(consultationForm.salesPerson || "-", 55, y);

      y += 8;
      doc.setFont("Times New Roman", "bold");
      doc.text("Patient Details:", 15, y);

      y += 6;
      doc.setFont("Times New Roman", "normal");
      doc.setFontSize(9);
      doc.text(`Patient Name: ${consultationForm.patientName || "-"}`, 15, y);
      doc.text(`Contact: ${consultationForm.patientContact || "-"}`, pageWidth - 15, y, { align: "right" });

      y += 6;
      doc.text(`Appointment No: ${consultationForm.appointmentNumber || "-"}`, 15, y);
      doc.text(`Time: ${consultationForm.appointmentTime || "-"}`, pageWidth - 15, y, { align: "right" });

      y += 6;
      doc.text(`Consultant: ${doctorName}`, 15, y);

      y += 8;
      doc.line(15, y, pageWidth - 15, y);

      y += 10;
      doc.setFont("Times New Roman", "bold");
      doc.setFontSize(10);
      doc.text("Charges", 15, y);

      y += 6;
      doc.setFont("Times New Roman", "bold");
      doc.setFontSize(9);
      doc.text("Description", 15, y);
      doc.text("Amount (Rs.)", pageWidth - 15, y, { align: "right" });

      y += 4;
      doc.setDrawColor(200);
      doc.setLineWidth(0.3);
      doc.line(15, y, pageWidth - 15, y);

      y += 6;
      doc.setFont("Times New Roman", "normal");
      doc.text("Clinic Charge", 15, y);
      doc.text(consultationForm.clinicCharge || "0.00", pageWidth - 15, y, { align: "right" });

      y += 6;
      doc.text("Doctor's Fee", 15, y);
      doc.text(consultationForm.doctorFee || "0.00", pageWidth - 15, y, { align: "right" });

      y += 6;
      doc.setDrawColor(200);
      doc.setLineWidth(0.3);
      doc.line(15, y, pageWidth - 15, y);

      y += 8;
      doc.setFont("Times New Roman", "bold");
      doc.setFontSize(12);
      doc.text("TOTAL", 15, y);
      const totalAmount = parseFloat(consultationForm.total) || 0;
      doc.text(`Rs. ${totalAmount.toFixed(2)}`, pageWidth - 15, y, { align: "right" });

      y += 15;
      // doc.setFont("Times New Roman", "normal");
      // doc.setFontSize(8);
      // doc.text("Thank you for choosing Ray Ban Eye Clinic", pageWidth / 2, y, { align: "center" });

    

      doc.save(`Consultation_Invoice_${consultationForm.billNumber || '001'}.pdf`);
      setIsGeneratingPDF(false);
    } catch (error) {
      console.error('Error generating PDF:', error);
      setConsultationErrorMsg('Failed to generate PDF');
      setIsGeneratingPDF(false);
    }
  };

  // Handle form submit - ONLY HERE we generate and increment the bill number
  const handleConsultationSubmit = async (e) => {
    e.preventDefault();
    setIsSubmittingConsultation(true);
    setConsultationSuccessMsg('');
    setConsultationErrorMsg('');

    // Validation
    if (!consultationForm.salesPerson) {
      setConsultationErrorMsg('Please select a sales person');
      setIsSubmittingConsultation(false);
      return;
    }
    if (!consultationForm.patientName) {
      setConsultationErrorMsg('Please enter patient name');
      setIsSubmittingConsultation(false);
      return;
    }
    if (!consultationForm.appointmentNumber) {
      setConsultationErrorMsg('Please enter appointment number');
      setIsSubmittingConsultation(false);
      return;
    }
    if (!consultationForm.consultant) {
      setConsultationErrorMsg('Please select a consultant');
      setIsSubmittingConsultation(false);
      return;
    }
    if (!consultationForm.patientContact) {
      setConsultationErrorMsg('Please enter patient contact number');
      setIsSubmittingConsultation(false);
      return;
    }

    try {
      // Generate NEW bill number ONLY when creating invoice
      const newBillNumber = await generateUniqueBillNumber();
      
      // Update form with the new bill number
      const updatedForm = {
        ...consultationForm,
        billNumber: newBillNumber
      };

      const selectedDoctor = doctorList.find(doc => doc.id === consultationForm.consultant);

      // Save to Firestore with the new bill number
      await addDoc(collection(db, 'consultation_invoices'), {
        billNumber: newBillNumber,
        salesPerson: consultationForm.salesPerson,
        date: consultationForm.date,
        patientName: consultationForm.patientName,
        appointmentNumber: consultationForm.appointmentNumber,
        consultant: consultationForm.consultant,
        consultantName: selectedDoctor ? selectedDoctor.drName : '',
        patientContact: consultationForm.patientContact,
        appointmentTime: consultationForm.appointmentTime,
        clinicCharge: parseFloat(consultationForm.clinicCharge) || 0,
        doctorFee: parseFloat(consultationForm.doctorFee) || 0,
        total: parseFloat(consultationForm.total) || 0,
        status: 'Completed',
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      });

      // Generate PDF with the new bill number
      await generateConsultationPDF(updatedForm);

      setConsultationSuccessMsg(`Invoice for Bill #${newBillNumber} created successfully!`);
      
      // Get the NEXT bill number WITHOUT incrementing
      const nextNumber = await getNextBillNumber();
      
      // Reset form with the next number
      const today = new Date().toISOString().split('T')[0];
      setConsultationForm({
        billNumber: nextNumber,
        salesPerson: consultationForm.salesPerson,
        date: today,
        patientName: '',
        appointmentNumber: '',
        consultant: '',
        patientContact: '',
        appointmentTime: '',
        clinicCharge: '',
        doctorFee: '',
        total: ''
      });

    } catch (error) {
      console.error('Error creating consultation invoice:', error);
      setConsultationErrorMsg('Failed to create invoice. Please try again.');
    } finally {
      setIsSubmittingConsultation(false);
    }
  };

  // Reset form
  const resetConsultationForm = async () => {
    const today = new Date().toISOString().split('T')[0];
    setConsultationForm({
      billNumber: nextBillNumber || '',
      salesPerson: consultationForm.salesPerson || '',
      date: today,
      patientName: '',
      appointmentNumber: '',
      consultant: '',
      patientContact: '',
      appointmentTime: '',
      clinicCharge: '',
      doctorFee: '',
      total: ''
    });
    setConsultationSuccessMsg('');
    setConsultationErrorMsg('');
  };












  ///////////////////////////////////////////////////////////// view consultation /////////////////////////////////
   // States with unique names
  const [consultationInvoiceList, setConsultationInvoiceList] = useState([]);
  const [consultationInvoiceSearch, setConsultationInvoiceSearch] = useState('');
  const [isConsultationInvoiceLoading, setIsConsultationInvoiceLoading] = useState(true);
  const [consultationInvoiceSuccessMsg, setConsultationInvoiceSuccessMsg] = useState('');
  const [consultationInvoiceErrorMsg, setConsultationInvoiceErrorMsg] = useState('');
  const [consultationInvoiceFilter, setConsultationInvoiceFilter] = useState('all');
  const [consultationInvoiceDateRange, setConsultationInvoiceDateRange] = useState({
    startDate: '',
    endDate: ''
  });

  const CONSULTATION_ADMIN_PASSWORD = 'rayban@142';

  // Fetch all consultation invoices
  const fetchConsultationInvoices = async () => {
    try {
      setIsConsultationInvoiceLoading(true);
      const invoicesCollection = collection(db, 'consultation_invoices');
      const q = query(invoicesCollection, orderBy('createdAt', 'desc'));
      const snapshot = await getDocs(q);
      
      const invoices = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      setConsultationInvoiceList(invoices);
    } catch (error) {
      console.error('Error fetching consultation invoices:', error);
      setConsultationInvoiceErrorMsg('Failed to load invoices');
    } finally {
      setIsConsultationInvoiceLoading(false);
    }
  };

  // Load initial data
  useEffect(() => {
    fetchConsultationInvoices();
  }, []);

  // Handle delete with password
  const handleConsultationInvoiceDelete = (id) => {
    const enteredPassword = prompt('Enter admin password to delete:');
    if (enteredPassword === null) return;
    
    if (enteredPassword === CONSULTATION_ADMIN_PASSWORD) {
      confirmConsultationInvoiceDelete(id);
    } else {
      setConsultationInvoiceErrorMsg('Incorrect password. Delete cancelled.');
      setTimeout(() => setConsultationInvoiceErrorMsg(''), 3000);
    }
  };

  // Confirm delete
  const confirmConsultationInvoiceDelete = async (id) => {
    try {
      await deleteDoc(doc(db, 'consultation_invoices', id));
      setConsultationInvoiceSuccessMsg('Invoice deleted successfully!');
      await fetchConsultationInvoices();
      setTimeout(() => setConsultationInvoiceSuccessMsg(''), 3000);
    } catch (error) {
      console.error('Error deleting invoice:', error);
      setConsultationInvoiceErrorMsg('Failed to delete invoice');
      setTimeout(() => setConsultationInvoiceErrorMsg(''), 3000);
    }
  };

// Generate Consultation Invoice PDF with Watermark
const generateConsultationInvoicePDF = (invoice) => {
  try {
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a5"
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    let y = 15;

    // Format date
    const formatDate = (dateValue) => {
      if (!dateValue) return "-";
      try {
        return new Date(dateValue).toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        });
      } catch (e) {
        return "Invalid Date";
      }
    };

    // ------------------------------
    // WATERMARK (CENTERED WITH OPACITY)
    // ------------------------------
    try {
      const imgProps = doc.getImageProperties("/consultation_watermark.png");
      const watermarkWidth = 120;
      const watermarkHeight = (imgProps.height * watermarkWidth) / imgProps.width;
      const centerX = pageWidth / 2 - watermarkWidth / 2;
      const centerY = pageHeight / 2 - watermarkHeight / 2;
      
      doc.setGState(new doc.GState({ opacity: 0.05 }));
      doc.addImage("/consultation_watermark.png", "PNG", centerX, centerY, watermarkWidth, watermarkHeight);
      doc.setGState(new doc.GState({ opacity: 1 }));
    } catch (watermarkError) {
      console.error("Watermark not found, continuing without it");
    }

    // ------------------------------
    // HEADER WITH LOGO
    // ------------------------------
    // try {
    //   doc.addImage("/ray-ban-clinic-logo.png", "PNG", 10, y, 35, 35);
    // } catch (logoError) {
    //   console.error("Logo not found, continuing without it");
    // }

    // doc.setFont("Times New Roman", "bold");
    // doc.setFontSize(14);


    // doc.setFont("Times New Roman", "normal");
    // doc.setFontSize(8);
    // doc.text("Ray Ban Building, 142, Kandy Road, Dalugama, Kiribathgoda", pageWidth - 10, 27, { align: "right" });
    // doc.text("Hotline: 0767873232 Tel: 0112912333 / 0112914949", pageWidth - 10, 33, { align: "right" });
    // doc.text("Email: info@raybanopticians.com | Web: raybanopticians.com", pageWidth - 10, 39, { align: "right" });

    // Invoice title
    y = 55;
    doc.setFont("Times New Roman", "bold");
    doc.setFontSize(14);
    doc.text("CONSULTATION INVOICE", pageWidth / 2, y, { align: "center" });

    y += 10;
    doc.setFont("Times New Roman", "normal");
    doc.setFontSize(10);
    doc.text(`Bill No: ${invoice.billNumber || invoice.invoiceNumber || '-'}`, 15, y);
    doc.text(`Date: ${formatDate(invoice.createdAt || invoice.date)}`, pageWidth - 15, y, { align: "right" });

    // Line separator
    y += 8;
    doc.setDrawColor(0);
    doc.setLineWidth(0.5);
    doc.line(15, y, pageWidth - 15, y);

    // ------------------------------
    // SALES PERSON
    // ------------------------------
    y += 10;
    doc.setFont("Times New Roman", "bold");
    doc.setFontSize(10);
    doc.text("Served By:", 15, y);
    doc.setFont("Times New Roman", "normal");
    doc.text(invoice.salesPerson || "-", 55, y);

    // ------------------------------
    // PATIENT DETAILS
    // ------------------------------
    y += 8;
    doc.setFont("Times New Roman", "bold");
    doc.text("Patient Details:", 15, y);

    y += 6;
    doc.setFont("Times New Roman", "normal");
    doc.setFontSize(9);
    doc.text(`Patient Name: ${invoice.patientName || "-"}`, 15, y);
    doc.text(`Contact: ${invoice.patientContact || "-"}`, pageWidth - 15, y, { align: "right" });

    y += 6;
    doc.text(`Appointment No: ${invoice.appointmentNumber || "-"}`, 15, y);
    doc.text(`Time: ${invoice.appointmentTime || "-"}`, pageWidth - 15, y, { align: "right" });

    y += 6;
    doc.text(`Consultant: ${invoice.consultantName || "-"}`, 15, y);

    // Line separator
    y += 8;
    doc.line(15, y, pageWidth - 15, y);

    // ------------------------------
    // CHARGES TABLE
    // ------------------------------
    y += 10;
    doc.setFont("Times New Roman", "bold");
    doc.setFontSize(10);
    doc.text("Charges", 15, y);

    y += 6;
    doc.setFont("Times New Roman", "bold");
    doc.setFontSize(9);
    doc.text("Description", 15, y);
    doc.text("Amount (Rs.)", pageWidth - 15, y, { align: "right" });

    y += 4;
    doc.setDrawColor(200);
    doc.setLineWidth(0.3);
    doc.line(15, y, pageWidth - 15, y);

    y += 6;
    doc.setFont("Times New Roman", "normal");
    doc.text("Clinic Charge", 15, y);
    doc.text((invoice.clinicCharge || 0).toFixed(2), pageWidth - 15, y, { align: "right" });

    y += 6;
    doc.text("Doctor's Fee", 15, y);
    doc.text((invoice.doctorFee || 0).toFixed(2), pageWidth - 15, y, { align: "right" });

    y += 6;
    doc.setDrawColor(200);
    doc.setLineWidth(0.3);
    doc.line(15, y, pageWidth - 15, y);

    // Total
    y += 8;
    doc.setFont("Times New Roman", "bold");
    doc.setFontSize(12);
    doc.text("TOTAL", 15, y);
    const totalAmount = parseFloat(invoice.total) || 0;
    doc.text(`Rs. ${totalAmount.toFixed(2)}`, pageWidth - 15, y, { align: "right" });

    // ------------------------------
    // FOOTER
    // ------------------------------
    y += 15;
    // doc.setFont("Times New Roman", "normal");
    // doc.setFontSize(8);
    // doc.text("Thank you for choosing Ray Ban Eye Clinic", pageWidth / 2, y, { align: "center" });

  

    // Save PDF
    doc.save(`Consultation_Invoice_${invoice.billNumber || invoice.invoiceNumber || '001'}.pdf`);
  } catch (error) {
    console.error('Error generating PDF:', error);
    setConsultationInvoiceErrorMsg('Failed to generate PDF');
    setTimeout(() => setConsultationInvoiceErrorMsg(''), 3000);
  }
};


  // Filter invoices
// Filter invoices - Search by ALL patient data
const filteredConsultationInvoices = consultationInvoiceList.filter(invoice => {
  // Search filter - Search ALL patient related fields
  const searchTerm = consultationInvoiceSearch.toLowerCase();
  const searchMatch = 
    // Patient fields
    invoice.patientName?.toLowerCase().includes(searchTerm) ||
    invoice.patientContact?.includes(consultationInvoiceSearch) ||
    // Bill/Invoice fields
    invoice.billNumber?.toLowerCase().includes(searchTerm) ||
    invoice.invoiceNumber?.toLowerCase().includes(searchTerm) ||
    invoice.appointmentNumber?.toLowerCase().includes(searchTerm) ||
    // Other fields
    invoice.salesPerson?.toLowerCase().includes(searchTerm) ||
    invoice.consultantName?.toLowerCase().includes(searchTerm);
  
  // Date range filter
  let dateMatch = true;
  if (consultationInvoiceDateRange.startDate && consultationInvoiceDateRange.endDate) {
    const invoiceDate = invoice.createdAt ? new Date(invoice.createdAt) : null;
    if (invoiceDate) {
      const start = new Date(consultationInvoiceDateRange.startDate);
      const end = new Date(consultationInvoiceDateRange.endDate);
      end.setHours(23, 59, 59);
      dateMatch = invoiceDate >= start && invoiceDate <= end;
    }
  }
  
  return searchMatch && dateMatch;
});







///////////////////////////////////////////////  consultation sale  /////////////////////////////////////////////////////////

// ============================================
// CONSULTATION SALE REPORT STATES
// ============================================
const [consultationSalesData, setConsultationSalesData] = useState([]);
const [filteredConsultationSales, setFilteredConsultationSales] = useState([]);
const [isConsultationSaleLoading, setIsConsultationSaleLoading] = useState(true);
const [consultationSaleCurrentPage, setConsultationSaleCurrentPage] = useState(1);
const [consultationSaleTotalPages, setConsultationSaleTotalPages] = useState(0);
const [consultationSaleSuccessMsg, setConsultationSaleSuccessMsg] = useState('');
const [consultationSaleErrorMsg, setConsultationSaleErrorMsg] = useState('');

// Filter states
const [consultationSaleDateFrom, setConsultationSaleDateFrom] = useState('');
const [consultationSaleDateTo, setConsultationSaleDateTo] = useState('');
const [consultationSaleMonth, setConsultationSaleMonth] = useState('');
const [consultationSaleYear, setConsultationSaleYear] = useState('');
const [consultationSaleDoctor, setConsultationSaleDoctor] = useState('');
const [consultationSaleYears, setConsultationSaleYears] = useState([]);

const CONSULTATION_SALE_ITEMS_PER_PAGE = 20;

// ============================================
// FETCH CONSULTATION SALES
// ============================================
const fetchConsultationSales = async () => {
  try {
    setIsConsultationSaleLoading(true);
    const salesCollection = collection(db, 'consultation_invoices');
    const snapshot = await getDocs(salesCollection);
    const sales = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    
    // Sort by date descending
    sales.sort((a, b) => new Date(b.date) - new Date(a.date));
    
    setConsultationSalesData(sales);
    
    // Extract years for filter
    const years = [...new Set(sales.map(sale => sale.date?.split('-')[0]).filter(Boolean))];
    setConsultationSaleYears(years.sort());
    
    applyConsultationSaleFiltersToData(sales);
  } catch (error) {
    console.error('Error fetching consultation sales:', error);
    setConsultationSaleErrorMsg('Failed to load consultation sales');
  } finally {
    setIsConsultationSaleLoading(false);
  }
};

// ============================================
// APPLY FILTERS - UNIQUE FUNCTION NAME
// ============================================
const applyConsultationSaleFiltersToData = (data = consultationSalesData) => {
  let filtered = [...data];
  
  // Date range filter
  if (consultationSaleDateFrom && consultationSaleDateTo) {
    filtered = filtered.filter(sale => 
      sale.date >= consultationSaleDateFrom && sale.date <= consultationSaleDateTo
    );
  } else if (consultationSaleDateFrom) {
    filtered = filtered.filter(sale => sale.date >= consultationSaleDateFrom);
  } else if (consultationSaleDateTo) {
    filtered = filtered.filter(sale => sale.date <= consultationSaleDateTo);
  }
  
  // Month filter
  if (consultationSaleMonth) {
    filtered = filtered.filter(sale => {
      const month = sale.date?.split('-')[1];
      return month === consultationSaleMonth;
    });
  }
  
  // Year filter
  if (consultationSaleYear) {
    filtered = filtered.filter(sale => {
      const year = sale.date?.split('-')[0];
      return year === consultationSaleYear;
    });
  }
  
  // Doctor filter
  if (consultationSaleDoctor) {
    filtered = filtered.filter(sale => sale.consultant === consultationSaleDoctor);
  }
  
  // Update pagination
  setConsultationSaleTotalPages(Math.ceil(filtered.length / CONSULTATION_SALE_ITEMS_PER_PAGE));
  setConsultationSaleCurrentPage(1);
  setFilteredConsultationSales(filtered);
};

// ============================================
// FILTER HANDLERS
// ============================================
const applyConsultationSaleFilters = () => {
  applyConsultationSaleFiltersToData(consultationSalesData);
  setConsultationSaleSuccessMsg('Filters applied successfully!');
  setTimeout(() => setConsultationSaleSuccessMsg(''), 3000);
};

const clearConsultationSaleFilters = () => {
  setConsultationSaleDateFrom('');
  setConsultationSaleDateTo('');
  setConsultationSaleMonth('');
  setConsultationSaleYear('');
  setConsultationSaleDoctor('');
  setConsultationSaleSuccessMsg('Filters cleared!');
  setTimeout(() => setConsultationSaleSuccessMsg(''), 3000);
  applyConsultationSaleFiltersToData(consultationSalesData);
};

// ============================================
// PAGINATION
// ============================================
const goToConsultationSalePage = (page) => {
  if (page >= 1 && page <= consultationSaleTotalPages) {
    setConsultationSaleCurrentPage(page);
  }
};

const getPaginatedConsultationSales = () => {
  const startIndex = (consultationSaleCurrentPage - 1) * CONSULTATION_SALE_ITEMS_PER_PAGE;
  const endIndex = startIndex + CONSULTATION_SALE_ITEMS_PER_PAGE;
  return filteredConsultationSales.slice(startIndex, endIndex);
};

// ============================================
// CALCULATE TOTALS
// ============================================
const totalConsultationRevenue = filteredConsultationSales.reduce((sum, sale) => {
  const total = typeof sale.total === 'number' ? sale.total : parseFloat(sale.total) || 0;
  return sum + total;
}, 0);

const totalClinicCharges = filteredConsultationSales.reduce((sum, sale) => {
  const charge = typeof sale.clinicCharge === 'number' ? sale.clinicCharge : parseFloat(sale.clinicCharge) || 0;
  return sum + charge;
}, 0);

const totalDoctorFees = filteredConsultationSales.reduce((sum, sale) => {
  const fee = typeof sale.doctorFee === 'number' ? sale.doctorFee : parseFloat(sale.doctorFee) || 0;
  return sum + fee;
}, 0);

// ============================================
// EXPORT TO PDF
// ============================================
const exportConsultationSalePDF = () => {
  try {
    if (filteredConsultationSales.length === 0) {
      setConsultationSaleErrorMsg('No data to export!');
      setTimeout(() => setConsultationSaleErrorMsg(''), 3000);
      return;
    }

    const doc = new jsPDF('landscape', 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    let y = 20;
    
    // Title
    doc.setFont('Times New Roman', 'bold');
    doc.setFontSize(18);
    doc.text('Consultation Sales Report', pageWidth / 2, y, { align: 'center' });
    y += 10;
    
    // Date range
    doc.setFontSize(10);
    doc.setFont('Times New Roman', 'normal');
    let filterText = 'Filters: ';
    if (consultationSaleDateFrom && consultationSaleDateTo) {
      filterText += `Date: ${consultationSaleDateFrom} to ${consultationSaleDateTo} | `;
    }
    if (consultationSaleMonth) {
      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      filterText += `Month: ${monthNames[parseInt(consultationSaleMonth) - 1]} | `;
    }
    if (consultationSaleYear) {
      filterText += `Year: ${consultationSaleYear} | `;
    }
    if (consultationSaleDoctor) {
      const doctor = doctorList.find(d => d.id === consultationSaleDoctor);
      filterText += `Doctor: Dr. ${doctor?.drName || ''}`;
    }
    doc.text(filterText, 14, y);
    y += 10;
    
    // Summary
    doc.setFont('Times New Roman', 'bold');
    doc.setFontSize(11);
    doc.text(`Total Invoices: ${filteredConsultationSales.length}`, 14, y);
    doc.text(`Total Revenue: Rs. ${totalConsultationRevenue.toFixed(2)}`, 70, y);
    doc.text(`Total Clinic Charges: Rs. ${totalClinicCharges.toFixed(2)}`, 130, y);
    doc.text(`Total Doctor Fees: Rs. ${totalDoctorFees.toFixed(2)}`, 190, y);
    y += 10;
    
    // Table headers
    doc.setFontSize(9);
    const headers = ['#', 'Bill No', 'Date', 'Patient', 'Doctor', 'Clinic', 'Doctor Fee', 'Total', 'Sales Person'];
    const colWidths = [10, 20, 25, 40, 40, 25, 25, 25, 30];
    let x = 14;
    
    doc.setFillColor(50, 50, 50);
    doc.rect(14, y - 5, pageWidth - 28, 8, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFont('Times New Roman', 'bold');
    
    headers.forEach((header, i) => {
      doc.text(header, x, y);
      x += colWidths[i];
    });
    
    y += 10;
    doc.setTextColor(0, 0, 0);
    doc.setFont('Times New Roman', 'normal');
    
    // Table data (limit to first 50 rows to avoid PDF issues)
    const displayData = filteredConsultationSales.slice(0, 50);
    displayData.forEach((sale, index) => {
      if (y > 270) {
        doc.addPage();
        y = 20;
      }
      
      x = 14;
      const rowData = [
        index + 1,
        sale.billNumber,
        sale.date,
        sale.patientName?.substring(0, 20) || '-',
        sale.consultantName?.substring(0, 20) || '-',
        `Rs.${(typeof sale.clinicCharge === 'number' ? sale.clinicCharge : parseFloat(sale.clinicCharge) || 0).toFixed(2)}`,
        `Rs.${(typeof sale.doctorFee === 'number' ? sale.doctorFee : parseFloat(sale.doctorFee) || 0).toFixed(2)}`,
        `Rs.${(typeof sale.total === 'number' ? sale.total : parseFloat(sale.total) || 0).toFixed(2)}`,
        sale.salesPerson || '-'
      ];
      
      rowData.forEach((data, i) => {
        doc.text(String(data), x, y);
        x += colWidths[i];
      });
      y += 7;
    });
    
    // Footer
    if (filteredConsultationSales.length > 50) {
      y += 5;
      doc.setFont('Times New Roman', 'italic');
      doc.setFontSize(8);
      doc.text(`* Showing first 50 of ${filteredConsultationSales.length} records`, 14, y);
    }
    
    doc.save(`Consultation_Sales_Report_${new Date().toISOString().split('T')[0]}.pdf`);
    setConsultationSaleSuccessMsg('PDF exported successfully!');
    setTimeout(() => setConsultationSaleSuccessMsg(''), 3000);
  } catch (error) {
    console.error('Error exporting PDF:', error);
    setConsultationSaleErrorMsg('Failed to export PDF');
    setTimeout(() => setConsultationSaleErrorMsg(''), 3000);
  }
};

// ============================================
// EXPORT TO EXCEL
// ============================================
const exportConsultationSaleExcel = () => {
  try {
    if (filteredConsultationSales.length === 0) {
      setConsultationSaleErrorMsg('No data to export!');
      setTimeout(() => setConsultationSaleErrorMsg(''), 3000);
      return;
    }

    // Prepare data for Excel
    const excelData = filteredConsultationSales.map((sale, index) => ({
      'S.No': index + 1,
      'Bill Number': sale.billNumber || '-',
      'Date': sale.date || '-',
      'Patient Name': sale.patientName || '-',
      'Patient Contact': sale.patientContact || '-',
      'Doctor': sale.consultantName || '-',
      'Clinic Charge (Rs.)': typeof sale.clinicCharge === 'number' ? sale.clinicCharge.toFixed(2) : '0.00',
      'Doctor Fee (Rs.)': typeof sale.doctorFee === 'number' ? sale.doctorFee.toFixed(2) : '0.00',
      'Total (Rs.)': typeof sale.total === 'number' ? sale.total.toFixed(2) : '0.00',
      'Sales Person': sale.salesPerson || '-',
      'Appointment No': sale.appointmentNumber || '-',
      'Status': sale.status || 'Completed'
    }));

    // Add summary row
    const summaryRow = {
      'S.No': '',
      'Bill Number': 'TOTALS',
      'Date': '',
      'Patient Name': '',
      'Patient Contact': '',
      'Doctor': '',
      'Clinic Charge (Rs.)': totalClinicCharges.toFixed(2),
      'Doctor Fee (Rs.)': totalDoctorFees.toFixed(2),
      'Total (Rs.)': totalConsultationRevenue.toFixed(2),
      'Sales Person': '',
      'Appointment No': '',
      'Status': ''
    };
    excelData.push(summaryRow);

    // Add empty row and filter info
    const filterInfo = {
      'S.No': '',
      'Bill Number': 'FILTERS APPLIED:',
      'Date': '',
      'Patient Name': '',
      'Patient Contact': '',
      'Doctor': '',
      'Clinic Charge (Rs.)': '',
      'Doctor Fee (Rs.)': '',
      'Total (Rs.)': '',
      'Sales Person': '',
      'Appointment No': '',
      'Status': ''
    };
    excelData.push(filterInfo);

    // Add filter details
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const filterDetails = {
      'S.No': '',
      'Bill Number': `Date From: ${consultationSaleDateFrom || 'All'}`,
      'Date': `Date To: ${consultationSaleDateTo || 'All'}`,
      'Patient Name': `Month: ${consultationSaleMonth ? monthNames[parseInt(consultationSaleMonth) - 1] : 'All'}`,
      'Patient Contact': `Year: ${consultationSaleYear || 'All'}`,
      'Doctor': `Doctor: ${consultationSaleDoctor ? doctorList.find(d => d.id === consultationSaleDoctor)?.drName || 'Selected' : 'All'}`,
      'Clinic Charge (Rs.)': `Total Records: ${filteredConsultationSales.length}`,
      'Doctor Fee (Rs.)': '',
      'Total (Rs.)': '',
      'Sales Person': '',
      'Appointment No': '',
      'Status': ''
    };
    excelData.push(filterDetails);

    // Create workbook
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(excelData);

    // Set column widths
    const colWidths = [
      { wch: 8 },   // S.No
      { wch: 15 },  // Bill Number
      { wch: 15 },  // Date
      { wch: 25 },  // Patient Name
      { wch: 18 },  // Patient Contact
      { wch: 30 },  // Doctor
      { wch: 18 },  // Clinic Charge
      { wch: 18 },  // Doctor Fee
      { wch: 18 },  // Total
      { wch: 22 },  // Sales Person
      { wch: 18 },  // Appointment No
      { wch: 15 }   // Status
    ];
    ws['!cols'] = colWidths;

    // Style the header row - make it bold
    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const address = XLSX.utils.encode_cell({ r: 0, c: C });
      if (!ws[address]) continue;
      ws[address].s = {
        font: { bold: true, sz: 12 },
        fill: { fgColor: { rgb: "2C3E50" } },
        font: { color: { rgb: "FFFFFF" } }
      };
    }

    // Style the total row
    const totalRowIndex = excelData.length - 3; // Index of total row
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const address = XLSX.utils.encode_cell({ r: totalRowIndex, c: C });
      if (!ws[address]) continue;
      ws[address].s = {
        font: { bold: true },
        fill: { fgColor: { rgb: "E8F4FD" } }
      };
    }

    XLSX.utils.book_append_sheet(wb, ws, 'Consultation Sales');
    
    // Generate filename with date
    const dateStr = new Date().toISOString().split('T')[0];
    const filename = `Consultation_Sales_Report_${dateStr}.xlsx`;
    
    // Save file
    XLSX.writeFile(wb, filename);
    
    setConsultationSaleSuccessMsg('Excel report exported successfully!');
    setTimeout(() => setConsultationSaleSuccessMsg(''), 3000);
  } catch (error) {
    console.error('Error exporting to Excel:', error);
    setConsultationSaleErrorMsg('Failed to export Excel report');
    setTimeout(() => setConsultationSaleErrorMsg(''), 3000);
  }
};

// ============================================
// VIEW INVOICE
// ============================================
const viewConsultationInvoice = (sale) => {
  generateConsultationPDF({
    billNumber: sale.billNumber,
    salesPerson: sale.salesPerson,
    date: sale.date,
    patientName: sale.patientName,
    appointmentNumber: sale.appointmentNumber || '-',
    consultant: sale.consultant,
    patientContact: sale.patientContact,
    appointmentTime: sale.appointmentTime || '-',
    clinicCharge: sale.clinicCharge,
    doctorFee: sale.doctorFee,
    total: sale.total
  });
};

// ============================================
// LOAD DATA ON MOUNT
// ============================================
useEffect(() => {
  fetchConsultationSales();
}, []);






///////////////////////////// fetch salespersons ////////////////////////////////////

// Call fetchSalesPersons in your useEffect
useEffect(() => {
  fetchSalesPersons();
  // ... other initialization code
}, []);



























// =============================================
// ADD THESE STATES AT THE TOP WITH YOUR OTHER STATES
// =============================================
const [passwordInput, setPasswordInput] = useState("");
const [pendingReport, setPendingReport] = useState(null);

// =============================================
// ADD THIS PASSWORD VERIFICATION FUNCTION
// =============================================
const handlePasswordVerifyForManageSales = () => {
  if (passwordInput === "rayban@142") {
    // Password correct - proceed to the report
    setShowPasswordModal(false);
    setPasswordInput("");
    if (pendingReport) {
      handleSelectReport(pendingReport);
      setPendingReport(null);
    }
  } else {
    alert("Incorrect password! Access denied.");
    setPasswordInput("");
  }
};

// =============================================
// CREATE A NEW UNIQUE FUNCTION FOR HANDLING PASSWORD PROTECTED REPORTS
// =============================================
const handleProtectedReportClick = (report) => {
  // Check if this is a protected option - ONLY Manage Sales Person
  const protectedOptions = ["manageSalesPerson"];
  
  if (protectedOptions.includes(report)) {
    // Show password modal
    setPendingReport(report);
    setShowPasswordModal(true);
    return;
  }
  
  // For non-protected options, use the existing handleSelectReport
  handleSelectReport(report);
};










////////////////////////////////////// nav bar //////////////////////////////////






return (
  <>
    {/* 🔵 TOP NAVIGATION BAR */}
    <nav className="top-nav">
      <div className="logo">Powered By Glaxmore IT</div>

      <ul className="nav-links">
        {/* Normal Tabs */}
        <li
          className={selectedOption === "dashboard" ? "active" : ""}
          onClick={() => {
            setOpenMenu(null);
            handleSelect("dashboard");
          }}
        >
          Dashboard
        </li>

        <li
          className={selectedOption === "viewPatient" ? "active" : ""}
          onClick={() => {
            setOpenMenu(null);
            handleSelect("viewPatient");
          }}
        >
          View Patients
        </li>

        {/* Invoice Dropdown */}
        <li
          className="dropdown"
          onClick={(e) => {
            e.stopPropagation();
            setOpenMenu(openMenu === "invoice" ? null : "invoice");
          }}
        >
          Invoice ▾

          {openMenu === "invoice" && (
            <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
              <p onClick={() => handleSelectInvoice("createInvoice")}>Create Invoice</p>
              <p onClick={() => handleSelectInvoice("directSales")}>Create Direct Sale Invoice</p>
              <p onClick={() => handleSelectInvoice("serviceInvoice")}>Create Service Invoice</p>
              <p onClick={() => handleSelectInvoice("consultationInvoice")}>Create Consultation Invoice</p>
              <p onClick={() => handleSelectInvoice("viewInvoice")}>View All Invoice</p>
              <p onClick={() => handleSelectInvoice("createBalanceInvoice")}>Create Balance Invoice</p>
              <p onClick={() => handleSelectInvoice("viewBalanceInvoice")}>View All Balance Invoice</p>
              <p onClick={() => handleSelectInvoice("downloadMainInvoice")}>Download Order Form & Invoice</p>
              <p onClick={() => handleSelectInvoice("downloadDirectSaleInvoice")}>View & Download Direct-Sale Invoice</p>
              <p onClick={() => handleSelectInvoice("downloadServiceInvoice")}>View & Download Service Invoice</p>
              <p onClick={() => handleSelectInvoice("downloadConsultationInvoice")}>View & Download Consultation Invoice</p>
            </div>
          )}
        </li>

        {/* Appointment Dropdown */}
        <li
          className="dropdown"
          onClick={(e) => {
            e.stopPropagation();
            setOpenMenu(openMenu === "appointment" ? null : "appointment");
          }}
        >
          Appointment ▾

          {openMenu === "appointment" && (
            <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
              <p onClick={() => handleSelectInvoice("createAppointment")}>Create Appointment</p>
              <p onClick={() => handleSelectInvoice("viewAppointment")}>View All Appointment</p>
            </div>
          )}
        </li>

        {/* Eye Exam Dropdown */}
        <li
          className="dropdown"
          onClick={(e) => {
            e.stopPropagation();
            setOpenMenu(openMenu === "eyeExam" ? null : "eyeExam");
          }}
        >
          Eye Exam Report ▾

          {openMenu === "eyeExam" && (
            <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
              <p onClick={() => handleSelectInvoice("createEyeExamReport")}>Create Eye Exam Report</p>
              <p onClick={() => handleSelectInvoice("viewEyeExamReport")}>View All Eye Exam Report</p>
              <p onClick={() => handleSelectInvoice("eyeExamReportForPatient")}>Eye Exam Report For Patient</p>
            </div>
          )}
        </li>

        {/* Spectacle Status Tracking */}
        <li
          className={selectedOption === "trackSpectacle" ? "active" : ""}
          onClick={() => {
            setOpenMenu(null);
            handleSelect("trackSpectacle");
          }}
        >
          Spectacle Status Tracking
        </li>

        {/* Supplier Dropdown */}
        <li
          className="dropdown"
          onClick={(e) => {
            e.stopPropagation();
            setOpenMenu(openMenu === "supplier" ? null : "supplier");
          }}
        >
          Supplier ▾

          {openMenu === "supplier" && (
            <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
              <p onClick={() => handleSelectSupplier("addSupplier")}>Add Supplier</p>
              <p onClick={() => handleSelectSupplier("viewSupplier")}>View Supplier</p>
            </div>
          )}
        </li>

        {/* Stock Dropdown */}
        <li
          className="dropdown"
          onClick={(e) => {
            e.stopPropagation();
            setOpenMenu(openMenu === "stock" ? null : "stock");
          }}
        >
          Stock ▾

          {openMenu === "stock" && (
            <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
              <p onClick={() => handleSelectStock("quickAdd")}>Add Stock</p>
            </div>
          )}
        </li>

        {/* Reports Dropdown */}
        <li
          className="dropdown"
          onClick={(e) => {
            e.stopPropagation();
            setOpenMenu(openMenu === "report" ? null : "report");
          }}
        >
          Reports ▾

          {openMenu === "report" && (
            <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
              <p onClick={() => handleSelectReport("StockHistory")}>Stock Report</p>
              <p onClick={() => handleSelectReport("viewStockOut")}>View Stock-Out Report</p>
              <p onClick={() => handleSelectReport("salesReport")}>Sales Report</p>
              <p onClick={() => handleSelectReport("consultationSale")}>consultation Sales Report</p>
            </div>
          )}
        </li>

        {/* Patient Follow up */}
        <li
          className={selectedOption === "patientfollowup" ? "active" : ""}
          onClick={() => {
            setOpenMenu(null);
            handleSelect("patientfollowup");
          }}
        >
          Patient Follow-Up
        </li>

        {/* Birthday Wishes */}
        <li
          className={selectedOption === "birthdayWishes" ? "active" : ""}
          onClick={() => {
            setOpenMenu(null);
            handleSelect("birthdayWishes");
          }}
        >
          Birthday Wishes
        </li>

        {/* Add To System - Password Modal is NOT inside this */}
        <li
          className="dropdown"
          onClick={(e) => {
            e.stopPropagation();
            setOpenMenu(openMenu === "addSystem" ? null : "addSystem");
          }}
        >
          Add To System ▾

          {openMenu === "addSystem" && (
            <div className="dropdown-menu" onClick={(e) => e.stopPropagation()}>
              <p onClick={() => handleProtectedReportClick("addSalesperson")}>Add Sales Person</p>
              <p onClick={() => handleProtectedReportClick("manageSalesPerson")}>Manage Sales Person</p>
              <p onClick={() => handleProtectedReportClick("addDoctors")}>Add Doctors</p>
              <p onClick={() => handleProtectedReportClick("manageDoctors")}>Manage Doctors</p>
              <p onClick={() => handleProtectedReportClick("addEyeCamp")}>Add Eye Camp</p>
              <p onClick={() => handleProtectedReportClick("viewEyeCamps")}>View Eye Camps</p>
            </div>
          )}
        </li>

        {/* Logout */}
        <li
          onClick={(e) => {
            e.stopPropagation();
            setOpenMenu(null);
            handleLogout();
          }}
        >
          Logout
        </li>
      </ul>
    </nav>

    {/* ============================================= */}
    {/* PASSWORD MODAL - OUTSIDE THE NAVBAR */}
    {/* ============================================= */}
    {showPasswordModal && (
      <div 
        className="password-modal-overlay" 
        onClick={() => {
          setShowPasswordModal(false);
          setPasswordInput("");
          setPendingReport(null);
        }}
      >
        <div className="password-modal" onClick={(e) => e.stopPropagation()}>
          <div className="password-modal-header">
            <h3>🔒 Authorization Required</h3>
            <button 
              className="close-modal-btn"
              onClick={() => {
                setShowPasswordModal(false);
                setPasswordInput("");
                setPendingReport(null);
              }}
            >
              ×
            </button>
          </div>
          
          <div className="password-modal-body">
            <p>Please enter the admin password to access <strong>Manage Sales Person</strong>.</p>
            <input
              type="password"
              placeholder="Enter password..."
              value={passwordInput}
              onChange={(e) => setPasswordInput(e.target.value)}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handlePasswordVerifyForManageSales();
                }
              }}
              autoFocus
              className="password-input"
            />
            
            <div className="password-modal-actions">
              <button 
                className="password-cancel-btn"
                onClick={() => {
                  setShowPasswordModal(false);
                  setPasswordInput("");
                  setPendingReport(null);
                }}
              >
                Cancel
              </button>
              <button 
                className="password-confirm-btn"
                onClick={handlePasswordVerifyForManageSales}
              >
                Verify Password
              </button>
            </div>
          </div>
        </div>
      </div>
    )}




      {/* 🔵 PAGE BODY */}
      <div className="page-body">




{/***************************************  consultationReport   **********************************************/}

{selectedOption === "consultationSale" && (
  <div className="consultation-sale-container">
    <h2>Consultation Sales Report</h2>

    {/* Messages */}
    {consultationSaleSuccessMsg && (
      <div className="consultation-sale-success-message">
        ✅ {consultationSaleSuccessMsg}
      </div>
    )}
    {consultationSaleErrorMsg && (
      <div className="consultation-sale-error-message">
        ❌ {consultationSaleErrorMsg}
      </div>
    )}

    {/* Filters */}
    <div className="consultation-sale-filters">
      <div className="filter-group">
        <label>Date Range</label>
        <div className="date-range-inputs">
          <input
            type="date"
            value={consultationSaleDateFrom}
            onChange={(e) => setConsultationSaleDateFrom(e.target.value)}
            className="filter-input"
          />
          <span>to</span>
          <input
            type="date"
            value={consultationSaleDateTo}
            onChange={(e) => setConsultationSaleDateTo(e.target.value)}
            className="filter-input"
          />
        </div>
      </div>

      <div className="filter-group">
        <label>Month</label>
        <select
          value={consultationSaleMonth}
          onChange={(e) => setConsultationSaleMonth(e.target.value)}
          className="filter-select"
        >
          <option value="">All Months</option>
          <option value="01">January</option>
          <option value="02">February</option>
          <option value="03">March</option>
          <option value="04">April</option>
          <option value="05">May</option>
          <option value="06">June</option>
          <option value="07">July</option>
          <option value="08">August</option>
          <option value="09">September</option>
          <option value="10">October</option>
          <option value="11">November</option>
          <option value="12">December</option>
        </select>
      </div>

      <div className="filter-group">
        <label>Year</label>
        <select
          value={consultationSaleYear}
          onChange={(e) => setConsultationSaleYear(e.target.value)}
          className="filter-select"
        >
          <option value="">All Years</option>
          {consultationSaleYears.map(year => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
      </div>

      <div className="filter-group">
        <label>Doctor</label>
        <select
          value={consultationSaleDoctor}
          onChange={(e) => setConsultationSaleDoctor(e.target.value)}
          className="filter-select"
        >
          <option value="">All Doctors</option>
          {doctorList.map(doctor => (
            <option key={doctor.id} value={doctor.id}>
              Dr. {doctor.drName}
            </option>
          ))}
        </select>
      </div>

      <div className="filter-actions">
        <button onClick={applyConsultationSaleFilters} className="apply-filter-btn">
          Apply Filters
        </button>
        <button onClick={clearConsultationSaleFilters} className="clear-filter-btn">
          ✕ Clear
        </button>
        <button onClick={exportConsultationSalePDF} className="export-btn">
          📊 Export PDF
        </button>
        <button onClick={exportConsultationSaleExcel} className="export-excel-btn">
          📋 Export Excel
        </button>
      </div>
    </div>

    {/* Summary Cards */}
    <div className="consultation-sale-summary">
      <div className="summary-card">
        <h4>Total Invoices</h4>
        <p className="summary-number">{filteredConsultationSales.length}</p>
      </div>
      <div className="summary-card">
        <h4>Total Revenue</h4>
        <p className="summary-number">Rs. {totalConsultationRevenue.toFixed(2)}</p>
      </div>
      <div className="summary-card">
        <h4>Total Clinic Charges</h4>
        <p className="summary-number">Rs. {totalClinicCharges.toFixed(2)}</p>
      </div>
      <div className="summary-card">
        <h4>Total Doctor Fees</h4>
        <p className="summary-number">Rs. {totalDoctorFees.toFixed(2)}</p>
      </div>
    </div>

    {/* Table */}
    {isConsultationSaleLoading ? (
      <div className="loading-spinner">
        <p>Loading consultation sales...</p>
      </div>
    ) : (
      <div className="table-wrapper">
        {filteredConsultationSales.length === 0 ? (
          <p className="no-data-message">No consultation sales found.</p>
        ) : (
          <>
            <table className="consultation-sale-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Bill No</th>
                  <th>Date</th>
                  <th>Patient Name</th>
                  <th>Contact</th>
                  <th>Doctor</th>
                  <th>Clinic Charge</th>
                  <th>Doctor Fee</th>
                  <th>Total</th>
                  <th>Sales Person</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {getPaginatedConsultationSales().map((sale, index) => {
                  const actualIndex = (consultationSaleCurrentPage - 1) * CONSULTATION_SALE_ITEMS_PER_PAGE + index + 1;
                  return (
                    <tr key={sale.id}>
                      <td>{actualIndex}</td>
                      <td><strong>{sale.billNumber}</strong></td>
                      <td>{sale.date}</td>
                      <td>{sale.patientName}</td>
                      <td>{sale.patientContact}</td>
                      <td>{sale.consultantName || '-'}</td>
                      <td>Rs. {typeof sale.clinicCharge === 'number' ? sale.clinicCharge.toFixed(2) : '0.00'}</td>
                      <td>Rs. {typeof sale.doctorFee === 'number' ? sale.doctorFee.toFixed(2) : '0.00'}</td>
                      <td><strong>Rs. {typeof sale.total === 'number' ? sale.total.toFixed(2) : '0.00'}</strong></td>
                      <td>{sale.salesPerson}</td>
                      <td>
                        <button
                          onClick={() => viewConsultationInvoice(sale)}
                          className="view-invoice-btn"
                        >
                          View Invoice
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr className="total-row">
                  <td colSpan="6"><strong>TOTALS</strong></td>
                  <td><strong>Rs. {totalClinicCharges.toFixed(2)}</strong></td>
                  <td><strong>Rs. {totalDoctorFees.toFixed(2)}</strong></td>
                  <td><strong>Rs. {totalConsultationRevenue.toFixed(2)}</strong></td>
                  <td colSpan="2"></td>
                </tr>
              </tfoot>
            </table>

            {/* Pagination */}
            {consultationSaleTotalPages > 1 && (
              <div className="pagination">
                <button
                  onClick={() => goToConsultationSalePage(consultationSaleCurrentPage - 1)}
                  disabled={consultationSaleCurrentPage === 1}
                  className="pagination-btn"
                >
                  Previous
                </button>
                <span className="page-info">
                  Page {consultationSaleCurrentPage} of {consultationSaleTotalPages}
                </span>
                <button
                  onClick={() => goToConsultationSalePage(consultationSaleCurrentPage + 1)}
                  disabled={consultationSaleCurrentPage === consultationSaleTotalPages}
                  className="pagination-btn"
                >
                  Next
                </button>
              </div>
            )}
          </>
        )}
      </div>
    )}
  </div>
)}


{/************************************* create consultation *****************************************/}

{selectedOption === "consultationInvoice" && (
<div className="consultation-invoice-container">
      <h2>Consultation Invoice</h2>

      {consultationSuccessMsg && (
        <div className="consultation-success-message">✅ {consultationSuccessMsg}</div>
      )}
      {consultationErrorMsg && (
        <div className="consultation-error-message">❌ {consultationErrorMsg}</div>
      )}

      <form onSubmit={handleConsultationSubmit} className="consultation-form">

        {/* Bill Number - Auto Generated */}
        <div className="consultation-form-group">
          <label className="consultation-label">
            Bill Number <span className="required-star">*</span>
          </label>
          <input
            type="text"
            name="billNumber"
            value={consultationForm.billNumber}
            className="consultation-input consultation-bill-input"
            disabled
            readOnly
          />
          <small className="consultation-hint">Auto-generated unique bill number</small>
        </div>

        {/* Sales Person Selection */}
        <div className="consultation-form-group">
          <label className="consultation-label">
            Sales Person <span className="required-star">*</span>
          </label>
          <select
            name="salesPerson"
            value={consultationForm.salesPerson}
            onChange={handleConsultationChange}
            className="consultation-select"
            required
          >
            <option value="">Select Sales Person...</option>
            {salesPersonList.map(person => (
              <option key={person.id} value={person.salespersonName}>
                {person.salespersonName}
              </option>
            ))}
          </select>
        </div>

        {/* Date */}
        <div className="consultation-form-group">
          <label className="consultation-label">
            Date <span className="required-star">*</span>
          </label>
          <input
            type="date"
            name="date"
            value={consultationForm.date}
            onChange={handleConsultationChange}
            className="consultation-input"
            required
          />
        </div>

        {/* Patient Name */}
        <div className="consultation-form-group">
          <label className="consultation-label">
            Patient Name <span className="required-star">*</span>
          </label>
          <input
            type="text"
            name="patientName"
            value={consultationForm.patientName}
            onChange={handleConsultationChange}
            className="consultation-input"
            placeholder="Enter patient full name"
            required
          />
        </div>

        {/* Appointment Number */}
        <div className="consultation-form-group">
          <label className="consultation-label">
            Appointment Number <span className="required-star">*</span>
          </label>
          <input
            type="text"
            name="appointmentNumber"
            value={consultationForm.appointmentNumber}
            onChange={handleConsultationChange}
            className="consultation-input"
            placeholder="Enter appointment number"
            required
          />
        </div>

        {/* Consultant */}
        <div className="consultation-form-group">
          <label className="consultation-label">
            Consultant <span className="required-star">*</span>
          </label>
          <select
            name="consultant"
            value={consultationForm.consultant}
            onChange={(e) => {
              const selectedDoctorId = e.target.value;
              setConsultationForm(prev => ({
                ...prev,
                consultant: selectedDoctorId
              }));
              
              if (selectedDoctorId) {
                const selectedDoctor = doctorList.find(doc => doc.id === selectedDoctorId);
                if (selectedDoctor && selectedDoctor.channelingCharge) {
                  setConsultationForm(prev => ({
                    ...prev,
                    doctorFee: selectedDoctor.channelingCharge.toString()
                  }));
                }
              } else {
                setConsultationForm(prev => ({
                  ...prev,
                  doctorFee: ''
                }));
              }
            }}
            className="consultation-select"
            required
          >
            <option value="">Select Consultant...</option>
            {doctorList.map(doctor => (
              <option key={doctor.id} value={doctor.id}>
                {doctor.drName} - {doctor.practice} (Fee: Rs.{doctor.channelingCharge || 'N/A'})
              </option>
            ))}
          </select>
        </div>

        {/* Patient Contact */}
        <div className="consultation-form-group">
          <label className="consultation-label">
            Patient Contact No <span className="required-star">*</span>
          </label>
          <input
            type="tel"
            name="patientContact"
            value={consultationForm.patientContact}
            onChange={handleConsultationChange}
            className="consultation-input"
            placeholder="Enter patient contact number"
            required
          />
        </div>

        {/* Appointment Time */}
        <div className="consultation-form-group">
          <label className="consultation-label">
            Appointment Time <span className="required-star">*</span>
          </label>
          <input
            type="time"
            name="appointmentTime"
            value={consultationForm.appointmentTime}
            onChange={handleConsultationChange}
            className="consultation-input"
            required
          />
        </div>

        {/* Clinic Charge */}
        <div className="consultation-form-group">
          <label className="consultation-label">
            Clinic Charge (Rs.) <span className="required-star">*</span>
          </label>
          <input
            type="number"
            name="clinicCharge"
            value={consultationForm.clinicCharge}
            onChange={(e) => {
              const value = e.target.value;
              setConsultationForm(prev => ({
                ...prev,
                clinicCharge: value
              }));
            }}
            className="consultation-input"
            placeholder="Enter clinic charge"
            min="0"
            step="0.01"
            required
            onWheel={(e) => e.target.blur()}
          />
        </div>

        {/* Doctor's Fee */}
        <div className="consultation-form-group">
          <label className="consultation-label">
            Doctor's Fee (Rs.) <span className="required-star">*</span>
          </label>
          <input
            type="number"
            name="doctorFee"
            value={consultationForm.doctorFee}
            onChange={(e) => {
              const value = e.target.value;
              setConsultationForm(prev => ({
                ...prev,
                doctorFee: value
              }));
            }}
            className="consultation-input consultation-doctor-fee-input"
            placeholder="Auto-filled from doctor"
            min="0"
            step="0.01"
            required
            onWheel={(e) => e.target.blur()}
          />
        </div>

        {/* Total */}
        <div className="consultation-form-group total-display">
          <label className="consultation-label">
            Total (Rs.)
          </label>
          <input
            type="text"
            name="total"
            value={(() => {
              const clinicCharge = parseFloat(consultationForm.clinicCharge) || 0;
              const doctorFee = parseFloat(consultationForm.doctorFee) || 0;
              const total = clinicCharge + doctorFee;
              return total.toFixed(2);
            })()}
            className="consultation-input consultation-total-input"
            readOnly
            disabled
          />
          <small className="consultation-hint">Auto-calculated</small>
        </div>

        {/* Buttons */}
        <div className="consultation-button-group">
          <button
            type="submit"
            disabled={isSubmittingConsultation || isGeneratingPDF}
            className="consultation-submit-btn"
          >
            {isSubmittingConsultation ? 'Creating...' : isGeneratingPDF ? 'Generating PDF...' : 'Create Invoice & PDF'}
          </button>
          <button
            type="button"
            onClick={resetConsultationForm}
            className="consultation-reset-btn"
            disabled={isSubmittingConsultation || isGeneratingPDF}
          >
            Reset
          </button>
        </div>
      </form>

    </div>
)}



{/************************************* view all consultation *****************************************/}


{selectedOption === "downloadConsultationInvoice" && (
  <div className="download-consultation-invoice-container">
    <div className="consultation-invoice-list-container">
      <h2>Consultation Invoices</h2>

      {/* Messages */}
      {consultationInvoiceSuccessMsg && (
        <div className="consultation-invoice-success-message">
          ✅ {consultationInvoiceSuccessMsg}
        </div>
      )}
      {consultationInvoiceErrorMsg && (
        <div className="consultation-invoice-error-message">
          ❌ {consultationInvoiceErrorMsg}
        </div>
      )}

      {/* Filters */}
      <div className="consultation-invoice-filters">
        <div className="consultation-invoice-search">

        <input
          type="text"
          placeholder="🔍 Search by Patient Name, Phone, Bill No, Appointment No..."
          value={consultationInvoiceSearch}
          onChange={(e) => setConsultationInvoiceSearch(e.target.value)}
          className="consultation-search-input"
        />

        </div>

        <div className="consultation-invoice-date-filters">
          <div className="consultation-date-group">
            <label>From:</label>
            <input
              type="date"
              value={consultationInvoiceDateRange.startDate}
              onChange={(e) => setConsultationInvoiceDateRange(prev => ({
                ...prev,
                startDate: e.target.value
              }))}
              className="consultation-date-input"
            />
          </div>
          <div className="consultation-date-group">
            <label>To:</label>
            <input
              type="date"
              value={consultationInvoiceDateRange.endDate}
              onChange={(e) => setConsultationInvoiceDateRange(prev => ({
                ...prev,
                endDate: e.target.value
              }))}
              className="consultation-date-input"
            />
          </div>
          <button
            onClick={() => setConsultationInvoiceDateRange({ startDate: '', endDate: '' })}
            className="consultation-clear-filters-btn"
          >
            Clear Filters
          </button>
        </div>

        <div className="consultation-invoice-actions-top">
          <button
            onClick={fetchConsultationInvoices}
            className="consultation-refresh-btn"
          >
            🔄 Refresh
          </button>
          <span className="consultation-total-count">
            Total: {filteredConsultationInvoices.length}
          </span>
        </div>
      </div>

      {/* Table */}
      {isConsultationInvoiceLoading ? (
        <div className="consultation-loading-spinner">
          <p>Loading invoices...</p>
        </div>
      ) : (
        <div className="consultation-table-wrapper">
          {filteredConsultationInvoices.length === 0 ? (
            <p className="consultation-no-data-message">No consultation invoices found.</p>
          ) : (
            <table className="consultation-invoice-table">
              <thead>
                <tr>
                  <th>Bill No</th>
                  <th>Patient Name</th>
                  <th>Patient Contact</th>
                  <th>Appointment No</th>
                  <th>Sales Person</th>
                  <th>Consultant</th>
                  <th>Date</th>
                  <th>Total</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredConsultationInvoices.map((invoice) => (
                  <tr key={invoice.id}>
                    <td><strong>{invoice.billNumber || invoice.invoiceNumber || '-'}</strong></td>
                    <td>{invoice.patientName || '-'}</td>
                    <td>{invoice.patientContact || '-'}</td>
                    <td>{invoice.appointmentNumber || '-'}</td>
                    <td>{invoice.salesPerson || '-'}</td>
                    <td>{invoice.consultantName || '-'}</td>
                    <td>
                      {invoice.createdAt ? new Date(invoice.createdAt).toLocaleDateString() : '-'}
                    </td>
                    <td><strong>Rs. {(invoice.total || 0).toFixed(2)}</strong></td>
                    <td>
                      <div className="consultation-action-buttons">
                        <button
                          className="consultation-download-btn"
                          onClick={() => generateConsultationInvoicePDF(invoice)}
                        >
                          📄 Download
                        </button>
                        <button
                          className="consultation-delete-btn"
                          onClick={() => handleConsultationInvoiceDelete(invoice.id)}
                        >
                          🗑️ Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  </div>
)}




{/************************************* create appointment *****************************************/}


{selectedOption === "createAppointment" && (
  <div className="add-appointment-container">
    <h2>Create Appointment</h2>
    
    {/* Success Message */}
    {appointmentSuccessMsg && (
      <div className="appointment-success-message">
        ✅ {appointmentSuccessMsg}
      </div>
    )}
    
    {/* Error Message */}
    {appointmentErrorMsg && (
      <div className="appointment-error-message">
        ❌ {appointmentErrorMsg}
      </div>
    )}

    <form onSubmit={handleAppointmentFormSubmit} className="appointment-form">
      {/* Appointment No - Manual Entry */}
      <div className="appointment-form-group">
        <label className="appointment-label">
          Appointment No <span className="required-star">*</span>
        </label>
        <input
          type="text"
          name="appointmentNo"
          value={appointmentFormData.appointmentNo}
          onChange={handleAppointmentFormChange}
          className="appointment-input"
          placeholder="Enter Appointment No. (e.g., APT-001)"
          required
        />
      </div>

      {/* Patient Name */}
      <div className="appointment-form-group">
        <label className="appointment-label">
          Patient Name <span className="required-star">*</span>
        </label>
        <input
          type="text"
          name="patientName"
          value={appointmentFormData.patientName}
          onChange={handleAppointmentFormChange}
          className="appointment-input"
          placeholder="Enter patient full name"
          required
        />
      </div>

      {/* Patient Contact No */}
      <div className="appointment-form-group">
        <label className="appointment-label">
          Patient Contact No <span className="required-star">*</span>
        </label>
        <input
          type="tel"
          name="patientContact"
          value={appointmentFormData.patientContact}
          onChange={handleAppointmentFormChange}
          className="appointment-input"
          placeholder="Enter patient contact number"
          required
        />
      </div>

      {/* Appointment Date */}
      <div className="appointment-form-group">
        <label className="appointment-label">
          Appointment Date <span className="required-star">*</span>
        </label>
        <input
          type="date"
          name="appointmentDate"
          value={appointmentFormData.appointmentDate}
          onChange={handleAppointmentFormChange}
          className="appointment-input"
          required
          min={new Date().toISOString().split('T')[0]}
        />
      </div>

      {/* Appointment Time */}
      <div className="appointment-form-group">
        <label className="appointment-label">
          Appointment Time <span className="required-star">*</span>
        </label>
        <input
          type="time"
          name="appointmentTime"
          value={appointmentFormData.appointmentTime}
          onChange={handleAppointmentFormChange}
          className="appointment-input"
          required
        />
      </div>

      {/* Referred By - Doctor Selection */}
      <div className="appointment-form-group">
        <label className="appointment-label">
          Referred By <span className="required-star">*</span>
        </label>
        <select
          name="referredBy"
          value={appointmentFormData.referredBy}  
          onChange={handleAppointmentFormChange}
          className="appointment-input"  
          required
        >
          <option value="">Select Doctor...</option>
          {doctorListData.map(doctor => (
            <option key={doctor.id} value={doctor.id}>
              {doctor.drName}
            </option>
          ))}
        </select>
      </div>

      {/* Remark */}
      <div className="appointment-form-group">
        <label className="appointment-label">
          Remark <span className="optional-text">(Optional)</span>
        </label>
        <textarea
          name="remark"
          value={appointmentFormData.remark}
          onChange={handleAppointmentFormChange}
          className="appointment-textarea"
          placeholder="Any additional notes..."
          rows="3"
        />
      </div>

      {/* Buttons */}
      <div className="appointment-button-group">
        <button
          type="submit"
          disabled={isSubmittingAppointment}
          className="appointment-submit-btn"
        >
          {isSubmittingAppointment ? 'Creating...' : 'Create Appointment'}
        </button>
        <button
          type="button"
          onClick={resetAppointmentFormData}
          className="appointment-reset-btn"
          disabled={isSubmittingAppointment}
        >
          Reset
        </button>
      </div>
    </form>
  </div>
)}


{/************************************* view appointment *****************************************/}


{selectedOption === "viewAppointment" && (
  <div className="view-appointment-container">
    <h2>Manage Appointments</h2>

    {/* Messages */}
    {appointmentSuccessMsg && (
      <div className="appointment-success-message">
        ✅ {appointmentSuccessMsg}
      </div>
    )}
    {appointmentErrorMsg && (
      <div className="appointment-error-message">
        ❌ {appointmentErrorMsg}
      </div>
    )}

    {/* Controls */}
    <div className="appointment-controls">
      <div className="search-section">
        <input
          type="text"
          className="search-input"
          placeholder="Search by appointment no, patient or doctor..."
          value={appointmentSearchTerm}
          onChange={(e) => setAppointmentSearchTerm(e.target.value)}
        />
      </div>
      
      <div className="filter-controls">
        {/* Quick Date Filters */}
        <div className="quick-filters">
          <button 
            onClick={loadTodayAppointments}
            className={appointmentDateFilter === 'today' ? 'active-filter-btn' : 'filter-btn'}
          >
            Today
          </button>
          <button 
            onClick={() => {
              setAppointmentDateFilter('all');
              setAppointmentDateFrom('');
              setAppointmentDateTo('');
              setAppointmentFilterDoctor('');
              fetchAppointmentData(1, null, null, null);
            }}
            className={appointmentDateFilter === 'all' ? 'active-filter-btn' : 'filter-btn'}
          >
            All
          </button>
        </div>
        
        {/* Doctor Filter Dropdown - FIXED */}
        {/* <div className="doctor-filter">
          <select
            value={appointmentFilterDoctor}
            onChange={(e) => {
              const doctorId = e.target.value;
              setAppointmentFilterDoctor(doctorId);
              setAppointmentCurrentPage(1);
              // Keep current date filters when applying doctor filter
              const dateFrom = appointmentDateFrom || null;
              const dateTo = appointmentDateTo || null;
              fetchAppointmentData(1, dateFrom, dateTo, doctorId || null);
            }}
            className="doctor-filter-select"
          >
            <option value="">All Doctors</option>
            {appointmentDoctorList.map(doctor => (
              <option key={doctor.id} value={doctor.id}>
                Dr. {doctor.drName}
              </option>
            ))}
          </select>
        </div>
         */}
        {/* Date Range Filter */}
        <div className="date-filter-section">
          <label>
            From:
            <input
              type="date"
              value={appointmentDateFrom}
              onChange={(e) => setAppointmentDateFrom(e.target.value)}
              className="date-filter-input"
            />
          </label>
          <label>
            To:
            <input
              type="date"
              value={appointmentDateTo}
              onChange={(e) => setAppointmentDateTo(e.target.value)}
              className="date-filter-input"
            />
          </label>
          <button 
            onClick={() => {
              setAppointmentCurrentPage(1);
              setAppointmentDateFilter('custom');
              const doctorId = appointmentFilterDoctor || null;
              fetchAppointmentData(1, appointmentDateFrom || null, appointmentDateTo || null, doctorId);
            }}
            className="apply-filter-btn"
          >
            Apply Filter
          </button>
          <button 
            onClick={() => {
              setAppointmentDateFrom('');
              setAppointmentDateTo('');
              setAppointmentFilterDoctor('');
              setAppointmentCurrentPage(1);
              setAppointmentDateFilter('all');
              fetchAppointmentData(1, null, null, null);
            }}
            className="clear-filter-btn"
          >
            ✕ Clear
          </button>
        </div>
      </div>
      
      <div className="action-buttons-container">
        <button 
          onClick={() => {
            const dateFrom = appointmentDateFrom || null;
            const dateTo = appointmentDateTo || null;
            const doctorId = appointmentFilterDoctor || null;
            fetchAppointmentData(appointmentCurrentPage, dateFrom, dateTo, doctorId);
          }} 
          className="refresh-button"
        >
          🔄 Refresh
        </button>
        <button 
          onClick={exportAppointmentToExcel}
          className="export-excel-btn"
        >
          📊 Export Excel
        </button>
      </div>
    </div>

    {/* REMOVED: Doctor-wise Breakdown section - deleted */}

    {/* Table */}
    {isAppointmentLoading ? (
      <div className="loading-spinner">
        <p>Loading appointments...</p>
      </div>
    ) : (
      <div className="table-wrapper">
        {filteredAppointmentData.length === 0 ? (
          <p className="no-data-message">No appointments found.</p>
        ) : (
          <>
            {/* Show total count */}
            <div className="table-info">
              Showing {filteredAppointmentData.length} appointments
              {appointmentFilterDoctor && ' for selected doctor'}
              {appointmentDateFrom && appointmentDateTo && 
                ` (${appointmentDateFrom} to ${appointmentDateTo})`}
            </div>
            
            <table className="appointments-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Appointment No</th>
                  <th>Patient Name</th>
                  <th>Patient Contact</th>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Referred By</th>
                  <th>Remark</th>
                  <th>WhatsApp</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredAppointmentData.map((appointment, index) => (
                  <tr key={appointment.id} className={appointmentEditingId === appointment.id ? 'editing-row' : ''}>
                    {appointmentEditingId === appointment.id ? (
                      // Edit Mode
                      <>
                        <td>{index + 1}</td>
                        <td>{appointment.appointmentNo}</td>
                        <td>
                          <input
                            type="text"
                            name="patientName"
                            value={appointmentEditForm.patientName}
                            onChange={handleAppointmentEditChange}
                            className="edit-input"
                            required
                          />
                        </td>
                        <td>
                          <input
                            type="tel"
                            name="patientContact"
                            value={appointmentEditForm.patientContact}
                            onChange={handleAppointmentEditChange}
                            className="edit-input"
                            required
                          />
                        </td>
                        <td>
                          <input
                            type="date"
                            name="appointmentDate"
                            value={appointmentEditForm.appointmentDate}
                            onChange={handleAppointmentEditChange}
                            className="edit-input"
                            required
                          />
                        </td>
                        <td>
                          <input
                            type="time"
                            name="appointmentTime"
                            value={appointmentEditForm.appointmentTime}
                            onChange={handleAppointmentEditChange}
                            className="edit-input"
                            required
                          />
                        </td>
                        <td>
                          <select
                            name="referredBy"
                            value={appointmentEditForm.referredBy}
                            onChange={handleAppointmentEditChange}
                            className="edit-select"
                            required
                          >
                            <option value="">Select Doctor...</option>
                            {appointmentDoctorList.map(doctor => (
                              <option key={doctor.id} value={doctor.id}>
                                Dr. {doctor.drName}
                              </option>
                            ))}
                          </select>
                        </td>
                        <td>
                          <input
                            type="text"
                            name="remark"
                            value={appointmentEditForm.remark}
                            onChange={handleAppointmentEditChange}
                            className="edit-input"
                            placeholder="Remark"
                          />
                        </td>
                        <td>-</td>
                        <td>
                          <button
                            onClick={() => handleAppointmentSaveEdit(appointment.id)}
                            className="save-btn"
                          >
                            Save
                          </button>
                          <button
                            onClick={cancelAppointmentEdit}
                            className="cancel-btn"
                          >
                            Cancel
                          </button>
                        </td>
                      </>
                    ) : (
                      // View Mode
                      <>
                        <td>{index + 1}</td>
                        <td><strong>{appointment.appointmentNo}</strong></td>
                        <td>{appointment.patientName || '-'}</td>
                        <td>{appointment.patientContact || '-'}</td>
                        <td>{appointment.appointmentDate}</td>
                        <td>{appointment.appointmentTime}</td>
                        <td>{appointment.referredByName || '-'}</td>
                        <td>{appointment.remark || '-'}</td>
                        <td>
                          <div className="whatsapp-buttons">
                            <button
                              onClick={() => sendAppointmentReminderWhatsApp(appointment)}
                              className="whatsapp-reminder-btn"
                              title="Send Reminder"
                            >
                              Reminder
                            </button>
                            <button
                              onClick={() => sendAppointmentCancellationWhatsApp(appointment)}
                              className="whatsapp-cancel-btn"
                              title="Send Cancellation"
                            >
                              Cancel
                            </button>
                          </div>
                        </td>
                        <td>
                          <div className="action-buttons">
                            <button
                              onClick={() => handleAppointmentEditClick(appointment)}
                              className="edit-btn"
                            >
                              Edit
                            </button>
                            <button
                              onClick={() => handleAppointmentDelete(appointment.id)}
                              className="delete-btn"
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}

        {/* Pagination */}
        {appointmentTotalPages > 1 && (
          <div className="pagination">
            <button
              onClick={() => goToAppointmentPage(appointmentCurrentPage - 1)}
              disabled={appointmentCurrentPage === 1}
              className="pagination-btn"
            >
              Previous
            </button>
            <span className="page-info">
              Page {appointmentCurrentPage} of {appointmentTotalPages}
            </span>
            <button
              onClick={() => goToAppointmentPage(appointmentCurrentPage + 1)}
              disabled={appointmentCurrentPage === appointmentTotalPages}
              className="pagination-btn"
            >
              Next
            </button>
          </div>
        )}
      </div>
    )}
  </div>
)}


{/************************************** add sales persons ******************************************************/}

{selectedOption === "addSalesperson" && (
 <div className="add-salesperson-container">
      <h2>Add Salesperson</h2>
      
      {/* Success Message */}
      {successMsg && (
        <div className="salesperson-success-message">
          {successMsg}
        </div>
      )}
      
      {/* Error Message */}
      {errorMsg && (
        <div className="salesperson-error-message">
          {errorMsg}
        </div>
      )}

      <form onSubmit={handleSalespersonSubmit} className="salesperson-form">
        {/* Salesperson Name */}
        <div className="salesperson-form-group">
          <label htmlFor="salespersonName" className="salesperson-label">
            Salesperson Name <span className="required-star">*</span>
          </label>
          <input
            type="text"
            id="salespersonName"
            name="salespersonName"
            value={salespersonFormData.salespersonName}
            onChange={handleSalespersonChange}
            className="salesperson-input"
            placeholder="Enter salesperson full name"
            required
          />
        </div>

        {/* Join Date */}
        <div className="salesperson-form-group">
          <label htmlFor="joinDate" className="salesperson-label">
            Join Date <span className="required-star">*</span>
          </label>
          <input
            type="date"
            id="joinDate"
            name="joinDate"
            value={salespersonFormData.joinDate}
            onChange={handleSalespersonChange}
            className="salesperson-input"
            required
          />
        </div>

        {/* Salesperson Code (Password-like) */}
        <div className="salesperson-form-group">
          <label htmlFor="salespersonCode" className="salesperson-label">
            Salesperson Code (Password) <span className="required-star">*</span>
          </label>
          <div className="salesperson-code-wrapper">
            <input
              type={showPassword ? 'text' : 'password'}
              id="salespersonCode"
              name="salespersonCode"
              value={salespersonFormData.salespersonCode}
              onChange={handleSalespersonChange}
              className="salesperson-input salesperson-code-input"
              placeholder="Enter salesperson code or generate"
              required
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="toggle-password-btn"
              title={showPassword ? 'Hide code' : 'Show code'}
            >
              {showPassword ? '👁️' : '👁️‍🗨️'}
            </button>
            <button
              type="button"
              onClick={generateSalespersonCode}
              className="generate-code-btn"
              title="Generate random code"
            >
              Generate
            </button>
          </div>
          <small className="salesperson-hint">
            Code will be used as password for salesperson login
          </small>
        </div>

        {/* Email (Optional) */}
        <div className="salesperson-form-group">
          <label htmlFor="salespersonEmail" className="salesperson-label">
            Email Address <span className="optional-text">(Optional)</span>
          </label>
          <input
            type="email"
            id="salespersonEmail"
            name="salespersonEmail"
            value={salespersonFormData.salespersonEmail}
            onChange={handleSalespersonChange}
            className="salesperson-input"
            placeholder="Enter email address"
          />
        </div>

        {/* Phone (Optional) */}
        <div className="salesperson-form-group">
          <label htmlFor="salespersonPhone" className="salesperson-label">
            Phone Number <span className="optional-text">(Optional)</span>
          </label>
          <input
            type="tel"
            id="salespersonPhone"
            name="salespersonPhone"
            value={salespersonFormData.salespersonPhone}
            onChange={handleSalespersonChange}
            className="salesperson-input"
            placeholder="Enter phone number"
          />
        </div>

  
        {/* Submit Button */}
        <button
          type="submit"
          disabled={isSubmitting}
          className="salesperson-submit-btn"
        >
          {isSubmitting ? 'Adding Salesperson...' : 'Add Salesperson'}
        </button>
      </form>

      {/* Code generation info */}
      <div className="salesperson-info-box">
        <h4>💡 Tip:</h4>
        <p>
          The <strong>Salesperson Code</strong> serves as a password and should be 
          shared securely with the salesperson. You can either:
        </p>
        <ul>
          <li>Enter a custom code manually</li>
          <li>Click <strong>"Generate"</strong> for a random secure code</li>
        </ul>

      </div>
    </div>
)}



{/************************************** view all sales persons ******************************************************/}

{selectedOption === "manageSalesPerson" && (
 <div className="manage-salesperson-container">
      <h2>Manage Salespersons</h2>
      
      {/* Notification Messages */}
      {successNotification && (
        <div className="salesperson-success-message">
          {successNotification}
        </div>
      )}
      
      {errorNotification && (
        <div className="salesperson-error-message">
          {errorNotification}
        </div>
      )}

      {/* Controls */}
      <div className="salesperson-table-controls">
        <button 
          onClick={loadAllSalespersons}
          className="salesperson-refresh-button"
          disabled={isLoadingData}
        >
          {isLoadingData ? 'Loading...' : 'Refresh List'}
        </button>
        <span className="salesperson-total-count">
          Total Salespersons: {salespersonList.length}
        </span>
      </div>

      {/* Salespersons Table */}
      {isLoadingData ? (
        <div className="salesperson-loading-spinner">
          <p>Loading salespersons...</p>
        </div>
      ) : (
        <div className="salesperson-table-wrapper">
          {salespersonList.length === 0 ? (
            <p className="salesperson-no-data-message">No salespersons found.</p>
          ) : (
            <table className="salespersons-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Join Date</th>
                  <th>Code</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {salespersonList.map((salesperson, index) => (
                  <tr 
                    key={salesperson.id} 
                    className={editingSalespersonId === salesperson.id ? 'salesperson-editing-row' : ''}
                  >
                    {editingSalespersonId === salesperson.id ? (
                      // Edit Mode
                      <>
                        <td>{index + 1}</td>
                        <td>
                          <input
                            type="text"
                            name="salespersonName"
                            value={editSalespersonForm.salespersonName}
                            onChange={handleEditSalespersonChange}
                            className="salesperson-edit-input"
                            required
                          />
                        </td>
                        <td>
                          <input
                            type="date"
                            name="joinDate"
                            value={editSalespersonForm.joinDate}
                            onChange={handleEditSalespersonChange}
                            className="salesperson-edit-input"
                            required
                          />
                        </td>
                        <td>
                          <div className="salesperson-code-readonly">
                            <input
                              type={showPassword ? 'text' : 'password'}
                              name="salespersonCode"
                              value={editSalespersonForm.salespersonCode}
                              className="salesperson-edit-input salesperson-code-readonly-input"
                              readOnly
                              disabled
                            />
                   
                            <span className="salesperson-readonly-badge">Read Only</span>
                          </div>
                        </td>
                        <td>
                          <input
                            type="email"
                            name="salespersonEmail"
                            value={editSalespersonForm.salespersonEmail}
                            onChange={handleEditSalespersonChange}
                            className="salesperson-edit-input"
                          />
                        </td>
                        <td>
                          <input
                            type="tel"
                            name="salespersonPhone"
                            value={editSalespersonForm.salespersonPhone}
                            onChange={handleEditSalespersonChange}
                            className="salesperson-edit-input"
                          />
                        </td>
<td>
  <div className="salesperson-edit-actions">
    <button
      onClick={() => handleSaveSalespersonEdit(salesperson.id)}
      className="salesperson-save-button"
    >
      Save
    </button>
    <button
      onClick={resetSalespersonEditMode}
      className="salesperson-cancel-button"
    >
      Cancel
    </button>
  </div>
</td>
                      </>
                    ) : (
                      // View Mode
                      <>
                        <td>{index + 1}</td>
                        <td><strong>{salesperson.salespersonName}</strong></td>
                        <td>{salesperson.joinDate}</td>
               <td>
  <div className="salesperson-code-display">
    <span className="salesperson-code-text">
      {showCodeInTable[salesperson.id] ? 
        salesperson.salespersonCode : 
        maskCode(salesperson.salespersonCode)
      }
    </span>

  </div>
</td>
                        <td>{salesperson.salespersonEmail || '-'}</td>
                        <td>{salesperson.salespersonPhone || '-'}</td>
          
                        <td>
                          <button
                            onClick={() => handleEditSalespersonClick(salesperson)}
                            className="salesperson-edit-button"
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => handleDeleteSalespersonClick(salesperson.id)}
                            className="salesperson-delete-button"
                          >
                            Delete
                          </button>
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
)}


{/************************************** add doctors ******************************************************/}

{selectedOption === "addDoctors" && (
 <div className="add-doctor-container">
      <h2>Add Doctors</h2>
      
      {successMsg && (
        <div className="success-message" style={{
          backgroundColor: '#d4edda',
          color: '#155724',
          padding: '10px',
          borderRadius: '4px',
          marginBottom: '15px'
        }}>
          {successMsg}
        </div>
      )}
      
      {errorMsg && (
        <div className="error-message" style={{
          backgroundColor: '#f8d7da',
          color: '#721c24',
          padding: '10px',
          borderRadius: '4px',
          marginBottom: '15px'
        }}>
          {errorMsg}
        </div>
      )}

      <form onSubmit={handleDoctorSubmit} className="doctor-form">
        <div className="form-group" style={{ marginBottom: '15px' }}>
          <label htmlFor="drName" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Dr. Name:
          </label>
          <input
            type="text"
            id="drName"
            name="drName"
            value={doctorFormData.drName}
            onChange={handleDoctorChange}
            required
            style={{
              width: '100%',
              padding: '8px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px'
            }}
            placeholder="Enter doctor's full name"
          />
        </div>

        <div className="form-group" style={{ marginBottom: '15px' }}>
          <label htmlFor="contactNo" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Contact No:
          </label>
          <input
            type="tel"
            id="contactNo"
            name="contactNo"
            value={doctorFormData.contactNo}
            onChange={handleDoctorChange}
            style={{
              width: '100%',
              padding: '8px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px'
            }}
            placeholder="Enter contact number"
          />
        </div>

        <div className="form-group" style={{ marginBottom: '15px' }}>
          <label htmlFor="address" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Address:
          </label>
          <textarea
            id="address"
            name="address"
            value={doctorFormData.address}
            onChange={handleDoctorChange}
            style={{
              width: '100%',
              padding: '8px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px',
              minHeight: '80px',
              resize: 'vertical'
            }}
            placeholder="Enter clinic/hospital address"
          />
        </div>

        <div className="form-group" style={{ marginBottom: '15px' }}>
          <label htmlFor="channelingCharge" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Channeling Charge:
          </label>
          <input
            type="number"
            id="channelingCharge"
            name="channelingCharge"
            value={doctorFormData.channelingCharge}
            onChange={handleDoctorChange}
            min="0"
            step="0.01"
            style={{
              width: '100%',
              padding: '8px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px'
            }}
            placeholder="Enter channeling charge"
          />
        </div>

        <div className="form-group" style={{ marginBottom: '15px' }}>
          <label htmlFor="practice" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
            Practice (Specific):
          </label>
          <input
            type="text"
            id="practice"
            name="practice"
            value={doctorFormData.practice}
            onChange={handleDoctorChange}
            style={{
              width: '100%',
              padding: '8px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '16px'
            }}
            placeholder="Enter specific practice area"
          />
        </div>

        <button
          type="submit"
          disabled={isLoading}
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: isLoading ? '#6c757d' : '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '16px',
            fontWeight: 'bold',
            cursor: isLoading ? 'not-allowed' : 'pointer',
            transition: 'background-color 0.3s'
          }}
        >
          {isLoading ? 'Adding Doctor...' : 'Add Doctor'}
        </button>
      </form>
    </div>
)}




{/************************************** manage doctors ******************************************************/}

{selectedOption === "manageDoctors" && (
     <div className="manage-doctor-container">
      <h2>Manage Doctors</h2>
      
      {/* Notification Messages */}
      {successNotification && (
        <div className="success-message">
          {successNotification}
        </div>
      )}
      
      {errorNotification && (
        <div className="error-message">
          {errorNotification}
        </div>
      )}

      {/* Controls */}
      <div className="table-controls">
        <button 
          onClick={loadAllDoctors}
          className="refresh-button"
          disabled={isLoadingData}
        >
          {isLoadingData ? 'Loading...' : 'Refresh List'}
        </button>
        <span className="total-count">
          Total Doctors: {doctorList.length}
        </span>
      </div>

      {/* Doctors Table */}
      {isLoadingData ? (
        <div className="loading-spinner">
          <p>Loading doctors...</p>
        </div>
      ) : (
        <div className="table-wrapper">
          {doctorList.length === 0 ? (
            <p className="no-data-message">No doctors found.</p>
          ) : (
            <table className="doctors-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Dr. Name</th>
                  <th>Contact</th>
                  <th>Address</th>
                  <th>Charge</th>
                  <th>Practice</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {doctorList.map((doctor, index) => (
                  <tr 
                    key={doctor.id} 
                    className={editingDoctorId === doctor.id ? 'editing-row' : ''}
                  >
                    {editingDoctorId === doctor.id ? (
                      // Edit Mode
                      <>
                        <td>{index + 1}</td>
                        <td>
                          <input
                            type="text"
                            name="doctorName"
                            value={editDoctorForm.doctorName}
                            onChange={handleEditDoctorChange}
                            className="edit-input"
                            required
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="doctorContact"
                            value={editDoctorForm.doctorContact}
                            onChange={handleEditDoctorChange}
                            className="edit-input"
                            required
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="doctorAddress"
                            value={editDoctorForm.doctorAddress}
                            onChange={handleEditDoctorChange}
                            className="edit-input"
                            required
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            name="doctorCharge"
                            value={editDoctorForm.doctorCharge}
                            onChange={handleEditDoctorChange}
                            className="edit-input"
                            min="0"
                            step="0.01"
                            required
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="doctorPractice"
                            value={editDoctorForm.doctorPractice}
                            onChange={handleEditDoctorChange}
                            className="edit-input"
                            required
                          />
                        </td>
                        <td>
                          <button
                            onClick={() => handleSaveDoctorEdit(doctor.id)}
                            className="save-button"
                          >
                            Save
                          </button>
                          <button
                            onClick={resetEditMode}
                            className="cancel-button"
                          >
                            Cancel
                          </button>
                        </td>
                      </>
                    ) : (
                      // View Mode
                      <>
                        <td>{index + 1}</td>
                        <td>{doctor.drName}</td>
                        <td>{doctor.contactNo}</td>
                        <td>{doctor.address}</td>
                        <td>Rs. {doctor.channelingCharge || 0}</td>
                        <td>{doctor.practice}</td>
                        <td>
                          <button
                            onClick={() => handleEditDoctorClick(doctor)}
                            className="edit-button"
                          >
                            Edit
                          </button>
                          <button
                            onClick={() => handleDeleteDoctorClick(doctor.id)}
                            className="delete-button"
                          >
                            Delete
                          </button>
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
)}





{/********************* download Direct Sale Invoice *********************/}

{selectedOption === "downloadDirectSaleInvoice" && (
  <div className="download-Direct-Sale-Invoice-container">
    <div className="Direct-Sale-Invoice-container">
      <h2>Download Direct Sale Invoice</h2>


<div className="direct-sale-search">
  <input
    type="text"
    placeholder="Search Invoice No..."
    value={invoiceSearch}
    onChange={(e) => setInvoiceSearch(e.target.value)}
  />
</div>


<table className="direct-sale-table">
  <thead>
    <tr>
      <th>Invoice No</th>
      <th>Customer</th>
      <th>TP No</th>
      <th>Address</th>
      <th>Products</th>
      <th>Date</th>
      <th>Total</th>
      <th>Action</th>
    </tr>
  </thead>

  <tbody>
    {filteredDirectSaleInvoices.map((invoice) => (
      <tr key={invoice.id}>
        <td>{invoice.invoiceNumber}</td>

        <td>
          {invoice.customer?.fullName || "-"}
        </td>

        <td>
          {invoice.customer?.tpNo || "-"}
        </td>

        <td>
          {invoice.customer?.address || "-"}
        </td>

<td>
  {Array.isArray(invoice.products) ? (
    invoice.products.map((product) =>
      `Model: ${product.modelNo} | qty: ${product.qty} | size: ${product.size} | Base Curve: ${product.BaseCurve} | R power: ${product.rPower} | L Power: ${product.lPower}`
    ).join(" | ")
  ) : (
    "-"
  )}
</td>

        <td>
          {new Date(
            invoice.createdAt
          ).toLocaleDateString()}
        </td>

        <td>
          Rs.{" "}
          {Number(
            invoice.financial?.totalAmount || 0
          ).toFixed(2)}
        </td>

        <td>
          <div className="action-buttons">
            <button
              className="download-btn"
              onClick={() =>
                generateDirectSaleInvoicePDF(invoice)
              }
            >
              Download
            </button>
          </div>
        </td>
      </tr>
    ))}
  </tbody>
</table>

    </div>
  </div>
)}






{/********************* download Service Invoice *********************/}


{selectedOption === "downloadServiceInvoice" && (
  <div className="download-Service-Invoice-container">

    <div className="Service-Invoice-container">

      <h2>Download Service Invoice</h2>

      <div className="direct-sale-search">
        <input
          type="text"
          placeholder="Search Invoice No..."
          value={serviceInvoiceSearch}
          onChange={(e) =>
            setServiceInvoiceSearch(e.target.value)
          }
        />
      </div>

      <table className="direct-sale-table">
        <thead>
          <tr>
            <th>Invoice No</th>
            <th>Customer</th>
            <th>TP No</th>
            <th>Address</th>
            <th>Service</th>
            <th>Date</th>
            <th>Total</th>
            <th>Balance</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>

          {filteredServiceInvoices.map((invoice) => (

            <tr key={invoice.id}>

              <td>{invoice.invoiceNumber}</td>

              <td>
                {invoice.customer?.fullName || "-"}
              </td>

              <td>
                {invoice.customer?.tpNo || "-"}
              </td>

              <td>
                {invoice.customer?.address || "-"}
              </td>

              <td>
                {invoice.service?.description || "-"}
              </td>

              <td>
                {new Date(
                  invoice.createdAt
                ).toLocaleDateString()}
              </td>

              <td>
                Rs.
                {Number(
                  invoice.financial?.totalAmount || 0
                ).toFixed(2)}
              </td>

              <td>
                Rs.
                {Number(
                  invoice.financial?.balanceDue || 0
                ).toFixed(2)}
              </td>

              <td>
                <div className="action-buttons">

                  <button
                    className="download-btn"
                    onClick={() =>
                      generateServiceInvoicePDF(invoice)
                    }
                  >
                    Download
                  </button>

                </div>
              </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>

  </div>
)}






{/********************* download main Invoice *********************/}

{selectedOption === "downloadMainInvoice" && (
  <div className="download-Service-Invoice-container">
    <div className="Service-Invoice-container">
      <h2>Download Main Invoice</h2>

      <div className="direct-sale-search">
        <input
          type="text"
          placeholder="Search Invoice No..."
          value={mainInvoiceSearch}
          onChange={(e) => setMainInvoiceSearch(e.target.value)}
        />
      </div>

      <table className="direct-sale-table">
        <thead>
          <tr>
            <th>Invoice No</th>
            <th>Customer</th>
            <th>TP No</th>
            <th>Address</th>
            <th>Frame Details</th>
            <th>Lens Details</th>
            <th>Date</th>
            <th>Total</th>
            <th>Balance</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredMainInvoices.length > 0 ? (
            filteredMainInvoices.map((invoice) => (
              <tr key={invoice.id}>
                <td>{invoice.invoiceNumber}</td>
                <td>{invoice.customer?.fullName || "-"}</td>
                <td>{invoice.customer?.tpNo || "-"}</td>
                <td>{invoice.customer?.address || "-"}</td>
                
                {/* Frame Details */}
                <td>
                  {invoice.products?.frameModel ? (
                    `${invoice.products.frameModel} | ${invoice.products.brand || "-"} | ${invoice.products.colour || "-"}`
                  ) : (
                    "-"
                  )}
                </td>

                {/* Lens Details */}
                <td>
                  {(() => {
                    const leftLens = invoice.products?.leftLens;
                    const rightLens = invoice.products?.rightLens;
                    const highIndexLeft = invoice.products?.highIndexLeft;
                    const highIndexRight = invoice.products?.highIndexRight;
                    
                    // Check for High Index lenses
                    if (invoice.products?.highIndexLens) {
                      const left = highIndexLeft?.name || highIndexLeft?.lensName || '';
                      const right = highIndexRight?.name || highIndexRight?.lensName || '';
                      if (left || right) {
                        return `${left}${right ? ' / ' + right : ''}`;
                      }
                    }
                    
                    // Check for regular lenses
                    if (leftLens?.name || rightLens?.name) {
                      const left = leftLens?.name || '';
                      const right = rightLens?.name || '';
                      return `${left}${right ? ' / ' + right : ''}`;
                    }
                    
                    return "-";
                  })()}
                </td>

                <td>{new Date(invoice.createdAt).toLocaleDateString()}</td>
                <td>Rs.{Number(invoice.financial?.totalAmount || 0).toFixed(2)}</td>
                <td>Rs.{Number(invoice.financial?.balanceDue || 0).toFixed(2)}</td>
                <td>
                  <div className="action-buttons">
                    <button
                      className="download-btn"
                      onClick={() => generateFullInvoicePDF(invoice)}
                    >
                      Customer Invoice
                    </button>
                    {invoice.prescription && (
                      <button
                        className="download-prescription-btn"
                        onClick={() => generateCustomerPrescriptionPDF(invoice)}
                        style={{ marginLeft: '8px' }}
                      >
                        Oder Form
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="10" style={{ textAlign: 'center', padding: '40px' }}>
                No main invoices found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
)}





{/****************************************************  add eye camp  ************************************************************/}


{selectedOption === "addEyeCamp" && (
  <div className="add-eye-camp-container">
    <div className="add-eye-camp-card">
      <h2>Add Eye Camp</h2>

      {/* Eye Camp Name */}
      <label>
        Eye Camp Name <span className="required-star">*</span>
      </label>
      <input
        type="text"
        value={eyeCampName}
        onChange={(e) => setEyeCampName(e.target.value)}
        placeholder="Enter eye camp name (e.g., Vision Care Camp 2024)"
      />

      {/* City */}
      <label>
        City <span className="required-star">*</span>
      </label>
      <input
        type="text"
        value={eyeCampCity}
        onChange={(e) => setEyeCampCity(e.target.value)}
        placeholder="Enter city (e.g., Colombo, Kandy)"
      />

      {/* Buttons */}
      <div className="button-group">
        <button 
          className="btn-clear-eye-camp" 
          onClick={handleClearEyeCamp}
          type="button"
        >
          Clear
        </button>
        <button 
          className="btn-add-eye-camp" 
          onClick={handleAddEyeCamp} 
          disabled={addingEyeCamp}
        >
          {addingEyeCamp ? "Adding..." : "Add Eye Camp"}
        </button>
      </div>
    </div>
  </div>
)}


{/****************************************************  view eye camp  ************************************************************/}

{selectedOption === "viewEyeCamps" && (
  <div className="view-eye-camps-container">
    <div className="view-eye-camps-header">
      <h2>Eye Camps</h2>
      <div className="search-section">
        <input
          type="text"
          className="search-input"
          placeholder="Search by name or city..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button onClick={fetchEyeCamps} className="refresh-button">
          🔄 Refresh
        </button>
      </div>
    </div>

    <table className="eye-camps-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Eye Camp Name</th>
          <th>City</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {filteredCamps.map((camp, index) => (
          <tr key={camp.id} className={editingEyeCampId === camp.id ? 'editing-row' : ''}>
            {editingEyeCampId === camp.id ? (
              // Edit Mode
              <>
                <td>{index + 1}</td>
                <td>
                  <input
                    type="text"
                    name="name"
                    value={editEyeCampForm.name}
                    onChange={handleEditEyeCampChange}
                    className="edit-input"
                    required
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="city"
                    value={editEyeCampForm.city}
                    onChange={handleEditEyeCampChange}
                    className="edit-input"
                    required
                  />
                </td>
                <td>
                  <div className="action-buttons">
                    <button
                      onClick={() => handleSaveEyeCampEdit(camp.id)}
                      className="save-btn"
                    >
                      Save
                    </button>
                    <button
                      onClick={resetEyeCampEditMode}
                      className="cancel-btn"
                    >
                      Cancel
                    </button>
                  </div>
                </td>
              </>
            ) : (
              // View Mode
              <>
                <td>{index + 1}</td>
                <td>{camp.name}</td>
                <td>{camp.city}</td>
                <td>
                  <div className="action-buttons">
                    <button
                      onClick={() => handleEditEyeCamp(camp)}
                      className="edit-btn"
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDeleteEyeCamp(camp.id)}
                      className="delete-btn"
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)}



{/*************************************** patient follow-up **********************************************************/}

{selectedOption === "patientfollowup" && (
  <div
    style={{
      padding: "20px",
      background: "#f8fafc",
      minHeight: "100vh",
    }}
  >
    {/* Header */}
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
      }}
    >
      <div>
        <h2
          style={{
            margin: 0,
            color: "#1e293b",
            fontWeight: "700",
          }}
        >
          Patient Follow-ups
        </h2>

        <small style={{ color: "#64748b" }}>
          Upcoming patient follow-up reminders
        </small>
      </div>

      <div
        style={{
          background: "#dc2626",
          color: "#fff",
          padding: "10px 18px",
          borderRadius: "30px",
          fontWeight: "600",
          boxShadow: "0 4px 12px rgba(220,38,38,.2)",
        }}
      >
        Today:{" "}
        {
          followUpPatients.filter((p) => {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            const followDate = new Date(
              p.followUp?.date
            );

            return (
              followDate.getTime() ===
              today.getTime()
            );
          }).length
        }
      </div>
    </div>

    {loadingFollowUps ? (
      <div
        style={{
          textAlign: "center",
          padding: "50px",
          color: "#64748b",
        }}
      >
        Loading Follow-ups...
      </div>
    ) : (
      <div
        style={{
          display: "grid",
          gap: "12px",
        }}
      >
        {followUpPatients.map((patient) => {
          const followDate = new Date(
            patient.followUp.date
          );

          const today = new Date();
          today.setHours(0, 0, 0, 0);

          const diffDays = Math.ceil(
            (followDate - today) /
              (1000 * 60 * 60 * 24)
          );

          let statusColor = "#22c55e";
          let statusText = `${diffDays} Days Left`;

          if (diffDays <= 3) {
            statusColor = "#ef4444";
          } else if (diffDays <= 7) {
            statusColor = "#f97316";
          }

          if (diffDays === 0) {
            statusText = "Today";
          }

          if (diffDays === 1) {
            statusText = "Tomorrow";
          }

          return (
            <div
              key={patient.id}
              style={{
                background: "#fff",
                borderRadius: "14px",
                padding: "15px 18px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                boxShadow:
                  "0 2px 10px rgba(0,0,0,0.06)",
                border: "1px solid #e2e8f0",
              }}
            >
              {/* Left Side */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                }}
              >
                <div
                  style={{
                    width: "18px",
                    height: "18px",
                    borderRadius: "50%",
                    background: statusColor,
                    boxShadow: `0 0 10px ${statusColor}`,
                  }}
                />

                <div>
                  <div
                    style={{
                      fontWeight: "700",
                      color: "#0f172a",
                      fontSize: "15px",
                    }}
                  >
                    {patient.patientInfo?.name}
                  </div>

                  <div
                    style={{
                      color: "#64748b",
                      fontSize: "13px",
                      marginTop: "3px",
                    }}
                  >
                    📅 {patient.followUp?.date}
                  </div>

                  <div
                    style={{
                      color: "#475569",
                      fontSize: "13px",
                      marginTop: "2px",
                    }}
                  >
                    📝 {patient.followUp?.remarks}
                  </div>
                </div>
              </div>

              {/* Right Side */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <div
                  style={{
                    background: `${statusColor}15`,
                    color: statusColor,
                    padding: "6px 12px",
                    borderRadius: "30px",
                    fontSize: "12px",
                    fontWeight: "600",
                  }}
                >
                  {statusText}
                </div>

                <button
                  onClick={() =>
                    sendFollowUpWhatsApp(patient)
                  }
                  style={{
                    background: "#25D366",
                    color: "#fff",
                    border: "none",
                    padding: "8px 14px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontWeight: "600",
                  }}
                >
                  {patient.patientInfo?.contactNo}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    )}
  </div>
)}






{/*********************************************  Birthday Wishes  *************************************************/}



{selectedOption === "birthdayWishes" && (
  <div
    style={{
      padding: "20px",
      background: "#f8fafc",
      minHeight: "100vh",
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent:
          "space-between",
        alignItems: "center",
        marginBottom: "20px",
      }}
    >
      <h2
        style={{
          margin: 0,
          color: "#1e293b",
        }}
      >
        🎂 Patient Birthday Wishes
      </h2>

      <div
        style={{
          background: "#ec4899",
          color: "#fff",
          padding: "10px 18px",
          borderRadius: "30px",
          fontWeight: "600",
        }}
      >
        Today: {todayBirthdays.length}
      </div>
    </div>

    {loadingBirthdays ? (
      <p>Loading...</p>
    ) : (
      <div
        style={{
          display: "grid",
          gridTemplateColumns:
            "repeat(auto-fit,minmax(350px,1fr))",
          gap: "20px",
        }}
      >
        {/* Today */}
        <div>
          <h3
            style={{
              color: "#ef4444",
              marginBottom: "12px",
            }}
          >
            🎉 Today
          </h3>

          {todayBirthdays.length ===
          0 ? (
            <p
              style={{
                color: "#64748b",
              }}
            >
              No birthdays today
            </p>
          ) : (
            todayBirthdays.map(
              (patient) => (
                <BirthdayCard
                  key={patient.id}
                  patient={patient}
                  color="#ef4444"
                />
              )
            )
          )}
        </div>

        {/* Tomorrow */}
        <div>
          <h3
            style={{
              color: "#f97316",
              marginBottom: "12px",
            }}
          >
            🎁 Tomorrow
          </h3>

          {tomorrowBirthdays.length ===
          0 ? (
            <p
              style={{
                color: "#64748b",
              }}
            >
              No birthdays tomorrow
            </p>
          ) : (
            tomorrowBirthdays.map(
              (patient) => (
                <BirthdayCard
                  key={patient.id}
                  patient={patient}
                  color="#f97316"
                />
              )
            )
          )}
        </div>

        {/* Day After Tomorrow */}
        <div>
          <h3
            style={{
              color: "#22c55e",
              marginBottom: "12px",
            }}
          >
            🎈 Day After Tomorrow
          </h3>

          {dayAfterTomorrowBirthdays.length ===
          0 ? (
            <p
              style={{
                color: "#64748b",
              }}
            >
              No birthdays
            </p>
          ) : (
            dayAfterTomorrowBirthdays.map(
              (patient) => (
                <BirthdayCard
                  key={patient.id}
                  patient={patient}
                  color="#22c55e"
                />
              )
            )
          )}
        </div>
      </div>
    )}
  </div>
)}





{/************************************************ CREATE service Invoice  / service bill *****************************************************/}


{selectedOption === "serviceInvoice" && (

<div className="invoice-wrap">

  {/* HEADER */}

    <div className="invoice-header">
      <div className="header-left">
        <h2>Service Invoice</h2>
        <p className="invoice-subtitle">Eye Care Services & Professional Charges</p>
      </div>
      
      <div className="invoice-number-display">
        {/* Main Invoice Number - Always displayed */}
    <div className="invoice-number-display">
      Next Invoice: {currentMainInvoiceNumber}
    </div>
        
        {/* R Number */}
        <div className="invoice-type-selector">
          <label>R No:</label>
          <span className="number">{currentRNumber}</span>
        </div>
      </div>
    </div>

  <div className="invoice-content">

    {/* =====================================================
       CUSTOMER SECTION
    ===================================================== */}

    <div className="invoice-section">

      {/* SERVED BY */}

     <div className="detail-item">
  <label>
    Served By <span className="required-star">*</span>
  </label>
  <select
    className={errors.salePerson ? "error-input" : ""}
    value={formData.salePerson}
    onChange={(e) =>
      setFormData({
        ...formData,
        salePerson: e.target.value,
      })
    }
    required
  >
    <option value="">
      Select Sales Person
    </option>
    {salesPersonList.map(person => (
      <option key={person.id} value={person.salespersonName}>
        {person.salespersonName}
      </option>
    ))}
  </select>
  {errors.salePerson && <span className="error-message">{errors.salePerson}</span>}
</div>

      <div className="section-header">

        <h3>Customer Information</h3>

        <span className="section-badge">
          Required
        </span>

      </div>

      <div className="form-row">

        <div className="form-group">

          <label>Title</label>

          <select
            name="title"
            value={formData.title}
            onChange={handleInputChange}
          >
            <option value="">Select</option>
            <option value="Mr">Mr.</option>
            <option value="Mrs">Mrs.</option>
            <option value="Ms">Ms.</option>
            <option value="Dr">Dr.</option>
          </select>

        </div>

        <div className="form-group">

          <label>First Name *</label>

          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleInputChange}
            placeholder="Enter first name"
          />

        </div>

        <div className="form-group">

          <label>Last Name *</label>

          <input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleInputChange}
            placeholder="Enter last name"
          />

        </div>

      </div>

      <div className="form-row">

        <div className="form-group">

          <label>Address *</label>

          <input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleInputChange}
            placeholder="Street, city, postal code"
          />

        </div>

        <div className="form-group">

          <label>TP No *</label>

          <input
            type="text"
            name="tpNo"
            value={formData.tpNo}
            onChange={handleInputChange}
            placeholder="Phone Number"
          />

        </div>

      </div>

    </div>

    {/* =====================================================
       SERVICE DETAILS
    ===================================================== */}

    <div className="invoice-section">

      <div className="section-header">

        <h3>Service Details</h3>

        <span className="section-badge">
          Required
        </span>

      </div>

      <div className="form-group">

        <label>Service Description *</label>

        <textarea
          rows="5"
          placeholder="Enter service description"
          value={serviceDescription}
          onChange={(e) =>
            setServiceDescription(
              e.target.value
            )
          }
        />

      </div>

      <div className="form-row">

        <div className="form-group">

          <label>Service Charge *</label>

          <input
            type="number"
            value={serviceAmount}
            onChange={(e) =>
              setServiceAmount(
                e.target.value
              )
            }
             onWheel={(e) => e.target.blur()}
            placeholder="Enter amount"
          />

        </div>

      </div>

    </div>

   {/* BILLING & PAYMENT SECTION */}
<div className="invoice-section">
  <div className="section-header">
    <h3>Billing & Payment</h3>
  </div>

  <div className="form-row">
    <div className="form-group">
      <label>Billing Date</label>
      <input
        type="date"
        value={billingDate}
        onChange={(e) => setBillingDate(e.target.value)}
      />
    </div>

    <div className="form-group">
      <label>Payment Method</label>
      <select
        value={servicePaymentMethod}
        onChange={(e) => {
          setServicePaymentMethod(e.target.value);
          // Reset amounts when switching
          if (e.target.value !== 'Split') {
            setServiceCashAmount(0);
            setServiceCardAmount(0);
          }
        }}
      >
        <option value="Cash">Cash</option>
        <option value="Card">Card</option>
        <option value="Split">Split (Cash + Card)</option>
      </select>
    </div>
  </div>

  {/* Split Payment Inputs */}
  {servicePaymentMethod === 'Split' && (
    <div className="split-payment-container">
      <div className="form-row">
        <div className="form-group">
          <label>Cash Amount</label>
          <input
            type="number"
            min="0"
            value={serviceCashAmount}
            onChange={(e) => {
              const val = Number(e.target.value);
              setServiceCashAmount(val);
            }}
            placeholder="Enter cash amount"
            onWheel={(e) => e.target.blur()}
          />
        </div>
        <div className="form-group">
          <label>Card Amount</label>
          <input
            type="number"
            min="0"
            value={serviceCardAmount}
            onChange={(e) => {
              const val = Number(e.target.value);
              setServiceCardAmount(val);
            }}
            placeholder="Enter card amount"
            onWheel={(e) => e.target.blur()}
          />
        </div>
      </div>
      
      <div className="split-total">
        <span>Total Paid: Rs.{(Number(serviceCashAmount) + Number(serviceCardAmount)).toFixed(2)}</span>
        <span className="split-remaining">
          Remaining: Rs.{(serviceGrandTotal - (Number(serviceCashAmount) + Number(serviceCardAmount))).toFixed(2)}
        </span>
      </div>
    </div>
  )}

  {/* Regular payment input for non-split */}
  {servicePaymentMethod !== 'Split' && (
    <div className="form-row">
      <div className="form-group">
        <label>Payment Type</label>
        <select
          value={servicePaymentType}
          onChange={(e) => setServicePaymentType(e.target.value)}
        >
          <option value="full">Full Payment</option>
          <option value="advance">Advance Payment</option>
        </select>
      </div>

      {servicePaymentType === "advance" && (
        <div className="form-group">
          <label>Advance Payment</label>
          <input
            type="number"
            name="advancePayment"
            value={formData.advancePayment}
            onChange={handleInputChange}
            onWheel={(e) => e.target.blur()}
            placeholder="Enter advance amount"
          />
        </div>
      )}
    </div>
  )}

  {/* Discount Section */}
  <div className="form-row">
    <div className="form-group">
      <label>Discount Type</label>
      <select
        value={discountType}
        onChange={(e) => setDiscountType(e.target.value)}
      >
        <option value="amount">Amount</option>
        <option value="percentage">Percentage %</option>
      </select>
    </div>

    <div className="form-group">
      <label>Discount</label>
      <input
        type="number"
        name="discount"
        value={formData.discount}
        onChange={handleInputChange}
        onWheel={(e) => e.target.blur()}
      />
    </div>
  </div>

  {/* Financial Summary */}
  <div className="financial-summary">
    <div data-label="Subtotal">
      Rs.{serviceSubtotal.toFixed(2)}
    </div>

    <div data-label="Discount">
      Rs.{serviceCalculatedDiscount.toFixed(2)}
    </div>

    <div data-label="Grand Total">
      Rs.{serviceGrandTotal.toFixed(2)}
    </div>

    {servicePaymentMethod === 'Split' && (
      <>
        <div data-label="Cash Paid">
          Rs.{(Number(serviceCashAmount) || 0).toFixed(2)}
        </div>
        <div data-label="Card Paid">
          Rs.{(Number(serviceCardAmount) || 0).toFixed(2)}
        </div>
      </>
    )}

    <div data-label="Paid">
      Rs.{serviceAdvanceAmount.toFixed(2)}
    </div>

    <div data-label="Balance">
      Rs.{serviceBalance.toFixed(2)}
    </div>

    <div data-label="Status">
      {serviceBalance <= 0 ? "FULLY PAID" : "ADVANCE PAID"}
    </div>
  </div>
</div>

    {/* =====================================================
       ACTIONS
    ===================================================== */}

    <div className="invoice-actions">

<button 
  className="btn-save"
  onClick={handleSaveServiceInvoice}
  disabled={isSavingServiceInvoice}
>
  {isSavingServiceInvoice
    ? "Creating..."
    : "Create Service Invoice"}
</button>

    </div>

  </div>

</div>

)}





{/********************************* direct sales direct invoice *******************************************************/}


{selectedOption === "directSales" && (

<div className="invoice-wrap">

<div className="invoice-header">
  <div className="header-left">
    <h2>Direct Sales Invoice</h2>
    <p className="invoice-subtitle">Sunglasses, Accessories & Other Products</p>
  </div>
  
  <div className="invoice-number-display">
    {/* Main Invoice Number - Always displayed */}
    <div className="invoice-number-display">
      Next Invoice: {currentMainInvoiceNumber}
    </div>
    
    {/* CL/S Number - Selectable */}
    <div className="invoice-type-selector">
      <label>Type:</label>
      <select 
        value={directInvoiceType} 
        onChange={handleDirectInvoiceTypeChange}
        className="invoice-type-select"
      >
        <option value="CL">CL No</option>
        <option value="S">S No</option>
      </select>
      <span className="number">
        {directInvoiceType === 'CL' ? currentCLNumber : currentSNumber}
      </span>
    </div>
  </div>
</div>

  <div className="invoice-content">

    {/* CUSTOMER */}

    <div className="invoice-section">

      {/* ================= SERVED BY ================= */}

<div className="detail-item">
  <label>Served By <span className="required-star">*</span></label>
  <select
    value={saleForm.salePerson}
    onChange={(e) =>
      setSaleForm({
        ...saleForm,
        salePerson: e.target.value
      })
    }
    className="sale-person-select"
    required
  >
    <option value="">
      Select Sales Person
    </option>
    {salesPersonList.map(person => (
      <option key={person.id} value={person.salespersonName}>
        {person.salespersonName} 
      </option>
    ))}
  </select>
</div>

      <div className="section-header">
        <h3>Customer Information</h3>
        <span className="section-badge">
          Required
        </span>
      </div>

      <div className="form-row">

        <div className="form-group">
          <label>Title</label>
          <select
            name="title"
            value={formData.title}
            onChange={handleInputChange}
          >
            <option value="">Select</option>
            <option value="Mr">Mr.</option>
            <option value="Mrs">Mrs.</option>
            <option value="Ms">Ms.</option>
            <option value="Dr">Dr.</option>
          </select>
        </div>

        <div className="form-group">
          <label>First Name *</label>
          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleInputChange}
            placeholder="Enter first name"
          />
        </div>

        <div className="form-group">
          <label>Last Name *</label>
          <input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleInputChange}
            placeholder="Enter last name"
          />
        </div>

      </div>

      <div className="form-row">

        <div className="form-group">
          <label>Address *</label>
          <input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleInputChange}
            placeholder="Street, city, postal code"
          />
        </div>

        <div className="form-group">
          <label>TP No *</label>
          <input
            type="text"
            name="tpNo"
            value={formData.tpNo}
            onChange={handleInputChange}
            placeholder="Phone Number"
          />
        </div>

      </div>

    </div>

    {/* PRODUCT SEARCH */}

    <div className="invoice-section">

      <div className="section-header">
        <h3>Products</h3>
        <span className="section-badge">
          Add Items
        </span>
      </div>

      <div className="form-group">

        <label>
          Search Product
        </label>

        <div style={{ position: "relative" }}>

          <input
            type="text"
            value={directSaleSearch}
            onChange={(e) =>
              handleDirectSaleSearch(e.target.value)
            }
            placeholder="Search by model no / brand / colour"
          />

          {showDirectSaleSuggestions &&
            directSaleSuggestions.length > 0 && (

            <div className="suggestions-dropdown">

              {directSaleSuggestions.map(
                (item, index) => (

                <div
                  key={index}
                  className="suggestion-item"
                  onClick={() =>
                    selectDirectProduct(item)
                  }
                >

                  <strong>
                    {item.modelNo}
                  </strong>

                  <div className="suggestion-details">

                    {item.brand} |
                    {item.colour} |
                    {item.size} |
                    Rs.{item.sellingPrice} |
                    {item.BaseCurve} |
                    {item.lPower} |
                    {item.rPower}

                    <span className="stock-badge">
                      Stock: {item.qty}
                    </span>

                  </div>

                </div>

              ))}

            </div>

          )}

        </div>

      </div>

      {/* CART */}

      {directSaleItems.length > 0 && (

      <div className="direct-sale-cart">

        <table className="direct-sale-table">

          <thead>
            <tr>
              <th>#</th>
              <th>Model</th>
              <th>Brand</th>
              <th>Size</th>
              <th>Colour</th>
              <th>Base Curve</th>
              <th>R Power</th>
              <th>L Power</th>
              <th>Price</th>
              <th>Qty</th>
              <th>Total</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {directSaleItems.map((item, index) => (

            <tr key={index}>
              <td>{index + 1}</td>
              <td>{item.modelNo}</td>
              <td>{item.brand}</td>
              <th>{item.size}</th>
              <td>{item.colour}</td>
              <td>{item.BaseCurve}</td>
              <td>{item.lPower}</td>
              <td>{item.rPower}</td>

              <td>
                Rs.{Number(item.sellingPrice).toFixed(2)}
              </td>
              <td>
                <input
                  type="number"
                  min="1"
                  max={item.stockQty}
                  value={item.qty}
                  className="qty-input"
                  onChange={(e) => {
                    let value = Number(e.target.value);
                    if (e.target.value === "") {
                      value = 1;
                    }
                    if (value < 1) {
                      value = 1;
                    }
                    if (value > item.stockQty) {
                      value = item.stockQty;
                    }
                    updateDirectSaleQty(index, value);
                  }}
                  onWheel={(e) => e.target.blur()}
                />
                <small className="stock-text">
                  Available Stock: {item.stockQty}
                </small>
              </td>
              <td className="item-total">
                Rs.{Number(item.total).toFixed(2)}
              </td>
              <td>
                <button
                  className="btn-delete-item"
                  onClick={() =>
                    removeDirectSaleItem(index)
                  }
                >
                  Delete
                </button>
              </td>
            </tr>

            ))}
          </tbody>

        </table>

      </div>

      )}

    </div>

    {/* BILLING */}

    <div className="invoice-section">

      <div className="section-header">
        <h3>Billing & Payment</h3>
      </div>

      <div className="form-row">

        <div className="form-group">
          <label>Billing Date</label>
          <input
            type="date"
            value={billingDate}
            onChange={(e) =>
              setBillingDate(e.target.value)
            }
          />
        </div>

        <div className="form-group">
          <label>Payment Method</label>
          <select
            value={paymentMethod}
            onChange={(e) => {
              setPaymentMethod(e.target.value);
              // Reset amounts when switching
              if (e.target.value !== 'Split') {
                setCashAmount(0);
                setCardAmount(0);
              }
            }}
          >
            <option value="Cash">Cash</option>
            <option value="Card">Card</option>
            <option value="Split">Split (Cash + Card)</option>
          </select>
        </div>

      </div>

      {/* Split Payment Inputs */}
      {paymentMethod === 'Split' && (
        <div className="split-payment-container">
          <div className="form-row">
            <div className="form-group">
              <label>Cash Amount</label>
              <input
                type="number"
                min="0"
                value={cashAmount}
                onChange={(e) => {
                  const val = Number(e.target.value);
                  setCashAmount(val);
                }}
                placeholder="Enter cash amount"
                onWheel={(e) => e.target.blur()}
              />
            </div>
            <div className="form-group">
              <label>Card Amount</label>
              <input
                type="number"
                min="0"
                value={cardAmount}
                onChange={(e) => {
                  const val = Number(e.target.value);
                  setCardAmount(val);
                }}
                placeholder="Enter card amount"
                onWheel={(e) => e.target.blur()}
              />
            </div>
          </div>
          
          <div className="split-total">
            <span>Total Paid: Rs.{(Number(cashAmount) + Number(cardAmount)).toFixed(2)}</span>
            <span className="split-remaining">Remaining: Rs.{(directSaleTotal - (Number(cashAmount) + Number(cardAmount))).toFixed(2)}</span>
          </div>
        </div>
      )}

      {/* Regular payment input for non-split */}
      {paymentMethod !== 'Split' && (
        <div className="form-row">
          <div className="form-group">
            <label>Paid Amount</label>
            <input
              type="number"
              name="advancePayment"
              value={formData.advancePayment}
              onChange={handleInputChange}
              onWheel={(e) => e.target.blur()}
              placeholder="Enter paid amount"
            />
          </div>
        </div>
      )}

      {/* Discount section */}
      <div className="form-row">

        <div className="form-group">
          <label>Discount Type</label>
          <select
            value={discountType}
            onChange={(e) =>
              setDiscountType(e.target.value)
            }
          >
            <option value="amount">
              Amount
            </option>
            <option value="percentage">
              Percentage %
            </option>
          </select>
        </div>

        <div className="form-group">
          <label>Discount</label>
          <input
            type="number"
            name="discount"
            value={formData.discount}
            onChange={handleInputChange}
            onWheel={(e) => e.target.blur()}
            placeholder="Enter discount"
          />
        </div>

      </div>

      {/* Financial Summary */}
      <div className="financial-summary">

        <div data-label="Subtotal">
          Rs.{directSaleSubtotal.toFixed(2)}
        </div>

        <div data-label="Discount">
          Rs.{calculatedDiscount.toFixed(2)}
        </div>

        <div data-label="Grand Total">
          Rs.{directSaleTotal.toFixed(2)}
        </div>

        {paymentMethod === 'Split' && (
          <>
            <div data-label="Cash Paid">
              Rs.{(Number(cashAmount) || 0).toFixed(2)}
            </div>
            <div data-label="Card Paid">
              Rs.{(Number(cardAmount) || 0).toFixed(2)}
            </div>
          </>
        )}

        <div data-label="Paid">
          Rs.{directSaleAdvanceAmount.toFixed(2)}
        </div>

        <div data-label="Balance">
          Rs.{directSaleBalance.toFixed(2)}
        </div>

        <div data-label="Status">
          {paymentStatus.toUpperCase()}
        </div>

      </div>

    </div>

    {/* ACTIONS */}

    <div className="invoice-actions">

      <button 
        className="btn-save"
        onClick={handleSaveDirectSale}
        disabled={isSavingDirectSale}
      >
        {isSavingDirectSale
          ? "Creating..."
          : "Create Direct Sale Bill"}
      </button>

    </div>

  </div>

</div>

)}



{/*************************************************  eye exam report for patient *************************************************************/}


{selectedOption === "eyeExamReportForPatient" && (
<div className="peer-wrapper">
    <div className="peer-container">
      
      <div className="peer-header">
        <h1 className="peer-title">
          <span className="peer-title-icon">👤</span>
          Patient Eye Examination History
        </h1>
        <p className="peer-subtitle">View examination records for specific patient</p>
      </div>

      <div className="peer-controls">
        <div className="peer-search-wrapper">
          <span className="peer-search-icon">🔍</span>
          <input 
            type="text" 
            placeholder="Search patient records..." 
            className="peer-search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <select 
          className="peer-filter-select"
          onChange={(e) => setFilterOption(e.target.value)}
          value={filterOption}
        >
          <option value="all">📋 All Records</option>
          <option value="today">📅 Today</option>
          <option value="week">📊 This Week</option>
          <option value="month">📈 This Month</option>
        </select>
      </div>

      {filteredRecords.length === 0 ? (
        <div className="peer-empty-state">
          <div className="peer-empty-icon">📭</div>
          <h3>No examination records found</h3>
          <p>No eye exams have been recorded for this patient yet</p>
        </div>
      ) : (
        <div className="peer-table-wrapper">
          <table className="peer-table">
            <thead>
              <tr>
                <th>Patient Name</th>
                <th>Patient ID</th>
                <th>Date</th>
                <th>Age</th>
                <th>Chief Complaint</th>
                <th>VA (OD/OS)</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredRecords.map((record) => (
                <tr key={record.id} className="peer-row">
                  <td className="peer-cell-patient">
                    <strong>{record.patientInfo?.name}</strong>
                  </td>
                  <td className="peer-cell-id">{record.patientInfo?.id || '-'}</td>
                  <td>{new Date(record.patientInfo?.date).toLocaleDateString()}</td>
                  <td>{record.patientInfo?.age || '-'}</td>
                  <td className="peer-cell-complaint" title={record.history?.chiefComplaint}>
                    {record.history?.chiefComplaint?.substring(0, 40)}
                    {record.history?.chiefComplaint?.length > 40 ? '...' : ''}
                  </td>
                  <td className="peer-cell-va">
                    <span className="peer-badge-od">{record.visualAcuity?.od_cg || '-'}</span>
                    <span className="peer-badge-sep">/</span>
                    <span className="peer-badge-os">{record.visualAcuity?.os_cg || '-'}</span>
                  </td>
                  <td>
                    <div className="peer-action-buttons">
                      <button 
                        className="peer-btn peer-btn-pdf"
                        onClick={() => generatePatientEyeExam(record)}
                        title="Download PDF Report"
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M5 20h14v-2H5v2zm7-18v10l4-4h-3V2h-2v6h-3l4 4V2z"/>
                        </svg>
                        <span>PDF</span>
                      </button>

                          <button
      className="veer-btn veer-btn-delete"
      onClick={() => handleDeleteEyeExam(record.id)}
      title="Delete Record"
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm3.46-7.12 1.41-1.41L12 11.59l1.12-1.12 1.41 1.41L13.41 13l1.12 1.12-1.41 1.41L12 14.41l-1.12 1.12-1.41-1.41L10.59 13l-1.13-1.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"/>
      </svg>
      <span>Delete</span>
    </button>

                    </div>
                  </td>















                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  </div>
)}


{/************************************************* view all eye exam report *************************************************************/}


{selectedOption === "viewEyeExamReport" && (
  <div className="veer-wrapper">
    <div className="veer-container">
      
      <div className="veer-header">
        <h1 className="veer-title">
          <span className="veer-title-icon">👁️</span>
          Eye Examination Records
        </h1>
        <p className="veer-subtitle">View and manage all eye examination reports</p>
      </div>

      <div className="veer-controls">
        <div className="veer-search-wrapper">
          <span className="veer-search-icon">🔍</span>
          <input 
            type="text" 
            placeholder="Search by patient name or ID..." 
            className="veer-search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <select 
          className="veer-filter-select"
          onChange={(e) => setFilterOption(e.target.value)}
          value={filterOption}
        >
          <option value="all">📋 All Records</option>
          <option value="today">📅 Today</option>
          <option value="week">📊 This Week</option>
          <option value="month">📈 This Month</option>
        </select>
      </div>

      {filteredRecords.length === 0 ? (
        <div className="veer-empty-state">
          <div className="veer-empty-icon">📭</div>
          <h3>No examination records found</h3>
          <p>Try adjusting your search or filter criteria</p>
        </div>
      ) : (
        <div className="veer-table-wrapper">
          <table className="veer-table">
            <thead>
              <tr>
                <th>Patient Name</th>
                <th>Patient ID</th>
                <th>Date</th>
                <th>Age</th>
                <th>Chief Complaint</th>
                <th>VA (OD/OS)</th>
                <th>PD (OD/OS)</th>
                <th>SEG</th>
                <th>Refraction</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredRecords.map((record) => (
                <tr key={record.id} className="veer-row">
                  <td className="veer-cell-patient">
                    <strong>{record.patientInfo?.name}</strong>
                  </td>
                  <td className="veer-cell-id">{record.patientInfo?.id || '-'}</td>
                  <td>{new Date(record.patientInfo?.date).toLocaleDateString()}</td>
                  <td>{record.patientInfo?.age || '-'}</td>
                  <td className="veer-cell-complaint" title={record.history?.chiefComplaint}>
                    {record.history?.chiefComplaint?.substring(0, 30)}
                    {record.history?.chiefComplaint?.length > 30 ? '...' : ''}
                  </td>
                  <td className="veer-cell-va">
                    <span className="veer-badge-od">{record.visualAcuity?.od_cg || '-'}</span>
                    <span className="veer-badge-sep">/</span>
                    <span className="veer-badge-os">{record.visualAcuity?.os_cg || '-'}</span>
                  </td>
                  <td>
                    {record.visualAcuity?.od_pd || '-'} / {record.visualAcuity?.os_pd || '-'}
                  </td>
                  <td className="veer-cell-seg">{record.visualAcuity?.seg_va || '-'}</td>
                  <td className="veer-cell-refraction">
                    {record.refraction?.od_sph || '0'} {record.refraction?.od_cyl || '0'} x {record.refraction?.od_axis || '0'}
                  </td>
                  <td>
                    <div className="veer-action-buttons">

                      <button 
                        className="veer-btn veer-btn-view"
                        onClick={() => setSelectedRecord(record)}
                        title="View Details"
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                        </svg>
                      </button>

                                            <button 
                        className="veer-btn veer-btn-pdf"
                        onClick={() => generateEyeExamPDF(record)}
                        title="Download PDF Report"
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M5 20h14v-2H5v2zm7-18v10l4-4h-3V2h-2v6h-3l4 4V2z"/>
                        </svg>
                        <span>PDF</span>
                      </button>


      <button
      className="veer-btn veer-btn-delete"
      onClick={() => handleDeleteEyeExam(record.id)}
      title="Delete Record"
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
        <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm3.46-7.12 1.41-1.41L12 11.59l1.12-1.12 1.41 1.41L13.41 13l1.12 1.12-1.41 1.41L12 14.41l-1.12 1.12-1.41-1.41L10.59 13l-1.13-1.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"/>
      </svg>
      <span>Delete</span>
    </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Record Detail Modal */}
      {selectedRecord && (
        <div className="veer-modal-overlay" onClick={() => setSelectedRecord(null)}>
          <div className="veer-modal" onClick={(e) => e.stopPropagation()}>
            <button className="veer-modal-close" onClick={() => setSelectedRecord(null)}>×</button>
            
            <div className="veer-modal-header">
              <h2>Eye Examination Details</h2>
              <p>Complete examination report</p>
            </div>

            <div className="veer-modal-content">
              {/* Patient Info Card */}
              <div className="veer-info-card">
                <h3>
                  <span className="veer-info-icon">👤</span>
                  Patient Information
                </h3>
                <div className="veer-info-grid">
                  <div className="veer-info-item">
                    <label>Patient Name</label>
                    <span>{selectedRecord.patientInfo?.name}</span>
                  </div>
                  <div className="veer-info-item">
                    <label>Patient ID</label>
                    <span>{selectedRecord.patientInfo?.id}</span>
                  </div>
                  <div className="veer-info-item">
                    <label>Age / Gender</label>
                    <span>{selectedRecord.patientInfo?.age} / {selectedRecord.patientInfo?.gender}</span>
                  </div>
                  <div className="veer-info-item">
                    <label>Examination Date</label>
                    <span>{new Date(selectedRecord.patientInfo?.date).toLocaleDateString()}</span>
                  </div>
                </div>
              </div>

              {/* History Card */}
              <div className="veer-info-card">
                <h3>
                  <span className="veer-info-icon">📜</span>
                  Medical History
                </h3>
                <div className="veer-history-content">
                  <div className="veer-history-item">
                    <label>Chief Complaint</label>
                    <p>{selectedRecord.history?.chiefComplaint || '-'}</p>
                  </div>
                  <div className="veer-history-item">
                    <label>HPC</label>
                    <p>{selectedRecord.history?.hpc || '-'}</p>
                  </div>
                  <div className="veer-history-item">
                    <label>Past Ocular History</label>
                    <p>{selectedRecord.history?.pastOcularHistory || '-'}</p>
                  </div>
                  <div className="veer-history-item">
                    <label>Medical History</label>
                    <p>{selectedRecord.history?.medicalHistory || '-'}</p>
                  </div>
                </div>
              </div>

              {/* Examination Card */}
              <div className="veer-info-card">
                <h3>
                  <span className="veer-info-icon">🔬</span>
                  Examination Results
                </h3>
                
                <div className="veer-exam-section">
                  <h4>Visual Acuity</h4>
                  <div className="veer-exam-grid">
                    <div className="veer-exam-item">
                      <label>OD (Right)</label>
                      <span>C/C: {selectedRecord.visualAcuity?.od_cg || '-'}</span>
                      <span>S/C: {selectedRecord.visualAcuity?.od_sg || '-'}</span>
                      <span>P/H: {selectedRecord.visualAcuity?.od_ph || '-'}</span>
                      <span>PD: {selectedRecord.visualAcuity?.od_pd || '-'}</span>
                    </div>
                    <div className="veer-exam-item">
                      <label>OS (Left)</label>
                      <span>C/C: {selectedRecord.visualAcuity?.os_cg || '-'}</span>
                      <span>S/C: {selectedRecord.visualAcuity?.os_sg || '-'}</span>
                      <span>P/H: {selectedRecord.visualAcuity?.os_ph || '-'}</span>
                      <span>PD: {selectedRecord.visualAcuity?.os_pd || '-'}</span>
                    </div>
                  </div>
                  <div className="veer-exam-item veer-full-width">
                    <label>SEG</label>
                    <span>{selectedRecord.visualAcuity?.seg_va || '-'}</span>
                  </div>
                </div>

                <div className="veer-exam-section">
                  <h4>Refraction</h4>
                  <div className="veer-exam-grid">
                    <div className="veer-exam-item">
                      <label>OD (Right)</label>
                      <span>Sph: {selectedRecord.refraction?.od_sph || '0'}</span>
                      <span>Cyl: {selectedRecord.refraction?.od_cyl || '0'}</span>
                      <span>Axis: {selectedRecord.refraction?.od_axis || '0'}</span>
                      <span>Vision: {selectedRecord.refraction?.od_vision || '-'}</span>
                    </div>
                    <div className="veer-exam-item">
                      <label>OS (Left)</label>
                      <span>Sph: {selectedRecord.refraction?.os_sph || '0'}</span>
                      <span>Cyl: {selectedRecord.refraction?.os_cyl || '0'}</span>
                      <span>Axis: {selectedRecord.refraction?.os_axis || '0'}</span>
                      <span>Vision: {selectedRecord.refraction?.os_vision || '-'}</span>
                    </div>
                  </div>
                </div>

                {/* External Examination */}
                {selectedRecord.externalExam && (
                  <div className="veer-exam-section">
                    <h4>External Examination</h4>
                    <div className="veer-exam-grid">
                      <div className="veer-exam-item">
                        <label>Left Eye</label>
                        {selectedRecord.externalExam.lidsLeft && <span>Lids: {selectedRecord.externalExam.lidsLeft}</span>}
                        {selectedRecord.externalExam.conjunctivaLeft && <span>Conjunctiva: {selectedRecord.externalExam.conjunctivaLeft}</span>}
                        {selectedRecord.externalExam.corneaLeft && <span>Cornea: {selectedRecord.externalExam.corneaLeft}</span>}
                      </div>
                      <div className="veer-exam-item">
                        <label>Right Eye</label>
                        {selectedRecord.externalExam.lidsRight && <span>Lids: {selectedRecord.externalExam.lidsRight}</span>}
                        {selectedRecord.externalExam.conjunctivaRight && <span>Conjunctiva: {selectedRecord.externalExam.conjunctivaRight}</span>}
                        {selectedRecord.externalExam.corneaRight && <span>Cornea: {selectedRecord.externalExam.corneaRight}</span>}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              <button 
                className="veer-btn veer-btn-full"
                onClick={() => generateEyeExamPDF(selectedRecord)}
              >
                <span className="veer-btn-icon">📄</span>
                Generate Complete Report
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  </div>
)}



{/************************************************* create eye exam report *************************************************************/}



{selectedOption === "createEyeExamReport" && (
  <div className="eer-wrapper">
    <div className="eer-container">
      
      <div className="eer-header">
        <h1 className="eer-title">
          <span className="eer-title-icon">👁️</span>
          Eye Examination Report
        </h1>
        <p className="eer-subtitle">Comprehensive eye examination form</p>
      </div>

      <form onSubmit={handleEyeExamSubmit} className="eer-form">
        
        {/* Patient Information */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">📋</span>
            Patient Information
          </h2>
          
          <div className="eer-form-row">





            <div className="eer-form-group">
              <label className="eer-label">Patient Name <span className="eer-required">*</span></label>
              <input 
                type="text" 
                className="eer-input"
                placeholder="Enter patient full name"
                value={patientName}
                onChange={(e) => setPatientName(e.target.value)}
                required
              />
            </div>
            
            <div className="eer-form-group">
              <label className="eer-label">Examination Date <span className="eer-required">*</span></label>
              <input 
                type="date" 
                className="eer-input eer-date-input"
                value={examDate}
                onChange={(e) => setExamDate(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="eer-form-row eer-grid-4">
            <div className="eer-form-group">
              <label className="eer-label">Date of Birth</label>
              <input 
                type="date" 
                className="eer-input eer-date-input"
                value={dob}
                onChange={(e) => setDob(e.target.value)}
              />
            </div>

            <div className="eer-form-group">
              <label className="eer-label">Age</label>
              <input 
                type="text" 
                className="eer-input"
                placeholder="Age"
                value={age}
                onChange={(e) => setAge(e.target.value)}
              />
            </div>

            <div className="eer-form-group">
              <label className="eer-label">Gender</label>
              <select 
                className="eer-select"
                value={gender}
                onChange={(e) => setGender(e.target.value)}
              >
                <option value="" disabled>Select Gender</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div>

            <div className="eer-form-group">
              <label className="eer-label">Contact No</label>
              <input 
                type="text" 
                className="eer-input"
                placeholder="Contact number"
                value={contactNo}
                onChange={(e) => setContactNo(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* History Taking */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">📜</span>
            History Taking
          </h2>
          
          <div className="eer-form-group">
            <label className="eer-label">Chief Complaint</label>
            <textarea 
              className="eer-textarea"
              value={chiefComplaint}
              onChange={(e) => setChiefComplaint(e.target.value)}
              rows="2"
              placeholder="Enter chief complaint"
            />
          </div>

          <div className="eer-form-group">
            <label className="eer-label">HPC (History of Present Complaint)</label>
            <textarea 
              className="eer-textarea"
              value={hpc}
              onChange={(e) => setHpc(e.target.value)}
              rows="2"
              placeholder="Enter history of present complaint"
            />
          </div>

          <div className="eer-form-group">
            <label className="eer-label">Past Ocular History</label>
            <textarea 
              className="eer-textarea"
              value={pastOcularHistory}
              onChange={(e) => setPastOcularHistory(e.target.value)}
              rows="2"
              placeholder="Enter past ocular history"
            />
          </div>

          <div className="eer-form-group">
            <label className="eer-label">Medical History</label>
            <textarea 
              className="eer-textarea"
              value={medicalHistory}
              onChange={(e) => setMedicalHistory(e.target.value)}
              rows="2"
              placeholder="Enter medical history"
            />
          </div>

          <div className="eer-form-group">
            <label className="eer-label">Family Ocular History</label>
            <textarea 
              className="eer-textarea"
              value={familyOcularHistory}
              onChange={(e) => setFamilyOcularHistory(e.target.value)}
              rows="2"
              placeholder="Enter family ocular history"
            />
          </div>

          <div className="eer-form-group">
            <label className="eer-label">Social History</label>
            <textarea 
              className="eer-textarea"
              value={socialHistory}
              onChange={(e) => setSocialHistory(e.target.value)}
              rows="2"
              placeholder="Enter social history"
            />
          </div>
        </div>

        {/* External Examination */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">🔬</span>
            External Examination
          </h2>

          {/* Lids */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">Lids</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={lidsLeft}
                  onChange={(e) => setLidsLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye lids condition"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={lidsRight}
                  onChange={(e) => setLidsRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye lids condition"
                />
              </div>
            </div>
          </div>

          {/* Conjunctiva */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">Conjunctiva</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={conjunctivaLeft}
                  onChange={(e) => setConjunctivaLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye conjunctiva"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={conjunctivaRight}
                  onChange={(e) => setConjunctivaRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye conjunctiva"
                />
              </div>
            </div>
          </div>

          {/* Cornea */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">Cornea</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={corneaLeft}
                  onChange={(e) => setCorneaLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye cornea"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={corneaRight}
                  onChange={(e) => setCorneaRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye cornea"
                />
              </div>
            </div>
          </div>

          {/* Sclera */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">Sclera</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={scleraLeft}
                  onChange={(e) => setScleraLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye sclera"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={scleraRight}
                  onChange={(e) => setScleraRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye sclera"
                />
              </div>
            </div>
          </div>

          {/* Anterior Chamber */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">A/C (Anterior Chamber)</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={acLeft}
                  onChange={(e) => setAcLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye A/C"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={acRight}
                  onChange={(e) => setAcRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye A/C"
                />
              </div>
            </div>
          </div>

          {/* Lens */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">Lens</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={lensLeft}
                  onChange={(e) => setLensLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye lens"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={lensRight}
                  onChange={(e) => setLensRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye lens"
                />
              </div>
            </div>
          </div>

          {/* Vitreous */}
          <div className="eer-exam-group">
            <label className="eer-exam-label">Vitreous</label>
            <div className="eer-eye-inputs">
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Left Eye</span>
                <textarea
                  className="eer-textarea"
                  value={vitreousLeft}
                  onChange={(e) => setVitreousLeft(e.target.value)}
                  rows="2"
                  placeholder="Left eye vitreous"
                />
              </div>
              <div className="eer-eye-col">
                <span className="eer-eye-badge">Right Eye</span>
                <textarea
                  className="eer-textarea"
                  value={vitreousRight}
                  onChange={(e) => setVitreousRight(e.target.value)}
                  rows="2"
                  placeholder="Right eye vitreous"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Family History */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">👪</span>
            Family History
          </h2>
          
          <div className="eer-checkbox-group">
            <label className="eer-checkbox">
              <input 
                type="checkbox" 
                name="poag"
                checked={familyHistory.poag}
                onChange={handleFamilyHistoryChange}
              />
              <span>FHx POAG</span>
            </label>
            
            <label className="eer-checkbox">
              <input 
                type="checkbox" 
                name="amd"
                checked={familyHistory.amd}
                onChange={handleFamilyHistoryChange}
              />
              <span>FHx AMD</span>
            </label>
            
            <label className="eer-checkbox">
              <input 
                type="checkbox" 
                name="dm"
                checked={familyHistory.dm}
                onChange={handleFamilyHistoryChange}
              />
              <span>FHx DM</span>
            </label>
            
            <div className="eer-custom-condition">
              <input 
                type="text" 
                className="eer-input"
                name="other"
                value={familyHistory.other}
                onChange={handleFamilyHistoryChange}
                placeholder="Other family history"
              />
            </div>
          </div>
        </div>

        {/* Visual Acuity */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">👀</span>
            Visual Acuity
          </h2>
          
          <div className="eer-va-grid">
            <div className="eer-va-header">
              <div></div>
              <div>OD (Right)</div>
              <div>OS (Left)</div>
            </div>
            
            <div className="eer-va-row">
              <div className="eer-va-label">C∕C</div>
              <input 
                type="text" 
                className="eer-va-input"
                name="od_cg"
                value={visualAcuity.od_cg}
                onChange={handleVisualAcuityChange}
              />
              <input 
                type="text" 
                className="eer-va-input"
                name="os_cg"
                value={visualAcuity.os_cg}
                onChange={handleVisualAcuityChange}
              />
            </div>
            
            <div className="eer-va-row">
              <div className="eer-va-label">S∕C</div>
              <input 
                type="text" 
                className="eer-va-input"
                name="od_sg"
                value={visualAcuity.od_sg}
                onChange={handleVisualAcuityChange}
              />
              <input 
                type="text" 
                className="eer-va-input"
                name="os_sg"
                value={visualAcuity.os_sg}
                onChange={handleVisualAcuityChange}
              />
            </div>
            
            <div className="eer-va-row">
              <div className="eer-va-label">P∕H</div>
              <input 
                type="text" 
                className="eer-va-input"
                name="od_ph"
                value={visualAcuity.od_ph}
                onChange={handleVisualAcuityChange}
              />
              <input 
                type="text" 
                className="eer-va-input"
                name="os_ph"
                value={visualAcuity.os_ph}
                onChange={handleVisualAcuityChange}
              />
            </div>

            <div className="eer-va-row">
              <div className="eer-va-label">PD</div>
              <input 
                type="text" 
                className="eer-va-input"
                name="od_pd"
                value={visualAcuity.od_pd}
                onChange={handleVisualAcuityChange}
              />
              <input 
                type="text" 
                className="eer-va-input"
                name="os_pd"
                value={visualAcuity.os_pd}
                onChange={handleVisualAcuityChange}
              />
            </div>

            <div className="eer-va-row eer-va-single">
              <div className="eer-va-label">SEG</div>
              <input 
                type="text" 
                className="eer-va-input"
                name="seg_va"
                value={visualAcuity.seg_va}
                onChange={handleVisualAcuityChange}
              />
            </div>
          </div>

          <div className="eer-va-additional">
            <div className="eer-form-group">
              <label className="eer-label">CT</label>
              <input 
                type="text" 
                className="eer-input"
                name="ct"
                value={visualAcuity.ct}
                onChange={handleVisualAcuityChange}
              />
            </div>
            
            <div className="eer-form-group">
              <label className="eer-label">NPC</label>
              <input 
                type="text" 
                className="eer-input"
                name="npc"
                value={visualAcuity.npc}
                onChange={handleVisualAcuityChange}
              />
            </div>
            
            <div className="eer-form-group">
              <label className="eer-label">OM</label>
              <input 
                type="text" 
                className="eer-input"
                name="om"
                value={visualAcuity.om}
                onChange={handleVisualAcuityChange}
              />
            </div>
          </div>
        </div>

        {/* Fundi */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">🔍</span>
            Fundi
          </h2>
          
          <div className="eer-form-group">
            <label className="eer-label">Description</label>
            <input 
              type="text" 
              className="eer-input"
              value={fundi}
              onChange={(e) => setFundi(e.target.value)}
              placeholder="Enter fundi description"
            />
          </div>
        </div>

        {/* Hb Rx */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">📊</span>
            Hb Rx
          </h2>
          
          <div className="eer-refraction-grid">
            <div className="eer-refraction-header">
              <div></div>
              <div>Sph</div>
              <div>Cyl</div>
              <div>Axis</div>
              <div>Vision</div>
            </div>
            
            <div className="eer-refraction-row">
              <div className="eer-refraction-label">OD</div>
              <input type="text" className="eer-refraction-input" name="hb_od_sph" value={hbrx.hb_od_sph} onChange={handleHbrxChange} />
              <input type="text" className="eer-refraction-input" name="hb_od_cyl" value={hbrx.hb_od_cyl} onChange={handleHbrxChange} />
              <input type="text" className="eer-refraction-input" name="hb_od_axis" value={hbrx.hb_od_axis} onChange={handleHbrxChange} />
              <input type="text" className="eer-refraction-input" name="hb_od_vision" value={hbrx.hb_od_vision} onChange={handleHbrxChange} />
            </div>
            
            <div className="eer-refraction-row">
              <div className="eer-refraction-label">OS</div>
              <input type="text" className="eer-refraction-input" name="rx_os_sph" value={hbrx.rx_os_sph} onChange={handleHbrxChange} />
              <input type="text" className="eer-refraction-input" name="rx_os_cyl" value={hbrx.rx_os_cyl} onChange={handleHbrxChange} />
              <input type="text" className="eer-refraction-input" name="rx_os_axis" value={hbrx.rx_os_axis} onChange={handleHbrxChange} />
              <input type="text" className="eer-refraction-input" name="rx_os_vision" value={hbrx.rx_os_vision} onChange={handleHbrxChange} />
            </div>
          </div>

                 <div className="eer-refraction-label">Addition (Near)</div> 
                 <input type="text" className="eer-refraction-input" name="add" value={hbrx.add} onChange={handleHbrxChange} />


        </div>

        {/* Refraction */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">📐</span>
            Refraction
          </h2>
          
          <div className="eer-refraction-grid">
            <div className="eer-refraction-header">
              <div></div>
              <div>Sph</div>
              <div>Cyl</div>
              <div>Axis</div>
              <div>Vision</div>
            </div>
            
            <div className="eer-refraction-row">
              <div className="eer-refraction-label">OD</div>
              <input type="text" className="eer-refraction-input" name="od_sph" value={refraction.od_sph} onChange={handleRefractionChange} />
              <input type="text" className="eer-refraction-input" name="od_cyl" value={refraction.od_cyl} onChange={handleRefractionChange} />
              <input type="text" className="eer-refraction-input" name="od_axis" value={refraction.od_axis} onChange={handleRefractionChange} />
              <input type="text" className="eer-refraction-input" name="od_vision" value={refraction.od_vision} onChange={handleRefractionChange} />
            </div>
            
            <div className="eer-refraction-row">
              <div className="eer-refraction-label">OS</div>
              <input type="text" className="eer-refraction-input" name="os_sph" value={refraction.os_sph} onChange={handleRefractionChange} />
              <input type="text" className="eer-refraction-input" name="os_cyl" value={refraction.os_cyl} onChange={handleRefractionChange} />
              <input type="text" className="eer-refraction-input" name="os_axis" value={refraction.os_axis} onChange={handleRefractionChange} />
              <input type="text" className="eer-refraction-input" name="os_vision" value={refraction.os_vision} onChange={handleRefractionChange} />
            </div>
          </div>
        </div>


      {/* Addition */}
          <div className="eer-form-group">
            <label className="eer-label">Near Vision (ADD)</label>
            <textarea 
              className="eer-textarea"
              value={addition}
              onChange={(e) => setAddition(e.target.value)}
              rows="2"
              placeholder="Enter addition"
            />
          </div>





        {/* Follow Up */}
        <div className="eer-card">
          <h2 className="eer-card-title">
            <span className="eer-card-icon">📅</span>
            Follow Up
          </h2>
          
          <div className="eer-form-row">
            <div className="eer-form-group eer-checkbox-group">
              <label className="eer-checkbox">
                <input 
                  type="checkbox" 
                  checked={needsFollowUp}
                  onChange={(e) => setNeedsFollowUp(e.target.checked)}
                />
                <span>Needs Follow Up</span>
              </label>
            </div>

            <div className="eer-form-group">
              <input 
                type="date" 
                className="eer-input eer-date-input"
                value={followUpDate}
                onChange={(e) => setFollowUpDate(e.target.value)}
                disabled={!needsFollowUp}
              />
            </div>
          </div>

          <div className="eer-form-group">
            <textarea 
              className="eer-textarea"
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              rows={4}
              placeholder="Enter remarks"
            />
          </div>
        </div>

        <div className="eer-actions">
          <button type="submit" className="eer-btn eer-btn-primary">
            <span className="eer-btn-icon">📄</span>
            Generate Eye Exam Report
          </button>
          <button type="button" className="eer-btn eer-btn-secondary">
            <span className="eer-btn-icon">↺</span>
            Reset Form
          </button>
        </div>
      </form>
    </div>
  </div>
)}




{/**************************************************** View purchasing order ********************************************************************/}

{selectedOption === "viewPurchasingOrders" && (
  <div className="view-purchase-container">
    <h2>Purchasing Orders</h2>

    {loadingPO ? (
      <p>Loading...</p>
    ) : purchaseOrders.length === 0 ? (
      <p>No Purchasing Orders Found</p>
    ) : (
      <div className="purchase-orders-wrapper">
        {purchaseOrders.map((po, index) => (
          <div className="purchase-card" key={po.id}>
            <div className="purchase-top">
              <h3>{po.purchaseOrderNo}</h3>
              <span>
                {po.createdAt?.toDate
                  ? po.createdAt.toDate().toLocaleString()
                  : "No Date"}
              </span>
            </div>

            <p>
              <strong>Supplier:</strong> {po.supplierName}
            </p>

            {/* LENS LIST */}
            {po.lensList && po.lensList.length > 0 && (
              <div className="inner-box">
                <h4>Lens Items ({po.lensList.length})</h4>

                <table>
                  <thead>
                    <tr>
                      <th>Code</th>
                      <th>Sph</th>
                      <th>Add</th>
                      <th>Cyl</th>
                      <th>Axis</th>
                      <th>Model</th>
                      <th>Prog</th>
                      <th>Qty</th>
                    </tr>
                  </thead>

                  <tbody>
                    {po.lensList.map((lens, i) => (
                      <tr key={i}>
                        <td>{lens.itemCode}</td>
                        <td>{lens.sph}</td>
                        <td>{lens.add}</td>
                        <td>{lens.cyl}</td>
                        <td>{lens.axis}</td>
                        <td>{lens.model}</td>
                        <td>{lens.progressive ? "Yes" : "No"}</td>
                        <td>{lens.qty}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            {/* FRAME LIST */}
            {po.frameList && po.frameList.length > 0 && (
              <div className="inner-box">
                <h4>Frame Items ({po.frameList.length})</h4>

                <table>
                  <thead>
                    <tr>
                      <th>Code</th>
                      <th>Model</th>
                      <th>Brand</th>
                      <th>Colour</th>
                      <th>Sex</th>
                      <th>Qty</th>
                    </tr>
                  </thead>

                  <tbody>
                    {po.frameList.map((frame, i) => (
                      <tr key={i}>
                        <td>{frame.itemCode}</td>
                        <td>{frame.modelNo}</td>
                        <td>{frame.brand}</td>
                        <td>{frame.colour}</td>
                        <td>{frame.sex}</td>
                        <td>{frame.qty}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ))}
      </div>
    )}
  </div>
)}












{/******************************************************** Track spectacles ****************************************************************/}

{selectedOption === "trackSpectacle" && (
  <div className="track-spectacle-container">
    <h1>Track Spectacles</h1>

    {/* FILTERS */}
    <div className="track-filters">

      <input
        type="text"
        placeholder="Search Invoice No"
        value={trackSearchInvoice}
        onChange={(e) => setTrackSearchInvoice(e.target.value)}
      />

      <select
        value={trackFilterStatus}
        onChange={(e) => setTrackFilterStatus(e.target.value)}
      >
        <option value="all">All Status</option>
        <option value="Sent To Lab">Sent To Lab</option>
        <option value="Preparing">Preparing</option>
        <option value="Received From Lab">Received From Lab</option>
        <option value="Done">Done</option>
        <option value="Delivered To Customer">Delivered To Customer</option>
        <option value="Received From Customer">Received From Customer</option>

      </select>

      <input
        type="date"
        value={trackFilterDate}
        onChange={(e) => setTrackFilterDate(e.target.value)}
      />

      <select
        value={trackFilterMonth}
        onChange={(e) => setTrackFilterMonth(e.target.value)}
      >
        <option value="">Month</option>
        {[...Array(12)].map((_, i) => (
          <option key={i} value={i + 1}>
            {i + 1}
          </option>
        ))}
      </select>

      <input
        type="number"
        placeholder="Year"
        value={trackFilterYear}
        onChange={(e) => setTrackFilterYear(e.target.value)}
      />
    </div>

    {/* TABLE */}
    <div className="track-table-wrap">
      <table className="track-table">
        <thead>
          <tr>
            <th>Invoice</th>
            <th>Contact No</th>
            <th>Customer</th>
            <th>Status</th>
            <th>Latest Date</th>
            <th>WhatsApp</th>
            <th>New Status</th>
            <th>Date</th>
            <th>Save</th>
          </tr>
        </thead>

      <tbody>
  {filteredTrackInvoices.map((inv) => {
    const track = trackDataMap[inv.id];

    /* BUILD STATUS HISTORY ARRAY */
    const history = [];

    if (track?.totalSteps) {
      for (let i = 1; i <= track.totalSteps; i++) {
        if (track[`status${i}`]) {
          history.push({
status: ` ${track[`status${i}`]} `,
date: ` ${track[`date${i}`]} `,
          });
        }
      }
    }

    return (
      <tr key={inv.id}>
        <td>{inv.invoiceNumber}</td>
<td>{inv.customer?.tpNo || "-"}</td>
        <td>{inv.customer?.fullName}</td>

        {/* SHOW ALL STATUS HISTORY */}
        <td>
          <div className="status-history-box">
            {history.length > 0 ? (
              history.map((item, index) => (
                <div key={index} className="status-line">
                  <span className="status-count">
                    {index + 1}.
                  </span>

                  <span className="status-name">
                    {item.status}
                  </span>



                  <span className="status-date">
                    {item.date}
                  </span>
                </div>




              ))
            ) : (
              <span>-</span>
            )}
          </div>
        </td>



        {/* LATEST STATUS */}
        {/* <td>{track?.latestStatus || "-"}</td> */}

        <td>{track?.latestDate || "-"}</td>

                  <td>
  {track?.latestStatus === "Done" ? (
    <button
      className="whatsapp-btn"
      onClick={() => sendWhatsAppMessage(inv)}
    >
      WhatsApp
    </button>
  ) : (
    "-"
  )}
</td>





        <td>
          <select id={`status-${inv.id}`}>
            <option value="">Select</option>
            <option value="Sent To Lab">Sent To Lab</option>
            <option value="Preparing">Preparing</option>
            <option value="Received From Lab">
              Received From Lab
            </option>
              <option value="Done">Done</option>
            <option value="Delivered To Customer">
              Delivered To Customer
            </option>
            <option value="Received From Customer">
              Received from Customer
            </option>
          
          </select>
        </td>

        <td>
          <input type="date" id={`date-${inv.id}`} />
        </td>

        <td>
          <button
            className="track-save-btn"
            onClick={() =>
              saveTrackStatus(
                inv,
                document.getElementById(`status-${inv.id}`).value,
                document.getElementById(`date-${inv.id}`).value
              )
            }
          >
            Save
          </button>
        </td>
      </tr>
    );
  })}
</tbody>
      </table>
    </div>
  </div>
)}




{/************************************************ view all invoices*************************************************************/}

{selectedOption === "viewInvoice" && (
  <div className="view-invoice-container">
    <div className="view-invoice-header">
      <div>
        <h2>All Invoices</h2>
        <p className="subtitle">View, download, and manage all customer invoices</p>
      </div>
      <button className="btn-export-report" onClick={generateInvoiceSummaryReport}>
        📊 Export Summary Report
      </button>
      <button
        className="btn-export-report"
        onClick={downloadUpinReceiptExcel}
      >
        📥 Download Frame List - 2nd Time
      </button>
    </div>

    {/* Filters Section */}
    <div className="filters-section">
      <div className="filter-row">
        <div className="filter-group">
          <label>Search:</label>
          <input
            type="text"
            placeholder="Search by invoice #, customer, phone..."
            value={invoiceSearchTerm}
            onChange={(e) => setInvoiceSearchTerm(e.target.value)}
            className="filter-input"
          />
        </div>

        <div className="filter-group">
          <label>Status:</label>
          <select
            value={invoiceFilterStatus}
            onChange={(e) => setInvoiceFilterStatus(e.target.value)}
            className="filter-select"
          >
            <option value="all">All</option>
            <option value="paid">Paid</option>
            <option value="pending">Pending</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Payment Method:</label>
          <select
            value={invoiceFilterPaymentMethod}
            onChange={(e) => setInvoiceFilterPaymentMethod(e.target.value)}
            className="filter-select"
          >
            <option value="all">All</option>
            <option value="Cash">Cash</option>
            <option value="Card">Card</option>
            <option value="Bank Transfer">Bank Transfer</option>
            <option value="Deposit">Deposit</option>

            <option value="Cheque">
              Cheque
            </option>

          </select>
        </div>

        <div className="filter-group">
          <label>Date Range:</label>
          <input
            type="date"
            value={invoiceDateRange.start}
            onChange={(e) => setInvoiceDateRange(prev => ({ ...prev, start: e.target.value }))}
            className="filter-date"
          />
          <span>to</span>
          <input
            type="date"
            value={invoiceDateRange.end}
            onChange={(e) => setInvoiceDateRange(prev => ({ ...prev, end: e.target.value }))}
            className="filter-date"
          />
        </div>

        <button className="btn-reset" onClick={resetInvoiceFilters}>
          🔄 Reset
        </button>
        <button className="btn-refresh" onClick={fetchAllInvoices}>
          🔄 Refresh
        </button>
      </div>
    </div>

    {/* Summary Cards */}
    <div className="summary-cards">
      <div className="summary-card">
        <div className="summary-title">Total Invoices</div>
        <div className="summary-value">{filteredInvoices.length}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Amount</div>
        <div className="summary-value">
          Rs. {filteredInvoices.reduce((sum, inv) => sum + (inv.financial?.totalAmount || 0), 0).toFixed(2)}
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Paid</div>
        <div className="summary-value">
          Rs. {filteredInvoices.reduce((sum, inv) => sum + (inv.financial?.advancePayment || 0), 0).toFixed(2)}
            {/* removed from upper line - 16841 "+ (inv.totalBalancePaid || 0)"   */}  
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Due</div>
        <div className="summary-value">
          Rs. {filteredInvoices.reduce((sum, inv) => sum + (inv.financial?.balanceDue || 0), 0).toFixed(2)}
        </div>
      </div>
    </div>

    {/* Invoices Table */}
    {isLoadingInvoices ? (
      <div className="loading-spinner">Loading invoices...</div>
    ) : (
      <div className="invoice-table-container">
        <table className="invoice-table">
          <thead>
            <tr>
              <th>Invoice #</th>
              <th>RX /VIP/CL/S/R No</th>
              <th>Customer Name</th>
              <th>Phone</th>
              <th>Address</th>
              <th>Products</th>
              <th>Sales Person</th>
              <th>Total Amount</th>
              <th>Total Paid</th>
              <th>Balance Due</th>
              <th>Payment Method</th>
              <th>Date</th>
              <th>Status</th>
              <th>Frame-2nd Time</th> 
              <th>Remark</th>  
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredInvoices.length === 0 ? (
              <tr>
                <td colSpan="13" style={{ textAlign: 'center', padding: '40px' }}>
                  No invoices found
                </td>
              </tr>
            ) : (
              filteredInvoices.map((invoice) => (
                <tr key={invoice.id}>
                  <td className="invoice-link" onClick={() => viewInvoiceDetails(invoice)}>
                    {invoice.invoiceNumber}
                  </td>










{/* RX / VIP / CL / S / R No - NEW COLUMN */}
        {/* <td>
          {invoice.invoiceType === 'RX' && invoice.rxNumber && (
            <span>RX: {invoice.rxNumber}</span>
          )}
          {invoice.invoiceType === 'VIP' && invoice.vipNumber && (
            <span>VIP: {invoice.vipNumber}</span>
          )}
          {invoice.type === 'direct-sale' && invoice.directInvoiceType === 'CL' && (
            <span>CL: {invoice.clNumber}</span>
          )}
          {invoice.type === 'direct-sale' && invoice.directInvoiceType === 'S' && (
            <span>S: {invoice.sNumber}</span>
          )}
          {invoice.invoiceType === 'R' && invoice.rNumber && (
            <span>R: {invoice.rNumber}</span>
          )}
          {!invoice.rxNumber && !invoice.vipNumber && !invoice.clNumber && !invoice.sNumber && !invoice.rNumber && (
            <span>-</span>
          )}
        </td> */}

{/* RX / VIP / CL / S / R No - NEW COLUMN */}
<td>
  {invoice.invoiceType === 'RX' && invoice.rxNumber && (
    <span>RX: {invoice.rxNumber}</span>
  )}
  {invoice.invoiceType === 'VIP' && invoice.vipNumber && (
    <span>VIP: {invoice.vipNumber}</span>
  )}
  {invoice.type === 'direct-sale' && invoice.directInvoiceType === 'CL' && (
    <span>CL: {invoice.clNumber}</span>
  )}
  {invoice.type === 'direct-sale' && invoice.directInvoiceType === 'S' && (
    <span>S: {invoice.sNumber}</span>
  )}
  {/* ✅ FIXED: Check for service-invoice type */}
  {invoice.type === 'service-invoice' && invoice.rNumber && (
    <span>R: {invoice.rNumber}</span>
  )}
  {!invoice.rxNumber && !invoice.vipNumber && !invoice.clNumber && !invoice.sNumber && !invoice.rNumber && (
    <span>-</span>
  )}
</td>











                  <td>{invoice.customer?.fullName || '-'}</td>
                  <td>{invoice.customer?.tpNo || '-'}</td>
                  <td>{invoice.customer?.address || '-'}</td>
                  <td>
                    <small>
                      Frame: {invoice.products?.frameModel || "-"}
                      <br />
                      Lens: {invoice.products?.highIndexLens
                        ? `${invoice.products?.highIndexLeft?.name || ""}${invoice.products?.highIndexRight?.name ? ` / ${invoice.products.highIndexRight.name}` : ""}`
                        : invoice.products?.lensModel || "-"}
                    </small>
                  </td>

                   <td>{invoice.invoiceData?.salePerson || invoice.salePerson ||   '-'}</td>

                  <td className="amount">Rs. {(invoice.financial?.totalAmount || 0).toFixed(2)}</td>
                  <td className="paid-amount">
                    Rs. {((invoice.financial?.advancePayment || 0) ).toFixed(2)}
                    {invoice.balancePayments?.length > 0 && (
                      <small className="balance-payments-count">(+{invoice.balancePayments.length} balance payments)</small>
                    )}
                  </td>
                  <td className={`balance-due ${invoice.financial?.balanceDue <= 0 ? 'settled' : ''}`}>
                    Rs. {(invoice.financial?.balanceDue || 0).toFixed(2)}
                  </td>
                  <td>
                    <span className="payment-method-badge">{invoice.financial?.paymentMethod || '-'}</span>
                  </td>
                  <td>
                    <div className="date-cell">
                      <div>{invoice.formattedDate}</div>
                      <small>{invoice.formattedTime}</small>
                    </div>
                  </td>
                  <td>
                    <span 
                      className="status-badge" 
                      style={{ backgroundColor: invoice.statusColor }}
                    >
                      {invoice.financial?.balanceDue <= 0 ? 'Paid' : 'Pending'}
                    </span>
                  </td>
                   <td>{invoice.upinNo || "-"}</td> 
                   <td>{invoice.receiptNo || "-"}</td> 
                  <td>
                    <div className="action-buttons">

<button
  className="btn-edit"
  onClick={() => openEditInvoiceModal(invoice)}
  title="Edit Customer details & Sales Person"
>
  ✏️
</button>


                      <button
                        className="btn-edit"
                        onClick={() => openUpinReceiptEditor(invoice)}
                        title="Edit UPIN / Receipt"
                      >
                        👓
                      </button>
                      <button
                        className="btn-view"
                        onClick={() => viewInvoiceDetails(invoice)}
                        title="View Details"
                      >
                        👁️
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => deleteInvoice(invoice.id, invoice.invoiceNumber)}
                        title="Delete"
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    )}

    {/* Invoice Details Modal */}
    {showInvoiceDetails && selectedInvoiceDetails && (
      <div className="modal-overlay" onClick={() => setShowInvoiceDetails(false)}>
        <div className="modal-content large" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Invoice Details</h3>
            <button className="modal-close" onClick={() => setShowInvoiceDetails(false)}>×</button>
          </div>
          
          <div className="modal-body">
            <div className="details-grid">
              <div className="details-section">
                <h4>Invoice Information</h4>
                <div className="detail-item">
                  <label>Invoice #:</label>
                  <span className="value">{selectedInvoiceDetails.invoiceNumber}</span>
                </div>
                <div className="detail-item">
                  <label>Date Created:</label>
                  <span>{selectedInvoiceDetails.formattedDate} at {selectedInvoiceDetails.formattedTime}</span>
                </div>
                <div className="detail-item">
                  <label>Delivery Date:</label>
                  <span>{selectedInvoiceDetails.delivery?.date || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Status:</label>
                  <span className="status-badge" style={{ backgroundColor: selectedInvoiceDetails.statusColor }}>
                    {selectedInvoiceDetails.financial?.balanceDue <= 0 ? 'Paid' : 'Pending'}
                  </span>
                </div>
              </div>

              <div className="details-section">
                <h4>Customer Information</h4>
                <div className="detail-item">
                  <label>Name:</label>
                  <span>{selectedInvoiceDetails.customer?.fullName || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Phone:</label>
                  <span>{selectedInvoiceDetails.customer?.tpNo || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Email:</label>
                  <span>{selectedInvoiceDetails.customer?.email || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Address:</label>
                  <span>{selectedInvoiceDetails.customer?.address || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Age:</label>
                  <span>{selectedInvoiceDetails.customer?.age || '-'}</span>
                </div>
              </div>

              <div className="details-section">
                <h4>Products</h4>
                <div className="detail-item">
                  <label>Frame Model:</label>
                  <span>{selectedInvoiceDetails.products?.frameModel || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Frame Price:</label>
                  <span>Rs. {(selectedInvoiceDetails.products?.framePrice || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Lens Model:</label>
                  <span>{selectedInvoiceDetails.products?.lensModel || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Lens Price:</label>
                  <span>Rs. {(selectedInvoiceDetails.products?.lensPrice || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Brand:</label>
                  <span>{selectedInvoiceDetails.products?.brand || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Colour:</label>
                  <span>{selectedInvoiceDetails.products?.colour || '-'}</span>
                </div>
              </div>

              <div className="details-section">
                <h4>Payment Details</h4>
                <div className="detail-item">
                  <label>Subtotal:</label>
                  <span>Rs. {(selectedInvoiceDetails.financial?.subtotal || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Discount:</label>
                  <span>Rs. {(selectedInvoiceDetails.financial?.discount || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item highlight">
                  <label>Total Amount:</label>
                  <span className="paid-amount">Rs. {(selectedInvoiceDetails.financial?.totalAmount || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Advance Payment:</label>
                  <span>Rs. {(selectedInvoiceDetails.financial?.advancePayment || 0).toFixed(2)}</span>
                </div>
                {selectedInvoiceDetails.balancePayments?.length > 0 && (
                  <>
                    <div className="detail-item">
                      <label>Balance Payments:</label>
                      <span>Rs. {selectedInvoiceDetails.totalBalancePaid.toFixed(2)}</span>
                    </div>
                    <div className="balance-payments-list">
                      <label>Payment History:</label>
                      {selectedInvoiceDetails.balancePayments.map((payment, idx) => (
                        <div key={idx} className="payment-history-item">
                          <small>{new Date(payment.date).toLocaleDateString()}</small>
                          <small>{payment.method}</small>
                          <small>Rs. {payment.amount.toFixed(2)}</small>
                          <small className="payment-invoice">{payment.invoiceNumber}</small>
                        </div>
                      ))}
                    </div>
                  </>
                )}
                <div className="detail-item">
                  <label>Balance Due:</label>
                  <span className={`remaining ${selectedInvoiceDetails.financial?.balanceDue <= 0 ? 'settled' : ''}`}>
                    Rs. {(selectedInvoiceDetails.financial?.balanceDue || 0).toFixed(2)}
                  </span>
                </div>
                <div className="detail-item">
                  <label>Payment Method:</label>
                  <span>{selectedInvoiceDetails.financial?.paymentMethod || '-'}</span>
                </div>
              </div>

              <div className="details-section">
                <h4>Prescription</h4>
                <div className="prescription-details">
                  <div className="eye-details">
                    <strong>Right Eye (OD)</strong>
                    <div>VA: {selectedInvoiceDetails.prescription?.rightEye?.visualAcuity || '-'}</div>
                    <div>SPH: {selectedInvoiceDetails.prescription?.rightEye?.sph || '-'}</div>
                    <div>CYL: {selectedInvoiceDetails.prescription?.rightEye?.cyl || '-'}</div>
                    <div>AXIS: {selectedInvoiceDetails.prescription?.rightEye?.axis || '-'}</div>
                    <div>ADD: {selectedInvoiceDetails.prescription?.rightEye?.add || '-'}</div>
                  </div>
                  <div className="eye-details">
                    <strong>Left Eye (OS)</strong>
                    <div>VA: {selectedInvoiceDetails.prescription?.leftEye?.visualAcuity || '-'}</div>
                    <div>SPH: {selectedInvoiceDetails.prescription?.leftEye?.sph || '-'}</div>
                    <div>CYL: {selectedInvoiceDetails.prescription?.leftEye?.cyl || '-'}</div>
                    <div>AXIS: {selectedInvoiceDetails.prescription?.leftEye?.axis || '-'}</div>
                    <div>ADD: {selectedInvoiceDetails.prescription?.leftEye?.add || '-'}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button 
              className="btn-delete" 
              onClick={() => {
                deleteInvoice(selectedInvoiceDetails.id, selectedInvoiceDetails.invoiceNumber);
                setShowInvoiceDetails(false);
              }}
            >
              🗑️ Delete
            </button>
            <button className="btn-close" onClick={() => setShowInvoiceDetails(false)}>
              Close
            </button>
          </div>
        </div>
      </div>
    )}



{/* Password verification modal */}

{showPasswordModal && (
  <div className="modal-overlay" onClick={() => {
    setShowPasswordModal(false);
    setEditSalesPerson(originalSalesPerson);
    setSelectedNewSalesPerson(originalSalesPerson);
    setIsSalesPersonChangeAuthorized(false);
  }}>
    <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: "450px" }}>
      <div className="modal-header">
        <h3>🔐 Verify Current Sales Person</h3>
        <button 
          className="modal-close" 
          onClick={() => {
            setShowPasswordModal(false);
            setEditSalesPerson(originalSalesPerson);
            setSelectedNewSalesPerson(originalSalesPerson);
            setIsSalesPersonChangeAuthorized(false);
          }}
        >
          ×
        </button>
      </div>
      
      <div className="modal-body">
        <div style={{ 
          background: '#fef3c7', 
          padding: '12px', 
          borderRadius: '8px', 
          marginBottom: '15px',
          borderLeft: '4px solid #f59e0b'
        }}>
          <div style={{ fontSize: '14px', fontWeight: '600', color: '#92400e' }}>
            ⚠️ Authorization Required
          </div>
          <div style={{ fontSize: '13px', color: '#78350f', marginTop: '5px' }}>
            You are about to change the sales person from 
            <strong style={{ display: 'block', marginTop: '5px', fontSize: '15px' }}>
              "{originalSalesPerson}"
            </strong>
            to 
            <strong style={{ display: 'block', marginTop: '5px', fontSize: '15px', color: '#1a73e8' }}>
              "{selectedNewSalesPerson}"
            </strong>
          </div>
        </div>
        
        <div style={{ 
          background: '#eff6ff', 
          padding: '12px', 
          borderRadius: '8px', 
          marginBottom: '15px',
          borderLeft: '4px solid #3b82f6'
        }}>
          <div style={{ fontSize: '13px', color: '#1e40af' }}>
            <strong>🔑 Enter the Salesperson Code of the CURRENT sales person:</strong>
            <div style={{ marginTop: '5px', fontSize: '14px', fontWeight: 'bold', color: '#1e3a8a' }}>
              {originalSalesPerson}
            </div>
            <div style={{ marginTop: '5px', fontSize: '12px', color: '#6b7280' }}>
              (Use their unique salesperson code as password)
            </div>
          </div>
        </div>
        
        <div className="detail-item">
          <label>Enter Salesperson Code (Password)</label>
          <input
            type="password"
            value={enteredPassword}
            onChange={(e) => setEnteredPassword(e.target.value)}
            placeholder={`Enter ${originalSalesPerson}'s code`}
            className="filter-input"
            style={{ fontSize: '16px', letterSpacing: '2px' }}
            onKeyPress={(e) => {
              if (e.key === 'Enter') {
                verifyCurrentSalesPersonPassword();
              }
            }}
            autoFocus
          />
        </div>
        
        <div style={{ marginTop: '12px', fontSize: '12px', color: '#6b7280' }}>
          💡 Each salesperson has a unique code. Enter their code to verify identity.
        </div>
      </div>
      
      <div className="modal-footer">
        <button 
          className="btn-download" 
          onClick={verifyCurrentSalesPersonPassword}
          style={{ background: '#1a73e8' }}
        >
          ✅ Verify & Change Sales Person
        </button>
        <button 
          className="btn-close" 
          onClick={() => {
            setShowPasswordModal(false);
            setEditSalesPerson(originalSalesPerson);
            setSelectedNewSalesPerson(originalSalesPerson);
            setIsSalesPersonChangeAuthorized(false);
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}





{/* Edit Invoice Modal */}


{showEditInvoiceModal && selectedInvoiceForEdit && (
  <div className="modal-overlay" onClick={() => setShowEditInvoiceModal(false)}>
    <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: "650px" }}>
      <div className="modal-header">
        <h3>✏️ Edit Invoice Details</h3>
        <button className="modal-close" onClick={() => setShowEditInvoiceModal(false)}>×</button>
      </div>
      
      <div className="modal-body">
        {/* Debug Info - Remove after testing */}
        <div style={{ 
          background: '#f3f4f6', 
          padding: '8px', 
          borderRadius: '4px',
          marginBottom: '15px',
          fontSize: '12px',
          fontFamily: 'monospace'
        }}>
          <div>Current Sales Person: <strong>{originalSalesPerson}</strong></div>
          <div>Selected Sales Person: <strong>{editSalesPerson}</strong></div>
          <div>Authorized: <strong>{isSalesPersonChangeAuthorized ? '✅ Yes' : '❌ No'}</strong></div>
        </div>
        
        <div className="detail-item">
          <label>Customer Name *</label>
          <input
            type="text"
            value={editCustomerName}
            onChange={(e) => setEditCustomerName(e.target.value)}
            placeholder="Enter customer name"
            className="filter-input"
          />
        </div>
        
        <div className="detail-item" style={{ marginTop: "15px" }}>
          <label>Telephone Number *</label>
          <input
            type="text"
            value={editCustomerPhone}
            onChange={(e) => setEditCustomerPhone(e.target.value)}
            placeholder="Enter phone number"
            className="filter-input"
          />
        </div>
        
        <div className="detail-item" style={{ marginTop: "15px" }}>
          <label>Address</label>
          <input
            type="text"
            value={editCustomerAddress}
            onChange={(e) => setEditCustomerAddress(e.target.value)}
            placeholder="Enter address"
            className="filter-input"
          />
        </div>
        
        <div className="detail-item" style={{ marginTop: "15px" }}>
          <label>Sales Person</label>
          <select
            value={editSalesPerson}
            onChange={(e) => handleSalesPersonChange(e.target.value)}
            className="filter-select"
            style={{ 
              width: '100%', 
              padding: '10px', 
              borderRadius: '6px', 
              border: editSalesPerson !== originalSalesPerson ? '2px solid #f59e0b' : '1px solid #d1d5db',
              backgroundColor: editSalesPerson !== originalSalesPerson ? '#fffbeb' : 'white'
            }}
          >
            {salespersonsList.map((sp) => (
              <option key={sp.id} value={sp.salespersonName}>
                {sp.salespersonName} 
              </option>
            ))}
          </select>
          
          {editSalesPerson !== originalSalesPerson && (
            <div style={{ 
              marginTop: '8px', 
              padding: '8px', 
              borderRadius: '4px',
              background: isSalesPersonChangeAuthorized ? '#f0fdf4' : '#fef3c7',
              border: isSalesPersonChangeAuthorized ? '1px solid #22c55e' : '1px solid #f59e0b',
              fontSize: '12px', 
              color: isSalesPersonChangeAuthorized ? '#15803d' : '#92400e' 
            }}>
              {isSalesPersonChangeAuthorized ? (
                <>
                  ✅ Sales person changed from <strong>{originalSalesPerson}</strong> to <strong>{editSalesPerson}</strong>
                  <div style={{ marginTop: '4px', fontSize: '11px' }}>
                    ✓ Password of {originalSalesPerson} has been verified
                  </div>
                </>
              ) : (
                <>
                  ⚠️ Pending: Enter password for <strong>{originalSalesPerson}</strong> to confirm change
                </>
              )}
            </div>
          )}
          
          {editSalesPerson === originalSalesPerson && (
            <div style={{ 
              marginTop: '8px', 
              fontSize: '12px', 
              color: '#6b7280' 
            }}>
              ℹ️ To change sales person, select a different name
            </div>
          )}
        </div>
      </div>
      
      <div className="modal-footer">
        <button 
          className="btn-download" 
          onClick={saveInvoiceEdits}
          style={{ 
            background: '#22c55e',
            opacity: (editSalesPerson !== originalSalesPerson && !isSalesPersonChangeAuthorized) ? 0.5 : 1,
            cursor: (editSalesPerson !== originalSalesPerson && !isSalesPersonChangeAuthorized) ? 'not-allowed' : 'pointer'
          }}
          disabled={editSalesPerson !== originalSalesPerson && !isSalesPersonChangeAuthorized}
        >
          💾 Save All Changes
        </button>
        <button 
          className="btn-close" 
          onClick={() => {
            setShowEditInvoiceModal(false);
            setEditSalesPerson(originalSalesPerson);
            setIsSalesPersonChangeAuthorized(false);
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}























    {/* UPIN + RECEIPT MODAL */}
    {showUpinReceiptModal && (
      <div className="modal-overlay" onClick={() => setShowUpinReceiptModal(false)}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: "500px" }}>
          <div className="modal-header">
            <h3>Update Frame Issue</h3>
            <button className="modal-close" onClick={() => setShowUpinReceiptModal(false)}>×</button>
          </div>

          <div className="modal-body">
            <div className="detail-item">
              <label>Invoice No</label>
              <input
                type="text"
                value={selectedInvoiceForEdit?.invoiceNumber || ""}
                disabled
                className="filter-input"
              />
            </div>

            <div className="detail-item" style={{ marginTop: "15px" }}>
              <label>Frame 2nd Time</label>
              <input
                type="text"
                value={upinNo}
                onChange={(e) => setUpinNo(e.target.value)}
                placeholder="Enter Frame details"
                className="filter-input"
              />
            </div>

            <div className="detail-item" style={{ marginTop: "15px" }}>
              <label>Remark</label>
              <input
                type="text"
                value={receiptNo}
                onChange={(e) => setReceiptNo(e.target.value)}
                placeholder="Remark"
                className="filter-input"
              />
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn-download" onClick={saveUpinAndReceipt}>💾 Save</button>
            <button className="btn-close" onClick={() => setShowUpinReceiptModal(false)}>Cancel</button>
          </div>
        </div>
      </div>
    )}
  </div>
)}






{/******************************************************* View All Balance Invoices ********************************************************/}

{selectedOption === "viewBalanceInvoice" && (
  <div className="view-balance-container">
    <div className="view-balance-header">
      <div>
        <h2>Balance Invoices</h2>
        <p className="subtitle">View, download, and manage all balance invoices</p>
      </div>
      <button className="btn-export-report" onClick={generateBalanceSummaryReport}>
        📊 Export Summary Report
      </button>
    </div>

    {/* Filters Section */}
    <div className="filters-section">
      <div className="filter-row">
        <div className="filter-group">
          <label>Search:</label>
          <input
            type="text"
            placeholder="Search by invoice #, customer..."
            value={balanceInvoiceSearchTerm}
            onChange={(e) => setBalanceInvoiceSearchTerm(e.target.value)}
            className="filter-input"
          />
        </div>

        <div className="filter-group">
          <label>Status:</label>
          <select
            value={balanceInvoiceFilterStatus}
            onChange={(e) => setBalanceInvoiceFilterStatus(e.target.value)}
            className="filter-select"
          >
            <option value="all">All</option>
            <option value="settled">Settled</option>
            <option value="partial">Partial Payment</option>
          </select>
        </div>

        <button className="btn-reset" onClick={resetBalanceFilters}>
          🔄 Reset
        </button>
        <button className="btn-refresh" onClick={fetchAllBalanceInvoices}>
          🔄 Refresh
        </button>
      </div>
    </div>

    {/* Summary Cards */}
    <div className="summary-cards">
      <div className="summary-card">
        <div className="summary-title">Total Balance Invoices</div>
        <div className="summary-value">{filteredBalanceInvoices.length}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Amount Paid</div>
        <div className="summary-value">
          Rs. {filteredBalanceInvoices.reduce((sum, inv) => sum + (inv.paidAmount || 0), 0).toFixed(2)}
        </div>
      </div>

      <div className="summary-card">
        <div className="summary-title">Settled</div>
        <div className="summary-value">
          {filteredBalanceInvoices.filter(inv => inv.remainingBalance <= 0).length}
        </div>
      </div>
    </div>

    {/* Balance Invoices Table */}
    {isLoadingBalanceInvoices ? (
      <div className="loading-spinner">Loading balance invoices...</div>
    ) : (
      <div className="balance-table-container">
        <table className="balance-table">
          <thead>
            <tr>
              <th>Balance Invoice #</th>
              <th>Original Invoice #</th>
              <th>Customer Name</th>
              <th>Phone</th>
              <th>Paid Amount</th>
              <th>Remaining Balance</th>
              <th>Payment Method</th>
              <th>Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredBalanceInvoices.length === 0 ? (
              <tr>
                <td colSpan="10" style={{ textAlign: 'center', padding: '40px' }}>
                  No balance invoices found
                </td>
              </tr>
            ) : (
              filteredBalanceInvoices.map((invoice) => (
                <tr key={invoice.id}>
                  <td className="invoice-link" onClick={() => viewBalanceInvoiceDetails(invoice)}>
                    {invoice.balanceInvoiceNumber}
                  </td>
                  <td>{invoice.originalInvoiceNumber}</td>
                  <td>{invoice.customerName || '-'}</td>
                  <td>{invoice.customerPhone || '-'}</td>
                  <td className="amount-paid">Rs. {(invoice.paidAmount || 0).toFixed(2)}</td>
                  <td className={`remaining-amount ${invoice.remainingBalance <= 0 ? 'settled' : ''}`}>
                    Rs. {(invoice.remainingBalance || 0).toFixed(2)}
                  </td>
                  <td>
                    <span className="payment-method-badge">{invoice.paymentMethod}</span>
                  </td>
                  <td>
                    <div className="date-cell">
                      <div>{invoice.formattedDate}</div>
                      <small>{invoice.formattedTime}</small>
                    </div>
                  </td>
                  <td>
                    <span 
                      className="status-badge" 
                      style={{ backgroundColor: invoice.statusColor }}
                    >
                      {invoice.statusText}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button
                        className="btn-view"
                        onClick={() => viewBalanceInvoiceDetails(invoice)}
                        title="View Details"
                      >
                        👁️
                      </button>
                      <button
                        className="btn-download"
                        onClick={() => downloadBalanceInvoicePDF(invoice)} 
                        title="Download PDF"
                      >
                        📄
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => deleteBalanceInvoice(invoice.id, invoice.balanceInvoiceNumber)}
                        title="Delete"
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    )}

    {/* Balance Invoice Details Modal */}
    {showBalanceInvoiceDetails && selectedBalanceInvoice && (
      <div className="modal-overlay" onClick={() => setShowBalanceInvoiceDetails(false)}>
        <div className="modal-content large" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Balance Invoice Details</h3>
            <button className="modal-close" onClick={() => setShowBalanceInvoiceDetails(false)}>×</button>
          </div>
          
          <div className="modal-body">
            <div className="details-grid">
              <div className="details-section">
                <h4>Invoice Information</h4>
                <div className="detail-item">
                  <label>Balance Invoice #:</label>
                  <span className="value">{selectedBalanceInvoice.balanceInvoiceNumber}</span>
                </div>
                <div className="detail-item">
                  <label>Original Invoice #:</label>
                  <span>{selectedBalanceInvoice.originalInvoiceNumber}</span>
                </div>
                <div className="detail-item">
                  <label>Date Created:</label>
                  <span>{selectedBalanceInvoice.formattedDate} at {selectedBalanceInvoice.formattedTime}</span>
                </div>
                <div className="detail-item">
                  <label>Status:</label>
                  <span className="status-badge" style={{ backgroundColor: selectedBalanceInvoice.statusColor }}>
                    {selectedBalanceInvoice.statusText}
                  </span>
                </div>
              </div>

              <div className="details-section">
                <h4>Customer Information</h4>
                <div className="detail-item">
                  <label>Customer Name:</label>
                  <span>{selectedBalanceInvoice.customerName || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Phone Number:</label>
                  <span>{selectedBalanceInvoice.customerPhone || '-'}</span>
                </div>
              </div>

              <div className="details-section">
                <h4>Payment Details</h4>
                <div className="detail-item">
                  <label>Original Amount:</label>
                  <span>Rs. {(selectedBalanceInvoice.originalAmount || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Previous Advance:</label>
                  <span>Rs. {(selectedBalanceInvoice.originalAdvance || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Previous Balance:</label>
                  <span>Rs. {(selectedBalanceInvoice.originalBalance || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item highlight">
                  <label>Amount Paid:</label>
                  <span className="paid-amount">Rs. {(selectedBalanceInvoice.paidAmount || 0).toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Payment Method:</label>
                  <span>{selectedBalanceInvoice.paymentMethod}</span>
                </div>
                <div className="detail-item">
                  <label>Remaining Balance:</label>
                  <span className={`remaining ${selectedBalanceInvoice.remainingBalance <= 0 ? 'settled' : ''}`}>
                    Rs. {(selectedBalanceInvoice.remainingBalance || 0).toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button 
              className="btn-download" 
              onClick={() => downloadBalanceInvoicePDF(selectedBalanceInvoice)}
            >
              📄 Download PDF
            </button>
            <button 
              className="btn-delete" 
              onClick={() => {
                deleteBalanceInvoice(selectedBalanceInvoice.id, selectedBalanceInvoice.balanceInvoiceNumber);
                setShowBalanceInvoiceDetails(false);
              }}
            >
              🗑️ Delete
            </button>
            <button className="btn-close" onClick={() => setShowBalanceInvoiceDetails(false)}>
              Close
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)}









{/***********************************************  view all consultation ********************************************/}


{selectedOption === "viewConsultation" && (
  <div className="consultation-container">
    <div className="consultation-header">
      <div>
        <h2>Consultations</h2>
        <p className="subtitle">View and manage all patient consultations</p>
      </div>
      <button className="btn-export-report" onClick={generateConsultationReportPDF}>
        📊 Export Report
      </button>
    </div>

    {/* Filters Section */}
    <div className="filters-section">
      <div className="filter-row">
        <div className="filter-group">
          <label>Search:</label>
          <input
            type="text"
            placeholder="Search by customer name..."
            value={consultationSearchTerm}
            onChange={(e) => setConsultationSearchTerm(e.target.value)}
            className="filter-input"
          />
        </div>

        <div className="filter-group">
          <label>Status:</label>
          <select
            value={consultationFilterStatus}
            onChange={(e) => setConsultationFilterStatus(e.target.value)}
            className="filter-select"
          >
            <option value="all">All</option>
            <option value="completed">Completed</option>
            <option value="pending">Pending</option>
            <option value="cancelled">Cancelled</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Date Range:</label>
          <input
            type="date"
            value={consultationDateRange.start}
            onChange={(e) => setConsultationDateRange(prev => ({ ...prev, start: e.target.value }))}
            className="filter-date"
          />
          <span>to</span>
          <input
            type="date"
            value={consultationDateRange.end}
            onChange={(e) => setConsultationDateRange(prev => ({ ...prev, end: e.target.value }))}
            className="filter-date"
          />
        </div>

        <button className="btn-reset" onClick={resetConsultationFilters}>
          🔄 Reset
        </button>
        <button className="btn-refresh" onClick={fetchAllConsultations}>
          🔄 Refresh
        </button>
      </div>
    </div>

    {/* Summary Cards */}
    <div className="summary-cards">
      <div className="summary-card">
        <div className="summary-title">Total Consultations</div>
        <div className="summary-value">{filteredConsultations.length}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Revenue</div>
        <div className="summary-value">
          Rs. {filteredConsultations.reduce((sum, c) => sum + c.totalAmount, 0).toFixed(2)}
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Completed</div>
        <div className="summary-value">
          {filteredConsultations.filter(c => c.pendingItems === 0 && c.cancelledItems === 0).length}
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Pending</div>
        <div className="summary-value">
          {filteredConsultations.filter(c => c.pendingItems > 0).length}
        </div>
      </div>
    </div>

    {/* Consultations Table */}
    {isLoadingConsultations ? (
      <div className="loading-spinner">Loading consultations...</div>
    ) : (
      <div className="consultation-table-container">
        <table className="consultation-table">
          <thead>
            <tr>
              <th>Date & Time</th>
              <th>Customer Name</th>
              <th>Delivery Date</th>
              <th>Items</th>
              <th>Total Amount</th>
              <th>Completed</th>
              <th>Pending</th>
              <th>Cancelled</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredConsultations.length === 0 ? (
              <tr>
                <td colSpan="10" style={{ textAlign: 'center', padding: '40px' }}>
                  No consultations found
                </td>
              </tr>
            ) : (
              filteredConsultations.map((consultation) => {
                const status = getStatusBadge(consultation);
                return (
                  <tr key={consultation.id}>
                    <td>
                      <div className="date-cell">
                        <div>{consultation.formattedDate}</div>
                        <small>{consultation.formattedTime}</small>
                      </div>
                    </td>
                    <td className="customer-name">{consultation.customerName}</td>
                    <td>{consultation.deliveryDate || '-'}</td>
                    <td className="text-center">{consultation.items.length}</td>
                    <td className="amount">Rs. {consultation.totalAmount.toFixed(2)}</td>
                    <td className="text-center completed">{consultation.completedItems}</td>
                    <td className="text-center pending">{consultation.pendingItems}</td>
                    <td className="text-center cancelled">{consultation.cancelledItems}</td>
                    <td>
                      <span className="status-badge" style={{ backgroundColor: status.color }}>
                        {status.text}
                      </span>
                    </td>
                    <td>
                      <div className="action-buttons">
                        <button
                          className="btn-view"
                          onClick={() => {
                            setSelectedConsultation(consultation);
                            setShowConsultationDetails(true);
                          }}
                          title="View Details"
                        >
                          👁️
                        </button>
                        <button
                          className="btn-delete"
                          onClick={() => deleteConsultation(consultation.id, consultation.customerName)}
                          title="Delete"
                        >
                          🗑️
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    )}

    {/* Consultation Details Modal */}
    {showConsultationDetails && selectedConsultation && (
      <div className="modal-overlay" onClick={() => setShowConsultationDetails(false)}>
        <div className="modal-content large" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Consultation Details</h3>
            <button className="modal-close" onClick={() => setShowConsultationDetails(false)}>×</button>
          </div>
          
          <div className="modal-body">
            <div className="details-grid">
              <div className="details-section">
                <h4>Consultation Information</h4>
                <div className="detail-item">
                  <label>Customer Name:</label>
                  <span className="value">{selectedConsultation.customerName}</span>
                </div>
                <div className="detail-item">
                  <label>Date:</label>
                  <span>{selectedConsultation.formattedDate}</span>
                </div>
                <div className="detail-item">
                  <label>Time:</label>
                  <span>{selectedConsultation.formattedTime}</span>
                </div>
                <div className="detail-item">
                  <label>Delivery Date:</label>
                  <span>{selectedConsultation.deliveryDate || 'Not specified'}</span>
                </div>
              </div>

              <div className="details-section">
                <h4>Summary</h4>
                <div className="detail-item">
                  <label>Total Items:</label>
                  <span>{selectedConsultation.items.length}</span>
                </div>
                <div className="detail-item">
                  <label>Total Amount:</label>
                  <span className="amount">Rs. {selectedConsultation.totalAmount.toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Completed:</label>
                  <span className="completed">{selectedConsultation.completedItems}</span>
                </div>
                <div className="detail-item">
                  <label>Pending:</label>
                  <span className="pending">{selectedConsultation.pendingItems}</span>
                </div>
                <div className="detail-item">
                  <label>Cancelled:</label>
                  <span className="cancelled">{selectedConsultation.cancelledItems}</span>
                </div>
              </div>

              <div className="details-section full-width">
                <h4>Consultation Items</h4>
                <div className="items-table-container">
                  <table className="items-table">
                    <thead>
                      <tr>
                        <th>Item Name</th>
                        <th>Price (Rs.)</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {selectedConsultation.items.map((item) => (
                        <tr key={item.id}>
                          <td>{item.name}</td>
                          <td>Rs. {item.price.toFixed(2)}</td>
                          <td>
                            <span className={`status-badge-small ${item.status}`}>
                              {item.status}
                            </span>
                          </td>
                          <td>
                            {item.status === 'pending' && (
                              <div className="status-update-buttons">
                                <button
                                  className="btn-complete"
                                  onClick={() => {
                                    setSelectedItemForStatus(item);
                                    setNewStatus('completed');
                                    setShowUpdateStatusModal(true);
                                  }}
                                >
                                  ✓ Complete
                                </button>
                                <button
                                  className="btn-cancel"
                                  onClick={() => {
                                    setSelectedItemForStatus(item);
                                    setNewStatus('cancelled');
                                    setShowUpdateStatusModal(true);
                                  }}
                                >
                                  ✗ Cancel
                                </button>
                              </div>
                            )}
                            {item.status === 'completed' && (
                              <span className="completed-badge">✓ Completed</span>
                            )}
                            {item.status === 'cancelled' && (
                              <span className="cancelled-badge">✗ Cancelled</span>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn-close" onClick={() => setShowConsultationDetails(false)}>
              Close
            </button>
          </div>
        </div>
      </div>
    )}

    {/* Update Status Modal */}
    {showUpdateStatusModal && selectedItemForStatus && (
      <div className="modal-overlay" onClick={() => setShowUpdateStatusModal(false)}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Update Item Status</h3>
            <button className="modal-close" onClick={() => setShowUpdateStatusModal(false)}>×</button>
          </div>
          
          <div className="modal-body">
            <div className="detail-item">
              <label>Item:</label>
              <span>{selectedItemForStatus.name}</span>
            </div>
            <div className="detail-item">
              <label>Current Status:</label>
              <span className={`status-badge-small ${selectedItemForStatus.status}`}>
                {selectedItemForStatus.status}
              </span>
            </div>
            <div className="detail-item">
              <label>New Status:</label>
              <span className={`status-badge-small ${newStatus}`}>
                {newStatus}
              </span>
            </div>
            <p className="confirmation-message">
              Are you sure you want to mark this item as {newStatus}?
            </p>
          </div>

          <div className="modal-footer">
            <button className="btn-cancel" onClick={() => setShowUpdateStatusModal(false)}>
              No, Cancel
            </button>
            <button 
              className="btn-confirm"
              onClick={() => updateConsultationItemStatus(
                selectedConsultation.id,
                selectedItemForStatus.id,
                newStatus
              )}
            >
              Yes, Update Status
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)}







{/*************************************************************** Add Supplier******************************************************/}
 
 
   {selectedOption === "addSupplier" && (
  <div className="add-supplier-container">
    <div className="add-supplier-card">
      <h2>Add Supplier</h2>

      {/* Supplier Name */}
      <label>Supplier Name *</label>
      <input
        type="text"
        value={supplierName}
        onChange={(e) => setSupplierName(e.target.value)}
        placeholder="Enter supplier name"
      />

      {/* Email */}
      <label>Email</label>
      <input
        type="email"
        value={supplierEmail}
        onChange={(e) => setSupplierEmail(e.target.value)}
        placeholder="Enter email"
      />

      {/* Phone */}
      <label>Phone *</label>
      <input
        type="tel"
        value={supplierPhone}
        onChange={(e) => setSupplierPhone(e.target.value)}
        placeholder="Enter phone number"
      />

      {/* Company */}
      <label>Company *</label>
      <input
        type="text"
        value={supplierCompany}
        onChange={(e) => setSupplierCompany(e.target.value)}
        placeholder="Enter company name"
      />

      {/* Address */}
      <label>Address *</label>
      <textarea
        value={supplierAddress}
        onChange={(e) => setSupplierAddress(e.target.value)}
        placeholder="Enter address"
        rows="3"
      />

      {/* Buttons */}
      <button onClick={handleClearSupplier}>Clear</button>

<button onClick={handleAddSupplier} disabled={addingSupplier}>
  {addingSupplier ? "Adding..." : "Add Supplier"}
</button>

    </div>
  </div>
)}




{/******************************************************* DashBoard  *****************************************************************/}

        {selectedOption === "dashboard" && (
  <div className="dashboard-container">
    {isLoadingDashboard ? (
  <div className="dashboard-skeleton">
    <div className="skeleton-header"></div>
    <div className="skeleton-grid">
      {[1,2,3,4].map(i => <div key={i} className="skeleton-card"></div>)}
    </div>
  </div>
) : (
      <>
        {/* Header with date filters */}
        <div className="dashboard-header">
          <div>
            <h2>Dashboard</h2>
            <p className="subtitle">Welcome back! Here's your business overview</p>
          </div>
          <div className="date-filters">
<select
  value={selectedYear || new Date().getFullYear()}
  onChange={(e) => setSelectedYear(Number(e.target.value))}
  className="filter-select"
>
  <option value={2023}>2023</option>
  <option value={2024}>2024</option>
  <option value={2025}>2025</option>
  <option value={2026}>2026</option>
  <option value={2027}>2027</option>
  <option value={2028}>2028</option>
  <option value={2029}>2029</option>
  <option value={2030}>2030</option>
  <option value={2031}>2031</option>
  <option value={2032}>2032</option>
  <option value={2033}>2033</option>
  <option value={2034}>2034</option>
  <option value={2035}>2035</option>
  <option value={2036}>2036</option>
  <option value={2037}>2037</option>
</select>



<select
  value={selectedMonth || new Date().getMonth() + 1}
  onChange={(e) => setSelectedMonth(Number(e.target.value))}
  className="filter-select"
>
  <option value={1}>January</option>
  <option value={2}>February</option>
  <option value={3}>March</option>
  <option value={4}>April</option>
  <option value={5}>May</option>
  <option value={6}>June</option>
  <option value={7}>July</option>
  <option value={8}>August</option>
  <option value={9}>September</option>
  <option value={10}>October</option>
  <option value={11}>November</option>
  <option value={12}>December</option>
</select>




            <button className="btn-refresh" onClick={fetchDashboardData}>
              🔄 Refresh
            </button>
          </div>
        </div>

        {/* KPI Cards */}
        <div className="kpi-grid">
          <div className="kpi-card revenue">
            <div className="kpi-icon">💰</div>
            <div className="kpi-content">
              <div className="kpi-label">Total Sale</div>
              <div className="kpi-value">{formatCurrency(dashboardStats.totalRevenue)}</div>
              {/* <div className="kpi-trend positive">↑ 12% from last month</div> */}
            </div>
          </div>

                    <div className="kpi-card revenue">
            <div className="kpi-icon">💰</div>
            <div className="kpi-content">
              <div className="kpi-label">Total Received</div>
              <div className="kpi-value">{formatCurrency(dashboardStats.totalReceived)}</div>
              {/* <div className="kpi-trend positive">↑ 12% from last month</div> */}
            </div>
          </div>
          
          <div className="kpi-card invoices">
            <div className="kpi-icon">📄</div>
            <div className="kpi-content">
              <div className="kpi-label">Total Invoices</div>
              <div className="kpi-value">{dashboardStats.totalInvoices}</div>
              <div className="kpi-trend">Avg. {formatCurrency(dashboardStats.averageInvoiceValue)} per invoice</div>
            </div>
          </div>
          
          <div className="kpi-card patients">
            <div className="kpi-icon">👥</div>
            <div className="kpi-content">
              <div className="kpi-label">Total Patients</div>
              <div className="kpi-value">{dashboardStats.totalPatients}</div>
              <div className="kpi-trend">Unique customers served</div>
            </div>
          </div>
          
          <div className="kpi-card pending">
            <div className="kpi-icon">⏳</div>
            <div className="kpi-content">
              <div className="kpi-label">Pending Balance</div>
              <div className="kpi-value">{formatCurrency(dashboardStats.pendingBalance)}</div>
              <div className="kpi-trend negative">Due from customers</div>
            </div>
          </div>
        </div>

        {/* Products Sold Cards */}
        <div className="products-grid">
          <div className="product-card frames">
            <div className="product-icon">👓</div>
            <div className="product-info">
              <div className="product-label">Frames Sold</div>
              <div className="product-value">{dashboardStats.framesSold}</div>
            </div>
          </div>
          <div className="product-card lenses">
            <div className="product-icon">🔍</div>
            <div className="product-info">
              <div className="product-label">Lenses Sold</div>
              <div className="product-value">{dashboardStats.lensesSold}</div>
            </div>
          </div>
        </div>



<div className="product-panel">

  {/* HEADER */}
  <div className="product-panel-header">
    <h2>Available Products</h2>

    <input
      type="text"
      placeholder="Search by Model, Brand, Code..."
      value={productSearch}
      onChange={(e) => setProductSearch(e.target.value)}
      className="product-search"
    />
  </div>

  {/* TABLE */}
  <div className="product-table-wrapper">

    <table className="product-table">

      <thead>
        <tr>
          <th>Category</th>
          <th>Model / Code</th>
          <th>Brand</th>
          <th>Colour</th>
          <th>Sex</th>
          <th>Available Qty</th>
          <th>Added Qty</th>
          <th>Price</th>
        </tr>
      </thead>

      <tbody>

        {filteredProducts.length === 0 ? (
          <tr>
            <td colSpan="8" className="no-products">
              No products found
            </td>
          </tr>
        ) : (

          filteredProducts.map((p, index) => (

            <tr key={index}>

              <td>
                <span className={`category-badge ${p.category}`}>
                  {p.category}
                </span>
              </td>

              <td>{p.modelNo || p.itemCode}</td>

              <td>{p.brand || "-"}</td>

              <td>{p.colour || "-"}</td>

              <td>{p.sex || "-"}</td>

              <td className="qty-green">
                {p.qty || 0}
              </td>

              <td className="qty-dark">
                {p.supplyQty || 0}
              </td>

              <td className="price-text">
                Rs. {p.sellingPrice || 0}
              </td>

            </tr>

          ))

        )}

      </tbody>

    </table>

  </div>

</div>


        {/* Charts Section */}
        <div className="charts-grid">
          <div className="chart-card large">
            <div className="chart-header">
              <h3>Revenue Overview</h3>
            </div>
            <div className="chart-container">
              <Bar data={revenueChartData} options={revenueChartOptions} />
            </div>
          </div>
          
          <div className="chart-card">
            <div className="chart-header">
              <h3>Payment Methods</h3>
            </div>
            <div className="chart-container small">
              <Doughnut data={paymentMethodChartData} options={paymentMethodOptions} />
            </div>
          </div>
        </div>

        {/* Daily Sales Chart */}
        <div className="chart-card full-width">
          <div className="chart-header">
            <h3>Daily Sales Performance</h3>
            <p className="chart-subtitle">Sales breakdown for {new Date(selectedYear, selectedMonth - 1, 1).toLocaleString('default', { month: 'long' })} {selectedYear}</p>
          </div>
          <div className="chart-container medium">
            <Line data={dailySalesChartData} options={dailySalesOptions} />
          </div>
        </div>

        {/* Top Products & Recent Invoices */}
        <div className="two-column-grid">
          {/* Top Products */}
          <div className="info-card">
            <div className="card-header">
              <h3>🏆 Top Selling Products</h3>
            </div>
            <div className="card-body">
              {dashboardStats.topProducts.length === 0 ? (
                <div className="empty-state">No products sold yet</div>
              ) : (
                <div className="top-products-list">
                  {dashboardStats.topProducts.map((product, index) => (
                    <div key={index} className="product-item">
                      <div className="product-rank">{index + 1}</div>
                      <div className="product-name">{product.name}</div>
                      <div className="product-count">{product.count} units</div>
                      <div className="product-bar">
                        <div 
                          className="product-bar-fill" 
                          style={{ 
                            width: `${(product.count / dashboardStats.topProducts[0].count) * 100}%`,
                            backgroundColor: index === 0 ? '#4CAF50' : index === 1 ? '#2196F3' : '#FF9800'
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Recent Invoices */}
          <div className="info-card">
            <div className="card-header">
              <h3>📋 Recent Invoices</h3>
            </div>
            <div className="card-body">
              {dashboardStats.recentInvoices.length === 0 ? (
                <div className="empty-state">No recent invoices</div>
              ) : (
                <div className="recent-invoices-list">
                  {dashboardStats.recentInvoices.map((invoice, index) => (
                    <div key={index} className="invoice-item">
                      <div className="invoice-info">
                        <div className="invoice-number">{invoice.invoiceNumber}</div>
                        <div className="invoice-customer">{invoice.customerName}</div>
                        <div className="invoice-date">
                          {new Date(invoice.date).toLocaleDateString()}
                        </div>
                      </div>
                      <div className="invoice-amounts">
                        <div className="invoice-total">{formatCurrency(invoice.totalAmount)}</div>
                        <div className="invoice-paid">Paid: {formatCurrency(invoice.paidAmount)}</div>
                        {invoice.balanceDue > 0 && (
                          <div className="invoice-due">Due: {formatCurrency(invoice.balanceDue)}</div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Quick Stats Footer */}
        <div className="quick-stats">
          <div className="stat-item">
            <span className="stat-label">Average Invoice Value:</span>
            <span className="stat-value">{formatCurrency(dashboardStats.averageInvoiceValue)}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Collection Rate:</span>
            <span className="stat-value">
              {((dashboardStats.totalRevenue / (dashboardStats.totalRevenue + dashboardStats.pendingBalance)) * 100).toFixed(1)}%
            </span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Revenue per Patient:</span>
            <span className="stat-value">
              {formatCurrency(dashboardStats.totalPatients > 0 ? dashboardStats.totalRevenue / dashboardStats.totalPatients : 0)}
            </span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Monthly Average:</span>
            <span className="stat-value">
              {formatCurrency(dashboardStats.monthlyRevenue.reduce((a, b) => a + b, 0) / 12)}
            </span>
          </div>
        </div>
      </>
    )}
  </div>
)}


{/******************************************************* view patients  *****************************************************************/}



{selectedOption === "viewPatient" && (
  <div className="patient-directory-container">
    <div className="patient-directory-header">
      <div>
        <h2>Patient Directory</h2>
        <p className="subtitle">View and manage all patient records from invoices</p>
      </div>
      <button className="btn-export-report" onClick={generatePatientReportPDF}>
        📊 Export Patient Report
      </button>
    </div>

    {/* Filters Section */}
    <div className="filters-section">
      <div className="filter-row">
        <div className="filter-group">
          <label>Search:</label>
          <input
            type="text"
            placeholder="Search by name, phone, email..."
            value={patientSearchTerm}
            onChange={(e) => setPatientSearchTerm(e.target.value)}
            className="filter-input"
          />
        </div>

        <div className="filter-group">
          <label>Age Group:</label>
          <select
            value={patientFilterAge}
            onChange={(e) => setPatientFilterAge(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Ages</option>
            <option value="child">Child (&lt; 18)</option>
            <option value="adult">Adult (18-59)</option>
            <option value="senior">Senior (60+)</option>
          </select>
        </div>



        <div className="filter-group">
          <label>Last Visit Range:</label>
          <input
            type="date"
            value={patientDateRange.start}
            onChange={(e) => setPatientDateRange(prev => ({ ...prev, start: e.target.value }))}
            className="filter-date"
          />
          <span>to</span>
          <input
            type="date"
            value={patientDateRange.end}
            onChange={(e) => setPatientDateRange(prev => ({ ...prev, end: e.target.value }))}
            className="filter-date"
          />
        </div>

        <button className="btn-reset" onClick={resetPatientFilters}>
          🔄 Reset
        </button>
        <button className="btn-refresh" onClick={fetchAllPatients}>
          🔄 Refresh
        </button>
      </div>
    </div>

    {/* Summary Cards */}
    <div className="summary-cards">
      <div className="summary-card">
        <div className="summary-title">Total Patients</div>
        <div className="summary-value">{filteredPatients.length}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Revenue</div>
        <div className="summary-value">
          Rs. {filteredPatients.reduce((sum, p) => sum + p.totalSpent, 0).toFixed(2)}
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Due</div>
        <div className="summary-value">
          Rs. {filteredPatients.reduce((sum, p) => sum + p.totalDue, 0).toFixed(2)}
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Average Spent</div>
        <div className="summary-value">
          Rs. {(filteredPatients.reduce((sum, p) => sum + p.totalSpent, 0) / (filteredPatients.length || 1)).toFixed(2)}
        </div>
      </div>
    </div>

    {/* Patients Table */}
    {isLoadingPatients ? (
      <div className="loading-spinner">Loading patients...</div>
    ) : (
      <div className="patient-table-container">
        <table className="patient-table">
          <thead>
            <tr>
              <th>Invoice No</th>
              <th>Patient Name</th>
              <th>Address</th>
              <th>Contact</th>
              <th>Age</th>
              <th>Total Invoices</th>
              <th>Total Spent</th>
              <th>Balance Due</th>
              <th>Last Visit</th>
              <th>Status</th>
              <th>Spectacle Tracking</th>
              <th>QC By</th>
              <th>Actions</th>
            </tr>
          </thead>
        <tbody>
  {filteredPatients.length === 0 ? (
    <tr>
      <td colSpan="11" style={{ textAlign: "center", padding: "40px" }}>
        No patients found
      </td>
    </tr>
  ) : (
    filteredPatients.map((patient) => {
      const latestInvoice =
        patient.invoices && patient.invoices.length > 0
          ? patient.invoices[patient.invoices.length - 1]
          : null;

      return (
        <tr key={patient.id}>
          <td className="invoice-number">
            {latestInvoice ? latestInvoice.invoiceNumber : "-"}   
          </td>
          <td
            className="patient-name"
           
          >
            <div className="name-cell">
              <strong>{patient.fullName}</strong>
              {/* {patient.title && <small>({patient.title})</small>} */}
            </div>
          </td>


          <td>
            <div className="contact-cell">
              <div>{patient.address || "-"}</div>
            </div>
          </td>


          <td>
            <div className="contact-cell">
              <div>{patient.tpNo || "-"}</div>
              <small>{patient.email || "-"}</small>
            </div>
          </td>

          <td>
            <div className="age-cell">
              {patient.age || "-"}
              <small className="age-group">
                {getAgeGroup(patient.age)}
              </small>
            </div>
          </td>



          <td className="text-center">{patient.totalInvoices}</td>

          <td className="amount">
            Rs. {patient.totalSpent.toFixed(2)}
          </td>

          <td
            className={`balance-due ${
              patient.totalDue <= 0 ? "settled" : ""
            }`}
          >
            Rs. {patient.totalDue.toFixed(2)}
          </td>

          <td>
            <div className="date-cell">
              <div>
                {new Date(patient.lastVisit).toLocaleDateString()}
              </div>
              <small>
                First: {new Date(patient.firstVisit).toLocaleDateString()}
              </small>
            </div>
          </td>

          <td>
            <span
              className={`status-badge ${
                patient.totalDue <= 0 ? "paid" : "pending"
              }`}
            >
              {patient.totalDue <= 0 ? "Settled" : "Has Due"}
            </span>
          </td>

          {/* ✅ FIXED SPECTACLE TRACKING (NO invoice variable) */}
          <td>
            {latestInvoice?.spectacleTracking ? (
              <div className="tracking-status-cell">
                <span
                  className={`tracking-badge ${
                    latestInvoice.spectacleTracking?.latestStatus
                      ?.toLowerCase()
                      .includes("delivered")
                      ? "delivered"
                      : latestInvoice.spectacleTracking?.latestStatus
                          ?.toLowerCase()
                          .includes("received")
                      ? "received"
                      : "processing"
                  }`}
                >
                  {latestInvoice.spectacleTracking?.latestStatus ||
                    "No Status"}
                </span>

                <small>
                  {latestInvoice.spectacleTracking?.latestDate || "-"}
                </small>
              </div>
            ) : (
              <span className="tracking-none">No Tracking</span>
            )}
          </td>


<td>
  {latestInvoice?.qcData ? (
    <div className="qc-status-cell">
      <span className="qc-badge">
        {latestInvoice.qcData.qcPerson}
      </span>

      <small>
        {latestInvoice.qcData.qcDate} |{" "}
        {latestInvoice.qcData.qcTime}
      </small>
    </div>
  ) : (
    <span className="tracking-none">
      No QC
    </span>
  )}
</td>




<td>
  <div className="action-buttons">
    {/* <button
      className="btn-view"
      onClick={() => viewPatientDetails(patient)}
      title="View Details"
    >
      👁️
    </button> */}

    <button
      className="btn-qc"
      onClick={() => openQCModal(patient)}
      title="Quality Check"
    >
      QC
    </button>
  </div>
</td>
        </tr>
      );
    })
  )}
 </tbody>
        </table>
      </div>
    )}

    {/* Patient Details Modal */}
    {showPatientDetails && selectedPatient && (
      <div className="modal-overlay" onClick={() => setShowPatientDetails(false)}>
        <div className="modal-content large" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Patient Details</h3>
            <button className="modal-close" onClick={() => setShowPatientDetails(false)}>×</button>
          </div>
          
          <div className="modal-body">
            <div className="details-grid">
              <div className="details-section">
                <h4>Personal Information</h4>
                <div className="detail-item">
                  <label>Full Name:</label>
                  <span className="value">{selectedPatient.fullName}</span>
                </div>
                <div className="detail-item">
                  <label>Age:</label>
                  <span>{selectedPatient.age} years ({getAgeGroup(selectedPatient.age)})</span>
                </div>
                <div className="detail-item">
                  <label>Gender:</label>
                  <span>{selectedPatient.gender || 'Not specified'}</span>
                </div>
                <div className="detail-item">
                  <label>Phone:</label>
                  <span>{selectedPatient.tpNo || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Email:</label>
                  <span>{selectedPatient.email || '-'}</span>
                </div>
                <div className="detail-item">
                  <label>Address:</label>
                  <span>{selectedPatient.address || '-'}</span>
                </div>
              </div>

              <div className="details-section">
                <h4>Financial Summary</h4>
                <div className="detail-item">
                  <label>Total Invoices:</label>
                  <span>{selectedPatient.totalInvoices}</span>
                </div>
                <div className="detail-item">
                  <label>Total Spent:</label>
                  <span className="amount">Rs. {selectedPatient.totalSpent.toFixed(2)}</span>
                </div>
                <div className="detail-item">
                  <label>Total Paid:</label>
                  <span className="paid-amount">Rs. {selectedPatient.totalPaid.toFixed(2)}</span>
                </div>
                <div className="detail-item highlight">
                  <label>Balance Due:</label>
                  <span className={`balance-due ${selectedPatient.totalDue <= 0 ? 'settled' : ''}`}>
                    Rs. {selectedPatient.totalDue.toFixed(2)}
                  </span>
                </div>
                <div className="detail-item">
                  <label>First Visit:</label>
                  <span>{new Date(selectedPatient.firstVisit).toLocaleDateString()}</span>
                </div>
                <div className="detail-item">
                  <label>Last Visit:</label>
                  <span>{new Date(selectedPatient.lastVisit).toLocaleDateString()}</span>
                </div>
              </div>

              <div className="details-section full-width">
                <h4>Invoice History</h4>
                <div className="invoice-history-table">
                  <table className="mini-table">
                    <thead>
                      <tr>
                        <th>Invoice #</th>
                        <th>Date</th>
                        <th>Frame</th>
                        <th>Lens</th>
                        <th>Total</th>
                        <th>Paid</th>
                        <th>Balance</th>
                        <th>Status</th>
                        <th>Spectacle Tracking</th>
                        <th>QC</th>
                      
                      </tr>
                    </thead>
                    <tbody>
                      {selectedPatient.invoices.map((invoice, idx) => (
                        <tr key={idx}>
                          <td className="invoice-link">{invoice.invoiceNumber}</td>
                          <td>{new Date(invoice.date).toLocaleDateString()}</td>
                          <td>{invoice.products?.frameModel || '-'}</td>
                          <td>{invoice.products?.lensModel || '-'}</td>
                          <td>Rs. {invoice.totalAmount.toFixed(2)}</td>
                          <td>Rs. {invoice.paidAmount.toFixed(2)}</td>
                          <td className={invoice.balanceDue > 0 ? 'balance-due' : 'settled'}>
                            Rs. {invoice.balanceDue.toFixed(2)}
                          </td>
                          <td>
                            <span className={`status-badge ${invoice.status}`}>
                              {invoice.status === 'paid' ? 'Paid' : 'Pending'}
                            </span>
                          </td>


 <td>
  {invoice.spectacleTracking ? (
    <div className="tracking-status-cell">
      <span
        className={`tracking-badge ${
          invoice.spectacleTracking?.latestStatus
            ?.toLowerCase()
            .includes("delivered")
            ? "delivered"
            : invoice.spectacleTracking?.latestStatus
                ?.toLowerCase()
                .includes("received")
            ? "received"
            : "processing"
        }`}
      >
        {invoice.spectacleTracking?.latestStatus || "No Status"}
      </span>

      <small>
        {invoice.spectacleTracking?.latestDate || "-"}
      </small>
    </div>
  ) : (
    <span className="tracking-none">
      No Tracking
    </span>
  )}
 </td>


<td>
  {invoice.qcData ? (
    <div className="qc-status-cell">
      <span className="qc-badge">
        {invoice.qcData.qcPerson}
      </span>

      <small>
        {invoice.qcData.qcDate} | {invoice.qcData.qcTime}
      </small>
    </div>
  ) : (
    <span className="tracking-none">
      No QC
    </span>
  )}
</td>


                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {selectedPatient.prescriptions && selectedPatient.prescriptions.length > 0 && (
                <div className="details-section full-width">
                  <h4>Latest Prescription</h4>
                  <div className="prescription-grid">
                    <div className="eye-prescription">
                      <strong>Right Eye (OD)</strong>
                      <div>VA: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.rightEye?.visualAcuity || '-'}</div>
                      <div>SPH: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.rightEye?.sph || '-'}</div>
                      <div>CYL: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.rightEye?.cyl || '-'}</div>
                      <div>AXIS: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.rightEye?.axis || '-'}</div>
                      <div>ADD: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.rightEye?.add || '-'}</div>
                    </div>
                    <div className="eye-prescription">
                      <strong>Left Eye (OS)</strong>
                      <div>VA: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.leftEye?.visualAcuity || '-'}</div>
                      <div>SPH: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.leftEye?.sph || '-'}</div>
                      <div>CYL: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.leftEye?.cyl || '-'}</div>
                      <div>AXIS: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.leftEye?.axis || '-'}</div>
                      <div>ADD: {selectedPatient.prescriptions[selectedPatient.prescriptions.length - 1]?.leftEye?.add || '-'}</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn-close" onClick={() => setShowPatientDetails(false)}>
              Close
            </button>
          </div>
        </div>
      </div>
    )}








{/* QC MODAL */}
{showQCModal && selectedQCPatient && (
  <div
    className="modal-overlay"
    onClick={() => setShowQCModal(false)}
  >
    <div
      className="modal-content qc-modal"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="modal-header">
        <h3>Patient QC Entry</h3>

        <button
          className="modal-close"
          onClick={() => setShowQCModal(false)}
        >
          ×
        </button>
      </div>

      <div className="modal-body">
        <div className="detail-item">
          <label>Patient</label>
          <input
            type="text"
            value={selectedQCPatient.fullName}
            disabled
            className="filter-input"
          />
        </div>

       <div className="detail-item">
  <label>QC By</label>
  <select
    value={qcForm.qcPerson}
    onChange={(e) =>
      setQcForm({
        ...qcForm,
        qcPerson: e.target.value
      })
    }
    className="filter-select"
  >
    <option value="">Select QC Person</option>
    {salesPersonList.map(person => (
      <option key={person.id} value={person.salespersonName}>
        {person.salespersonName}
      </option>
    ))}
  </select>
</div>

        <div className="detail-item">
          <label>Date</label>

          <input
            type="date"
            value={qcForm.qcDate}
            onChange={(e) =>
              setQcForm({
                ...qcForm,
                qcDate: e.target.value
              })
            }
            className="filter-date"
          />
        </div>

        <div className="detail-item">
          <label>Time</label>

          <input
            type="text"
            value={qcForm.qcTime}
            disabled
            className="filter-input"
          />
        </div>
      </div>

      <div className="modal-footer">
        <button
          className="btn-close"
          onClick={() => setShowQCModal(false)}
        >
          Cancel
        </button>

        <button
          className="btn-save"
          onClick={saveQC}
        >
          Save QC
        </button>
      </div>
    </div>
  </div>
)}




  </div>
)}



{/******************************************************* create Invoice *****************************************************************/}


{selectedOption === "createInvoice" && (
  <>
    {showSuccess && (
      <div className="toast-notification">
        ✓ Order saved successfully! Total: ${totalAmount.toFixed(2)}
      </div>
    )}
    
    <div className="invoice-wrap">
      {/* Header */}


<div className="invoice-header">
  <div className="header-left">
    <h2>Create Order Form</h2>
    <p className="invoice-subtitle">Fill in all required fields (*) to generate order</p>
  </div>
  <div className="invoice-number-display">
    {/* Main Invoice Number - Always displayed */}
    <div className="invoice-number-row">
      <span className="label">Invoice No:</span>
      <span className="number">{currentMainInvoiceNumber}</span>
    </div>
    
    {/* RX/VIP Number - Selectable */}
    <div className="invoice-type-selector">
      <label>Type:</label>
      <select 
        value={invoiceType} 
        onChange={handleInvoiceTypeChange}
        className="invoice-type-select"
      >
        <option value="RX">RX No</option>
        <option value="VIP">VIP No</option>
      </select>
      <span className="number">{currentTypeNumber}</span>
    </div>
  </div>
</div>





      <div className="invoice-content">
        {/* Top Controls Row */}
        <div className="top-controls-row">
          {/* Eye Camp */}
          <div className="control-group">
            <label>Select Eye Camp <span className="optional-badge">Optional</span></label>
            <select
              value={selectedEyeCamp}
              onChange={(e) => setSelectedEyeCamp(e.target.value)}
              className="form-control"
            >
              <option value="-">-- No Eye Camp --</option>
              {eyeCamps.map(camp => (
                <option key={camp.id} value={camp.name}>
                  {camp.name} - {camp.city}
                </option>
              ))}
            </select>
          </div>

          {/* Sales Person */}
          <div className="control-group">
            <label>Served By <span className="required-star">*</span></label>
            <select
              className={errors.salePerson ? "error-input" : ""}
              value={formData.salePerson}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  salePerson: e.target.value,
                })
              }
              required
            >
              <option value="">Select Sales Person</option>
              {salesPersonList.map(person => (
                <option key={person.id} value={person.salespersonName}>
                  {person.salespersonName}
                </option>
              ))}
            </select>
            {errors.salePerson && <span className="error-message">{errors.salePerson}</span>}
          </div>
        </div>

        {/* Customer Information */}
        <div className="invoice-section">
          <div className="section-header">
            <h3>Customer Information</h3>
            <span className="section-badge">Required</span>
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <label>Title</label>
              <select 
                className="form-control"
                name="title"
                value={formData.title}
                onChange={handleInputChange}
              >
                <option value="">Select</option>
                <option value="Mr">Mr.</option>
                <option value="Mrs">Mrs.</option>
                <option value="Ms">Ms.</option>
                <option value="Dr">Dr.</option>
                <option value="Rev">Rev.</option>
              </select>
            </div>

            <div className="form-group">
              <label>First Name <span className="required-star">*</span></label>
              <input 
                type="text" 
                name="firstName"
                value={formData.firstName}
                onChange={handleInputChange}
                placeholder="Enter first name"
                className={errors.firstName ? 'error-input' : ''}
              />
              {errors.firstName && <span className="error-message">{errors.firstName}</span>}
            </div>
            
            <div className="form-group">
              <label>Last Name <span className="required-star">*</span></label>
              <input 
                type="text" 
                name="lastName"
                value={formData.lastName}
                onChange={handleInputChange}
                placeholder="Enter last name"
                className={errors.lastName ? 'error-input' : ''}
              />
              {errors.lastName && <span className="error-message">{errors.lastName}</span>}
            </div>
          </div>
          
          <div className="form-row">
            <div className="form-group">
              <label>Address <span className="required-star">*</span></label>
              <input 
                type="text" 
                name="address"
                value={formData.address}
                onChange={handleInputChange}
                placeholder="Street, city, postal code"
                className={errors.address ? 'error-input' : ''}
              />
              {errors.address && <span className="error-message">{errors.address}</span>}
            </div>
            
            <div className="form-group">
              <label>TP No <span className="required-star">*</span></label>
              <input 
                type="tel" 
                name="tpNo"
                value={formData.tpNo}
                onChange={handleInputChange}
                placeholder="Phone number"
                className={errors.tpNo ? 'error-input' : ''}
              />
              {errors.tpNo && <span className="error-message">{errors.tpNo}</span>}
            </div>
            
            <div className="form-group">
              <label>Landline No</label>
              <input 
                type="text" 
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Landline Number"
              />
            </div>
            
            <div className="form-group">
              <label>Age <span className="required-star"></span></label>
              <input 
                type="number" 
                name="age"
                value={formData.age}
                onChange={handleInputChange}
                placeholder="Years"
                className={errors.age ? 'error-input' : ''}
              />
              {errors.age && <span className="error-message">{errors.age}</span>}
            </div>
          </div>
        </div>

        {/* Optical Prescription */}
        <div className="invoice-section">
          <div className="section-header">
            <h3>Optical Prescription</h3>
            <span className="section-badge">Eye Details</span>
          </div>
          
<div className="form-row">
  <div className="form-group">
    <label>Prescription Date</label>
    <input 
      type="date" 
      name="prescriptionDate"
      value={formData.prescriptionDate}
      onChange={handleInputChange}
    />
  </div>
  
  <div className="form-group">
    <label>Referred By</label>
    <select 
      name="referredBy"
      value={formData.referredBy}
      onChange={handleInputChange}
      className="form-control"
    >
      <option value="">Select Referral Source...</option>
      <option value="OWN">OWN</option>
      <option value="Outside">OutSide</option>
      {doctorList.length > 0 && (
        <optgroup label="Doctors">
{doctorList.map(doctor => (
  <option key={doctor.id} value={doctor.drName}>
    {doctor.drName}
  </option>
))}
        </optgroup>
      )}
    </select>
  </div>

  <div className="form-group">
    <label>Right PD (R PD)</label>
    <input
      type="text"
      name="pd"
      value={formData.pd}
      onChange={handleInputChange}
      placeholder="Right PD"
    />
  </div>

  <div className="form-group">
    <label>Left PD (L PD)</label>
    <input
      type="text"
      name="lpd"
      value={formData.lpd}
      onChange={handleInputChange}
      placeholder="Left PD"
    />
  </div>

  <div className="form-group">
    <label>Height (H)</label>
    <input
      type="text"
      name="sh"
      value={formData.sh}
      onChange={handleInputChange}
      placeholder="Height"
    />
  </div>

  <div className="form-group">
    <label>FPD (Frame PD)</label>
    <input
      type="text"
      name="fpd"
      value={formData.fpd}
      onChange={handleInputChange}
      placeholder="Frame PD"
    />
  </div>

  <div className="form-group">
    <label>R-INSERT (Auto)</label>
    <input
      type="text"
      name="rInsert"
      value={formData.rInsert}
      readOnly
      className="readonly-field"
      placeholder="Auto-calculated"
    />
  </div>

  <div className="form-group">
    <label>L-INSERT (Auto)</label>
    <input
      type="text"
      name="lInsert"
      value={formData.lInsert}
      readOnly
      className="readonly-field"
      placeholder="Auto-calculated"
    />
  </div>
</div>







          <div className="prescription-grid">
            {/* Right Eye */}
            <div className="eye-section">
              <h4>Right Eye (OD)</h4>

              {/* <div className="eye-field-group">
                <label>Visual Acuity</label>
                <select 
                  className="form-control"
                  name="rightVisualAcuity"
                  value={formData.rightVisualAcuity}
                  onChange={handleInputChange}
                >
                  <option value="">Select</option>
                  <option value="6/6">6/6</option>
                  <option value="6/9">6/9</option>
                  <option value="6/12">6/12</option>
                  <option value="6/18">6/18</option>
                  <option value="6/24">6/24</option>
                  <option value="6/36">6/36</option>
                  <option value="6/60">6/60</option>  
                </select>
              </div> */}


               <div className="eye-field-group">
                <label>Right Prism</label>

                     <input 
                      type="text" 
                      name="rightVisualAcuity"
                      value={formData.rightVisualAcuity}
                      onChange={handleInputChange}
                      placeholder="Prism"
                    />
              </div> 



              <div className="eye-fields">
                <div className="eye-field-group">
                  <label>Distance</label>
                  <div className="presc-inputs">
                    <input 
                      type="text" 
                      name="rightSph"
                      value={formData.rightSph}
                      onChange={handleInputChange}
                      placeholder="SPH"
                    />
                    <input 
                      type="text" 
                      name="rightCyl"
                      value={formData.rightCyl}
                      onChange={handleInputChange}
                      placeholder="CYL"
                    />
                    <input 
                      type="text" 
                      name="rightAxis"
                      value={formData.rightAxis}
                      onChange={handleInputChange}
                      placeholder="AXIS"
                    />
                  </div>
                </div>
                
                <div className="eye-field-group">
                  <label>Reading</label>
                  <input 
                    type="text" 
                    name="rightAdd"
                    value={formData.rightAdd}
                    onChange={handleInputChange}
                    placeholder="Addition"
                  />
                </div>

                <div className="eye-field-group">

               <label>L Remark</label>

                <input 
                    type="text" 
                    name="rightNearVA"
                    value={formData.rightNearVA}
                    onChange={handleInputChange}
                    placeholder="R Remark"
                  />
                </div>
              </div>
            </div>

            {/* Left Eye */}
            <div className="eye-section">
              <h4>Left Eye (OS)</h4>

              <div className="eye-field-group">
                <label>Left Prism</label>

                     <input 
                      type="text" 
                      name="leftVisualAcuity"
                      value={formData.leftVisualAcuity}
                      onChange={handleInputChange}
                      placeholder="Prism"
                    />
              </div> 

              <div className="eye-fields">
                <div className="eye-field-group">
                  <label>Distance</label>
                  <div className="presc-inputs">
                    <input 
                      type="text" 
                      name="leftSph"
                      value={formData.leftSph}
                      onChange={handleInputChange}
                      placeholder="SPH"
                    />
                    <input 
                      type="text" 
                      name="leftCyl"
                      value={formData.leftCyl}
                      onChange={handleInputChange}
                      placeholder="CYL"
                    />
                    <input 
                      type="text" 
                      name="leftAxis"
                      value={formData.leftAxis}
                      onChange={handleInputChange}
                      placeholder="AXIS"
                    />
                  </div>
                </div>
                
                <div className="eye-field-group">
                  <label>Reading</label>
                  <input 
                    type="text" 
                    name="leftAdd"
                    value={formData.leftAdd}
                    onChange={handleInputChange}
                    placeholder="Addition"
                  />
                </div>

                <div className="eye-field-group">
                  <label>L Remark</label>

                <input 
                    type="text" 
                    name="leftNearVA"
                    value={formData.leftNearVA}
                    onChange={handleInputChange}
                    placeholder="L Remark"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Lens & Frame Details */}
        <div className="invoice-section">
          <div className="section-header">
            <h3>Lens & Frame Details</h3>
            <span className="section-badge">Products</span>
          </div>

          {/* Generic Lens Toggle */}
          <div className="high-index-toggle">
            <label className="toggle-label">
              <input
                type="checkbox"
                checked={isHighIndexLens}
                onChange={(e) => setIsHighIndexLens(e.target.checked)}
              />
              <span className="toggle-text">Generic Lens</span>
            </label>
          </div>

          {/* Generic Lens Panel */}
          {isHighIndexLens && (
            <div className="high-index-panel">
              <div className="high-index-header">
                <h4>Generic Lens Details</h4>
                <p>Enter individual lens information and pricing</p>
              </div>

              <div className="high-index-grid">
                {/* Right Lens */}
                <div className="high-index-card">
                  <h5>Right Lens</h5>
                  <input
                    type="text"
                    placeholder="Brand"
                    value={highIndexRightBrand}
                    onChange={(e) => setHighIndexRightBrand(e.target.value)}
                  />
                  <input
                    type="text"
                    placeholder="Lens Type"
                    value={highIndexRightType}
                    onChange={(e) => setHighIndexRightType(e.target.value)}
                  />
                  <input
                    type="text"
                    placeholder="Lens Name"
                    value={highIndexRightName}
                    onChange={(e) => setHighIndexRightName(e.target.value)}
                  />
                  <input
                    type="number"
                    placeholder="Price (Rs.)"
                    value={highIndexRightPrice}
                    onChange={(e) => setHighIndexRightPrice(e.target.value)}
                  />
                </div>

                {/* Left Lens */}
                <div className="high-index-card">
                  <h5>Left Lens</h5>
                  <input
                    type="text"
                    placeholder="Brand"
                    value={highIndexLeftBrand}
                    onChange={(e) => setHighIndexLeftBrand(e.target.value)}
                  />
                  <input
                    type="text"
                    placeholder="Lens Type"
                    value={highIndexLeftType}
                    onChange={(e) => setHighIndexLeftType(e.target.value)}
                  />
                  <input
                    type="text"
                    placeholder="Lens Name"
                    value={highIndexLeftName}
                    onChange={(e) => setHighIndexLeftName(e.target.value)}
                  />
                  <input
                    type="number"
                    placeholder="Price (Rs.)"
                    value={highIndexLeftPrice}
                    onChange={(e) => setHighIndexLeftPrice(e.target.value)}
                  />
                </div>
              </div>

              <div className="high-index-total">
                Total Lens Price: Rs. {(Number(highIndexLeftPrice || 0) + Number(highIndexRightPrice || 0)).toFixed(2)}
              </div>
            </div>
          )}

          {/* Lens Selection */}
          <div className="lens-selection-wrapper" style={{ opacity: isHighIndexLens ? 0.5 : 1, pointerEvents: isHighIndexLens ? "none" : "auto" }}>
            <div className="lens-selection-grid">
              {/* Right Eye Lens */}
              <div className="lens-side-card">
                <div className="lens-card-header">
                  <h4>Right Eye Lens</h4>
                </div>
                <div className="lens-card-body">
                  <div className="form-group">
                    <label>Brand</label>
                    <select
                      value={rightLensBrand}
                      onChange={(e) => {
                        setRightLensBrand(e.target.value);
                        setRightLensType("");
                        setRightLens(null);
                      }}
                    >
                      <option value="">Select Brand</option>
                      <option value="STANDARD">STANDARD</option>
                      <option value="ESSILOR">ESSILOR</option>
                      <option value="NEOFORM">NEOFORM</option>
                      <option value="GENERIC">GENERIC</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Lens Type</label>
                    <select
                      value={rightLensType}
                      onChange={(e) => {
                        setRightLensType(e.target.value);
                        setRightLens(null);
                      }}
                    >
                      <option value="">Select Type</option>
                      <option value="SV">SV</option>
                      <option value="BF">BF</option>
                      <option value="PAL">PAL</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Lens</label>
                    <select
                      value={rightLens?.name || ""}
                      onChange={(e) => {
                        const selected = lensData[rightLensBrand]?.[rightLensType]?.find(
                          lens => lens.name === e.target.value
                        );
                        setRightLens(selected);
                      }}
                    >
                      <option value="">Select Lens</option>
                      {rightLensBrand && rightLensType && lensData[rightLensBrand]?.[rightLensType]?.map((lens, index) => (
                        <option key={index} value={lens.name}>
                          {lens.name} - Rs.{lens.pairPrice}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="lens-price-box">
                    <span>Right Lens Price</span>
                    <strong>Rs. {rightLens ? (rightLens.pairPrice / 2).toFixed(2) : "0.00"}</strong>
                  </div>
                </div>
              </div>

              {/* Left Eye Lens */}
              <div className="lens-side-card">
                <div className="lens-card-header">
                  <h4>Left Eye Lens</h4>
                </div>
                <div className="lens-card-body">
                  <div className="form-group">
                    <label>Brand</label>
                    <select
                      value={leftLensBrand}
                      onChange={(e) => {
                        setLeftLensBrand(e.target.value);
                        setLeftLensType("");
                        setLeftLens(null);
                      }}
                    >
                      <option value="">Select Brand</option>
                      <option value="STANDARD">STANDARD</option>
                      <option value="ESSILOR">ESSILOR</option>
                      <option value="NEOFORM">NEOFORM</option>
                      <option value="GENERIC">GENERIC</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Lens Type</label>
                    <select
                      value={leftLensType}
                      onChange={(e) => {
                        setLeftLensType(e.target.value);
                        setLeftLens(null);
                      }}
                    >
                      <option value="">Select Type</option>
                      <option value="SV">SV</option>
                      <option value="BF">BF</option>
                      <option value="PAL">PAL</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Lens</label>
                    <select
                      value={leftLens?.name || ""}
                      onChange={(e) => {
                        const selected = lensData[leftLensBrand]?.[leftLensType]?.find(
                          lens => lens.name === e.target.value
                        );
                        setLeftLens(selected);
                      }}
                    >
                      <option value="">Select Lens</option>
                      {leftLensBrand && leftLensType && lensData[leftLensBrand]?.[leftLensType]?.map((lens, index) => (
                        <option key={index} value={lens.name}>
                          {lens.name} - Rs.{lens.pairPrice}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="lens-price-box">
                    <span>Left Lens Price</span>
                    <strong>Rs. {leftLens ? (leftLens.pairPrice / 2).toFixed(2) : "0.00"}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Frame Selection */}
          <div className="frame-selection-row">
            <div className="form-group frame-search-group">
              <label>Frame Model <span className="required-star">*</span></label>
              <div className="frame-search-wrapper">
                <input
                  type="text"
                  name="frameModel"
                  value={frameSearchTerm}
                  onChange={(e) => handleFrameSearch(e.target.value)}
                  onFocus={() => frameSearchTerm.length >= 2 && setShowFrameSuggestions(true)}
                  placeholder="Type frame model..."
                  className={errors.frameModel ? 'error-input' : ''}
                />
                {errors.frameModel && <span className="error-message">{errors.frameModel}</span>}
                
                {showFrameSuggestions && frameSuggestions.length > 0 && (
                  <div className="suggestions-dropdown">
                    {Object.values(
                      frameSuggestions.reduce((acc, frame) => {
                        const key = `${frame.modelNo}-${frame.colour}-${frame.size}-${frame.sellingPrice}`;
                        if (!acc[key]) {
                          acc[key] = { ...frame, totalQty: 0 };
                        }
                        acc[key].totalQty += parseInt(frame.qty || 0);
                        return acc;
                      }, {})
                    ).map((frame, index) => (
                      <div
                        key={index}
                        className="suggestion-item"
                        onClick={() => selectFrame(frame)}
                      >
                        <strong>{frame.modelNo}</strong>
                        <div className="suggestion-details">
                          {frame.brand} | {frame.colour} | {frame.size} |Rs.{frame.sellingPrice}
                          <span className="stock-badge">Stock: {frame.totalQty}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            
            <div className="form-group">
              <label>Brand</label>
              <input 
                type="text" 
                name="brand"
                value={formData.brand}
                readOnly
                className="readonly-field"
                placeholder="Auto-filled from frame"
              />
            </div>
            
            <div className="form-group">
              <label>Colour</label>
              <input 
                type="text" 
                name="colour"
                value={formData.colour}
                readOnly
                className="readonly-field"
                placeholder="Auto-filled from frame"
              />
            </div>

            <div className="form-group">
              <label>Size</label>
              <input 
                type="text" 
                name="size"
                value={formData.size}
                readOnly
                className="readonly-field"
                placeholder="Auto-filled from frame"
              />
            </div>

          </div>
        </div>

        {/* Pricing & Delivery */}
        <div className="invoice-section">
          <div className="section-header">
            <h3>Pricing & Delivery</h3>
            <span className="section-badge">Financial</span>
          </div>

          <div className="pricing-grid">
            {/* Delivery Date & VAT */}
            <div className="pricing-row">
              <div className="form-group">
                <label>Delivery Date</label>
                <input 
                  type="date" 
                  name="deliveryDate"
                  value={formData.deliveryDate}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group vat-checkbox-group">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    checked={applyVAT}
                    onChange={(e) => setApplyVAT(e.target.checked)}
                  />
                  <span>Apply 18% VAT</span>
                </label>
                {applyVAT && (
                  <div className="vat-hint">VAT (18%) will be added to the subtotal</div>
                )}
              </div>
            </div>

            {/* Lens Price & Discount */}
            <div className="pricing-row">
              <div className="form-group">
                <label>Lens Price (Rs.)</label>
                <input
                  type="number"
                  name="lensPrice"
                  value={formData.lensPrice}
                  readOnly
                  className="readonly-field"
                  placeholder="0.00"
                />
              </div>

              <div className="discount-group">
                <div className="discount-header">
                  <h4>Lens Discount</h4>
                </div>
                <div className="discount-inputs">
                  <div className="form-group">
                    <label>Type</label>
                    <select 
                      value={lensDiscountType}
                      onChange={(e) => setLensDiscountType(e.target.value)}
                      className="form-control"
                    >
                      <option value="amount">Amount (Rs.)</option>
                      <option value="percentage">Percentage (%)</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Value</label>
                    <input 
                      type="number"
                      value={lensDiscountValue}
                      onChange={(e) => setLensDiscountValue(e.target.value)}
                      placeholder={lensDiscountType === 'percentage' ? 'Enter %' : 'Enter amount'}
                      className="form-control"
                      min="0"
                      step={lensDiscountType === 'percentage' ? '0.1' : '0.01'}
                    />
                  </div>
                  {lensDiscountValue && (
                    <div className="discount-preview">
                      Lens Discount: Rs. {totals.lensDiscountAmount.toFixed(2)}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Frame Price & Discount */}
            <div className="pricing-row">
              <div className="form-group">
                <label>Frame Price (Rs.)</label>
                <input 
                  type="number" 
                  name="framePrice"
                  value={formData.framePrice}
                  readOnly
                  className="readonly-field"
                  placeholder="Auto-filled"
                />
              </div>

              <div className="discount-group">
                <div className="discount-header">
                  <h4>Frame Discount</h4>
                </div>
                <div className="discount-inputs">
                  <div className="form-group">
                    <label>Type</label>
                    <select 
                      value={frameDiscountType}
                      onChange={(e) => setFrameDiscountType(e.target.value)}
                      className="form-control"
                    >
                      <option value="amount">Amount (Rs.)</option>
                      <option value="percentage">Percentage (%)</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Value</label>
                    <input 
                      type="number"
                      value={frameDiscountValue}
                      onChange={(e) => setFrameDiscountValue(e.target.value)}
                      placeholder={frameDiscountType === 'percentage' ? 'Enter %' : 'Enter amount'}
                      className="form-control"
                      min="0"
                      step={frameDiscountType === 'percentage' ? '0.1' : '0.01'}
                    />
                  </div>
                  {frameDiscountValue && (
                    <div className="discount-preview">
                      Frame Discount: Rs. {totals.frameDiscountAmount.toFixed(2)}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Additional Charges */}
            <div className="additional-charges-section">
              <div className="section-header">
                <h4>Additional Charges</h4>
                <span className="section-badge">Optional</span>
              </div>
              
              <div className="charges-grid">
                <div className="charge-item">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={ownNylonCharge}
                      onChange={(e) => setOwnNylonCharge(e.target.checked)}
                    />
                    <span>
                      <strong>Own NYLON</strong>
                      <span className="charge-amount">Rs. {OWN_NYLON_AMOUNT}</span>
                    </span>
                  </label>
                </div>

                <div className="charge-item">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={ownRimlessCharge}
                      onChange={(e) => setOwnRimlessCharge(e.target.checked)}
                    />
                    <span>
                      <strong>Own Rimless</strong>
                      <span className="charge-amount">Rs. {OWN_RIMLESS_AMOUNT}</span>
                    </span>
                  </label>
                </div>

                <div className="charge-item">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={fittingCharge}
                      onChange={(e) => setFittingCharge(e.target.checked)}
                    />
                    <span>
                      <strong>Fitting Charges</strong>
                      <span className="charge-amount">Rs. {FITTING_CHARGE_AMOUNT}</span>
                    </span>
                  </label>
                </div>

                <div className="charge-item">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={tintCharge}
                      onChange={(e) => setTintCharge(e.target.checked)}
                    />
                    <span>
                      <strong>Tint Charges</strong>
                      <span className="charge-amount">Rs. {TINT_CHARGE_AMOUNT}</span>
                    </span>
                  </label>
                </div>

                <div className="charge-item">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={expressCharge}
                      onChange={(e) => setExpressCharge(e.target.checked)}
                    />
                    <span>
                      <strong>Express Charge</strong>
                      <span className="charge-amount">Rs. {EXPRESS_CHARGE_AMOUNT}</span>
                    </span>
                  </label>
                </div>
              </div>
            </div>

            {/* Payment & Total */}
            <div className="payment-row">
              <div className="form-group">
                <label>General Discount (Rs.)</label>
                <input 
                  type="number"
                  name="discount"
                  value={formData.discount}
                  onChange={handleInputChange}
                  placeholder="0.00"
                />
              </div>

              <div className="form-group">
                <label>Advance Payment (Rs.)</label>
                <input 
                  type="number"
                  name="advancePayment"
                  value={formData.advancePayment}
                  onChange={handleInputChange}
                  placeholder="0.00"
                  step="0.01"
                />
              </div>

              <div className="form-group total-group">
                <label>Total Amount (Rs.)</label>
                <input 
                  type="text" 
                  value={`Rs ${totalAmount.toFixed(2)}`}
                  readOnly
                  className="total-input"
                />
              </div>
            </div>

            {/* Total Breakdown */}
            <div className="total-breakdown">
              <div className="total-row">
                <span>Subtotal:</span>
                <span>Rs. {totals.subtotal.toFixed(2)}</span>
              </div>
              
              {totals.frameDiscountAmount > 0 && (
                <div className="total-row discount-row">
                  <span>Frame Discount:</span>
                  <span>- Rs. {totals.frameDiscountAmount.toFixed(2)}</span>
                </div>
              )}
              
              {totals.lensDiscountAmount > 0 && (
                <div className="total-row discount-row">
                  <span>Lens Discount:</span>
                  <span>- Rs. {totals.lensDiscountAmount.toFixed(2)}</span>
                </div>
              )}
              
              {totals.generalDiscount > 0 && (
                <div className="total-row discount-row">
                  <span>General Discount:</span>
                  <span>- Rs. {totals.generalDiscount.toFixed(2)}</span>
                </div>
              )}
              
              {applyVAT && (
                <div className="total-row vat-row">
                  <span>VAT (18%):</span>
                  <span>Rs. {totals.vatAmount.toFixed(2)}</span>
                </div>
              )}
              
              {(ownNylonCharge || ownRimlessCharge || fittingCharge || tintCharge || expressCharge) && (
                <div className="total-row charges-row">
                  <span>Additional Charges:</span>
                  <span>Rs. {totals.additionalCharges.toFixed(2)}</span>
                </div>
              )}
              
              <div className="total-row grand-total">
                <span><strong>Total Amount:</strong></span>
                <span><strong>Rs. {totals.total.toFixed(2)}</strong></span>
              </div>
            </div>
          </div>

          {/* Bill Description & Payment Method */}
          <div className="form-row">
            <div className="form-group">
              <label>Bill Description</label>
              <select 
                className="form-control"
                name="billDescription"
                value={formData.billDescription}
                onChange={handleInputChange}
              >
                <option value="Frame and Lenses">Frame and Lenses</option>
                <option value="Lenses">Lenses</option>
                <option value="Frame">Frame</option>
                <option value="Contact Lenses">Contact Lenses</option>
                <option value="Sunglass">Sunglass</option>  
              </select>
            </div>

            <div className="form-group">
              <label>Payment Method</label>
              <select 
                className="form-control"
                name="paymentMethod"
                value={formData.paymentMethod}
                onChange={handleInputChange}
              >
                <option value="Cash">Cash</option>
                <option value="Card">Card</option>
                <option value="Bank Transfer">Bank Transfer</option>
                <option value="Deposit">Deposit</option>
                <option value="Cheque">
                Cheque
                </option>
              </select>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="invoice-actions">
          <button className="btn-save" onClick={handleSaveOrder} disabled={isLoading}>
            {isLoading ? '⏳ Saving...' : '💾 Save Order'}
          </button>
          <button className="btn-clear" onClick={handleResetForm}>
            🗑️ Clear Form
          </button>
        </div>
      </div>
    </div>
  </>
)}








{/***************************************************** create blance invoice *********************************************************/}

{/* {selectedOption === "createBalanceInvoice" && (
   <div className="balance-invoice-container">
      <div className="balance-header">
        <h2>Create Balance Invoice</h2>
        <p className="subtitle">Manage pending payments and create balance invoices</p>
      </div>

     
      <div className="search-section">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search by invoice number..."
            value={searchInvoiceNo}
            onChange={(e) => setSearchInvoiceNo(e.target.value)}
            className="search-input"
          />
          <button onClick={handleInvoiceSearch} className="btn-search">
            🔍 Search
          </button>
          <button onClick={() => {
            setSearchInvoiceNo('');
            setFilteredInvoices(balanceInvoices);
          }} className="btn-reset">
            Reset
          </button>
        </div>
      </div>

      <div className="summary-cards">
        <div className="summary-card">
          <div className="summary-title">Pending Invoices</div>
          <div className="summary-value">{balanceInvoices.length}</div>
        </div>
        <div className="summary-card">
          <div className="summary-title">Total Balance Due</div>
          <div className="summary-value">
            Rs. {balanceInvoices.reduce((sum, inv) => sum + (inv.balanceDue || 0), 0).toFixed(2)}
          </div>
        </div>
        <div className="summary-card">
          <div className="summary-title">Partially Paid</div>
          <div className="summary-value">
            {balanceInvoices.filter(inv => inv.hasBalanceInvoices).length}
          </div>
        </div>
      </div>

    
      {isLoadingInvoices ? (
        <div className="loading-spinner">Loading invoices...</div>
      ) : (
        <div className="invoices-table-container">
          <table className="invoices-table">
            <thead>
              <tr>
                <th>Invoice No</th>
                <th>Prescription Name</th>
                <th>Phone</th>
                <th>Total Amount</th>
                <th>Advance Paid</th>
                <th>Balance Due</th>
                <th>Balance Payments</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredInvoices.length === 0 ? (
                <tr>
                  <td colSpan="9" style={{ textAlign: 'center' }}>
                    No pending invoices found
                  </td>
                </tr>
              ) : (
                filteredInvoices.map((invoice) => (
                  <tr key={invoice.id}>
                    <td className="invoice-number">{invoice.invoiceNumber}</td>
                    <td>{invoice.customer?.fullName}</td>
                    <td>{invoice.customer?.tpNo}</td>
                    <td>Rs. {(invoice.financial?.totalAmount || 0).toFixed(2)}</td>
                    <td>Rs. {(invoice.financial?.advancePayment || 0).toFixed(2)}</td>
                    <td className="balance-due">
                      Rs. {(invoice.balanceDue || 0).toFixed(2)}
                    </td>
                    <td>
                      {invoice.hasBalanceInvoices && (
                        <div className="balance-payments-list">
                          {invoice.balanceRecords?.map((record, idx) => (
                            <div key={idx} className="payment-record">
                              {record.balanceInvoiceNumber}: Rs.{record.paidAmount.toFixed(2)} 
                              ({record.paymentDateOnly || new Date(record.paymentDate).toLocaleDateString()})
                            </div>
                          ))}
                        </div>
                      )}
                    </td>
                    <td>
                      {invoice.balanceDue <= 0 ? (
                        <span className="status-badge paid">Paid</span>
                      ) : invoice.hasBalanceInvoices ? (
                        <span className="status-badge partial">Partial</span>
                      ) : (
                        <span className="status-badge pending">Pending</span>
                      )}
                    </td>
                    <td>
                      <button
                        className="btn-create-balance"
                        onClick={() => openBalanceModal(invoice)}
                        disabled={invoice.balanceDue <= 0}
                      >
                        {invoice.balanceDue <= 0 ? 'Settled' : 'Create Balance'}
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

    
      {showBalanceModal && selectedInvoice && (
        <div className="modal-overlay" onClick={() => setShowBalanceModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Create Balance Invoice</h3>
              <button className="modal-close" onClick={() => setShowBalanceModal(false)}>×</button>
            </div>
            
            <div className="modal-body">
              <div className="invoice-details">
                <h4>Original Invoice Details</h4>
                <div className="detail-row">
                  <span>Invoice Number:</span>
                  <strong>{selectedInvoice.invoiceNumber}</strong>
                </div>
                <div className="detail-row">
                  <span>Customer:</span>
                  <strong>{selectedInvoice.customer?.fullName}</strong>
                </div>
                <div className="detail-row">
                  <span>Phone:</span>
                  <strong>{selectedInvoice.customer?.tpNo}</strong>
                </div>
                <div className="detail-row">
                  <span>Total Amount:</span>
                  <strong>Rs. {(selectedInvoice.financial?.totalAmount || 0).toFixed(2)}</strong>
                </div>
                <div className="detail-row">
                  <span>Already Paid:</span>
                  <strong>Rs. {(selectedInvoice.financial?.advancePayment || 0).toFixed(2)}</strong>
                </div>
                <div className="detail-row highlight">
                  <span>Balance Due:</span>
                  <strong>Rs. {(selectedInvoice.balanceDue || 0).toFixed(2)}</strong>
                </div>
                {selectedInvoice.hasBalanceInvoices && (
                  <div className="detail-row">
                    <span>Previous Balance Payments:</span>
                    <div className="previous-payments">
                      {selectedInvoice.balanceRecords?.map((record, idx) => (
                        <div key={idx}>
                          {record.balanceInvoiceNumber}: Rs.{record.paidAmount.toFixed(2)} 
                          ({record.paymentDateOnly || new Date(record.paymentDate).toLocaleDateString()})
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <div className="payment-details">
                <h4>Payment Information</h4>
                <div className="form-group">
                  <label>Next Balance Invoice Number:</label>
                  <input
                    type="text"
                    // value={`${selectedInvoice.invoiceNumber}-${(selectedInvoice.balanceRecords?.length || 0) + 1}`}
                    value={nextBalanceInvoiceNo}
                    readOnly
                    className="form-control readonly"
                  />
                </div>

                <div className="form-group">
                  <label>Payment Date <span className="required-star">*</span></label>
                  <input
                    type="date"
                    value={paymentDate}
                    onChange={(e) => setPaymentDate(e.target.value)}
                    className="form-control"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Amount to Pay (Rs.) <span className="required-star">*</span></label>
<input
  type="number"
  value={balancePaidAmount}
  onChange={(e) => setBalancePaidAmount(e.target.value)}
  placeholder="Enter amount"
  max={selectedInvoice.balanceDue}
  className="form-control"

  // PREVENT SCROLL VALUE CHANGE
  onWheel={(e) => e.target.blur()}
/>
                  <small>Maximum: Rs. {selectedInvoice.balanceDue.toFixed(2)}</small>
                </div>

                <div className="form-group">
                  <label>Payment Method</label>
                  <select
                    value={balancePaymentMethod}
                    onChange={(e) => setBalancePaymentMethod(e.target.value)}
                    className="form-control"
                  >
                    <option value="Cash">Cash</option>
                    <option value="Card">Card</option>
                    <option value="Bank Transfer">Bank Transfer</option>
                    <option value="Deposit">Deposit</option>
                  </select>
                </div>

                <div className="payment-summary">
                  <div className="summary-row">
                    <span>New Balance After Payment:</span>
                    <strong className={selectedInvoice.balanceDue - parseFloat(balancePaidAmount || 0) <= 0 ? 'text-success' : 'text-warning'}>
                      Rs. {(selectedInvoice.balanceDue - parseFloat(balancePaidAmount || 0)).toFixed(2)}
                    </strong>
                  </div>
                </div>
              </div>
            </div>

            <div>
            </div>

            <div className="modal-footer">
              <button className="btn-cancel" onClick={() => setShowBalanceModal(false)}>
                Cancel
              </button>
              <button 
                className="btn-create" 
                onClick={handleCreateBalanceInvoice}
                disabled={isLoading || !balancePaidAmount || parseFloat(balancePaidAmount) <= 0 || !paymentDate}
              >
                {isLoading ? 'Creating...' : 'Create Balance Invoice'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
)} */}

{selectedOption === "createBalanceInvoice" && (
  <div className="balance-invoice-container">
    <div className="balance-header">
      <h2>Create Balance Invoice</h2>
      <p className="subtitle">Manage pending payments and create balance invoices</p>
    </div>

    {/* Search Section */}
    <div className="search-section">
      <div className="search-box">
        <input
          type="text"
          placeholder="Search by invoice number..."
          value={searchInvoiceNo}
          onChange={(e) => setSearchInvoiceNo(e.target.value)}
          className="search-input"
        />
        <button onClick={handleInvoiceSearch} className="btn-search">
          🔍 Search
        </button>
        <button onClick={() => {
          setSearchInvoiceNo('');
          setFilteredInvoices(balanceInvoices);
        }} className="btn-reset">
          Reset
        </button>
      </div>
    </div>

    {/* Summary Cards */}
    <div className="summary-cards">
      <div className="summary-card">
        <div className="summary-title">Pending Invoices</div>
        <div className="summary-value">{balanceInvoices.length}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Balance Due</div>
        <div className="summary-value">
          Rs. {balanceInvoices.reduce((sum, inv) => sum + (inv.balanceDue || 0), 0).toFixed(2)}
        </div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Partially Paid</div>
        <div className="summary-value">
          {balanceInvoices.filter(inv => inv.hasBalanceInvoices).length}
        </div>
      </div>
    </div>

    {/* Invoices Table */}
    {isLoadingInvoices ? (
      <div className="loading-spinner">Loading invoices...</div>
    ) : (
      <div className="invoices-table-container">
        <table className="invoices-table">
          <thead>
            <tr>
              <th>Invoice No</th>
              <th>Customer Name</th>
              <th>Phone</th>
              <th>Total Amount</th>
              <th>Total Paid</th>
              <th>Balance Due</th>
              <th>Balance Payments</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredInvoices.length === 0 ? (
              <tr>
                <td colSpan="9" style={{ textAlign: 'center' }}>
                  No pending invoices found
                </td>
              </tr>
            ) : (
              filteredInvoices.map((invoice) => (
                <tr key={invoice.id}>
                  <td className="invoice-number">{invoice.invoiceNumber}</td>
                  <td>{invoice.customer?.fullName}</td>
                  <td>{invoice.customer?.tpNo}</td>
                  <td>Rs. {(invoice.financial?.totalAmount || 0).toFixed(2)}</td>
                  <td>Rs. {(invoice.financial?.advancePayment || 0).toFixed(2)}</td>
                  <td className="balance-due">
                    Rs. {(invoice.balanceDue || 0).toFixed(2)}
                   </td>
                  <td>
                    {invoice.hasBalanceInvoices && (
                      <div className="balance-payments-list">
                        {invoice.balanceRecords?.map((record, idx) => (
                          <div key={idx} className="payment-record">
                            {record.balanceInvoiceNumber}: Rs.{record.paidAmount.toFixed(2)} 
                            ({record.paymentDateOnly || new Date(record.paymentDate).toLocaleDateString()})
                          </div>
                        ))}
                      </div>
                    )}
                   </td>
                  <td>
                    {invoice.balanceDue <= 0 ? (
                      <span className="status-badge paid">Paid</span>
                    ) : invoice.hasBalanceInvoices ? (
                      <span className="status-badge partial">Partial</span>
                    ) : (
                      <span className="status-badge pending">Pending</span>
                    )}
                   </td>
                  <td>
                    <button
                      className="btn-create-balance"
                      onClick={() => openBalanceModal(invoice)}
                      disabled={invoice.balanceDue <= 0}
                    >
                      {invoice.balanceDue <= 0 ? 'Settled' : 'Create Balance'}
                    </button>
                   </td>
                 </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    )}

    {/* Balance Invoice Modal */}
    {showBalanceModal && selectedInvoice && (
      <div className="modal-overlay" onClick={() => setShowBalanceModal(false)}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="modal-header">
            <h3>Create Balance Invoice</h3>
            <button className="modal-close" onClick={() => setShowBalanceModal(false)}>×</button>
          </div>
          
          <div className="modal-body">
            <div className="invoice-details">
              <h4>Original Invoice Details</h4>
              <div className="detail-row">
                <span>Invoice Number:</span>
                <strong>{selectedInvoice.invoiceNumber}</strong>
              </div>
              <div className="detail-row">
                <span>Customer:</span>
                <strong>{selectedInvoice.customer?.fullName}</strong>
              </div>
              <div className="detail-row">
                <span>Phone:</span>
                <strong>{selectedInvoice.customer?.tpNo}</strong>
              </div>
              <div className="detail-row">
                <span>Total Amount:</span>
                <strong>Rs. {(selectedInvoice.financial?.totalAmount || 0).toFixed(2)}</strong>
              </div>
              <div className="detail-row">
                <span>Already Paid:</span>
                <strong>Rs. {(selectedInvoice.financial?.advancePayment || 0).toFixed(2)}</strong>
              </div>
              <div className="detail-row highlight">
                <span>Balance Due:</span>
                <strong>Rs. {(selectedInvoice.balanceDue || 0).toFixed(2)}</strong>
              </div>
              {selectedInvoice.hasBalanceInvoices && (
                <div className="detail-row">
                  <span>Previous Balance Payments:</span>
                  <div className="previous-payments">
                    {selectedInvoice.balanceRecords?.map((record, idx) => (
                      <div key={idx}>
                        {record.balanceInvoiceNumber}: Rs.{record.paidAmount.toFixed(2)} 
                        ({record.paymentDateOnly || new Date(record.paymentDate).toLocaleDateString()})
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="payment-details">
              <h4>Payment Information</h4>
              <div className="form-group">
                <label>Next Balance Invoice Number:</label>
                <input
                  type="text"
                  value={nextBalanceInvoiceNo}
                  readOnly
                  className="form-control readonly"
                />
              </div>

              <div className="form-group">
                <label>Payment Date <span className="required-star">*</span></label>
                <input
                  type="date"
                  value={paymentDate}
                  onChange={(e) => setPaymentDate(e.target.value)}
                  className="form-control"
                  required
                />
              </div>

              <div className="form-group">
                <label>Amount to Pay (Rs.) <span className="required-star">*</span></label>
                <input
                  type="number"
                  value={balancePaidAmount}
                  onChange={(e) => setBalancePaidAmount(e.target.value)}
                  placeholder="Enter amount"
                  max={selectedInvoice.balanceDue}
                  className="form-control"
                  onWheel={(e) => e.target.blur()}
                />
                <small>Maximum: Rs. {selectedInvoice.balanceDue.toFixed(2)}</small>
              </div>

              <div className="form-group">
                <label>Payment Method</label>
                <select
                  value={balancePaymentMethod}
                  onChange={(e) => setBalancePaymentMethod(e.target.value)}
                  className="form-control"
                >
                  <option value="Cash">Cash</option>
                  <option value="Card">Card</option>
                  <option value="Bank Transfer">Bank Transfer</option>
                  <option value="Deposit">Deposit</option>
                  <option value="Cheque">
                   Cheque
                  </option>
                </select>
              </div>

              <div className="payment-summary">
                <div className="summary-row">
                  <span>New Balance After Payment:</span>
                  <strong className={selectedInvoice.balanceDue - parseFloat(balancePaidAmount || 0) <= 0 ? 'text-success' : 'text-warning'}>
                    Rs. {(selectedInvoice.balanceDue - parseFloat(balancePaidAmount || 0)).toFixed(2)}
                  </strong>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn-cancel" onClick={() => setShowBalanceModal(false)}>
              Cancel
            </button>
            <button 
              className="btn-create" 
              onClick={handleCreateBalanceInvoice}
              disabled={isLoading || !balancePaidAmount || parseFloat(balancePaidAmount) <= 0 || !paymentDate}
            >
              {isLoading ? 'Creating...' : 'Create Balance Invoice'}
            </button>
          </div>
        </div>
      </div>
    )}
  </div>
)}





{/**************************************************** stock history report *******************************************/}

{selectedOption === "StockHistory" && (
  <div className="stock-history-wrap">
    <div className="history-header">
      <h2>Stock History</h2>
      
      {/* Export Button */}
      <button onClick={exportToExcel} className="export-excel-btn">
        📊 Export to Excel
      </button>
    </div>
    
    {/* Category Selection Buttons */}
    <div className="history-category-buttons">
      <button 
        onClick={() => setHistoryCategory("lens")}
        className={`category-btn ${historyCategory === "lens" ? "active" : ""}`}
      >
        Lens History
      </button>
      <button 
        onClick={() => setHistoryCategory("frame")}
        className={`category-btn ${historyCategory === "frame" ? "active" : ""}`}
      >
        Frame History
      </button>
      <button 
        onClick={() => setHistoryCategory("sunglass")}
        className={`category-btn ${historyCategory === "sunglass" ? "active" : ""}`}
      >
        Sunglass History
      </button>
      <button 
        onClick={() => setHistoryCategory("other")}
        className={`category-btn ${historyCategory === "other" ? "active" : ""}`}
      >
        Other History
      </button>
    </div>

    {/* Filter Section */}
    <div className="filter-section">
      <div className="filter-controls">
        <label>Filter by Date:</label>
        <select 
          value={filterType} 
          onChange={(e) => {
            setFilterType(e.target.value);
            if (e.target.value === "all") setFilterValue("");
          }}
          className="filter-select"
        >
          <option value="all">All Records</option>
          <option value="day">Specific Day</option>
          <option value="month">Specific Month</option>
          <option value="year">Specific Year</option>
        </select>
        
        {filterType === "day" && (
          <input 
            type="date" 
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            className="filter-input"
          />
        )}
        
        {filterType === "month" && (
          <input 
            type="month" 
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            className="filter-input"
          />
        )}
        
        {filterType === "year" && (
          <input 
            type="number" 
            placeholder="Enter year (e.g., 2024)"
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            className="filter-input"
            min="2000"
            max="2100"
          />
        )}
        
        {(filterType !== "all" && filterValue) && (
          <button onClick={resetStockHistoryFilters} className="reset-filter-btn">
            Clear Filter
          </button>
        )}
      </div>
      
      {/* Filter Info Display */}
      {filterType !== "all" && filterValue && (
        <div className="filter-info">
          Showing data for: {
            filterType === "day" ? new Date(filterValue).toLocaleDateString() :
            filterType === "month" ? new Date(filterValue).toLocaleString('default', { month: 'long', year: 'numeric' }) :
            `Year ${filterValue}`
          }
          <span className="record-count">
            ({historyCategory === "lens" ? filteredLensHistory.reduce((total, stock) => total + (stock.items?.length || 0), 0) : 
              historyCategory === "frame" ? filteredFrameHistory.reduce((total, stock) => total + (stock.items?.length || 0), 0) :
              historyCategory === "sunglass" ? filteredSunglassHistory.reduce((total, stock) => total + (stock.items?.length || 0), 0) :
              filteredOtherHistory.reduce((total, stock) => total + (stock.items?.length || 0), 0)} records)
          </span>
        </div>
      )}
    </div>

    <div className="history-search">
      <input
        type="text"
        placeholder="Search by Brand, Model or Colour..."
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        className="search-input"
      />
    </div>

    {/* Loading State */}
    {loading && <div className="loading">Loading...</div>}

    {/* Lens Stock History Table */}
    {historyCategory === "lens" && !loading && (
      <div className="history-table-container">
        <table className="history-table">
          <thead>
            <tr>
              <th>PO No</th>
              <th>Supplier</th>
              <th>Purchase Date</th>
              <th>Model</th>
              <th>Sph</th>
              <th>Add</th>
              <th>Cyl</th>
              <th>Axis</th>
              <th>Progressive</th>
              <th>Available Qty</th>
              <th>Added Qty</th>
              <th>Stock Added Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredLensHistory.length > 0 ? (
              filteredLensHistory.map((stock) => (
                stock.items?.map((item, itemIndex) => (
                  <tr key={`${stock.id}-${itemIndex}`}>
                    <td>{stock.purchaseOrderNo}</td>
                    <td>{stock.supplierName}</td>
                    <td>{stock.purchaseDate}</td>
                    <td>{item.model}</td>
                    <td>{item.sph || '-'}</td>
                    <td>{item.add || '-'}</td>
                    <td>{item.cyl || '-'}</td>
                    <td>{item.axis || '-'}</td>
                    <td>{item.progressive ? "Yes" : "No"}</td>
                    <td>{item.qty}</td>
                    <td>{item.supplyQty || 0}</td>
                    <td>{formatDateDisplay(stock.createdAt)}</td>
                    <td>
                      <button
                        className="delete-btn"
                        onClick={() => handleDeleteStock(stock.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ))
            ) : (
              <tr>
                <td colSpan="13" className="no-data-cell">
                  No lens stock history found for the selected filter
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    )}

    {/* Frame Stock History Table */}
    {historyCategory === "frame" && !loading && (
      <div className="history-table-container">
        <table className="history-table">
          <thead>
            <tr>
              <th>PO No</th>
              <th>Supplier</th>
              <th>Purchase Date</th>
              <th>Brand</th>
              <th>Model No</th>
              <th>Size</th>
              <th>Colour</th>
              <th>Available Qty</th>
              <th>Added Qty</th>
              <th>Stock Added Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredFrameHistory.length > 0 ? (
              filteredFrameHistory.map((stock) => (
                stock.items?.map((item, itemIndex) => (
                  <tr key={`${stock.id}-${itemIndex}`}>
                    <td>{stock.purchaseOrderNo}</td>
                    <td>{stock.supplierName}</td>
                    <td>{stock.purchaseDate}</td>
                    <td>{item.brand}</td>
                    <td>{item.modelNo}</td>
                    <td>{item.size || '-'}</td>
                    <td>{item.colour || '-'}</td>
                    <td>{item.qty}</td>
                    <td>{item.supplyQty || 0}</td>
                    <td>{formatDateDisplay(stock.createdAt)}</td>
                    <td>
                      <button
                        className="delete-btn"
                        onClick={() => handleDeleteStock(stock.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ))
            ) : (
              <tr>
                <td colSpan="11" className="no-data-cell">
                  No frame stock history found for the selected filter
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    )}

    {/* Sunglass Stock History Table */}
    {historyCategory === "sunglass" && !loading && (
      <div className="history-table-container">
        <table className="history-table">
          <thead>
            <tr>
              <th>PO No</th>
              <th>Supplier</th>
              <th>Purchase Date</th>
              <th>Brand</th>
              <th>Model No</th>
              <th>Size</th>
              <th>Colour</th>
              <th>Available Qty</th>
              <th>Added Qty</th>
              <th>Stock Added Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredSunglassHistory.length > 0 ? (
              filteredSunglassHistory.map((stock) => (
                stock.items?.map((item, itemIndex) => (
                  <tr key={`${stock.id}-${itemIndex}`}>
                    <td>{stock.purchaseOrderNo}</td>
                    <td>{stock.supplierName}</td>
                    <td>{stock.purchaseDate}</td>
                    <td>{item.brand}</td>
                    <td>{item.modelNo}</td>
                    <td>{item.size || '-'}</td>
                    <td>{item.colour || '-'}</td>
                    <td>{item.qty}</td>
                    <td>{item.supplyQty || 0}</td>
                    <td>{formatDateDisplay(stock.createdAt)}</td>
                    <td>
                      <button
                        className="delete-btn"
                        onClick={() => handleDeleteStock(stock.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ))
            ) : (
              <tr>
                <td colSpan="11" className="no-data-cell">
                  No sunglass stock history found for the selected filter
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    )}

    {/* Other Stock History Table */}
    {historyCategory === "other" && !loading && (
      <div className="history-table-container">
        <table className="history-table">
          <thead>
            <tr>
              <th>PO No</th>
              <th>Supplier</th>
              <th>Purchase Date</th>
              <th>Brand</th>
              <th>Model No</th>
              <th>R Power</th>
              <th>L Power</th>
              <th>Base Curve</th>
              <th>Colour</th>
              <th>Available Qty</th>
              <th>Added Qty</th>
              <th>Stock Added Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredOtherHistory.length > 0 ? (
              filteredOtherHistory.map((stock) => (
                stock.items?.map((item, itemIndex) => (
                  <tr key={`${stock.id}-${itemIndex}`}>
                    <td>{stock.purchaseOrderNo}</td>
                    <td>{stock.supplierName}</td>
                    <td>{stock.purchaseDate}</td>
                    <td>{item.brand}</td>
                    <td>{item.modelNo}</td>
                    <td>{item.rPower || '-'}</td>
                    <td>{item.lPower || '-'}</td>
                    <td>{item.BaseCurve || '-'}</td>
                    <td>{item.colour || '-'}</td>
                    <td>{item.qty}</td>
                    <td>{item.supplyQty || 0}</td>
                    <td>{formatDateDisplay(stock.createdAt)}</td>
                    <td>
                      <button
                        className="delete-btn"
                        onClick={() => handleDeleteStock(stock.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ))
            ) : (
              <tr>
                <td colSpan="13" className="no-data-cell">
                  No other stock history found for the selected filter
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    )}
  </div>
)}



{/******************************************************* View Supplier *****************************************************************/}

        {selectedOption === "viewSupplier" && (
          <div className="sup-wrap">
      <h2>Supplier Management</h2>

      {/* TOP BAR */}
      <div className="sup-topbar">
        <input
          type="text"
          placeholder="Search supplier..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <select onChange={(e) => setSortType(e.target.value)}>
          <option value="newest">Newest</option>
          <option value="az">A - Z</option>
        </select>
      </div>

      {/* TABLE */}
      <table className="sup-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Company</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {currentItems.map((s) => (
            <tr key={s.id}>
              <td>{s.name}</td>
              <td>{s.phone}</td>
              <td>{s.email}</td>
              <td>{s.company}</td>
              <td>
                <button onClick={() => setEditData(s)}>Edit</button>
                <button onClick={() => handleDelete(s.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* PAGINATION */}
      <div className="sup-pagination">
        {[...Array(totalPages)].map((_, i) => (
          <button key={i} onClick={() => setCurrentPage(i + 1)}>
            {i + 1}
          </button>
        ))}
      </div>

      {/* EDIT MODAL */}
      {editData && (
        <div className="sup-modal">
          <div className="sup-modal-box">
            <h3>Edit Supplier</h3>

            <input
              value={editData.name}
              onChange={(e) =>
                setEditData({ ...editData, name: e.target.value })
              }
            />
            <input
              value={editData.phone}
              onChange={(e) =>
                setEditData({ ...editData, phone: e.target.value })
              }
            />
            <input
              value={editData.email}
              onChange={(e) =>
                setEditData({ ...editData, email: e.target.value })
              }
            />
            <input
              value={editData.company}
              onChange={(e) =>
                setEditData({ ...editData, company: e.target.value })
              }
            />
            <textarea
              value={editData.address}
              onChange={(e) =>
                setEditData({ ...editData, address: e.target.value })
              }
            />

            <div className="sup-modal-actions">
              <button onClick={handleUpdate}>Update</button>
              <button onClick={() => setEditData(null)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
)}




{/******************************************************* Report Section *****************************************************************/}


        {selectedOption === "reports" && <h2>Reports Section</h2>}


{/******************************************************* Purchasing Order *****************************************************************/}


{selectedOption === "purchasingOrder" && (
  <div className="purchase-container">
    <h2>Purchasing Order</h2>

    {/* HEADER */}
    <div className="po-header">
      <div className="po-field">
        <label>Purchase Order No:</label>
        <input
          value={purchaseOrderNo}
          readOnly
        />
      </div>

      <div className="po-field">
        <label>Supplier Name:</label>
        <select
          value={supplierName}
          onChange={(e) => setSupplierName(e.target.value)}
          style={{ maxHeight: "120px", overflowY: "auto" }} // scroll
        >
          <option value="">-- Select Supplier --</option>

          {suppliers.map((s) => (
            <option key={s.id} value={s.name}>
              {s.name}
            </option>
          ))}
        </select>
      </div>
    </div>

    {/* LENS SECTION */}
    <div className="section-box">
      <h3>Lens Detail</h3>

      <table>
        <thead>
          <tr>
            <th>Item Code</th>
            <th>Sph</th>
            <th>Add</th>
            <th>Cyl</th>
            <th>Axis</th>
            <th>Model</th>
            <th>Is Progressive</th>
            <th>Qty</th>
          </tr>
        </thead>

        <tbody>
          {lensList.map((l, i) => (
            <tr key={i}>
              <td>{l.itemCode}</td>
              <td>{l.sph}</td>
              <td>{l.add}</td>
              <td>{l.cyl}</td>
              <td>{l.axis}</td>
              <td>{l.model}</td>
              <td>{l.progressive ? "true" : "false"}</td>
              <td>{l.qty}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="lens-form">
        <input
          placeholder="Item Code"
          value={lensForm.itemCode}
          onChange={(e) =>
            setLensForm({ ...lensForm, itemCode: e.target.value })
          }
        />
        <input
          placeholder="Sph"
          value={lensForm.sph}
          onChange={(e) => setLensForm({ ...lensForm, sph: e.target.value })}
        />
        <input
          placeholder="Add"
          value={lensForm.add}
          onChange={(e) => setLensForm({ ...lensForm, add: e.target.value })}
        />
        <input
          placeholder="Cyl"
          value={lensForm.cyl}
          onChange={(e) => setLensForm({ ...lensForm, cyl: e.target.value })}
        />
        <input
          placeholder="Axis"
          value={lensForm.axis}
          onChange={(e) => setLensForm({ ...lensForm, axis: e.target.value })}
        />

        <select
          value={lensForm.model}
          onChange={(e) => setLensForm({ ...lensForm, model: e.target.value })}
        >
          <option value="CR39">CR39</option>
          <option value="CR39 S/V">CR39 S/V</option>
        </select>

        <label className="checkbox-row">
          <input
            type="checkbox"
            checked={lensForm.progressive}
            onChange={(e) =>
              setLensForm({ ...lensForm, progressive: e.target.checked })
            }
          />
          Is Progressive
        </label>

        <input
          placeholder="Qty"
          value={lensForm.qty}
          onChange={(e) => setLensForm({ ...lensForm, qty: e.target.value })}
        />

        <button onClick={handleLensAdd}>Add to List</button>
        <button onClick={() => setLensList([])}>Clear All</button>
      </div>
    </div>

    {/* FRAME SECTION */}
    <div className="section-box">
      <h3>Frame Detail</h3>

      <table>
        <thead>
          <tr>
            <th>Item Code</th>
            <th>Model No</th>
            <th>Brand</th>
            <th>Colour</th>
            <th>Sex</th>
            <th>Qty</th>
          </tr>
        </thead>

        <tbody>
          {frameList.map((f, i) => (
            <tr key={i}>
              <td>{f.itemCode}</td>
              <td>{f.modelNo}</td>
              <td>{f.brand}</td>
              <td>{f.colour}</td>
              <td>{f.sex}</td>
              <td>{f.qty}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="frame-form">
        <input
          placeholder="Item Code"
          value={frameForm.itemCode}
          onChange={(e) =>
            setFrameForm({ ...frameForm, itemCode: e.target.value })
          }
        />
        <input
          placeholder="Model No"
          value={frameForm.modelNo}
          onChange={(e) =>
            setFrameForm({ ...frameForm, modelNo: e.target.value })
          }
        />
        <input
          placeholder="Brand"
          value={frameForm.brand}
          onChange={(e) =>
            setFrameForm({ ...frameForm, brand: e.target.value })
          }
        />
        <input
          placeholder="Colour"
          value={frameForm.colour}
          onChange={(e) =>
            setFrameForm({ ...frameForm, colour: e.target.value })
          }
        />
        <input
          placeholder="Sex"
          value={frameForm.sex}
          onChange={(e) =>
            setFrameForm({ ...frameForm, sex: e.target.value })
          }
        />

        <input
          placeholder="Qty"
          value={frameForm.qty}
          onChange={(e) =>
            setFrameForm({ ...frameForm, qty: e.target.value })
          }
        />

        <button onClick={handleFrameAdd}>Add to List</button>
        <button onClick={() => setFrameList([])}>Clear All</button>
      </div>
    </div>

    {/* CREATE BUTTON */}
    <button className="create-btn" onClick={handleCreatePurchaseOrder}>
      Create
    </button>
  </div>
)}



{/************************************** view stock - out *****************************************************/}

{selectedOption === "viewStockOut" && (
  <div className="stock-out-container">
    <div className="stock-out-header">
      <h2>Stock Out History</h2>
      <button 
        className="btn-export" 
        onClick={generateStockOutReportPDF}
        disabled={filteredStockOut.length === 0}
      >
        📄 Export to PDF
      </button>
    </div>

    {/* Filters Section */}
    <div className="filters-section">
      <div className="filter-row">
        <div className="filter-group">
          <label>Search:</label>
          <input
            type="text"
            placeholder="Search by model, brand, customer, invoice..."
            value={stockOutSearchTerm}
            onChange={(e) => setStockOutSearchTerm(e.target.value)}
            className="filter-input"
          />
        </div>

        <div className="filter-group">
          <label>Product Type:</label>
          <select
            value={stockOutFilterType}
            onChange={(e) => setStockOutFilterType(e.target.value)}
            className="filter-select"
          >
            <option value="all">All Types</option>
            <option value="frame">Frames</option>
            <option value="lens">Lenses</option>
          </select>
        </div>

        <div className="filter-group">
          <label>Date Range:</label>
          <input
            type="date"
            value={stockOutDateRange.start}
            onChange={(e) => setStockOutDateRange(prev => ({ ...prev, start: e.target.value }))}
            className="filter-date"
          />
          <span>to</span>
          <input
            type="date"
            value={stockOutDateRange.end}
            onChange={(e) => setStockOutDateRange(prev => ({ ...prev, end: e.target.value }))}
            className="filter-date"
          />
        </div>

        <button className="btn-reset" onClick={resetStockOutFilters}>
          🔄 Reset Filters
        </button>
        <button className="btn-refresh" onClick={fetchStockOutHistory}>
          🔄 Refresh
        </button>
      </div>
    </div>

    {/* Summary Cards */}
    <div className="summary-cards">
      <div className="summary-card">
        <div className="summary-title">Total Items Sold</div>
        <div className="summary-value">{getStockOutSummary().totalItems}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Total Value</div>
        <div className="summary-value">Rs. {getStockOutSummary().totalValue.toFixed(2)}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Frames Sold</div>
        <div className="summary-value">{getStockOutSummary().frameTotal}</div>
      </div>
      <div className="summary-card">
        <div className="summary-title">Lenses Sold</div>
        <div className="summary-value">{getStockOutSummary().lensTotal}</div>
      </div>
    </div>

    {/* Stock Out Table */}
    {isLoadingStockOut ? (
      <div className="loading-spinner">Loading stock-out history...</div>
    ) : (
      <>
        <div className="stock-out-table-container">
          <table className="stock-out-table">
            <thead>
              <tr>
                <th>Invoice No</th>
                <th>RX / VIP / CL / S No / R No</th>
                <th>Customer Name</th>
                <th>Date</th>
                <th>Time</th>
                <th>Type</th>
                <th>Model</th>
                <th>Brand</th>
                <th>Colour</th>
                <th>Size</th>
                <th>Base Curve</th>
                <th>R Power</th>
                <th>L Power</th>
                <th>Quantity</th>
                <th>Price</th>
                <th>Total</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredStockOut.length === 0 ? (
                <tr>
                  <td colSpan="13" style={{ textAlign: 'center' }}>
                    No stock-out records found
                  </td>
                </tr>
              ) : (
                filteredStockOut.map((record) => (
                  <tr key={record.id}>
                    <td>
                      <strong>{record.invoiceNumber || '-'}</strong>
                    </td>


            {/* RX / VIP / CL / S / R No - NEW COLUMN */}
                     {/* RX / VIP / CL / S / R No */}
  <td>
    {record.invoiceType === "RX" && record.rxNumber && (
      <span>RX: {record.rxNumber}</span>
    )}

    {record.invoiceType === "VIP" && record.vipNumber && (
      <span>VIP: {record.vipNumber}</span>
    )}

    {record.type === "direct-sale" &&
      record.directInvoiceType === "CL" &&
      record.clNumber && (
        <span>CL: {record.clNumber}</span>
      )}

    {record.type === "direct-sale" &&
      record.directInvoiceType === "S" &&
      record.sNumber && (
        <span>S: {record.sNumber}</span>
      )}

    {record.invoiceType === "R" && record.rNumber && (
      <span>R: {record.rNumber}</span>
    )}

    {!record.rxNumber &&
      !record.vipNumber &&
      !record.clNumber &&
      !record.sNumber &&
      !record.rNumber && <span>-</span>}
  </td>

                      <td>{record.customerName}</td>

                    <td>{record.dateFormatted}</td>
                    <td><small>{record.timeFormatted}</small></td>
                    <td>
                      <span className={`product-type-badge ${record.productType}`}>
                        {record.productType}
                      </span>
                    </td>
                    <td><strong>{record.productModel}</strong></td>
                    <td>{record.brand || '-'}</td>
                    <td>{record.colour || '-'}</td>
                    <td>{record.size || '-'}</td>
                    <td>{record.BaseCurve || '-'}</td>
                     <td>{record.rPower || '-'}</td>
                      <td>{record.lPower || '-'}</td>
                    <td className="text-center">{record.quantity}</td>
                    <td>Rs. {(record.price || 0).toFixed(2)}</td>
                    <td>Rs. {((record.price || 0) * (record.quantity || 0)).toFixed(2)}</td>

                    <td>
                      <button
                        className="btn-delete-small"
                        title="Delete record"
                        onClick={() => {
                          const password = prompt("Enter authorization password");
                          if (password !== "rayban@142") {
                            alert("Invalid password");
                            return;
                          }
                          const confirmDelete = window.confirm("Are you sure you want to delete this record?");
                          if (!confirmDelete) return;
                          deleteStockOutRecord(record.id);
                        }}
                      >
                        🗑️
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        
        <div className="stock-out-footer">
          <div className="records-count">
            Showing {filteredStockOut.length} of {stockOutRecords.length} records
          </div>
        </div>
      </>
    )}



  </div>
)}







{/******************************************************* Add Stock *****************************************************************/}

    {selectedOption === "addStock" && (
 <div className="stock-wrap">
  <h2>Add Stock</h2>

  {/* Select Category */}
  <label>Category:</label>
  <select value={selectedCategory} onChange={e => setSelectedCategory(e.target.value)}>
    <option value="">-- Select --</option>
    <option value="lens">Lens</option>
    <option value="frame">Frame</option>
  </select>

  {/* Purchase Order */}
  <label>Purchase Order No:</label>
  <select value={purchaseOrderNo} onChange={e => setPurchaseOrderNo(e.target.value)}>
    <option value="">-- Select Order --</option>
    {purchaseOrders.map(po => (
      <option key={po.id} value={po.purchaseOrderNo}>{po.purchaseOrderNo}</option>
    ))}
  </select>
  <button onClick={handleLoad}>Load</button>

  <label>Supplier Name:</label>
  <input type="text" value={supplierName} readOnly />

  <label>Purchase Date:</label>
  <input type="date" value={purchaseDate} readOnly />

  {/* Dynamic Table */}
  <div className="stock-items">
    <table>
      <thead>
        <tr>
          {selectedCategory === "lens" ? (
            <>
             
              <th>Sph</th>
              <th>Add</th>
              <th>Cyl</th>
              <th>Axis</th>
              <th>Model</th>
              <th>Is Progressive</th>
              <th>Qty</th>
              <th>Supply Qty</th>
            </>
          ) : selectedCategory === "frame" ? (
            <>
            
              <th>Model No</th>
              <th>Brand</th>
              <th>Colour</th>
              <th>Sex</th>
              <th>Qty</th>
              <th>Supply Qty</th>
            </>
          ) : null}
        </tr>
      </thead>

      <tbody>
        {items.map((item, i) => (
          <tr key={i}>
            {selectedCategory === "lens" ? (
              <>
                
                <td>{item.sph}</td>
                <td>{item.add}</td>
                <td>{item.cyl}</td>
                <td>{item.axis}</td>
                <td>{item.model}</td>
                <td>{item.progressive ? "true" : "false"}</td>
                <td>{item.qty}</td>
                <td>
                  <input
                    type="number"
                    value={item.supplyQty}
                    onChange={e => handleSupplyQtyChange(i, e.target.value)}
                  />
                </td>
              </>
            ) : selectedCategory === "frame" ? (
              <>
               
                <td>{item.modelNo}</td>
                <td>{item.brand}</td>
                <td>{item.colour}</td>
                <td>{item.sex}</td>
                <td>{item.qty}</td>
                <td>
                  <input
                    type="number"
                    value={item.supplyQty}
                    onChange={e => handleSupplyQtyChange(i, e.target.value)}
                  />
                </td>
              </>
            ) : null}
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Actions */}
  <button onClick={handleClear}>Clear</button>
  <button onClick={handleAddItems}>Add Items</button>
</div>
)}




{/***************************************************** quick add stock*************************************************************/}

{selectedOption === "quickAdd" && (
  <div className="quick-add-container">
    <h2>Add Stock</h2>

    {/* Select Category */}
    <label>Category:</label>
    <select value={quickSelectedCategory} onChange={e => setQuickSelectedCategory(e.target.value)}>
      <option value="">-- Select --</option>
      <option value="lens">Lens</option>
      <option value="frame">Frame</option>
      <option value="sunglass">Sunglass</option>
      <option value="other">Other</option>
    </select>

    {/* Supplier Name */}
    <label>Supplier Name *</label>
    <select value={quickSupplierName} onChange={e => setQuickSupplierName(e.target.value)}>
      <option value="">-- Select Supplier --</option>
      {suppliersList.map(supplier => (
        <option key={supplier.id} value={supplier.name}>
          {supplier.name} - {supplier.company}
        </option>
      ))}
    </select>

    {/* Purchase Date */}
    <label>Purchase Date *</label>
    <input 
      type="date" 
      value={quickPurchaseDate} 
      onChange={e => setQuickPurchaseDate(e.target.value)}
    />

    {/* Dynamic Table for Items */}
    <div className="stock-items">
      <table>
        <thead>
          <tr>
            {quickSelectedCategory === "lens" ? (
              <>
               
                <th>Sph</th>
                <th>Add</th>
                <th>Cyl</th>
                <th>Axis</th>
                <th>Model</th>
                <th>Is Progressive</th>
                {/* <th>Buying Price</th> */}
                <th>Selling Price</th>
                <th>Qty</th>
                <th>Supply Qty</th>
                <th>Action</th>
              </>
            ) : quickSelectedCategory === "frame" ? (
              <>
                <th>Brand</th>
                <th>Model No</th>
                <th>Size</th>
                <th>Colour</th>
                {/* <th>Sex</th> */}
                <th>Qty</th>
                {/* <th>Buying Price</th> */}
                <th>Selling Price</th>
                <th>Supply Qty</th>
                <th>Action</th>
              </>

                          ) : quickSelectedCategory === "sunglass" ? (
              <>
                <th>Brand</th>
                <th>Model No</th>
                <th>Size</th>
                <th>Colour</th>
                {/* <th>Sex</th> */}
                <th>Qty</th>
                {/* <th>Buying Price</th> */}
                <th>Selling Price</th>
                <th>Supply Qty</th>
                <th>Action</th>
              </>


           ) : quickSelectedCategory === "other" ? (
  <>
    <th>Brand</th>
    <th>Model No</th>
    <th>R Power</th>
    <th>L Power</th>
    <th>Base Curve</th>
    <th>Colour</th>
    <th>Selling Price</th>
    <th>Qty</th>
    <th>Supply Qty</th>
    <th>Action</th>
  </>
) : null}
          </tr>
        </thead>
        <tbody>
          {quickItems.map((item, i) => (
            <tr key={i}>
              {quickSelectedCategory === "lens" ? (
                <>
                  <td>

                  </td>
                  <td>
                    <input 
                      type="text" 
                      value={item.sph} 
                      onChange={e => handleQuickItemChange(i, 'sph', e.target.value)}
                      placeholder="Sph"
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      value={item.add} 
                      onChange={e => handleQuickItemChange(i, 'add', e.target.value)}
                      placeholder="Add"
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      value={item.cyl} 
                      onChange={e => handleQuickItemChange(i, 'cyl', e.target.value)}
                      placeholder="Cyl"
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      value={item.axis} 
                      onChange={e => handleQuickItemChange(i, 'axis', e.target.value)}
                      placeholder="Axis"
                    />
                  </td>
                  <td>
                    <input 
                      type="text" 
                      value={item.model} 
                      onChange={e => handleQuickItemChange(i, 'model', e.target.value)}
                      placeholder="Model"
                    />
                  </td>
                  <td>
                    <select 
                      value={item.progressive} 
                      onChange={e => handleQuickItemChange(i, 'progressive', e.target.value === 'true')}
                    >
                      <option value="false">No</option>
                      <option value="true">Yes</option>
                    </select>
                  </td>




                  <td>
                    <input 
                      type="number" 
                      value={item.sellingPrice} 
                      onChange={e => handleQuickItemChange(i, 'sellingPrice', parseInt(e.target.value))}
                      placeholder="Selling Price"
                    />
                  </td>


                  <td>
                    <input 
                      type="number" 
                      value={item.qty} 
                      onChange={e => handleQuickItemChange(i, 'qty', parseInt(e.target.value))}
                      placeholder="Qty"
                    />
                  </td>
                  <td>
                    <input 
                      type="number" 
                      value={item.supplyQty} 
                      onChange={e => handleQuickItemChange(i, 'supplyQty', parseInt(e.target.value))}
                      placeholder="Supply Qty"
                    />
                  </td>
                  <td>
                    <button className="btn-remove-row" onClick={() => handleRemoveQuickItem(i)}>Remove</button>
                  </td>
                </>
              ) : quickSelectedCategory === "frame" ? (
                <>

                  <td>
                    <input 
                      type="text" 
                      value={item.brand} 
                      onChange={e => handleQuickItemChange(i, 'brand', e.target.value)}
                      placeholder="Brand"
                    />
                  </td>

                  <td>
                    <input 
                      type="text" 
                      value={item.modelNo} 
                      onChange={e => handleQuickItemChange(i, 'modelNo', e.target.value)}
                      placeholder="Model No"
                    />
                  </td>

                    <td>
                    <input 
                      type="text" 
                      value={item.size} 
                      onChange={e => handleQuickItemChange(i, 'size', e.target.value)}
                      placeholder="Size"
                    />
                  </td>

                  <td>
                    <input 
                      type="text" 
                      value={item.colour} 
                      onChange={e => handleQuickItemChange(i, 'colour', e.target.value)}
                      placeholder="Colour"
                    />
                  </td>

               


                  {/* <td>
                    <select 
                      value={item.sex} 
                      onChange={e => handleQuickItemChange(i, 'sex', e.target.value)}
                    >
                      <option value="">Select</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Unisex">Unisex</option>
                    </select>
                  </td> */}
                  <td>
                    <input 
                      type="number" 
                      value={item.qty} 
                      onChange={e => handleQuickItemChange(i, 'qty', parseInt(e.target.value))}
                      placeholder="Qty"
                    />
                  </td>


                  {/* <td>
                    <input 
                      type="number" 
                      value={item.buyingPrice} 
                      onChange={e => handleQuickItemChange(i, 'buyingPrice', parseInt(e.target.value) || 0)}
                      placeholder="Buying Price"
                    />
                  </td> */}


                  <td>
                    <input 
                      type="number" 
                      value={item.sellingPrice} 
                      onChange={e => handleQuickItemChange(i, 'sellingPrice', parseInt(e.target.value))}
                      placeholder="Selling Price"
                    />
                  </td>



                  <td>
                    <input 
                      type="number" 
                      value={item.supplyQty} 
                      onChange={e => handleQuickItemChange(i, 'supplyQty', parseInt(e.target.value))}
                      placeholder="Supply Qty"
                    />
                  </td>
                  <td>
                    <button className="btn-remove-row" onClick={() => handleRemoveQuickItem(i)}>Remove</button>
                  </td>
                </>




   ) : quickSelectedCategory === "sunglass" ? (
                <>
                  <td>
                    <input 
                      type="text" 
                      value={item.brand} 
                      onChange={e => handleQuickItemChange(i, 'brand', e.target.value)}
                      placeholder="Brand"
                    />
                  </td>

                  <td>
                    <input 
                      type="text" 
                      value={item.modelNo} 
                      onChange={e => handleQuickItemChange(i, 'modelNo', e.target.value)}
                      placeholder="Model No"
                    />
                  </td>



                  <td>
                    <input 
                      type="text" 
                      value={item.size} 
                      onChange={e => handleQuickItemChange(i, 'size', e.target.value)}
                      placeholder="Size"
                    />
                  </td>


                  <td>
                    <input 
                      type="text" 
                      value={item.colour} 
                      onChange={e => handleQuickItemChange(i, 'colour', e.target.value)}
                      placeholder="Colour"
                    />
                  </td>

                  <td>
                    <input 
                      type="number" 
                      value={item.qty} 
                      onChange={e => handleQuickItemChange(i, 'qty', parseInt(e.target.value))}
                      placeholder="Qty"
                    />
                  </td>


                  {/* <td>
                    <input 
                      type="number" 
                      value={item.buyingPrice} 
                      onChange={e => handleQuickItemChange(i, 'buyingPrice', parseInt(e.target.value) || 0)}
                      placeholder="Buying Price"
                    />
                  </td> */}


                  <td>
                    <input 
                      type="number" 
                      value={item.sellingPrice} 
                      onChange={e => handleQuickItemChange(i, 'sellingPrice', parseInt(e.target.value))}
                      placeholder="Selling Price"
                    />
                  </td>



                  <td>
                    <input 
                      type="number" 
                      value={item.supplyQty} 
                      onChange={e => handleQuickItemChange(i, 'supplyQty', parseInt(e.target.value))}
                      placeholder="Supply Qty"
                    />
                  </td>
                  <td>
                    <button className="btn-remove-row" onClick={() => handleRemoveQuickItem(i)}>Remove</button>
                  </td>
                </>




   ) : quickSelectedCategory === "other" ? (
  <>
    <td>
      <input 
        type="text" 
        value={item.brand} 
        onChange={e => handleQuickItemChange(i, 'brand', e.target.value)}
        placeholder="Brand"
      />
    </td>
    <td>
      <input 
        type="text" 
        value={item.modelNo} 
        onChange={e => handleQuickItemChange(i, 'modelNo', e.target.value)}
        placeholder="Model No"
      />
    </td>
    <td>
      <input 
        type="text" 
        value={item.rPower} 
        onChange={e => handleQuickItemChange(i, 'rPower', e.target.value)}
        placeholder="R Power"
      />
    </td>
    <td>
      <input 
        type="text" 
        value={item.lPower} 
        onChange={e => handleQuickItemChange(i, 'lPower', e.target.value)}
        placeholder="L Power"
      />
    </td>
    <td>
      <input 
        type="text" 
        value={item.BaseCurve} 
        onChange={e => handleQuickItemChange(i, 'BaseCurve', e.target.value)}
        placeholder="Base Curve"
      />
    </td>
    <td>
      <input 
        type="text" 
        value={item.colour} 
        onChange={e => handleQuickItemChange(i, 'colour', e.target.value)}
        placeholder="Colour"
      />
    </td>
    <td>
      <input 
        type="number" 
        value={item.sellingPrice} 
        onChange={e => handleQuickItemChange(i, 'sellingPrice', e.target.value)}
        placeholder="Selling Price"
      />
    </td>
    <td>
      <input 
        type="number" 
        value={item.qty} 
        onChange={e => handleQuickItemChange(i, 'qty', e.target.value)}
        placeholder="Qty"
      />
    </td>
    <td>
      <input 
        type="number" 
        value={item.supplyQty} 
        onChange={e => handleQuickItemChange(i, 'supplyQty', e.target.value)}
        placeholder="Supply Qty"
      />
    </td>
    <td>
      <button className="btn-remove-row" onClick={() => handleRemoveQuickItem(i)}>Remove</button>
    </td>
  </>
) : null}



            </tr>
          ))}
        </tbody>
      </table>
    </div>

    {/* Add Row Button */}
    <button className="btn-add-row" onClick={handleAddQuickItemRow}>
      + Add Item
    </button>

    {/* Actions */}
    <div className="quick-actions">
      <button onClick={handleClearQuickForm}>Clear</button>

<button
  onClick={handleQuickAddStock}
  disabled={isAddingStock}
  style={{
    opacity: isAddingStock ? 0.6 : 1,
    cursor: isAddingStock ? "not-allowed" : "pointer"
  }}
>
  {isAddingStock ? "Adding..." : "Add to Stock"}
</button>

    </div>
  </div>
)}


{/******************************************************* Search *****************************************************************/}


        {selectedOption === "about" && <h2>About</h2>}





{/******************************************************* Sales report *****************************************************************/}




{selectedOption === "salesReport" && (
  <div className="sales-report-container">
    <h2>Sales Overview</h2>

    <div style={{ marginBottom: "15px" }}>
      <button onClick={downloadExcel} className="btn-excel">📊 Download Excel</button>
      <button onClick={downloadPDF} style={{ marginLeft: "10px" }} className="btn-pdf">📄 Download PDF</button>
      <button onClick={resetFilters} style={{ marginLeft: "10px" }} className="btn-reset">🔄 Reset Filters</button>
    </div>

    {/* Filter Section */}
{/* Filter Section */}
<div style={{ marginBottom: "20px", padding: "15px", backgroundColor: "#f8f9fa", borderRadius: "8px" }}>
  <div style={{ marginBottom: "10px" }}>
    <label style={{ marginRight: "15px" }}>
      <input
        type="radio"
        value="month"
        checked={dateFilterType === "month"}
        onChange={(e) => setDateFilterType(e.target.value)}
      /> Filter by Month/Year
    </label>
    <label>
      <input
        type="radio"
        value="range"
        checked={dateFilterType === "range"}
        onChange={(e) => setDateFilterType(e.target.value)}
      /> Filter by Date Range
    </label>
  </div>

  {dateFilterType === "month" ? (
    <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
      <select value={selectedMonth} onChange={(e) => setSelectedMonth(e.target.value)}>
        <option value="all">All Months</option>
        <option value="1">January</option>
        <option value="2">February</option>
        <option value="3">March</option>
        <option value="4">April</option>
        <option value="5">May</option>
        <option value="6">June</option>
        <option value="7">July</option>
        <option value="8">August</option>
        <option value="9">September</option>
        <option value="10">October</option>
        <option value="11">November</option>
        <option value="12">December</option>
      </select>

      <select value={selectedYear} onChange={(e) => setSelectedYear(e.target.value)}>
        <option value="all">All Years</option>
        {getAvailableYears().map(year => (
          <option key={year} value={year}>{year}</option>
        ))}
      </select>
      
      {/* Show current filter info */}
      <span style={{ fontSize: "12px", color: "#666", alignSelf: "center" }}>
        {selectedMonth !== "all" && selectedYear !== "all" 
          ? `Showing: ${["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][parseInt(selectedMonth)]} ${selectedYear}`
          : selectedYear !== "all" 
          ? `Showing: Year ${selectedYear}`
          : selectedMonth !== "all"
          ? `Showing: ${["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][parseInt(selectedMonth)]}`
          : "Showing: All Records"}
      </span>
    </div>
  ) : (
    <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "center" }}>
      <div>
        <label>From Date: </label>
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          style={{ padding: "5px", marginLeft: "5px" }}
        />
      </div>
      <div>
        <label>To Date: </label>
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          style={{ padding: "5px", marginLeft: "5px" }}
        />
      </div>
      {startDate && endDate && (
        <span style={{ fontSize: "12px", color: "#666" }}>
          Showing: {new Date(startDate).toLocaleDateString()} - {new Date(endDate).toLocaleDateString()}
        </span>
      )}
    </div>
  )}

  {/* Payment Method Filter */}
  {/* <div style={{ marginTop: "15px" }}>
    <label style={{ marginRight: "10px" }}>Payment Method:</label>
    <select value={selectedPaymentMethod} onChange={(e) => setSelectedPaymentMethod(e.target.value)}>
      <option value="all">All Methods</option>
      <option value="Cash">Cash</option>
      <option value="Card">Card</option>
      <option value="Split">Split (Cash + Card)</option>
      <option value="Bank Transfer">Bank Transfer</option>
      <option value="Deposit">Deposit</option>
      <option value="Cheque">Cheque</option>
    </select>
  </div> */}

  {/* Sales Person Filter */}
  <div style={{ marginTop: "15px" }}>
    <label style={{ marginRight: "10px" }}>Sales Person:</label>
    <select 
      value={selectedSalesPerson} 
      onChange={(e) => setSelectedSalesPerson(e.target.value)}
      className="filter-select"
    >
      <option value="all">All Sales Persons</option>
      {salesPersonList.map(person => (
        <option key={person.id} value={person.salespersonName}>
          {person.salespersonName}
        </option>
      ))}
    </select>
  </div>

  {/* Eye Camp Filter */}
  <div className="filter-group" style={{ marginTop: "15px" }}>
    <label style={{ marginRight: "10px" }}>Eye Camp</label>
    <select 
      className="filter-select"
      value={selectedEyeCamp} 
      onChange={(e) => setSelectedEyeCamp(e.target.value)}
    >
      <option value="all">All Eye Camps</option>
      {eyeCampsList.map(camp => (
        <option key={camp.id} value={camp.name}>
          {camp.name}
        </option>
      ))}
    </select>
  </div>
  
  {/* Show record count */}
  <div style={{ marginTop: "15px", fontSize: "12px", color: "#666" }}>
    Showing {filteredReport.length} records out of {report.length} total
  </div>
</div>

    {/* Summary Cards */}
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "15px", marginBottom: "20px" }}>
      <div style={{ padding: "15px", backgroundColor: "#e3f2fd", borderRadius: "8px" }}>
        <h4>Total Sales</h4>
        <h3>Rs. {filteredReport.reduce((sum, r) => sum + (r.totalAmount || 0), 0).toLocaleString()}</h3>
      </div>
      <div style={{ padding: "15px", backgroundColor: "#e8f5e9", borderRadius: "8px" }}>
        <h4>Total Received</h4>
        <h3>Rs. {filteredReport.reduce((sum, r) => sum + (r.totalPaid || 0), 0).toLocaleString()}</h3>
      </div>
      <div style={{ padding: "15px", backgroundColor: "#fff3e0", borderRadius: "8px" }}>
        <h4>Pending Amount</h4>
        <h3>Rs. {filteredReport.reduce((sum, r) => sum + (r.remaining || 0), 0).toLocaleString()}</h3>
      </div>
      <div style={{ padding: "15px", backgroundColor: "#f3e5f5", borderRadius: "8px" }}>
        <h4>Total Cash</h4>
        <h3>Rs. {filteredReport.reduce((sum, r) => sum + (r.cashAmount || 0), 0).toLocaleString()}</h3>
      </div>
      <div style={{ padding: "15px", backgroundColor: "#e0f7fa", borderRadius: "8px" }}>
        <h4>Total Card</h4>
        <h3>Rs. {filteredReport.reduce((sum, r) => sum + (r.cardAmount || 0), 0).toLocaleString()}</h3>
      </div>
    </div>

    {loading ? (
      <p>Loading...</p>
    ) : (
      <div style={{ overflowX: "auto" }}>
        <table border="1" cellPadding="10" style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead style={{ backgroundColor: "#0f172a", color: "white" }}>
            <tr>
              <th>Invoice</th>
              <th>Customer</th>
              <th>Sales Person</th>
              <th>Eye Camp</th>
              <th>Payment Method</th>
              <th>Date</th>
              <th>Total Amount (Rs.)</th>
              <th>Cash (Rs.)</th>
              <th>Card (Rs.)</th>
              <th>Total Paid (Rs.)</th>
              <th>Remaining (Rs.)</th>
            </tr>
          </thead>
          <tbody>
            {filteredReport.length === 0 ? (
              <tr>
                <td colSpan="11" style={{ textAlign: "center" }}>No data available</td>
              </tr>
            ) : (
              filteredReport.map((r, i) => (
                <tr key={i}>
                  <td>{r.invoiceNumber}</td>
                  <td>{r.customer}</td>
                  <td>{r.salePerson || "-"}</td>
                  <td>{r.eyeCamp || "-"}</td>
                  <td>{r.paymentMethod}</td>
                  <td>{r.date.toLocaleDateString()}</td>
                  <td style={{ textAlign: "right" }}>{r.totalAmount.toLocaleString()}</td>
                  <td style={{ textAlign: "right", color: "#28a745" }}>{r.cashAmount.toLocaleString()}</td>
                  <td style={{ textAlign: "right", color: "#007bff" }}>{r.cardAmount.toLocaleString()}</td>
                  <td style={{ textAlign: "right" }}>{r.totalPaid.toLocaleString()}</td>
                  <td style={{ textAlign: "right", color: r.remaining > 0 ? "#dc3545" : "#28a745" }}>
                    {r.remaining.toLocaleString()}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    )}
  </div>
)}



{/******************************************************* Log Out *****************************************************************/}


        {selectedOption === "logout" && <h2>Logging Out…</h2>}
      </div>
    </>
  );
}

export default AdminPanel;